/* eslint-disable no-trailing-spaces */
/* eslint-disable eol-last */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/indent */

import { isNull, isUndefined } from 'lodash';

const partnerGlobalConfigLocal = JSON.parse(
  window.localStorage.getItem('partner_settings'),
);
let primaryColor =
  process.env.REACT_APP_PLATFORM_DEFAULT_PRIMARY_COLOR || '#006699';

if (
  !isNull(partnerGlobalConfigLocal) &&
  !isUndefined(partnerGlobalConfigLocal)
) {
  primaryColor = partnerGlobalConfigLocal?.color_schema?.primary;
}

export const nl = {
         login_sign_in: 'Log in',
         login_email_address: 'Email adres',
         login_form_password_label: 'Wachtwoord',
         login_forget_password: 'Wachtwoord vergeten',
         login_credentials_error: 'Controleer uw email adres en wachtwoord',
         login_api_error: 'Interne login API Error',
         internal_server_error: 'Internal Server Error',
         /* Forget Password */
         forget_password_title: 'Wachtwoord vergeten',
         forget_password_email_address: 'Email adres',
         forget_password_button: 'Stuur een link om uw wachtwoord te resetten.',
         forget_password_login: 'Terug',
         forgot_password_form_success:
           'E-mail voor wachtwoordherstel wordt doorgestuurd. Controleer uw inbox. Het kan zijn dat de e-mail in uw spam terecht is gekomen.',
         forgot_password_subject: 'Fortes Data Beheer  - Wachtwoord Vergeten',
         temporary_password_subject:
           'Fortes Data Beheer - Nieuw Account Aangemaakt',
         forgot_password_required_form_error: 'Email adres is verplicht',
         forgot_password_valid_form_error: 'Geen geldig email adres',
         /* END Forget Password */
         /** Herstel Password */
         reset_password_title: 'Herstel wachtwoord',
         reset_password_new_password: 'Nieuw wachtwoord',
         reset_password_confirm_password: 'Bevestig wachtwoord',
         reset_password_new_password_required_form_error:
           'Nieuw wachtwoord is verplicht',
         reset_password_confirm_password_required_form_error:
           'Bevestiging van het wachtwoord is verplicht',
         reset_password_passwords_not_matching:
           'De wachtwoorden komen niet overeen',
         reset_password_new_password_form_error:
           'Wachtwoord moet minimaal 8 tekens bevatten met tenminste één hoofdletter, één cijfer en één speciaal teken.',
         reset_password_button: 'Herstel wachtwoord',
         reset_password_form_success: 'Het wachtwoord is succesvol gewijzigd.',
         /** Eind Herstel Password */
         /* DASHBOARD */
         dashboard_title: 'Dashboard',
         dashboard_amount_of_devices: 'AANTAL DEVICES',
         dashboard_amount_of_devices_week: 'AANTAL DEVICES VORIGE WEEK',
         dashboard_amount_of_devices_error: 'AANTAL DEVICES MET STORINGEN',
         dashboard_temperature: 'RETOURTEMPERATUUR IN CELCIUS',
         dashboard_device_status: 'Device overzicht',
         dashboard_routing_temperature: 'Temperaturen van alles devices',
         dashboard_routing_temperature_hr: 'Uur',
         dashboard_error_devices: 'Devices met Actieve storingen:',
         dashboard_error: 'STORING',
         dashboard_online: 'ONLINE',
         dashboard_offline: 'OFFLINE',
         'dashboard organic': 'Organic',
         'dashboard referal': 'Referral',
         dashboard_see_all: 'SEE ALL',
         /* END DASHBOARD */
         /* Sidebar */
         date_range: 'Datum',
         sidebar_dashboard: 'Dashboard',
         sidebar_clients_overview: 'Klantbeheer',
         sidebar_clients: 'Klanten',
         sidebar_service_clients: 'Service klanten',
         sidebar_devices_overview: 'Toestel beheer',
         sidebar_devices: 'Afleverset overzicht',
         sidebar_projects: 'Project overzicht',
         sidebar_presets: 'Presets',
         sidebar_fortes_users: 'Administrators',
         sidebar_fortes_settings: 'Instellingen',
         sidebar_audit: 'Audit',
         sidebar_reports: 'Rapporten',
         sidebar_total_devices: 'Devices - Totaal',
         sidebar_online_devices: 'Devices - Online',
         sidebar_offline_devices: 'Devices - Offline',
         sidebar_error_devices: 'Devices - Storing',
         sidebar_change_logs: 'Change Logs',
         sidebar_version_title: 'Versie',
         image_upload_success: 'Afeelding is succesvol gewijzigd!',
         image_upload_file_type_error:
           'Alleen JPEG en PNG bestanden zijn toegestaan.',
         image_upload_file_size_error: 'Het bestand moet minder dan 5MB zijn.',
         image_uploading_text: 'Uploaden...',
         /* END Sidebar */
         /* Navbar */
         navbar_search: 'Zoeken',
         navbar_notification: 'Meldingen',
         navbar_no_notification: 'Er zijn geen meldingen',
         navbar_profile: 'Account',
         navbar_setting: 'Account instellingen',
         navbar_logout: 'Uitloggen',
         /* END Navbar */
         active_label: 'ACTIEF',
         deactive_label: 'INACTIEF',
         please_fix_form_errors: 'Corrigeer a.u.b. formulierfouten',
         /* Klanten */
         clients: 'Klanten',
         clients_all: 'ALLE',
         clients_active: 'ACTIEF',
         clients_inactive: 'INACTIEF',
         clients_add_new: 'Klant toevoegen',
         clients_filter_search: 'Zoek klant',
         clients_sort_by_filter_label: 'Sorteer op',
         clients_sort_by_value_1: 'Datum(nieuwste)',
         clients_sort_by_value_2: 'Datum(oudste)',
         clients_sort_by_value_3: 'Alfabetisch',
         clients_country_filter_label: 'Locatie',
         clients_filter_reset_button: 'Herstel',
         clients_filter_delete_button: 'Deactiveren',
         clients_table_name: 'Naam',
         clients_table_country: 'Locatie',
         clients_table_devices: 'Devices',
         clients_table_added: 'Toegevoegd op',
         clients_table_status: 'Status',
         clients_table_row_per_page: 'Resultaten per pagina',
         clients_bread_crumb_main_title: 'Klanten',
         add_clients_bread_crumb_first_link: 'Klant toevoegen',
         add_clients_form_header: 'Klant toevoegen',
         edit_clients_bread_crumb_first_link: 'Klant wijzigen',
         edit_clients_form_header: 'Klant wijzigen',
         clients_form_client_name_field: 'Naam',
         clients_form_email_field: 'Email adres',
         clients_form_user_field: 'Klant Contact',
         clients_form_city_field: 'Stad',
         clients_form_country_field: 'Land',
         clients_form_client_kong_role_field: 'Kong Rol',
         clients_form_client_kong_role_member_label: 'Gebruiker',
         clients_form_client_kong_role_admin_label: 'Admin',
         clients_form_allow_customization_field: 'White-labeling toestaan',
         clients_form_add_client_button: 'Klant toevoegen',
         clients_form_edit_client_button: 'Wijzigingen opslaan',
         clients_form_cancel_button: 'Annuleer',
         clients_form_submitting_client_button: 'Verwerken...',
         clients_name_required_form_error: 'Naam is verplicht',
         clients_email_required_form_error: 'Email adres is verplicht',
         clients_api_kong_role_required_form_error: 'Kong rol is verplicht',
         clients_email_valid_form_error: 'Ongeldig email adres',
         clients_city_required_form_error: 'Stad is verplicht',
         clients_country_required_form_error: 'Land is verplicht',
         clients_add_form_success: 'Klant is succesvol aangemaakt!',
         clients_edit_form_success: 'Klant is succesvol gewijzigd!',
         clients_form_api_error: 'Internal klant - API Server Error',
         clients_form_email_error: 'Het email adres bestaat al',
         clients_no_record_found: 'Geen klant gevonden',
         client_deactivated_message: 'Klant is succesvol gedeactiveerd',
         client_activated_message: 'Klant is succesvol geactiveerd',
         clients_bulk_no_user_is_selected_error_message:
           'Selecteer meerdere rijen om te deactiveren',
         clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} Klant(en) zijn succesvol gedeactiveerd',
         client_single_stats_table_title: 'Status',
         /* END Klanten */
         client_single_first_bread_crumb: 'Klanten',
         client_single_second_bread_crumb: 'Toon klant',
         client_single_country_label: 'Land',
         client_single_devices_label: 'Devices',
         client_single_edit_button: 'Wijzigen',
         client_single_users_tab: 'Gebruikers',
         client_single_apis_tab: 'API Keys',
         client_single_customization_tab: 'White label',
         client_single_customization_tab_logo: 'Logo',
         client_single_customization_tab_primary_color: 'Primaire kleur',
         client_single_customization_tab_secondary_color: 'Secondaire kleur',
         client_single_customization_tab_submit_button: 'Wijzigen opslaan',
         client_single_customization_color_schema_success:
           'White labeling is succesvol.',
         client_single_filter_search: 'Zoeken',
         client_single_add_new_user_button: 'Gebruiker toevoegen',
         client_single_add_new_api_key_button: 'API key toevoegen',
         client_single_role_id_filter: 'Rol',
         client_single_users_search: 'Zoeken',
         client_single_filter_reset_button: 'Herstel',
         client_single_users_all: 'ALL',
         client_single_users_active: 'ACTIEF',
         client_single_users_inactive: 'INACTIEF',
         client_single_filter_delete_button: 'Deactiveren',
         client_single_users_table_name: 'Naam',
         client_single_users_table_address: 'Adres',
         client_single_users_table_role_id: 'Rol',
         client_single_users_table_status: 'Status',
         client_single_users_table_added: 'Toegevoegd',
         client_single_users_table_no_record_found: 'Geen gebruiker gevonden',
         client_single_table_row_per_page: 'Resultaten per pagina',
         client_single_stats_online_devices_label: 'Online devices',
         client_single_stats_error_devices_label: 'Devices in storing',
         client_single_no_user_selected_for_de_activation_message:
           'Selecteer een Device om te deactiveren',
         /* END Klanten Single */
         /* Service Klanten */
         service_clients: 'Service klant',
         service_clients_all: 'ALL',
         service_clients_active: 'ACTIEF',
         service_clients_inactive: 'INACTIEF',
         service_clients_add_new: 'Service klant toevoegen',
         service_clients_filter_search: 'Zoeken',
         service_clients_sort_by_filter_label: 'Sorteren op',
         service_clients_sort_by_value_1: 'Datum (nieuwste)',
         service_clients_sort_by_value_2: 'Datum (oudste)',
         service_clients_sort_by_value_3: 'Alfabetisch',
         service_clients_country_filter_label: 'Land',
         service_clients_filter_reset_button: 'Herstel',
         service_clients_filter_delete_button: 'Verwijderen',
         service_clients_table_name: 'Naam',
         service_clients_table_country: 'Land',
         service_clients_table_devices: 'Devices',
         service_clients_table_added: 'Toegevoegd',
         service_clients_table_status: 'Status',
         service_clients_table_row_per_page: 'Resultaten per pagina',
         service_clients_bread_crumb_main_title: 'Service klanten',
         add_service_clients_bread_crumb_first_link: 'Service klant toevoegen',
         add_service_clients_form_header: 'Service klant toevoegen',
         edit_service_clients_bread_crumb_first_link: 'Service klant wijzigen',
         edit_service_clients_form_header: 'Service klant wijzigen',
         service_clients_form_service_client_name_field: 'Naam',
         service_clients_form_email_field: 'Email adres',
         service_clients_form_client_field: 'Klant',
         service_clients_form_user_field: 'Klant Contact',
         service_clients_form_city_field: 'Stad',
         service_clients_form_country_field: 'Land',
         service_clients_form_add_service_client_button: 'Wijzigingen opslaan',
         service_clients_form_edit_service_client_button: 'Wijzigingen opslaan',
         service_clients_form_cancel_button: 'Annuleer',
         service_clients_form_submitting_service_client_button: 'Verwerken...',
         service_clients_name_required_form_error: 'Naam is verplicht',
         service_clients_email_required_form_error: 'Email is verplicht',
         service_clients_focal_user_id_required_form_error:
           'Hoofdgebruiker is verplicht',
         service_clients_email_valid_form_error: 'Email adres is ongeldig',
         service_clients_city_required_form_error: 'Stad is verplicht',
         service_clients_client_required_form_error: 'Klant is verplicht',
         service_clients_country_required_form_error: 'Land is verplicht',
         service_clients_add_form_success:
           'Service klant is succesvol aangemaakt!',
         service_clients_edit_form_success:
           'Service klant is succesvol gewijzigd!',
         service_clients_form_api_error:
           'Internal Service klant - API Server Error',
         service_clients_form_email_error: 'Email adres is reeds in gebruik',
         service_clients_no_record_found: 'Geen Service klant gevonden',
         service_client_deactivated_message:
           'Service klant is succesvol gedeactiveerd',
         service_client_activated_message:
           'Service klant is succesvol geactiveerd',
         service_clients_bulk_no_user_is_selected_error_message:
           'Selecteer een gebruiker om te deactiveren',
         service_clients_bulk_deactivated_message:
           '{{ USERS_COUNT }} Service klant(en) zijn succesvol gedeactiveerd',
         service_client_single_stats_table_title: 'Status',
         /* END Service Klanten */
         service_client_single_first_bread_crumb: 'Service klanten',
         service_client_single_second_bread_crumb: 'Service klant weergeven',
         service_client_single_country_label: 'Land',
         service_client_single_devices_label: 'Devices',
         service_client_single_edit_button: 'Wijzigen',
         service_client_single_users_tab: 'Gebruikers',
         service_client_single_apis_tab: 'API Keys',
         service_client_single_filter_search: 'Zoeken',
         service_client_single_add_new_user_button: 'Gebruiker toevoegen',
         service_client_single_add_new_api_key_button: 'API key toevoegen',
         service_client_single_role_id_filter: 'Rol',
         service_client_single_users_search: 'Zoeken',
         service_client_single_filter_reset_button: 'Herstel',
         service_client_single_users_all: 'ALL',
         service_client_single_users_active: 'ACTIEF',
         service_client_single_users_inactive: 'INACTIEF',
         service_client_single_filter_delete_button: 'Verwijderen',
         service_client_single_users_table_name: 'Naam',
         service_client_single_users_table_address: 'Adres',
         service_client_single_users_table_role_id: 'Rol',
         service_client_single_users_table_status: 'Status',
         service_client_single_users_table_added: 'Toegevoegd',
         service_client_single_users_table_no_record_found:
           'Geen gebruiker gevonden',
         service_client_single_table_row_per_page: 'Resultaten per pagina',
         service_client_single_stats_active_devices_label: 'Online devices',
         service_client_single_stats_error_devices_label: 'Devices in storing',
         service_client_single_no_user_selected_for_de_activation_message:
           'Please select records to deactivate',
         /* END Service Klanten Single */
         /* Gebruikers */
         users_bread_crumb_main_title: 'Klanten',
         add_users_bread_crumb_first_link: 'Gebruiker toevoegen',
         add_users_form_header: 'Gebruiker toevoegen',
         edit_users_bread_crumb_first_link: 'Gebruiker wijzigen',
         edit_users_form_header: 'Wijzigen gebruiker',
         users_form_first_name_field: 'Voornaam',
         users_form_last_name_field: 'Achternaam',
         users_form_email_field: 'Email adres',
         users_form_official_email_field: 'Email adres',
         users_form_phone_field: 'Telefoonnummer',
         users_form_official_phone_number_field: 'Telefoonnummer',
         users_form_password_field: 'Wachtwoord',
         users_form_role_id_field: 'Rol',
         users_form_select_role_id_field: 'Selecteer rol',
         users_form_street_number_field: 'Straat',
         users_form_house_number_field: 'Huisnummer',
         users_form_neighbourhood_field: 'Buurt',
         users_form_postal_code_field: 'Postcode',
         users_form_city_field: 'Stad',
         users_form_country_field: 'Land',
         users_form_email_verification_field: 'Email bevestiging',
         users_form_email_verification_sub_title_field:
           'Als u deze knop uitschakelt, wordt automatisch een bevestigingsmail naar de gebruiker verzonden',
         users_form_add_user_button: 'Gebruiker toevoegen',
         users_form_edit_user_button: 'Wijzigingen opslaan',
         users_form_cancel_button: 'Annuleer',
         users_form_submitting_user_button: 'Verwerken...',
         users_first_name_required_form_error: 'Voornaam is verplicht',
         users_last_name_required_form_error: 'Achternaam is verplicht',
         users_email_required_form_error: 'Email is verplicht',
         users_email_valid_form_error: 'Uw email adres is ongeldig',
         users_password_required_form_error: 'Wachtwoord is verplicht',
         users_country_required_form_error: 'Land is verplicht',
         users_role_id_required_form_error: 'Rol is verplicht',
         users_password_form_error:
           'Wachtwoord moet minimaal 8 tekens bevatten met tenminste één hoofdletter, één cijfer en één speciaal teken',
         users_add_form_success: 'Gebruiker is succesvol aangemaakt!',
         users_edit_form_success: 'Gebruiker is succesvol gewijzigd!',
         users_form_api_error: 'Internal Gebruikers - API Server Error',
         users_form_email_error: 'Email adres bestaat al',
         users_no_record_found: 'Geen gebruikers gevonden',
         user_deactivated_message: 'Gebruiker is succesvol gedeactiveerd',
         user_activated_message: 'Gebruiker is succesvol geactiveerd',
         user_email_verified_title: 'Email adres bevestigd',
         user_email_verified_sub_title:
           'Als u deze knop uitschakelt, wordt automatisch een bevestigingsmail naar de gebruiker verzonden',
         users_bulk_no_user_is_selected_error_message:
           'Selecteer gebruiker(s) om te deactiveren',
         users_bulk_deactivated_message:
           '{{ USERS_COUNT }} Gebruikers zijn succesvol gedeactiveerd',
         /** Projecten */
         projecten: 'Projecten',
         projects_all: 'ALLE',
         projects_active: 'ACTIEF',
         projects_inactive: 'INACTIEF',
         projects_unassigned: 'NIET TOEGEWEZEN',
         projects_add_new: 'Nieuw project',
         projects_filter_search: 'Project zoeken',
         projects_sort_by_filter_label: 'Sorteren op',
         projects_sort_by_value_1: 'Datum (nieuwste)',
         projects_sort_by_value_2: 'Datum (oudste)',
         projects_sort_by_value_3: 'Alfabetisch',
         projects_country_filter_label: 'Land',
         projects_filter_reset_button: 'Herstel',
         projects_filter_delete_button: 'Verwijderen',
         projects_table_name: 'Naam project',
         projects_table_batch_number: 'Batchnummer',
         projects_table_client: 'Toegewezen klant',
         projects_table_devices: 'Devices',
         projects_table_added: 'Toegevoegd op',
         projects_table_status: 'Status',
         projects_table_row_per_page: 'Resultaten per pagina',
         projects_bread_crumb_main_title: 'Projecten',
         add_projects_bread_crumb_first_link: 'Project toevoegen',
         add_projects_form_header: 'Project toevoegen',
         edit_projects_bread_crumb_first_link: 'Project wijzigen',
         edit_projects_form_header: 'Project wijzigen',
         projects_form_project_name_field: 'Projectnaam',
         projects_form_email_field: 'Email adres',
         projects_form_client_field: 'Klant',
         projects_form_service_client_field: 'Service klant',
         projects_form_user_field: 'Gebruiker',
         projects_form_description_field: 'Omschrijving (optioneel)',
         projects_form_add_project_button: 'Project opslaan',
         projects_form_edit_project_button: 'Wijzigingen opslaan',
         projects_form_cancel_button: 'Annuleer',
         projects_form_submitting_service_client_button: 'Verwerken...',
         projects_name_required_form_error: 'Naam is verplicht',
         projects_form_unqiue_project_order_number_error:
           'Project Order Number moet uniek zijn',
         projects_batch_number_required_form_error: 'Batch nummer is verplicht',
         projects_client_required_form_error: 'Klant is verplicht',
         projects_description_required_form_error: 'Omschrijving is verplicht',
         projects_add_form_success: 'Project is succesvol aangemaakt!',
         projects_edit_form_success: 'Project is succesvol gewijzigd!',
         projects_form_api_error: 'Internal projecten - API Server Error',
         projects_no_record_found: 'Geen projecten gevonden',
         projects_deactivated_message: 'Project is succesvol gedeactiveerd',
         projects_activated_message: 'Project is succesvol geactiveerd',
         projects_bulk_no_user_is_selected_error_message:
           'Selecteer project(en) om te deactiveren',
         projects_bulk_deactivated_message:
           '{{ USERS_COUNT }} Project(en) zijn succesvol gedeactiveerd',
         projects_single_stats_table_title: 'Status',
         /** Devices */
         devices_form_header: 'Device overzicht',
         devices_all: 'ALLE',
         devices_active: 'Online',
         devices_inactive: 'Offline',
         devices_error: 'ALARM',
         devices_register_enabled: 'Ingeschakeld',
         devices_register_disabled: 'Uitgeschakeld',
         devices_add_new: 'Nieuw Device',
         devices_name: 'Naam',
         devices_address: 'Installatie adres',
         devices_description: 'Type afleverset',
         devices_client: 'Klant',
         devices_project: 'Project',
         devices_status: 'Status',
         device_is_online: 'Device is "online"',
         device_is_offline: 'Device is "offline"',
         devices_last_viewed: 'Laatste bericht',
         devices_action: 'Actie',
         devices_search: 'Zoeken',
         devices_row_per_page: 'Resultaten per pagina',
         device_rssi_title: 'RSSI',
         device_status_reg_105_no_error_255: 'Geen storing',
         devices_filter_search: 'Device zoeken',
         devices_sort_by_filter_label: 'Sorteren op',
         devices_sort_by_value_1: 'Datum (nieuwste)',
         devices_sort_by_value_2: 'Datum (oudste)',
         devices_sort_by_value_3: 'Alfabetisch',
         devices_country_filter_label: 'Land',
         devices_filter_reset_button: 'Herstel',
         devices_filter_delete_button: 'Verwijderen',
         devices_table_name: 'Naam',
         devices_table_firmware: 'Firmware',
         devices_table_device_type: 'Device type',
         devices_table_batch_number: 'Batch nummer',
         devices_table_client: 'Klanten',
         devices_table_devices: 'Devices',
         devices_table_added: 'Toegevoegd',
         devices_table_status: 'Status',
         devices_table_row_per_page: 'Resultaten per pagina',
         devices_bread_crumb_main_title: 'Devices',
         add_devices_bread_crumb_first_link: 'Device toevoegen',
         add_devices_form_header: 'Device toevoegen',
         edit_devices_bread_crumb_first_link: 'Device wijzigen',
         edit_devices_form_header: 'Device wijzigen',
         devices_form_device_information_tab: 'Device info',
         devices_form_name_field: 'Device naam',
         devices_form_type_field: 'Device type',
         devices_form_ip_address_field: 'IP Adres',
         devices_form_preset_field: 'Preset',
         devices_form_project_field: 'Project',
         devices_form_project_offboarding_error: 'The selected project is currently being offboarded:',
         devices_form_client_field: 'Klant',
         devices_form_batch_number_field: 'Batch nummer',
         devices_form_serial_number_field: 'Serienummer Mercurius',
         devices_form_box_serial_number_field: 'Serienummer afleverset',
         devices_form_firmware_field: 'Firmwareversie',
         devices_form_description_field: 'Type afleverset',
         devices_form_device_address_tab: 'Installatie adres',
         devices_form_street_number_field: 'Straat',
         devices_form_house_number_field: 'Huisnummer',
         devices_form_postal_code_field: 'Postcode',
         devices_form_neighbourhood_field: 'Extra informatie',
         devices_form_city_field: 'Stad',
         devices_form_country_field: 'Land',
         devices_form_floor_number_field: 'Verdieping',
         devices_form_building_number_field: 'Bouwnummer',
         devices_form_additional_information_tab: 'Extra informatie',
         devices_form_sn_heat_unit_field: 'Serienummer afleverset',
         devices_form_article_number_field: 'Artikelnummer afleverset',
         devices_form_prod_order_nr_week_field: 'Productie order nummer',
         devices_form_serial_number_mercurius_field: 'Serienummer Mercurius',
         devices_form_sim_card_number_field: 'Simkaart nummer',
         devices_form_customer_ref_field: 'Referentie klant',
         devices_form_production_date_field: 'Productiedatum',
         devices_form_order_number_field: 'Ordernummer',
         devices_form_product_number_field: 'Artikelnummer',
         devices_form_model_number_field: 'Model nummer',
         devices_form_note_field: 'Notitie (optioneel)',
         devices_form_settings_tab: 'Instellingen',
         devices_form_device_interval_field: 'Interval',
         devices_form_is_device_enabled_sensor_field: 'Inschakelen sensor data',
         devices_form_is_device_activated_field: 'Deactiveer Device',
         devices_form_mbus_tab: 'M-Bus',
         devices_form_is_device_enabled_heat_meter_field:
           'Inschakelen warmtemeter',
         devices_form_is_device_enabled_cool_meter_field:
           'Inschakelen koudemeter',
         devices_form_is_device_enabled_electric_meter_field:
           'Inschakelen elektriciteitsmeter',
         devices_form_is_device_enabled_bi_directional_meter_field:
           'Inschakelen warmte/koudemeter',
         devices_form_is_device_enabled_water_meter_field:
           'Inschakelen watermeter',
         devices_form_is_device_enabled_mbus_search_meter_button: 'Zoek Meters',
         devices_form_add_device_button: 'Device toevoegen',
         devices_form_edit_device_button: 'Wijzigingen opslaan',
         devices_form_cancel_button: 'Annuleer',
         devices_form_submitting_service_client_button: 'Verwerken...',
         devices_name_required_form_error: 'Naam is verplicht',
         devices_batch_number_required_form_error: 'Batch number is verplicht',
         devices_serial_number_required_form_error: 'Serienummer is verplicht',
         devices_sn_heat_number_numeric_form_error:
           'Serienummer van de afleverset moet een nummer zijn',
         devices_article_number_form_error: 'Artikelnummer is verplicht',
         devices_prod_order_nr_week_form_error:
           'Productie order nummer is verplicht',
         devices_serial_number_mercurius_form_error:
           'Serienummer Mercurius is verplicht',
         devices_sim_card_number_form_error: 'Simkaart nummer is verplicht',
         devices_device_interval_numeric_form_error:
           'Interval moet een getal zijn',
         devices_client_required_form_error: 'Klant is verplicht',
         devices_project_required_form_error: 'Project is verplicht',
         devices_preset_required_form_error: 'Preset is verplicht',
         devices_description_required_form_error: 'Omschrijving is verplicht',
         devices_add_form_success: 'Device is succesvol aangemaakt!',
         devices_edit_form_success: 'Device is succesvol gewijzigd!',
         devices_form_unique_error:
           'Serienummer afleverset en serienummer Mercurius moeten uniek zijn',
         devices_form_api_error: 'Internal devices - API Server Error',
         devices_no_record_found: 'Geen devices gevonden',
         substations_no_record_found: 'Geen substations gevonden',
         devices_deactivated_message: 'Device is succesvol gedeactiveerd',
         devices_activated_message: 'Device is succesvol geactiveerd',
         devices_search_mbus_registers_success:
           'Het bericht is succesvol naar het apparaat verzonden.',
         devices_search_mbus_registers_missing_serial_number_error:
           'Vul het serienummer in om verder te gaan.',
         devices_bulk_no_user_is_selected_error_message:
           'Selecteer gebruikers om te deactiveren',
         devices_bulk_deactivated_message:
           '{{ USERS_COUNT }} Devices zijn succesvol gedeactiveerd',
         // Devices Single
         device_single_page_title: 'Device details',
         devices_single_bread_crumb_main_title: 'Device overzicht',
         devices_single_bread_crumb_first_link: 'Devicepagina',
         devices_single_basic_details_client: 'KLANT',
         devices_single_basic_details_serial_number: 'SERIENUMMER MERCURIUS',
         devices_single_basic_details_firmware: 'FIRMWARE',
         devices_single_basic_details_type: 'Device TYPE',
         devices_single_edit_device_button: 'Device wijzigen',
         device_single_error_status: 'Error',
         device_single_online_status: 'Online',
         device_single_offline_status: 'Offline',
         device_single_rss_device_status: 'Device status',
         device_single_rss_signal_strength: 'Signaal sterkte',
         device_single_temperature_tab: 'Historie',
         device_single_temperature_title:
           'De historische data van de afleverset',
         device_single_temperature_hr: 'uur',
         device_single_registers_tab: 'Registers',
         device_single_event_tab: 'Events',
         device_single_device_details_tab: 'Info',
         device_single_device_api_timer_seconds_label: 'Seconden',
         device_single_device_api_timer_minute_label: 'Minuut',
         device_single_device_api_timer_minutes_label: 'Minuten',
         device_single_recall_device_status_api_timer_field: 'API Interval',
         devices_single_last_seen: 'Laatste bericht',
         devices_single_fetch_registers: 'VERNIEUW DATA',
         device_fetch_registers_success:
           'Het verzoek is succesvol verzonden naar het Device.',
         write_registers_success:
           'Schrijfbericht is succesvol verzonden naar Device.',
         write_registers_error: 'Wijzig de waarde om door te gaan.',
         fetch_registers_m_bus_meters_not_supported:
           'Meters worden momenteel niet herkend. Controleer de aansluiting en/of de M-Bus module van de energiemeter.',
         // Operating Status
         business_situation_operating_status_TR03_title:
           'Bedrijfsstatus afleverset',
         device_status_nr: 'NR',
         device_status_name: 'Naam',
         device_status_value: 'Waarde',
         business_situation_operating_status_TR03_100: 'Verwarming status',
         business_situation_operating_status_TR03_100_list: JSON.stringify({
           list: {
             0: 'Stand-by',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na circulatie',
             4: 'Uit',
             5: 'Voor circulatie',
           },
         }),
         business_situation_operating_status_TR03_101: 'Tapwater status',
         business_situation_operating_status_TR03_101_list: JSON.stringify({
           list: {
             0: 'Stand-by',
             1: 'Verzoek (tijdelijk onderbroken)',
             2: 'Vraag',
             3: 'Na circuleren',
             4: 'Uit',
           },
         }),
         business_situation_operating_status_TR03_102: 'Warmhoud status',
         business_situation_operating_status_TR03_102_list: JSON.stringify({
           list: {
             0: 'Stand-by',
             1: 'Actief',
           },
         }),
         business_situation_operating_status_TR03_103: 'Anti Legionella status',
         business_situation_operating_status_TR03_103_list: JSON.stringify({
           list: {
             0: 'Stand-by',
             1: 'Verzoek (tijdelijk onderbroken)',
             2: 'Vraag',
             3: 'Na circuleren',
             4: 'Uit',
           },
         }),
         business_situation_operating_status_TR03_104: 'Koelen status',
         business_situation_operating_status_TR03_104_list: JSON.stringify({
           list: {
             0: 'Stand-by',
             1: 'Verzoek (tijdelijk onderbroken)',
             2: 'Initialiseren',
             3: 'Vraag',
             4: 'Na circulatie',
             5: 'Voor circulatie',
           },
         }),
         business_situation_operating_status_TR03_1802: 'Elektrisch element',
         business_situation_operating_status_TR03_1802_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         business_situation_operating_status_TR03_105: 'Storingscode',
         business_situation_operating_status_TR03_106: 'Software versie',
         business_situation_operating_status_TR03_107:
           'Tapwater regelafsluiter (M1)',
         business_situation_operating_status_TR03_108:
           'Verwarmen/koelen regelafsluiter (M2)',
         business_situation_operating_status_TR03_109: 'Circulatie pomp',
         business_situation_operating_status_TR03_109_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Circuleren',
           },
         }),
         business_situation_operating_status_TR03_110: '6-weg kogelafsluiter',
         business_situation_operating_status_TR03_110_list: JSON.stringify({
           list: {
             0: 'Stand: Verwarmen',
             1: 'Stand: Koelen',
           },
         }),
         business_situation_operating_status_TR03_112_list: JSON.stringify({
           list: {
             0: 'Verwarmen of vraag',
             1: 'Koelen',
           },
         }),
         business_situation_operating_status_TR03_113: 'Ruimte thermostaat',
         business_situation_operating_status_TR03_113_list: JSON.stringify({
           list: {
             1: 'Geen warmte vraag',
             2: 'Warmte vraag',
           },
         }),
         business_situation_operating_status_TR03_114: 'OpenTherm Indicatie',
         business_situation_operating_status_TR03_114_list: JSON.stringify({
           list: {
             0: 'Inactieve verbinding',
             1: 'Actieve verbinding',
           },
         }),
         business_situation_operating_status_TR03_115: 'Toesteltype',
         // Business situation
         business_situation_measured_values_TR03_title: 'Meetwaarden',
         business_situation_measured_values_TR03_200: 'Volumestroom tapwater',
         business_situation_measured_values_TR03_201: 'T-Tapwater',
         business_situation_measured_values_TR03_202: 'T-Primaire aanvoer',
         business_situation_measured_values_TR03_203:
           'T-Primaire retour (T-Booster voor TE-Booster toestellen)',
         business_situation_measured_values_TR03_205: 'T-Secundaire aanvoer',
         business_situation_measured_values_TR03_206: 'T-Secundaire retour',
         business_situation_measured_values_TR03_204:
           'Berekende aanvoertemperatuur (setpoint)',
         business_situation_measured_values_TR03_207:
           'Ruimte temperatuur(OpenTherm)',
         business_situation_measured_values_TR03_208:
           'Ruimte setpoint (OpenTherm)',
         business_situation_measured_values_TR03_210:
           'Waterdruk in de binnenhuisinstallatie',
         business_situation_measured_values_TR03_263: '% pomp vermogen',
         // Operating time
         business_situation_operating_time_TR03_title: 'Bedrijfstijden',
         business_situation_operating_time_TR03_800:
           'Totale bedrijfstijd afleverset',
         business_situation_operating_time_TR03_801:
           'Totale bedrijfstijd warmte-vraag',
         business_situation_operating_time_TR03_802:
           'Totale bedrijfstijd koude-vraag',
         business_situation_operating_time_TR03_803:
           'Totale bedrijfstijd tapwater-vraag',
         business_situation_operating_time_TR03_804: 'Aantal tappingen',
         business_situation_operating_time_TR03_805:
           'Totale volume tapwater (let op! dit is een indicatie)',
         business_situation_operating_time_TR03_806: 'Stroomonderbrekingen',
         // Warmtapwater
         settings_dhw_warm_tap_water_TR03_title: 'Instellingen tapwater',
         settings_dhw_warm_tap_water_TR03_300: 'Tapwater setpoint',
         settings_dhw_warm_tap_water_TR03_301: 'Warmhoudmodus',
         settings_dhw_warm_tap_water_TR03_301_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Anti-vries programma',
             2: 'Eco programma',
             3: 'Comfort programma',
             4: 'Dynamisch (aanbevolen)',
           },
         }),
         settings_dhw_warm_tap_water_TR03_302:
           'Warmhoudsetpoint (comfort stand)',
         settings_dhw_warm_tap_water_TR03_303: 'Tapdrempel',
         settings_dhw_warm_tap_water_TR03_304: 'Tapwater inschakelen',
         settings_dhw_warm_tap_water_TR03_304_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         // Thermal disinfection
         settings_thermal_disinfection_TR03_title:
           'Instellingen anti-legionella',
         settings_thermal_disinfection_TR03_400:
           'Anti-Legionella ingeschakeling',
         settings_thermal_disinfection_TR03_400_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_thermal_disinfection_TR03_401: 'Anti-Legionella setpoint',
         settings_thermal_disinfection_TR03_402: 'Anti-Legionella brandtijd',
         settings_thermal_disinfection_TR03_403: 'Anti-Legionella wachttijd',
         // TE-Booster
         settings_dhw_te_booster_TR03_title: 'Instellingen TE-Booster',
         settings_dhw_te_booster_TR03_1800: 'TE-Booster',
         settings_dhw_te_booster_TR03_1800_list: JSON.stringify({
           list: {
             0: 'Uitgeschakeld',
             1: 'Ingeschakeld',
           },
         }),
         settings_dhw_te_booster_TR03_1804: 'TE-Booster setpoint',
         settings_dhw_te_booster_TR03_1805: 'TE-Booster setpoint hysterese',
         settings_dhw_te_booster_TR03_1812: 'TE-Booster setpoint timeout',
         settings_dhw_te_booster_TR03_1813: 'TE-Booster setpoint timer',
         settings_dhw_te_booster_TR03_1815: 'TE-Booster activatie drempel',
         settings_dhw_te_booster_TR03_1816: 'TE-Booster getapt volume',
         // Heating
         heating_and_cooling_settings_heating_TR03_title:
           'Instellingen verwarmen',
         heating_and_cooling_settings_heating_TR03_500:
           'Maximale setpoint verwarmen',
         heating_and_cooling_settings_heating_TR03_501:
           'Minimale setpoint verwarmen',
         heating_and_cooling_settings_heating_TR03_506:
           'Maximale retourtemperatuur verwarmen',
         heating_and_cooling_settings_heating_TR03_507:
           'Compensatie factor van de primaire retour',
         heating_and_cooling_settings_heating_TR03_508:
           'Delta primaire-secondary setpoint',
         heating_and_cooling_settings_heating_TR03_510:
           'Maximaalbeveiliging verwarmen',
         heating_and_cooling_settings_heating_TR03_509:
           'Minimum primaire-secundaire delta',
         heating_and_cooling_settings_heating_TR03_514: 'Verwarmen setpoint',
         heating_and_cooling_settings_heating_TR03_515: 'Verwarmen inschakelen',
         heating_and_cooling_settings_heating_TR03_515_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'aan',
           },
         }),
         // Cooling
         heating_and_cooling_settings_cooling_TR03_title: 'Instellingen koelen',
         heating_and_cooling_settings_cooling_TR03_600: 'Koelen setpoint',
         heating_and_cooling_settings_cooling_TR03_601:
           'Minimale primaire retour',
         heating_and_cooling_settings_cooling_TR03_602:
           'Compensatiefactor van de primaire retour',
         heating_and_cooling_settings_cooling_TR03_605:
           'Maximaalbeveiliging koelen',
         heating_and_cooling_settings_cooling_TR03_606:
           'Minimale setpoint koelen',
         heating_and_cooling_settings_cooling_TR03_607:
           'Maximale setpoint koelen',
         heating_and_cooling_settings_cooling_TR03_611: 'Koelen inschakelen',
         heating_and_cooling_settings_cooling_TR03_611_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         // Secundaire General
         heating_and_cooling_settings_secondary_general_TR03_title:
           'Algemene instellingen',
         heating_and_cooling_settings_secondary_general_TR03_512:
           'Minimale druk',
         heating_and_cooling_settings_secondary_general_TR03_513:
           'Maximale druk',
         heating_and_cooling_settings_secondary_general_TR03_603:
           'Wachttijd omschakelen verwarmen-koelen',
         heating_and_cooling_settings_secondary_general_TR03_604:
           '6-weg kogelkraan wachttijd',
         // Changeover WKW
         heating_and_cooling_settings_changeover_wkw_TR03_title:
           'Instellingen 3.5 pijps systeem',
         heating_and_cooling_settings_changeover_wkw_TR03_1850:
           '3.5 pijps configuratie',
         heating_and_cooling_settings_changeover_wkw_TR03_1850_list: JSON.stringify(
           {
             list: {
               0: 'Verwarmen',
               1: 'Koelen',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1851:
           'Koeling detectie drempel',
         heating_and_cooling_settings_changeover_wkw_TR03_1852:
           'Verwarming detectie drempel',
         heating_and_cooling_settings_changeover_wkw_TR03_1853:
           'Verwarming verlaagd setpoint',
         heating_and_cooling_settings_changeover_wkw_TR03_1854:
           'Verlaagd setpoint gebruikt',
         heating_and_cooling_settings_changeover_wkw_TR03_1854_list: JSON.stringify(
           {
             list: {
               0: 'Uit',
               1: 'Aan',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1855:
           'Predetectie M2 positie',
         heating_and_cooling_settings_changeover_wkw_TR03_1856:
           'Detectie interval',
         heating_and_cooling_settings_changeover_wkw_TR03_1857:
           'Detectie interval timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1858:
           'Predetectie timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1859:
           'Predetectie timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1860:
           'Configuratie switch timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1861:
           'Switch timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1862:
           'Configuratie switch drempel',
         heating_and_cooling_settings_changeover_wkw_TR03_1863:
           'Boost functie modus',
         heating_and_cooling_settings_changeover_wkw_TR03_1863_list: JSON.stringify(
           {
             list: {
               0: 'Uitgeschakeld',
               1: 'Ingeschakeld',
             },
           },
         ),
         heating_and_cooling_settings_changeover_wkw_TR03_1864:
           'Boost detectie timer',
         heating_and_cooling_settings_changeover_wkw_TR03_1865:
           'Boost detectie timeout',
         heating_and_cooling_settings_changeover_wkw_TR03_1866:
           'Maximum boost positie',
         // Manual Operation
         settings_manual_operation_TR03_title: 'Handbediening',
         settings_manual_operation_TR03_700: 'Handbediening inschakelen',
         settings_manual_operation_TR03_700_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_manual_operation_TR03_701:
           'Tapwater regelafsluiter bedienen (M1)',
         settings_manual_operation_TR03_702:
           'Verwarmen/koelen regelafsluiter bedienen (M2)',
         settings_manual_operation_TR03_703: 'Pomp',
         settings_manual_operation_TR03_703_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_manual_operation_TR03_704: '6-weg kogelafsluiter',
         settings_manual_operation_TR03_704_list: JSON.stringify({
           list: {
             0: 'Stand: Verwarmen',
             1: 'Stand: Koelen',
           },
         }),
         settings_manual_operation_TR03_706: 'Verwarmingsvraag status output',
         settings_manual_operation_TR03_706_list: JSON.stringify({
           list: {
             0: 'Verwarming or vraag',
             1: 'Koeling',
           },
         }),
         settings_manual_operation_TR03_707:
           'Tapwater regelafsluiter bedienen (M1)[%]',
         settings_manual_operation_TR03_708:
           'Verwarmen/koelen regelafsluiter bedienen (M2)[%]',
         settings_manual_operation_TR03_1801: 'Elektisch element TE-Booster',
         settings_manual_operation_TR03_1801_list: JSON.stringify({
           list: {
             0: 'Uitgeschakeld',
             1: 'Ingeschakeld',
           },
         }),
         settings_manual_operation_TR03_709: 'Handbediening uitstellen',
         // Live Tap Water
         live_tap_water_title: 'Livelog tapwater',
         live_tap_water_101: 'Tapwater status',
         live_tap_water_107: 'Tapwater regelafsluiter (M1)',
         live_tap_water_200: 'Tapwater volumestroom',
         live_tap_water_201: 'T-Tapwater',
         live_tap_water_202: 'T-Primaire aanvoer',
         live_tap_water_203: 'T-Primaire retour',
         live_tap_water_1007: 'Primaire flow energiemeter',
         live_tap_water_1008: 'Actuele vermogen',
         // Live CV
         live_cv_title: 'Livelog verwarmen',
         live_cv_100: 'Verwarmen status',
         live_cv_108: 'Verwarmen/koelen regelafsluiter (M2)',
         live_cv_202: 'T-Primaire aanvoer',
         live_cv_203: 'T-Primaire retour',
         live_cv_204: 'Berekende aanvoertemperatuur (setpoint)',
         live_cv_205: 'T-Secundaire aanvoer',
         live_cv_206: 'T-Secundaire retour',
         live_cv_113: 'Ruimtethermostaat contact',
         live_cv_210: 'Waterdruk in de binnenhuisinstallatie',
         live_cv_1007: 'Primaire flow energiemeter',
         live_cv_1008: 'Actuele vermogen',
         // Live Cooling
         live_cooling_title: 'Livelog koelen',
         live_cooling_104: 'Koelen status',
         live_cooling_109: 'Pomp',
         live_cooling_110: '6-weg kogelafsluiter',
         live_cooling_113: 'Ruimtethermostaat contact',
         live_cooling_108: 'Verwarmen/koelen regelafsluiter (M2)',
         live_cooling_202: 'T-Primaire aanvoer',
         live_cooling_204: 'Berekende aanvoertemperatuur (setpoint)',
         live_cooling_205: 'T-Secundaire aanvoer',
         live_cooling_206: 'T-Secundaire retour',
         // M Bus Limiet
         m_bus_limit_title: 'M-Bus Limiet',
         m_bus_limit_1500: 'Begrenzing inschakelen',
         m_bus_limit_1501: 'Serienummer begrenzing meter',
         m_bus_limit_1503: 'Begrens status',
         m_bus_limit_1504: 'Begrenzing configuratie Tapwater (h) en CV (l)',
         m_bus_limit_1505: 'Begrens vermogen',
         m_bus_limit_1506: 'Begrens flow',
         m_bus_limit_1507: 'Begrens retour temperatuur (Alleen voor CV)',
         // Meter 1
         m_bus_meter_1_title: 'Meter 1 (Warmte)',
         m_bus_meter_1_0000: 'Serienummer',
         m_bus_meter_1_0002: 'Fabrikant',
         m_bus_meter_1_0003: 'Meter Type',
         m_bus_meter_1_0004: 'Status',
         m_bus_meter_1_0005: 'Volumestroom',
         m_bus_meter_1_0006: 'Vermogen',
         m_bus_meter_1_0007: 'Aanvoertemperatuur',
         m_bus_meter_1_0008: 'Retourtemperatuur',
         m_bus_meter_1_0010: 'Totale energieverbruik',
         m_bus_meter_1_0012: 'Totale volume',
         // Meter 2
         m_bus_meter_2_title: 'Meter 2 (Koude)',
         m_bus_meter_2_0100: 'Serienummer',
         m_bus_meter_2_0102: 'Fabrikant',
         m_bus_meter_2_0103: 'Meter Type',
         m_bus_meter_2_0104: 'Status',
         m_bus_meter_2_0105: 'Volumestroom',
         m_bus_meter_2_0106: 'Vermogen',
         m_bus_meter_2_0107: 'Aanvoertemperatuur',
         m_bus_meter_2_0108: 'Retourtemperatuur',
         m_bus_meter_2_0110: 'Totale energieverbruik',
         m_bus_meter_2_0112: 'Totaal volume',
         // Meter 3
         m_bus_meter_3_title: 'Meter 3 (Elektriciteit)',
         m_bus_meter_3_0200: 'Serienummer',
         m_bus_meter_3_0202: 'Fabrikant',
         m_bus_meter_3_0203: 'Meter Type',
         m_bus_meter_3_0204: 'Status',
         m_bus_meter_3_0206: 'Power',
         m_bus_meter_3_0210: 'Energy',
         m_bus_meter_3_0214: 'Current',
         // Meter 4
         m_bus_meter_4_title: 'Meter 4 (Water)',
         m_bus_meter_4_0300: 'Serienummer',
         m_bus_meter_4_0302: 'Fabrikant',
         m_bus_meter_4_0303: 'Meter Type',
         m_bus_meter_4_0304: 'Status',
         m_bus_meter_4_0305: 'Volumestroom',
         m_bus_meter_4_0307: 'Aanvoertemperatuur',
         m_bus_meter_4_0312: 'Totaal volume',
         // Meter 5
         m_bus_meter_5_title: 'Meter 5 (Warmte/koude)',
         m_bus_meter_5_0400: 'Serienummer',
         m_bus_meter_5_0402: 'Fabrikant',
         m_bus_meter_5_0403: 'Meter Type',
         m_bus_meter_5_0404: 'Status',
         m_bus_meter_5_0405: 'Volumestroom',
         m_bus_meter_5_0406: 'Vermogen',
         m_bus_meter_5_0407: 'Aanvoertemperatuur',
         m_bus_meter_5_0408: 'Retourtemperatuur',
         m_bus_meter_5_0410: 'Totale energieverbruik (warmte)',
         m_bus_meter_5_0412: 'Volume',
         m_bus_meter_5_0414: 'Totale energieverbruik (koude)',
         // Geschiedenis Block Errors
         history_block_errors_title: 'Geschiedenis van block-errors',
         history_block_errors_860: 'Block Error 1',
         history_block_errors_861: 'Block Error 2',
         history_block_errors_862: 'Block Error 3',
         history_block_errors_863: 'Block Error 4',
         history_block_errors_864: 'Block Error 5',
         history_block_errors_865: 'Block Error 6',
         history_block_errors_866: 'Block Error 7',
         history_block_errors_867: 'Block Error 8',
         history_block_errors_868: 'Block Error 9',
         history_block_errors_869: 'Block Error 10',
         history_block_errors_870: 'Block Error 11',
         history_block_errors_871: 'Block Error 12',
         history_block_errors_872: 'Block Error 13',
         history_block_errors_873: 'Block Error 14',
         history_block_errors_874: 'Block Error 15',
         // Events
         device_events_type_filter_label: 'Event Type',
         device_events_type_filter_value_1: 'Audit',
         device_events_type_filter_value_2: 'Storing',
         // Presets
         presets: 'Presets',
         presets_all: 'ALLE',
         presets_active: 'ACTIEF',
         presets_inactive: 'INACTIEF',
         presets_add_new: 'Toevoegen',
         presets_filter_search: 'Zoeken',
         presets_filter_reset_button: 'Herstel',
         presets_filter_delete_button: 'Verwijderen',
         presets_table_name: 'Naam',
         presets_table_status: 'Status',
         presets_updated_date: 'Gewijzigd op',
         presets_action: 'Actions',
         presets_table_row_per_page: 'Resultaten per pagina',
         presets_status_menu_list: JSON.stringify([
           {
             key: 'settings_hot_water',
             value: 'Instellingen tapwater',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Instellingen verwarmen en koelen',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Handbediening',
             permission: 'manual-control-tab-read',
           },
         ]),
         add_presets_title: 'Preset toevoegen',
         edit_presets_title: 'Preset wijzigen',
         presets_form_name_required: 'Naam van de preset is verplicht',
         presets_form_register_required: 'Register waarde is verplicht',
         presets_form_add_preset_button: 'Wijzigingen opslaan',
         presets_form_edit_preset_button: 'Wijzigingen opslaan',
         presets_form_cancel_button: 'Annuleer',
         presets_add_form_success: 'Preset is succesvol aangemaakt!',
         presets_edit_form_success: 'Preset is succesvol gewijzigd!',
         presets_form_api_error: 'Internal Server Error',
         presets_no_record_found: 'Geen presets gevonden',
         presets_deactivated_message: 'Preset is succesvol gedeactiveerd',
         presets_activated_message: 'Preset is succesvol geactiveerd',
         presets_bulk_no_user_is_selected_error_message:
           'Selecteer preset(s) om te deactiveren',
         presets_bulk_deactivated_message:
           '{{ USERS_COUNT }} Preset(s) zijn succesvol gedeactiveerd',
         // Audits
         audits: 'Logboek handelingen',
         audits_all: 'Alle',
         audits_active: 'Audit',
         audits_inactive: 'Storingen',
         audits_filter_search: 'Zoeken',
         audits_client_filter_label: 'Klant',
         audits_error_code_filter_label: 'Storing',
         audits_project_filter_label: 'Project',
         audits_order_number_filter_label: 'Ordernummer',
         audits_events_type_filter_label: 'Event Type',
         audits_date_range_filter_label: 'Bereik',
         audits_events_type_filter_value_1: 'Audit',
         audits_events_type_filter_value_2: 'Storing',
         audits_reset_filters_button: 'Herstel',
         audits_date: 'Datum',
         audits_device: 'Device',
         audits_client: 'Klant',
         audits_message: 'Bericht',
         audits_table_row_per_page: 'Resultaten per pagina',
         audits_table_no_record_found: 'Geen devices gevonden',
         // Instellingen
         settings_update_profile_title: 'Wijzig profiel',
         settings_notification_title: 'Berichten',
         settings_notification_window_exceptions_title:
           'Stuur bericht bij windows uitzondering',
         settings_notification_device_error_title: 'Actieve Storingen email',
         settings_notification_channels_title: 'Meldingsmogelijkheden',
         settings_notification_use_email_title: 'Email',
         /* Admins */
         admins: 'Admins',
         admins_first_bread_crumb: 'Fortes administrators',
         admins_filter_search: 'Administrator zoeken',
         admins_add_new: 'Adminstrator toevoegen',
         admins_filter_reset_button: 'Herstel',
         admins_filter_delete_button: 'Deactiveren',
         admins_search: 'Zoeken',
         admins_all: 'ALLE',
         admins_active: 'ACTIEF',
         admins_inactive: 'INACTIEF',
         admins_table_name: 'Naam',
         admins_table_address: 'Adres',
         admins_table_role_id: 'Rol',
         admins_table_status: 'Status',
         admins_table_added: 'Toegevoegd',
         admins_table_no_record_found: 'Geen gebruiker gevonden',
         admins_table_row_per_page: 'Resultaten per pagina',
         admins_no_user_selected_for_de_activation_message:
           'Selecteer records om te deactiveren',
         admins_bread_crumb_main_title: 'Admins',
         add_admins_bread_crumb_first_link: 'Admin toevoegen',
         add_admins_form_header: 'Admin toevoegen',
         edit_admins_bread_crumb_first_link: 'Admin wijzigen',
         edit_admins_form_header: 'Admin wijzigen',
         admins_form_first_name_field: 'Voornaam',
         admins_form_last_name_field: 'Achternaam',
         admins_form_email_field: 'Email adres',
         admins_form_official_email_field: 'Email adres',
         admins_form_phone_field: 'Telefoonnummer',
         admins_form_official_phone_number_field: 'Telefoon nummer',
         admins_form_password_field: 'Wachtwoord',
         admins_form_role_id_field: 'Rol',
         admins_form_select_role_id_field: 'Selecteer rol',
         admins_form_street_number_field: 'Straat',
         admins_form_house_number_field: 'Huisnummer',
         admins_form_neighbourhood_field: 'Neighbourhood',
         admins_form_postal_code_field: 'Postcode',
         admins_form_city_field: 'Stad',
         admins_form_country_field: 'Land',
         admins_form_email_verification_field: 'Email verificatie',
         admins_form_email_verification_sub_title_field:
           'Als u dit uitschakelt, wordt de beheerder automatisch een verificatie email gestuurd',
         admins_form_add_admin_button: 'Wijzigingen opslaan',
         admins_form_edit_admin_button: 'Wijzigingen opslaan',
         admins_form_cancel_button: 'Annuleer',
         admins_form_submitting_admin_button: 'Verzenden...',
         admins_first_name_required_form_error: 'Voornaam is verplicht',
         admins_last_name_required_form_error: 'Achternaam is verplicht',
         admins_email_required_form_error: 'Email is verplicht',
         admins_email_valid_form_error: '',
         admins_password_required_form_error: 'Wachtwoord is verplicht',
         admins_country_required_form_error: 'Land is verplicht',
         admins_role_id_required_form_error: 'Rol is verplicht',
         admins_password_form_error:
           'Wachtwoord moet minimaal 8 tekens bevatten met tenminste één hoofdletter, één cijfer en één speciaal teken.',
         admins_add_form_success: 'Administrator is succesvol aangemaakt!',
         admins_edit_form_success: 'Administrator is succesvol gewijzigd!',
         admins_form_api_error: 'Internal Server Error',
         admins_form_email_error: 'Email adres bestaat al',
         admins_no_record_found: 'Geen administrator gevonden',
         admins_deactivated_message: 'Admin is succesvol gedeactiveerd',
         admins_activated_message: 'Administrator is sucesvol geactiveerd',
         admins_email_verified_title: 'Email bevestigd',
         admins_email_verified_sub_title:
           'Als u dit uitschakelt, wordt de beheerder automatisch een verificatie-e-mail gestuurd',
         admins_bulk_no_admin_is_selected_error_message:
           'Selecteer records om te deactiveren',
         admins_bulk_deactivated_message:
           '{{ USERS_COUNT }} Admin(s) zijn succesvol gedeactiveerd',
         // Zoeken Results
         search_result_title: 'Zoek resultaten: ',
         search_users: 'Gebruikers',
         search_clients: 'Klanten',
         search_service_clients: 'Service klanten',
         search_devices: 'Devices',
         search_presets: 'Presets',
         search_projects: 'Projecten',
         // Nieuwe Locales
         no_error_devices_found: 'Geen devices met storingen gevonden!',
         project_single_first_bread_crumb: 'Projecten',
         project_single_second_bread_crumb: 'Project weergeven',
         project_single_client_label: 'Klant',
         project_single_service_client_label: 'Service klant',
         project_single_devices_label: 'Devices',
         project_single_edit_button: 'Wijzigen',
         project_single_devices_tab: 'Devices',
         client_single_view_more_errors_button: 'Toon meer',
         client_error_single_devices_tab: 'Devices in storing',
         client_error_single_device_name: 'Device',
         client_error_single_device_error_code: 'Storingscode',
         client_error_single_device_error_date_time: 'Datum',
         devices_bulk_edit_registers_button: 'Instelling(en) wijzigen',
         devices_bulk_edit_ota_button: 'Device(s) updaten',
         client_error_single_device_errors_table_row_per_page:
           'Resultaten per pagina',
         client_error_single_device_error_no_record_found:
           'Geen devices gevonden',
         devices_bulk_edit_registers_title: 'Device registers groepswijziging',
         substations_bulk_edit_registers_title: 'Substation registers groepswijziging',
         heat_pumps_bulk_edit_registers_title: 'Warmtepomp registers groepswijziging',
         devices_bulk_edit_registers_form_submit_button: 'Groepsupdate',
         devices_bulk_edit_registers_form_cancel_button: 'Annuleer',
         devices_bulk_edit_registers_form_success:
           'Bericht wordt doorgestuurd naar geselecteerde apparaat(en)',
         devices_bulk_edit_registers_form_error:
           'Gelieve ten minste één registerwaarde in te vullen',
         devices_bulk_edit_registers_form_api_error: 'Internal Server Error',
         devices_bulk_edit_ota_title: 'Device OTA groep Update',
         devices_bulk_edit_ota_form_firmware_field: 'Firmware',
         devices_bulk_edit_ota_form_submit_button: 'Groepsupdate',
         substations_bulk_edit_ota_form_submit_button: 'Substations updaten',
         heat_pumps_bulk_edit_ota_form_submit_button: 'Warmtepompen updaten',
         devices_bulk_edit_ota_form_cancel_button: 'Annuleer',
         devices_bulk_edit_ota_form_success:
           'Bericht wordt doorgestuurd naar geselecteerde apparaat(en)',
         devices_bulk_edit_ota_form_firmware_required_error:
           'Firmware is verplicht',
         devices_bulk_edit_ota_form_api_error: 'Internal Server Error',
         devices_bulk_edit_registers_selected_devices:
           'Apparaten geselecteerd voor groepsbewerking',
         // Device Status Table Pop Over
         custom_popover_min_value: 'Min waarde',
         custom_popover_max_value: 'Max waarde',
         custom_popover_list_options: 'Mogelijke waarden',
         custom_popover_short_description: 'Omschrijving',
         custom_popover_close_modal_button: 'Sluiten',
         // Warmtapwater PopOver Short Omschrijving
         custom_popover_300_short_description: 'Tapwater Setpoint',
         custom_popover_301_short_description: 'Preheat modus',
         custom_popover_302_short_description: 'Comfort Setpoint',
         custom_popover_303_short_description: 'Startdrempel voor debiet',
         custom_popover_304_short_description: 'Tapwater Ingeschakeld',
         // Thermal disinfection PopOver Short Omschrijving
         custom_popover_400_short_description: 'Aleg Ingeschakeld',
         custom_popover_401_short_description: 'Aleg Setpoint',
         custom_popover_402_short_description: 'Aleg Brandtijd',
         custom_popover_403_short_description: 'Aleg Wachttijd',
         // TE-Booster PopOver Short Omschrijving
         custom_popover_1800_short_description: 'TE-Booster Ingeschakeld',
         custom_popover_1804_short_description: 'TE-Booster Setpoint',
         custom_popover_1805_short_description:
           'TE-Booster Setpoint Hysteresis',
         custom_popover_1812_short_description: 'TE-Booster Setpoint Timeout',
         custom_popover_1813_short_description: 'TE-Booster Setpoint Timer',
         custom_popover_1815_short_description: 'TE-Booster Drempel',
         custom_popover_1816_short_description: 'TE-Booster Afgenomen Volume',
         // Heating PopOver Short Omschrijving
         custom_popover_500_short_description: 'CV Max Setpoint',
         custom_popover_501_short_description: 'CV Min Setpoint',
         custom_popover_506_short_description: 'Max Primaire Retour',
         custom_popover_507_short_description: 'Max Primaire Retour Percentage',
         custom_popover_508_short_description: 'Delta Prim CV Setpoint',
         custom_popover_510_short_description: 'Max Verwarmingstemperatuur',
         custom_popover_509_short_description: 'Delta Prim Min',
         custom_popover_514_short_description: 'CV Setpoint',
         custom_popover_515_short_description: 'CV Enable',
         // Cooling PopOver Short Omschrijving
         custom_popover_600_short_description: 'CoolTempSetpoint',
         custom_popover_601_short_description: 'Cool MaxPrimary Retour',
         custom_popover_602_short_description:
           'Cool % of Max Setpoint compensation',
         custom_popover_605_short_description: 'Max Cooling Temp',
         custom_popover_606_short_description: 'Cool setpoint min',
         custom_popover_607_short_description: 'Cool setpoint max',
         custom_popover_611_short_description: 'Cooling Enable',
         // Secundaire General PopOver Short Omschrijving
         custom_popover_512_short_description: 'CV Min Pressure',
         custom_popover_513_short_description: 'CV Max Pressure',
         custom_popover_603_short_description: 'CoolHeatWaitingTime',
         custom_popover_604_short_description: '6way valve waiting time',
         // Changeover WKW PopOver Short Omschrijving
         custom_popover_1850_short_description: '3.5Pipe Configuration',
         custom_popover_1851_short_description: 'Cooling detection threshold',
         custom_popover_1852_short_description: 'Heating detection threshold',
         custom_popover_1853_short_description: 'Heating lowered setpoint',
         custom_popover_1854_short_description: 'Lowered setpoint used',
         custom_popover_1855_short_description: 'Predetection MCV2 position',
         custom_popover_1856_short_description: 'Detection interval',
         custom_popover_1857_short_description: 'Detection interval timer',
         custom_popover_1858_short_description: 'Predetection timeout',
         custom_popover_1859_short_description: 'Predetection timer',
         custom_popover_1860_short_description: 'Configuration switch timer',
         custom_popover_1861_short_description: 'Switch timeout',
         custom_popover_1862_short_description:
           'Configuration switch threshold',
         custom_popover_1863_short_description: 'Boost function mode',
         custom_popover_1864_short_description: 'Boost detection timer',
         custom_popover_1865_short_description: 'Boost detection timeout',
         custom_popover_1866_short_description: 'Maximum boost position',
         // Manual Operation PopOver Short Omschrijving
         custom_popover_700_short_description: 'Manual Control ingeschakeld',
         custom_popover_701_short_description: 'MCV-1 Handbediening',
         custom_popover_702_short_description: 'MCV-2 Handbediening',
         custom_popover_703_short_description: 'Pump (P1) Handbediening',
         custom_popover_704_short_description: 'Valve1',
         custom_popover_706_short_description: 'Heat demand status output',
         custom_popover_707_short_description: 'MCV-1 Handbediening[%]',
         custom_popover_708_short_description: 'MCV-1 Handbediening[%]',
         custom_popover_1801_short_description: 'Elektrisch element TE-Booster',
         custom_popover_709_short_description: 'Handbediening timeout',
         // Warmtapwater PopOver Long Omschrijving
         custom_popover_300_long_description: 'Tapwater Setpoint',
         custom_popover_301_long_description: 'Preheat mode',
         custom_popover_302_long_description: 'Comfort Setpoint',
         custom_popover_303_long_description: 'Flow rate start threshold',
         custom_popover_304_long_description: 'Tapwater Enable',
         // Thermal disinfection PopOver Long Omschrijving
         custom_popover_400_long_description: 'Aleg Ingeschakeld',
         custom_popover_401_long_description: 'Aleg Setpoint',
         custom_popover_402_long_description: 'Aleg Burn Tijd',
         custom_popover_403_long_description: 'Aleg Wait Tijd',
         // TE-Booster PopOver Long Omschrijving
         custom_popover_1800_long_description: 'TE-Booster Ingeschakeld',
         custom_popover_1804_long_description: 'TE-Booster Setpoint',
         custom_popover_1805_long_description: 'TE-Booster Setpoint Hysteresis',
         custom_popover_1812_long_description: 'TE-Booster Setpoint Timeout',
         custom_popover_1813_long_description: 'TE-Booster Setpoint Timer',
         custom_popover_1815_long_description: 'TE-Booster Threshold',
         custom_popover_1816_long_description: 'TE-Booster Taped Volume',
         // Heating PopOver Long Omschrijving
         custom_popover_500_long_description: 'CV Max Setpoint',
         custom_popover_501_long_description: 'CV Min Setpoint',
         custom_popover_506_long_description: 'Max Primaire Retour',
         custom_popover_507_long_description: 'Max Primaire Retour Percentage',
         custom_popover_508_long_description: 'Delta Prim CV Setpoint',
         custom_popover_510_long_description: 'Max Heating Temperatuur',
         custom_popover_509_long_description: 'Delta Prim Min',
         custom_popover_514_long_description: 'CV Setpoint',
         custom_popover_515_long_description: 'CV Enable',
         // Cooling PopOver Long Omschrijving
         custom_popover_600_long_description: 'CoolTempSetpoint',
         custom_popover_601_long_description: 'Cool MaxPrimary Retour',
         custom_popover_602_long_description:
           'Cool % of Max Setpoint compensation',
         custom_popover_605_long_description: 'Max Cooling Temp',
         custom_popover_606_long_description: 'Cool setpoint min',
         custom_popover_607_long_description: 'Cool setpoint max',
         custom_popover_611_long_description: 'Cooling Enable',
         // Secundaire General PopOver Long Omschrijving
         custom_popover_512_long_description: 'CV Min Pressure',
         custom_popover_513_long_description: 'CV Max Pressure',
         custom_popover_603_long_description: 'CoolHeatWaitingTime',
         custom_popover_604_long_description: '6way valve waiting time',
         // Changeover WKW PopOver Long Omschrijving
         custom_popover_1850_long_description: '3.5Pipe Configuration',
         custom_popover_1851_long_description: 'Cooling detection threshold',
         custom_popover_1852_long_description: 'Heating detection threshold',
         custom_popover_1853_long_description: 'Heating lowered setpoint',
         custom_popover_1854_long_description: 'Lowered setpoint used',
         custom_popover_1855_long_description: 'Predetection MCV2 position',
         custom_popover_1856_long_description: 'Detection interval',
         custom_popover_1857_long_description: 'Detection interval timer',
         custom_popover_1858_long_description: 'Predetection timeout',
         custom_popover_1859_long_description: 'Predetection timer',
         custom_popover_1860_long_description: 'Configuration switch timer',
         custom_popover_1861_long_description: 'Switch timeout',
         custom_popover_1862_long_description: 'Configuration switch threshold',
         custom_popover_1863_long_description: 'Boost function mode',
         custom_popover_1864_long_description: 'Boost detection timer',
         custom_popover_1865_long_description: 'Boost detection timeout',
         custom_popover_1866_long_description: 'Maximum boost position',
         // Manual Operation PopOver Long Omschrijving
         custom_popover_700_long_description: 'Manual Control ingeschakeld',
         custom_popover_701_long_description: 'MCV-1 Handbediening',
         custom_popover_702_long_description: 'MCV-2 Handbediening',
         custom_popover_703_long_description: 'Pump (P1) Handbediening',
         custom_popover_704_long_description: 'Valve1',
         custom_popover_706_long_description: 'Heat demand status output',
         custom_popover_707_long_description: 'MCV-1 Handbediening[%]',
         custom_popover_708_long_description: 'MCV-1 Handbediening[%]',
         custom_popover_1801_long_description: 'Elektrisch element TE-Booster',
         custom_popover_709_long_description: 'Handbediening timeout',
         // API keys
         client_single_api_key_approve_api_key_label: 'API Key',
         client_single_api_key_app_id_label: 'APP Id',
         client_single_api_key_approve_api_key_button: 'Account toestaan',
         client_single_api_key_suspend_api_key_button: 'Opschorten API toegang',
         client_single_api_key_unblock_application_button: 'API deblokkeren',
         client_single_api_key_generate_api_key_button: 'API Key genereren',
         client_single_api_key_generate_api_key_success:
           'API Key is succesvol gegenereerd',
         client_single_api_key_generate_api_limit_error:
           'Sorry, we kunnen geen nieuwe API-sleutel opnieuw genereren omdat de limiet voor opnieuw genereren is bereikt.',
         client_single_api_key_generate_api_kong_error:
           'Kong API Error. Neem contact op met de beheerder.',
         client_single_api_application_suspend_success:
           'Kong Application is suspended succesvol',
         client_single_api_application_unblock_success:
           'Kong Application is Unblocked succesvol',
         client_single_api_application_suspend_error:
           'Application is already suspended',
         client_single_api_application_unblock_errpr:
           'Application is already unblocked',
         client_single_api_key_account_pending_approval:
           'Uw account is nog niet goedgekeurd. Neem contact op met de beheerder.',
         client_single_api_key_account_suspended:
           'Uw account is opgeschort. Neem contact op met de beheerder.',
         // Klanten Form
         kong_temporary_password_subject:
           'Fortes Data Beheer - Kong Account Aangemaakt',
         clients_form_password_field: 'Wachtwoord',
         clients_password_required_form_error:
           'Wachtwoord moet minimaal 8 tekens bevatten met tenminste één hoofdletter, één cijfer en één speciaal teken.',
         // Devices Form
         devices_form_mbus_meters_are_not_connected:
           'Meters zijn niet verbonden.',
         MBUS_METER_HEATING: 'Warmtemeter',
         MBUS_METER_COOLING: 'Koudemeter',
         MBUS_METER_ELECTRICITY: 'Elektriciteitsmeter',
         MBUS_METER_WATER: 'Watermeter',
         MBUS_METER_BI_DIRECTIONAL: 'Warmte/koude meter',
         meter_enabled: 'Ingeschakeld',
         meter_disabled: 'Uitgeschakeld',
         devices_mbus_registers_toggle_register_status_success:
           'Het bericht is succesvol verstuurd naar het Device.',
         MBUS_METER_SERIAL_NUMBER: 'Serienummer',
         MBUS_METER_MANUFACTURER: 'Fabrikant',
         MBUS_METER_METER_TYPE: 'Meter type',
         MBUS_METER_STATUS: 'Status',
         MBUS_METER_FLOW: 'Volumestroom',
         MBUS_METER_POWER: 'Vermogen',
         MBUS_METER_SUPPLY_TEMPERATURE: 'Aanvoertemperatuur',
         MBUS_METER_RETURN_TEMPERATURE: 'Retourtemperatuur',
         MBUS_METER_HEATING_ENERGY: 'Totale energieverbruik (warmte)',
         MBUS_METER_ELECTRICITY_ENERGY:
           'Totale energieverbruik (elektriciteit)',
         MBUS_METER_VOLUME: 'Totale volume',
         MBUS_METER_COOLING_ENERGY: 'Totale energieverbruik (koude)',
         MBUS_METER_CURRENT: 'Current',
         custom_popover_MBUS_METER_SERIAL_NUMBER_short_description:
           'Serienummer',
         custom_popover_MBUS_METER_MANUFACTURER_short_description: 'Fabrikant',
         custom_popover_MBUS_METER_METER_TYPE_short_description: 'Meter type',
         custom_popover_MBUS_METER_STATUS_short_description: 'Status',
         custom_popover_MBUS_METER_FLOW_short_description: 'Volumestroom',
         custom_popover_MBUS_METER_POWER_short_description: 'Vermogen',
         custom_popover_MBUS_METER_SUPPLY_TEMPERATURE_short_description:
           'Aanvoertemperatuur',
         custom_popover_MBUS_METER_RETURN_TEMPERATURE_short_description:
           'Retourtemperatuur',
         custom_popover_MBUS_METER_HEATING_ENERGY_short_description:
           'Totale energieverbruik (warmte)',
         custom_popover_MBUS_METER_ELECTRICITY_ENERGY:
           'Totale energieverbruik (elektriciteit)',
         custom_popover_MBUS_METER_VOLUME_short_description: 'Totale volume',
         custom_popover_MBUS_METER_COOLING_ENERGY_short_description:
           'Totale energieverbruik (koude)',
         custom_popover_MBUS_METER_CURRENT_short_description: 'Stroom',
         // Device Data Logs Per Device
         device_single_device_registers_tab: 'Data Log',
         device_single_device_registers_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Bedrijfsstatus',
             permission: 'operating-state-tab-read',
           },
         ]),
         device_status_interval: 'Interval',
         device_status_interval_in_seconds: 'Interval in seconden',
         device_single_set_registers_error:
           'Selecteer tenminste 1 register om door te gaan.',
         device_single_set_registers_max_limit_error:
           'You can select a maximum of ##MAX## registers. You have selected ##SELECTED##.',
         device_single_set_registers_success:
           'Bericht is succesvol doorgestuurd naar het Device.',
         device_single_set_register_form_interval_required_error:
           'Interval (seconden) is vereist',
         device_single_set_register_form_interval_numeric_error:
           'Interval (seconden) moet een getal zijn',
         device_single_set_register_form_send_button: 'Instellen',
         device_single_set_register_form_cancel_button: 'Annuleren',
         clients_kong_email_error: 'Email bestaal al in Kong',
         page_title_appending_title: ' | Fortes Data Beheer',
         project_single_device_registers_tab: 'Data Log',
         audits_user: 'Gebruiker',
         audits_system_generated: 'Applicatie',
         device_single_project_set_registers_error:
           'Bericht wordt niet doorgestuurd omdat er geen devices aan het project zijn gekoppeld',
         audits_user_filter_label: 'Gebruiker',
         audits_event_type_field: 'Event type',
         audits_select_event_type_field: 'Selecteer event type',
         audits_select_event_type_incoming_option: 'Inkomend',
         audits_select_event_type_outgoing_option: 'Uitgaand',
         audits_select_event_type_system_generated_option: 'Applicatie',
         audits_table_loading: 'Events laden',
         appliance_type_reference_table_appliance_name: 'Naam',
         appliance_type_reference_table_appliance_type: 'Toesteltype',
         appliance_type_reference_table_updated_at: 'Gewijzigd op',
         sidebar_appliance_type_reference_menu: 'Toesteltype',
         appliance_types_register_form_send_button: 'Opslaan',
         appliance_types_register_form_cancel_button: 'Annuleer',
         appliance_types: 'Toesteltypes',
         appliance_types_table_no_record_found: 'Geen Device gevonden',
         appliance_types_table_row_per_page: 'Resultaten per pagina',
         add_appliance_type: 'Toesteltype toevoegen',
         add_appliance_types_form_header: 'Toestel type toevoegen',
         edit_appliance_types_form_header: 'Toesteltype wijzigen',
         appliance_types_add_new: 'Toevoegen',
         appliance_type_form_name_label: 'Naam',
         appliance_type_form_type_label: 'Toesteltype',
         appliance_type_form_select_type_label: 'Selecteer Toesteltype',
         appliance_name_form_required_error: 'Naam is verplicht',
         appliance_type_form_required_error: 'Toesteltype is verplicht',
         add_appliance_type_form_success:
           'Toesteltype record is succesvol aangemaakt',
         add_appliance_type_form_api_error:
           'Internal Server add toesteltype - API Storing',
         edit_appliance_type_form_success:
           'Toesteltype record is succesvol gewijzigd',
         edit_appliance_type_form_api_error:
           'Internal Server edit toesteltype - API Storing',
         device_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Bedrijfstatus',
             permission: 'operating-state-tab-read',
           },
           {
             key: 'settings_hot_water',
             value: 'Instellingen tapwater',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Instellingen verwarmen en koelen',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Handbediening',
             permission: 'manual-control-tab-read',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
           {
             key: 'm_bus_meters',
             value: 'Meters (M-Bus)',
             permission: 'm-bus-meters-tab-read',
           },
           {
             key: 'live_hot_water',
             value: 'Livelog tapwater',
             permission: 'livelog-hot-water-tab-read',
           },
           {
             key: 'live_heating',
             value: 'Livelog verwarming',
             permission: 'livelog-heating-tab-read',
           },
           {
             key: 'live_cooling',
             value: 'Livelog koeling',
             permission: 'livelog-cooling-tab-read',
           },
         ]),
         appliance_type_reference_table_filter_reset_button: 'Herstel',
         appliance_type_reference_table_search: 'Zoeken',
         appliance_type_reference_status_menu_list: JSON.stringify([
           {
             key: 'operating_state',
             value: 'Bedrijfsstatus',
             permission: 'operating-state-tab-read',
           },
           {
             key: 'settings_hot_water',
             value: 'Instellingen tapwater',
             permission: 'settings-hot-water-tab-read',
           },
           {
             key: 'settings_heating_and_cooling',
             value: 'Instellingen verwarmen en koelen',
             permission: 'settings-heating-and-cooling-tab-read',
           },
           {
             key: 'manual_control',
             value: 'Handbediening',
             permission: 'manual-control-tab-read',
           },
           {
             key: 'firmware_registers',
             value: 'Firmware Registers',
             permission: 'firmware-registers-tab-read',
           },
           {
             key: 'lin_pump_delta_parameters',
             value: 'LIN-Pump DeltaP Parameters',
             permission: 'lin-pump-tab-read',
           },
         ]),
         audits_filter_button: 'Filters',
         device_single_no_registers_are_available:
           'Registers zijn niet beschikbaar',
         device_single_device_diagnostics_tab: 'Diagnostiek',
         device_single_dp_measurement_back_button: 'Vorige',
         device_single_diagnostic_next_button: 'Volgende',
         device_single_dp_measurement_start_button: 'Start',
         device_single_diagnostict_finish_button: 'Finish',
         device_single_diagnostic_stop_button: 'Stop',
         device_single_dp_measurement_refresh_button: 'Verversen',
         device_single_dp_measurement_event_logs_title: 'Uitkomsten',
         device_single_dp_measurement_select_mbus_meter_button:
           'Selecteer Meter',
         device_single_dp_measurement_step_1_title:
           'Drukverschil berekening - Kies flow',
         device_single_dp_measurement_pressure_difference_stepper_1_title:
           'Kies flow',
         device_single_dp_measurement_step_1_flow_1_label:
           'Drukverschil berekenen',
         device_single_dp_measurement_step_1_flow_2_label: 'Warmwater',
         device_single_dp_measurement_pressure_difference_step_2_title:
           'Drukverschil berekening - Uitleg van de wizard',
         device_single_dp_measurement_pressure_difference_stepper_2_title:
           'Uitleg van de wizard',
         device_single_dp_measurement_pressure_difference_step_2_description:
           'Beschikbaar drukverschil is altijd een vraagstuk bij collectieve netwerken. Met de krachtige combinatie van AquaHeat aflversets en het Fortes Data Beheer platform kunt u middels een gebruiksvriendelijke module eenvoudig een drukverschilberekening uitvoeren op ieder punt in uw collectieve netwerk. Dit geeft een uitstekende eerste indicatie van een mogelijke oorzaak. Middels deze diagnose stellen wij u in staat om een eerste indicatie van het beschikbare drukverschil te laten berekenen. <br /><br /><strong>Vereist: Warmtemeter dient verbonden te zijn aan de Mercurius Communicatie Module</strong>',
         device_single_dp_measurement_pressure_difference_step_3_title:
           'Drukverschil berekening - Aansturen van de juiste componenten',
         device_single_dp_measurement_pressure_difference_stepper_3_title:
           'Handbediening register',
         device_single_dp_measurement_step_3_pressure_difference_output_1:
           'Uitkomst 1 - Aanzetten van de handbediening',
         device_single_dp_measurement_pressure_difference_output_2:
           'Uitkomst 2 - Openen van de regelafsluiter',
         device_single_dp_measurement_pressure_difference_step_3_mbus_meter_title:
           'Selecteer Meter (bij meerdere meters betreft het de energiemeter welke het tapwater registreert.)',
         device_single_dp_measurement_pressure_difference_stepper_4_title:
           'Meter selecteren',
         device_single_dp_measurement_pressure_difference_step_4_flow_label:
           'Debiet',
         device_single_dp_measurement_pressure_difference_stepper_5_title:
           'Berekenen van het drukverschil',
         device_single_dp_measurement_pressure_difference_output_3:
           'Uitkomst 3 - Selecteer Meter',
         device_single_dp_measurement_pressure_difference_output_4:
           'Uitkomst 4 - Calculation of de differential druk',
         device_single_dp_measurement_pressure_difference_stepper_6_title:
           'Resultaat',
         device_single_dp_measurement_pressure_difference_step_6_description:
           'Uw drukverschil is OK! Er zijn geen verdere acties vereist. ',
         device_single_dp_measurement_download_button: 'Download resultaten',
         device_single_dp_measurement_pressure_difference_step_7_description:
           'De drukverschil berekening is succesvol afgerond.',
         device_single_general_title: 'Algemeen',
         device_single_hotwater_title: 'Warmwater',
         device_single_dp_measurement_hot_water_flow_1_stepper_1_title:
           'Kies flow',
         device_single_dp_measurement_hot_water_flow_1_stepper_2_title:
           'Uitleg van de wizard',
         device_single_dp_measurement_hot_water_flow_1_stepper_3_title:
           'Open kraan',
         device_single_dp_measurement_hot_water_flow_1_stepper_4_title:
           'Checken kraan en tapwater klep',
         device_single_dp_measurement_hot_water_flow_1_stepper_5_title: 'Meter',
         device_single_dp_measurement_hot_water_flow_1_stepper_6_title:
           'Berekening van warm water flow',
         device_single_dp_measurement_hot_water_flow_1_stepper_7_title:
           'Resultaten',
         device_single_dp_measurement_hot_water_flow_1_step_2_title:
           'Drukverschil berekening - Uitleg van flow',
         device_single_dp_measurement_hot_water_flow_1_step_2_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_3_title:
           'Open kraan',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error:
           'Flow Sensor Defect',
         device_single_dp_measurement_hot_water_flow_1_step_3_faucet_error_one_try_left:
           'Probeer nog een keer',
         diagnostic_flows_form_open_faucet_title: 'Kraan is geopend door klant',
         diagnostic_flows_form_open_faucet_off_option_description:
           'Kraan is niet geopend door klant',
         device_single_dp_measurement_hot_water_flow_1_output_1:
           'Output 1 - Tapwater State',
         device_single_dp_measurement_hot_water_flow_1_output_2:
           'Output 2 - Tapwaterklep (M1)',
         device_single_dp_measurement_hot_water_flow_1_step_3_mbus_meter_title:
           'Selecteer Meter',
         device_single_dp_measurement_hot_water_flow_1_step_4_flow_label:
           'Flow',
         device_single_dp_measurement_step_4_hot_water_flow_1_output_3:
           'Output 3 - Selecteer Meter',
         device_single_dp_measurement_hot_water_flow_1_output_4:
           'Output 4 - Meter Flow',
         device_single_dp_measurement_hot_water_flow_1_output_5:
           'Output 5 - Berekening van warm water flow',
         device_single_dp_measurement_hot_water_flow_1_step_7_description:
           'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu proin amet vitae etiam. In mauris habitasse turpis quis tortor, integer magna dictum condimentum. In pellentesque proin eu ut viverra quam. Consequat pharetra proin lacus, ultrices enim. Tincidunt porta tortor lacinia varius mattis pellentesque. In augue sit vitae leo sed. Nibh sed mi bibendum convallis viverra vestibulum pretium commodo. Nibh quam vulputate malesuada sodales. Curabitur nisl leo quis sed vitae cras. Tempor risus, a volutpat consequat eget faucibus nulla fermentum. Ut dignissim proin nulla et congue mattis. Euismod et ipsum quis habitant in enim viverra. Mattis varius quis arcu cras vestibulum nunc mattis consectetur in. Tempus mauris egestas elit malesuada ullamcorper aliquet cras adipiscing ',
         device_single_dp_measurement_hot_water_flow_1_step_8_description:
           'Warm water - Flow 1 Diagnostiek is afgerond',
         device_single_heating_title: 'Verwarming',
         device_single_dp_measurement_step_1_flow_3_label: 'Flow 1',
         device_single_cooling_title: 'Koeling',
         device_single_dp_measurement_step_1_flow_4_label: 'Flow 1',
         device_single_temperature_graph_loading_data: 'Laden van de grafiek',
         device_single_temperature_no_graph_data_error:
           'De grafiek is niet beschikbaar',
         device_graph_week_filter: 'W',
         device_graph_weeks_filter: 'W',
         device_graph_day_filter: 'D',
         device_graph_days_filter: 'D',
         device_graph_hours_filter: 'H',
         device_single_registers_table_numeric_error:
           'Alleen numerieke waarden zijn toegestaan',
         device_single_registers_table_min_max_error:
           'Waarde moet tussen minimale en maximale waarde liggen',
         MBUS_METER_TYPE_WATER: 'Water',
         MBUS_METER_TYPE_ELECTRICITY: 'Elektriciteit',
         MBUS_METER_TYPE_HEATING: 'Warmte',
         MBUS_METER_TYPE_BIDIRECTIONAL: 'Warmte/koude',
         MBUS_METER_TYPE_COOLING: 'Koude',
         UNKNOWN_MANUFACTURER: 'Onbekende fabrikant',
         commissioning_form_header: 'Inbedrijfstelling',
         commissioning_form_serial_number_scan_button: 'Scan QR code Mercurius',
         commissioning_form_heat_interface_unit_scan_button:
           'Scan QR code afleverset',
         commissioning_device_submit_button: 'Gereed',
         commissioning_form_search_field: 'Serienummer Mercurius',
         sidebar_commissioning_overview: 'Inbedrijfstelling',
         sidebar_commissioning: 'Inbedrijfstelling',
         commissioning_form_success: 'De inbedrijfstelling is succesvol!',
         commissioning_error_message: 'Device is niet gevonden',
         swapping_form_header: 'Uitwisselen Device',
         swapping_old_device_title: 'Oude Device (serienummer)',
         swapping_new_device_title: 'Nieuwe Device (serienummer)',
         swapping_form_scan_button: 'Scan',
         swapping_form_search_field: 'Serienummer Mercurius',
         sidebar_swapping_overview: 'Inbedrijfstelling',
         sidebar_swapping: 'Uitwisseling',
         swapping_device_submit_button: 'Gereed',
         swapping_form_success: 'Device is succesvol bijgewerkt!',
         swapping_old_device_error_message: 'Oude Device is niet gevonden',
         swapping_new_device_error_message: 'Nieuwe Device is niet gevonden',
         email_device_swapped_by: 'Device uitgewisseld door:',
         swapping_device_unique_error: 'Device bestaat reeds',
         clear_device_form_header: 'Wissen',
         clear_device_form_scan_button: 'Scan',
         clear_device_form_search_field: 'Serienummer Mercurius',
         sidebar_clear_device_overview: 'Wis Device',
         sidebar_clear_device: 'Wissen',
         clear_device_form_success: 'Device is succesvol bijgewerkt!',
         clear_device_error_message: 'Device is niet gevonden',
         clear_device_submit_button: 'Wis Device',
         clear_device_audit_message: 'Device is gewist',
         device_single_swapped_devices_tab: 'Uitgewisselde devices',
         devices_single_swapped_old_device_name: 'Uitgewisseld van (Oud)',
         devices_single_swapped_device_old_firmware: 'Oude firmware',
         devices_single_swapped_device_new_firmware: 'Nieuwe firmware',
         devices_single_swapped_old_device_type: 'Oud Device type',
         devices_single_swapped_new_device_type: 'Nieuw Device type',
         devices_single_swapped_device_old_box_serial_number:
           'Oud Serienummer afleverset',
         devices_single_swapped_device_new_box_serial_number:
           'Serienummer afleverset',
         devices_single_swapped_device_old_sim_card_number:
           'Oud simkaartnummer',
         devices_single_swapped_device_new_sim_card_number:
           'Nieuwe simkaartnummer',
         devices_single_swapped_device_created_at: 'Datum uitwisseling',
         devices_single_swapped_device_name_search: 'Zoek',
         devices_single_swapped_new_device_name: 'Uitgewisseld voor (Nieuw)',
         devices_single_swapped_device_table_no_record_found: 'Niet gevonden!',
         devices_single_swapped_device_table_loading: 'Laden',
         devices_single_swapped_device_table_row_per_page:
           'Resultaten per pagina',
         sidebar_swapped_devices_overview: 'Uitgewisselde devices',
         sidebar_swapped_devices: 'Uitgewisselde devices',
         swapped_devices_form_header: 'Uitgewisselde devices',
         devices_bulk_edit_registers_form_no_devices_error:
           'Selecteer devices om door te gaan.',
         devices_bulk_edit_firmware_modal_title:
           'Weet u zeker dat u een firmware update wilt uitvoeren?',
         devices_bulk_edit_firmware_modal_subtitle:
           'Wilt u firmwareversie ##firmware_value## in bulk bijwerken voor ##total_devices## devices?',
         devices_bulk_edit_registers_modal_title:
           'Weet u zeker dat u de groepsactie wilt uitvoeren?',
         devices_bulk_edit_registers_modal_subtitle:
           'Wilt u de registers voor ##total_devices## devices in een keer bijwerken?',
         devices_bulk_edit_registers_modal_cancel_button: 'Annuleer',
         devices_bulk_edit_registers_modal_submit_button: 'Bevestigen',
         devices_bulk_edit_firmware_modal_cancel_button: 'Annuleer',
         devices_bulk_edit_firmware_modal_submit_button: 'Bevestigen',
         devices_bulk_export_button: 'Exporteer devices',
         projects_bulk_export_button: 'Exporteer projecten',
         project_devices_bulk_export_button: 'Exporteer projecten',
         devices_bulk_export_file_name: 'Device groeps export',
         projects_bulk_export_file_name: 'Project groeps export',
         project_devices_bulk_export_file_name: 'Device groeps export',
         sidebar_reporting_overview: 'Rapporten',
         sidebar_bulk_edit_ota_reporting: 'Updates',
         sidebar_bulk_reporting_registers_table_title: 'Groepswijzigingen',
         edit_ota_reporting: 'Update rapporten',
         reporting_ota_all: 'Alle',
         reporting_ota_success: 'Succesvol',
         reporting_ota_failure: 'Mislukt',
         reporting_ota_bulk_export_button: 'Exporteren',
         reporting_ota_filter_reset_button: 'Herstel',
         reporting_ota_table_filter_search: 'Zoeken',
         reporting_ota_table_updated_at: 'Datum',
         reporting_ota_table_total_devices: 'Totaal aantal devices',
         reporting_ota_table_user: 'Gebruiker',
         reporting_ota_table_message: 'Opmerking',
         reporting_registers_table_user: 'Gebruiker',
         reporting_registers_table_message: 'Opmerking',
         reporting_ota_table_no_record_found: 'Geen zoekresultaten gevonden',
         reporting_ota_table_row_per_page: 'Resultaten per pagina',
         edit_ota_reporting_details: 'OTA Audit Details',
         reporting_ota_details_all_tab: 'Alle',
         reporting_ota_details_pending_tab: 'Bezig',
         reporting_ota_details_success_tab: 'Succesvol',
         reporting_ota_details_failure_tab: 'Mislukt',
         reporting_ota_details_bulk_export_button: 'Exporteren',
         reporting_ota_details_filter_reset_button: 'Herstel',
         reporting_ota_details_table_filter_search: 'Zoeken',
         reporting_ota_details_message: 'Firmwareversie bijgewerkt naar',
         reporting_ota_details_table_created_at: 'Datum',
         reporting_ota_details_table_device: 'Device',
         reporting_ota_details_table_user: 'Gebruiker',
         reporting_ota_details_table_old_firmware_version:
           'Oude firmwareversie',
         reporting_ota_details_table_current_firmware_version:
           'Huidige firmwareversie',
         reporting_ota_details_table_current_status: 'Status',
         reporting_ota_details_table_message: 'Bericht',
         reporting_ota_details_table_no_record_found:
           'Geen zoekresultaten gevonden',
         reporting_ota_details_table_row_per_page: 'Resultaten per pagina',
         reporting_ota_bulk_export_file_name: 'OTA Rapport',
         reporting_ota_details_bulk_export_file_name:
           'Groeps OTA Details Rapport',
         devices_single_swapped_bulk_export_button_file_name:
           'Uitgewisselde Devices Rapport',
         devices_single_swapped_bulk_export_button: 'Exporteren',
         reporting_registers_all: 'Alle',
         reporting_registers_success: 'Succesvol',
         reporting_registers_failure: 'Mislukt',
         reporting_registers_table_created_at: 'Datum',
         reporting_registers_table_total_devices: 'Totaal aantal devices',
         reporting_registers_bulk_export_button: 'Exporteren',
         reporting_registers_filter_reset_button: 'Herstel',
         reporting_registers_table_filter_search: 'Zoeken',
         reporting_registers_table_no_record_found:
           'Geen zoekresultaten gevonden',
         reporting_registers_table_row_per_page: 'Resultaten per pagina',
         reporting_registers_table_title: 'Groepswijzigingen rapporten',
         reporting_registers_table_bulk_export_file_name:
           'Groeps Registers Rapport',
         registers_reporting_details_title: 'Details groepswijzigingen',
         reporting_registers_details_bulk_export_button: 'Exporteren',
         reporting_registers_details_filter_reset_button: 'Herstel',
         reporting_registers_details_table_filter_search: 'Zoeken',
         reporting_registers_details_table_created_at: 'Datum',
         reporting_registers_details_table_device: 'Device',
         reporting_registers_details_table_user: 'Gebruiker',
         reporting_registers_details_table_message: 'Bericht',
         reporting_registers_details_table_failed_message:
           'Firmwareversie is niet bijgewerkt naar',
         reporting_registers_details_table_pending_message:
           'Firmwareversie updaten naar',
         reporting_registers_details_table_successful_message:
           'Firmwareversie is bijgewerkt naar',
         reporting_registers_details_table_no_record_found:
           'Geen zoekresultaten gevonden',
         reporting_registers_details_table_row_per_page:
           'Resultaten per pagina',
         reporting_registers_details_bulk_export_file_name:
           'Groeps Registers Details Rapport',
         devices_bulk_edit_ota_form_firmware_field_select_label:
           'Selecteer firmware',
         dashboard_users_overview: 'Gebruikersoverzicht',
         dashboard_users_title: 'Gebruikers',
         dashboard_devices_overview: 'Device overzicht',
         dashboard_devices_title: 'Devices',
         dashboard_commissioning_overview: 'Inbedrijfstelling',
         dashboard_commissioning_title: 'Inbedrijfstelling',
         devices_filters: 'Filters:',
         devices_submit_button: 'Verzenden',
         device_single_device_documentation_tab: 'Documenten',
         device_single_documentation_brochure_button: 'Brochure',
         device_single_documentation_installation_manual_button:
           'gebruikers-/montagehandleiding',
         device_single_documentation_dimensional_drawing_button: 'Maattekening',
         device_single_documentation_parts_drawing_button: 'Onderdelentekening',
         device_single_documentation_flow_direction_button: 'Stromingsrichting',
         device_single_documentation_principle_diagram_button: 'Principeschema',
         device_single_documentation_information_end_user_button:
           'Informatie eindgebruiker',
         device_single_documentation_malfunction_key_button: 'Storingssleutel',
         reporting_ota_failed_message: 'Firmwareversie is niet bijgewerkt naar',
         reporting_ota_pending_message: 'Firmwareversie updaten naar',
         reporting_ota_successful_message: 'Firmwareversie bijgewerkt naar',
         ota_pending: 'Bezig',
         ota_success: 'Succesvol',
         ota_failed: 'Mislukt',
         clear_devices_modal_title: 'Wis Device',
         clear_devices_modal_subtitle:
           'Weet u zeker dat u dit apparaat wilt wissen met serienummer <strong>##serial_number##</strong>',
         clear_devices_modal_cancel_button: 'Annuleer',
         clear_devices_modal_submit_button: 'Wis Device',
         sidebar_fortes_roles: 'Rollen',
         sidebar_fortes_permissions: 'Recht',
         roles_all: 'Alle',
         roles_active: 'Actief',
         roles_inactive: 'Inactief',
         roles_filter_delete_button: 'Verwijderen',
         roles_table_identifier: 'Identifier',
         roles_table_name_en: 'Naam (EN)',
         roles_table_name_nl: 'Naam (NL)',
         roles_table_description_en: 'Omschrijving (EN)',
         roles_table_description_nl: 'Omschrijving (NL)',
         roles_table_status: 'Status',
         roles_table_updated_at: 'Bijgewerkt op',
         roles_filter_search: 'Zoeken',
         roles_no_record_found: 'Geen resultaten gevonden',
         roles_table_row_per_page: 'Resultaten per pagina',
         roles_bulk_no_record_is_selected_error_message:
           'Selecteer devices voor groepsdeactivering.',
         roles_deactivated_message: 'Rol is sucesvol gedeactiveerd',
         roles_activated_message: 'Rol is succesvol geactiveerd',
         roles_bulk_deactivated_message:
           '##ROLES_COUNT## Rollen zijn succesvol gedeactiveerd',
         roles_title: 'Rollen',
         roles_add_new: 'Rol toevoegen',
         roles_bread_crumb_main_title: 'Rollen',
         add_roles_bread_crumb_first_link: 'Toevoegen',
         edit_roles_bread_crumb_first_link: 'Rol wijzigen',
         add_roles_form_header: 'Rol toevoegen',
         edit_roles_form_header: 'Rol wijzigen',
         roles_form_role_identifier_field: 'Identifier',
         roles_identifier_required_form_error: 'Identifier is verplicht',
         roles_form_api_error: 'Interne Server Error',
         roles_form_unqiue_role_name_error: 'Identifier moet uniek zijn',
         roles_form_api_forbidden:
           'Gebruiker heeft geen rechten om een rol te maken',
         roles_add_form_success: 'Rol is succesvol aangemaakt',
         roles_edit_form_success: 'Rol is succesvol bijgewerkt',
         roles_form_add_role_button: 'Rol toevoegen',
         roles_form_edit_role_button: 'Rol wijzigen',
         roles_form_cancel_button: 'Annuleer',
         roles_form_permissions_title: 'Rechten',
         sidebar_fortes_modules: 'Modules',
         modules_all: 'Alle',
         modules_active: 'Actief',
         modules_inactive: 'Inactief',
         modules_filter_delete_button: 'Verwijderen',
         modules_table_identifier: 'Identifier',
         modules_table_name_en: 'Naam (EN)',
         modules_table_name_nl: 'Naam (NL)',
         modules_table_description_en: 'Omschrijving (EN)',
         modules_table_description_nl: 'Omschrijving (NL)',
         modules_table_status: 'Status',
         modules_table_updated_at: 'Bijgewerkt op',
         modules_filter_search: 'Zoeken',
         modules_no_record_found: 'Geen devices gevonden',
         modules_table_row_per_page: 'Resulataten per pagina',
         modules_bulk_no_record_is_selected_error_message:
           'Selecteer rijen voor bulkdeactivering.',
         modules_deactivated_message: 'Module is succesvol gedeactiveerd',
         modules_activated_message: 'Module is succesvol geactiveerd',
         modules_bulk_deactivated_message:
           '##MODULES_COUNT## modules zijn succesvol gedeactiveerd',
         modules_title: 'Modules',
         modules_add_new: 'Toevoegen',
         modules_bread_crumb_main_title: 'Modules',
         add_modules_bread_crumb_first_link: 'Module toevoegen',
         edit_modules_bread_crumb_first_link: 'Module wijzigen',
         add_modules_form_header: 'Module toevoegen',
         edit_modules_form_header: 'Module wijzigen',
         modules_form_module_identifier_field: 'Identifier',
         modules_identifier_required_form_error: 'Identifier is verplicht',
         modules_form_module_name_en_field: 'Naam (EN)',
         modules_form_module_name_nl_field: 'Naam (NL)',
         modules_name_en_required_form_error: 'Naam (EN) is verplicht',
         modules_name_nl_required_form_error: 'Naam (NL) is verplicht',
         modules_form_description_en_field: 'Omschrijving (EN)',
         modules_form_description_nl_field: 'Omschrijving (NL)',
         modules_form_api_error: 'Interne Server Error',
         modules_form_unqiue_module_name_error: 'Identifer moet uniek zijn',
         modules_form_api_forbidden:
           'Gebruiker heeft geen rechten om een module te maken',
         modules_add_form_success: 'Module is succesvol aangemaakt',
         modules_edit_form_success: 'Module is succesvol bijgewerkt',
         modules_form_add_module_button: 'Module toevoegen',
         modules_form_edit_module_button: 'Module wijzigen',
         modules_form_cancel_button: 'Annuleer',
         permissions_all: 'Alle',
         permissions_active: 'Actief',
         permissions_inactive: 'Inactief',
         permissions_filter_delete_button: 'Verwijderen',
         permissions_table_identifier: 'Identifier',
         permissions_table_module_name: 'Module',
         permissions_table_name_en: 'Naam (EN)',
         permissions_table_name_nl: 'Naam (NL)',
         permissions_table_description_en: 'Omschrijving (EN)',
         permissions_table_description_nl: 'Omschrijving (NL)',
         permissions_table_status: 'Status',
         permissions_filter_search: 'Zoeken',
         permissions_no_record_found: 'Geen Device gevonden',
         permissions_table_row_per_page: 'Resulataten per pagina',
         permissions_bulk_no_record_is_selected_error_message:
           'Selecteer rijen voor bulkdeactivering.',
         permissions_deactivated_message: 'Recht is succesvol gedeactiveerd',
         permissions_activated_message: 'Recht is succesvol geactiveerd',
         permissions_bulk_deactivated_message:
           '##PERMISSIONS_COUNT## rechten zijn succesvol gedeactiveerd',
         permissions_title: 'Rechten',
         permissions_add_new: 'Recht toevoegen',
         permissions_bread_crumb_main_title: 'Recht',
         add_permissions_bread_crumb_first_link: 'Recht toevoegen',
         edit_permissions_bread_crumb_first_link: 'Recht wijzigen',
         edit_permissions_form_header: 'Recht wijzigen',
         add_permissions_form_header: 'Recht toevoegen',
         permissions_form_permission_identifier_field: 'Identifier',
         permissions_form_permission_module_field: 'Module',
         permissions_form_permission_select_module_field: 'Selecteer module',
         permissions_module_required_form_error: 'Module is verplicht',
         permissions_identifier_required_form_error: 'Identifier is verplicht',
         permissions_form_permission_name_en_field: 'Naam (EN)',
         permissions_form_permission_name_nl_field: 'Naam (NL)',
         permissions_form_permission_sub_module_field: 'Sub-Module',
         permissions_form_permission_select_sub_module_field:
           'Selecteer Sub-Module',
         permissions_sub_module_required_form_error: 'Sub-Module is Verplicht',
         permissions_name_required_form_error: 'Naam is Verplicht',
         permissions_form_description_en_field: 'Beschrijving (EN)',
         permissions_form_description_nl_field: 'Omschrijving (NL)',
         permissions_form_api_error: 'Interne Server Error',
         permissions_form_unqiue_permission_name_error:
           'Identifer moet uniek zijn',
         permissions_edit_form_success: 'Klant is succesvol bijgewerkt!',
         permissions_form_api_forbidden:
           'Gebruiker heeft geen toestemming om rechten te maken',
         permissions_add_form_success: 'Recht succesvol aangemaakt',
         permissions_form_add_permission_button: 'Recht toevoegen',
         permissions_form_edit_permission_button: 'Recht wijzigen',
         permissions_form_cancel_button: 'Annuleer',
         permissions_read: 'Lezen',
         permissions_create: 'Toevoegen',
         permissions_update: 'Bijwerken',
         permissions_delete: 'Verwijderen',
         permissions_status: 'Toggle Status',
         permissions_get_all: 'Haal Alle Op',
         permissions_get_by_id: 'Haal Op By Id',
         permissions_bulk_deactivate: 'Deactiveer groep',
         permissions_form_title: 'Rechten',
         duplicate_roles_form_header: 'Rol dupliceren',
         duplicate_roles_bread_crumb_first_link: 'Rol dupliceren',
         roles_duplicate_form_success: 'Rol is succesvol gedupliceerd',
         roles_filter_duplicate_button: 'Rol dupliceren',
         roles_pre_identifier_required_form_error:
           'Pre Identifier is verplicht',
         roles_form_pre_identifier_field: 'Pre Identifier',
         roles_form_pre_identifier_select: 'Selecteer Pre Identifier',
         duplicate_roles_identifier_message:
           '<ul style="margin: "0", padding-left: 15px"> <li>Voor nieuwe klant start rol altijd met de identifier van klant_</li> <li>For nieuwe sub client rol always start de identifier with service_client_</li> <li>For nieuwe fortes rol always start de identifier with fortes_</li> </ul>',
         devices_single_device_counters_title: 'Device Tellers',
         devices_single_device_counters_offline_counter: 'Offline Teller',
         devices_single_device_counters_online_counter: 'Online Teller',
         devices_single_device_counters_ota_fail_counter: 'OTA mislukt Teller',
         devices_single_device_counters_ota_update_counter:
           'OTA Succesvol Teller',
         devices_single_device_counters_mbus_error_counter:
           'MBus Storing Teller',
         devices_single_device_counters_modbus_error_counter:
           'Modbus Storing Teller',
         devices_single_device_docs_directory: 'Directories',
         device_single_documentation_no_documents_found:
           'Geen documenten gevonden',
         reporting_registers_details_table_registers_pending:
           'Registers in afwachting',
         reporting_registers_details_table_registers_updated_fail:
           'Registers mislukt',
         reporting_registers_details_table_registers_updated_successful:
           'Registers succesvol',
         reporting_registers_details_table_status: 'Status',
         reporting_ota_message: 'Update Firmwareversie naar',
         devices_bulk_edit_registers_form_fix_register_values_error:
           'Corrigeer de fouten in alle tabbladen',
         login_permission_error:
           'Verkrijg de juiste machtigingen van Fortes Administrator',
         monitoring_title: 'Monitoring',
         monitoring_vm_title: 'Virtual Machine',
         monitoring_ram_title: 'RAM',
         monitoring_cpu_title: 'CPU',
         monitoring_disk_title: 'Disk',
         monitoring_restarts_title: 'Restarts',
         monitoring_uptime_title: 'Uptime',
         monitoring_services_title: 'Services',
         monitoring_service_table_service_name: 'Naam',
         monitoring_service_table_service_status: 'Status',
         be_user_service: 'Gebruikers',
         be_project_service: 'Projecten',
         be_export_service: 'Export',
         be_preset_service: 'Preset',
         be_status_updater_service: 'Status Updater',
         be_email_service: 'Email',
         be_permissions_rbac_service: 'Rechten',
         be_upload_images_service: 'Upload Images',
         be_db_archive_service: 'DB Archive',
         be_diagnostic_service: 'Diagnostisch',
         be_external_service: 'External APIs',
         be_mqtt_updater_service: 'MQTT',
         fortes_document_service: 'Fortes Document',
         external_client_service: 'Externe Klant',
         devices_form_service_client_field: 'Service klant',
         sidebar_kong_users: 'Kong klant Gebruikers',
         kong_users_title: 'Kong klant Gebruikers',
         kong_users_table_name: 'Naam',
         kong_users_table_email: 'Email',
         kong_users_table_client: 'Klant',
         kong_users_table_updated_at: 'Bijgewerkt Op',
         kong_users_bread_crumb_main_title: 'Kong klant Gebruikers',
         add_kong_users_bread_crumb_first_link: 'Add Kong klant gebruiker',
         add_kong_users_form_header: 'Add Kong klant gebruiker',
         kong_users_form_name_field: 'Naam',
         kong_users_form_email_field: 'Email Address',
         kong_users_form_client_field: 'Klant',
         kong_users_form_password_field: 'Wachtwoord',
         kong_users_name_required_form_error: 'Naam is verplicht',
         kong_users_email_valid_form_error: 'Must be a valid email',
         kong_users_email_required_form_error: 'Email is verplicht',
         kong_users_client_required_form_error: 'Klant is verplicht',
         kong_users_password_required_form_error:
           'Wachtwoord must contain at least 8 karakters with at least one uppercase letter, at least one number en at least one special character.',
         kong_users_no_record_found: 'Geen Records Gevonden',
         kong_users_table_row_per_page: 'Resultaten Per Pagina',
         kong_users_add_new: 'Voeg Kong klant gebruiker toe',
         kong_users_filter_search: 'Zoeken',
         kong_user_single_first_bread_crumb: 'Kong klant Gebruikers',
         kong_user_single_second_bread_crumb: 'Bekijk Kong klant Gebruikers',
         kong_user_single_apis_tab: 'API Keys',
         kong_user_single_edit_button_label: 'Wijzig',
         kong_user_single_user_label: 'Gebruiker',
         kong_user_single_email_label: 'Email',
         kong_user_single_client_label: 'Klant',
         edit_kong_users_form_header: 'Wijzig Kong klant gebruiker',
         edit_kong_users_bread_crumb_first_link: 'Wijzig Kong klant gebruiker',
         device_single_temperature_start_date: 'Startdatum',
         device_single_temperature_end_date: 'Einddatum',
         device_single_temperature_start_date_error:
           'Startdatum moet eerder of gelijk zijn aan Einddatum',
         sidebar_kong_admins: 'Kong Admin Gebruikers',
         kong_user_admins_title: 'Kong Admin Gebruikers',
         kong_user_admins_table_name: 'Naam',
         kong_user_admins_table_email: 'Email',
         kong_user_admins_table_updated_at: 'Bijgewerkt Op',
         kong_user_admins_bread_crumb_main_title: 'Kong Admin Gebruikers',
         add_kong_user_admins_bread_crumb_first_link:
           'Voeg Kong klant gebruiker toe',
         add_kong_user_admins_form_header: 'AVoeg Kong klant gebruiker toe',
         kong_user_admins_form_name_field: 'Naam',
         kong_user_admins_form_email_field: 'Email Address',
         kong_user_admins_form_client_field: 'Admin',
         kong_user_admins_form_password_field: 'Wachtwoord',
         kong_user_admins_name_required_form_error: 'Naam is verplicht',
         kong_user_admins_email_valid_form_error: 'Must be a valid email',
         kong_user_admins_email_required_form_error: 'Email is verplicht',
         kong_user_admins_password_required_form_error:
           'Wachtwoord must contain at least 8 karakters with at least one uppercase letter, at least one number en at least one special character.',
         kong_user_admins_no_record_found: 'Geen Records Gevonden',
         kong_user_admins_table_row_per_page: 'Resultaten Per Pagina',
         kong_user_admins_add_new: 'AVoeg Kong klant gebruiker toe',
         kong_user_admins_filter_search: 'Zoeken',
         kong_user_admin_single_first_bread_crumb: 'Kong Admin Gebruikers',
         kong_user_admin_single_second_bread_crumb:
           'Bekijk Kong Admin Gebruikers',
         kong_user_admin_single_apis_tab: 'API Keys',
         kong_user_admin_single_edit_button_label: 'Wijzig',
         kong_user_admin_single_user_label: 'Gebruiker',
         kong_user_admin_single_email_label: 'Email',
         edit_kong_user_admins_form_header: 'Wijzig Kong Admin gebruiker',
         edit_kong_user_admins_bread_crumb_first_link:
           'Wijzig Kong Admin gebruiker',
         projects_project_order_number_required_form_error:
           'Project Ordernummer is verplicht',
         projects_project_order_number_prefix_form_error:
           'Project Order Number must start with a P followed by 5 numbers, e.g. P12345',
         projects_form_project_order_number_field: 'Project Ordernummer',
         client_error_single_device_address: 'Installatie adres',
         navbar_notification_mark_all_as_read: 'Mark all as read',
         navbar_notification_view_all: 'Bekijk Alle',
         notifications_title: 'Meldingen',
         notifications_all: 'Allen',
         notifications_unread: 'Ongelezen',
         notifications_read: 'Gelezen',
         notifications_table_title: 'Titel (EN)',
         notifications_table_description: 'Beschrijving (EN)',
         notifications_table_notification_type: 'Notificatie Type',
         notifications_table_notification_category: 'Notificatie Categorie',
         notifications_table_date: 'Datum',
         notifications_filter_search: 'Zoeken',
         notifications_no_record_found: 'Geen Records Gevonden',
         notifications_table_row_per_page: 'Resultaten per pagina',
         add_notifications_form_header: 'Voeg Notificatie toe',
         notifications_title_en_required_form_error: 'Titel (EN) is verplicht',
         notifications_title_nl_required_form_error: 'Titel (NL) is verplicht',
         notifications_description_en_required_form_error:
           'Beschrijving (EN) is verplicht',
         notifications_description_nl_required_form_error:
           'Beschrijving (NL) is verplicht',
         notifications_form_notification_type_field: 'Notificatie Type',
         notifications_notification_type_required_form_error:
           'Notificatie Type is verplicht',
         notifications_form_notification_category_field: 'Notificatie Category',
         notifications_notification_category_required_form_error:
           'Notificatie Category is verplicht',
         notifications_form_title_en_field: 'Titel (EN)',
         notifications_form_title_nl_field: 'Titel (NL)',
         notifications_form_start_date_field: 'Startdatum',
         notifications_form_end_date_field: 'Einddatum',
         notifications_form_description_en_field: 'Beschrijving (EN)',
         notifications_form_description_nl_field: 'Beschrijving (NL)',
         notifications_form_add_button: 'Voeg Notificatie toe',
         notifications_form_edit_button: 'Wijzig Notificatie',
         notifications_form_cancel_button: 'Annuleer',
         notifications_add_form_success: 'Notificatie is succesvol toegevoegd',
         notifications_form_api_error: 'Interne Server Error',
         notification_type_information: 'Informatie',
         notification_type_warning: 'Waarschuwing',
         notification_category_simple: 'Simpel',
         notification_category_timebased: 'Tijd gevoelig',
         edit_notifications_form_header: 'Wijzig Notificatie',
         sidebar_notification_menu: 'Berichten',
         pop_over_close_button: 'Sluiten',
         docs_user_type_end_user: 'Eindgebruiker',
         docs_user_type_installer: 'Installateur',
         devices_single_device_docs_no_directory_found:
           'Geen Directories Gevonden',
         device_single_status_tab: 'Visuals',
         device_single_status_picture_tab: 'Foto',
         device_single_status_principle_tab: 'Principe',
         device_single_status_table_loading: 'Laden ...',
         device_single_status_mbus_export_button: 'Exporteer',
         device_single_status_mbus_date_range_filter_label: 'Datumbereik',
         device_single_status_mbus_date_export_label: 'Datum',
         device_single_status_mbus_time_export_label: 'Tijd',
         device_single_status_mbus_port_export_label: 'Poort',
         device_single_status_mbus_meter_connected_at_export_label:
           'Meter Verbonden Op',
         device_single_status_mbus_meter_status_export_label: 'Meter Status',
         device_single_status_mbus_meter_type_export_label: 'Meter Type',
         device_single_status_mbus_select_meter_type_export_label:
           'Selecteer Meter Type',
         device_single_status_mbus_select_meter_type_error:
           'Meter Type afwezig',
         device_single_status_mbus_export_internal_server_error:
           'Interne Server Error',
         device_single_status_mbus_export_no_data_found_error:
           'Geen record gevonden',
         sidebar_diagnostic_formulas: 'Diagnostische Formules',
         diagnostic_formulas_all: 'Allen',
         diagnostic_formulas_active: 'Actief',
         diagnostic_formulas_inactive: 'InActief',
         diagnostic_formulas_filter_delete_button: 'Verwijder',
         diagnostic_formulas_table_identifier: 'Identifier',
         diagnostic_formulas_table_name_en: 'Naam (EN)',
         diagnostic_formulas_table_name_nl: 'Naam (NL)',
         diagnostic_formulas_table_description_en: 'Beschrijving (EN)',
         diagnostic_formulas_table_description_nl: 'Beschrijving (NL)',
         diagnostic_formulas_table_formula: 'Formule',
         diagnostic_formulas_table_status: 'Status',
         diagnostic_formulas_table_updated_at: 'Bijgewerkt op',
         diagnostic_formulas_filter_search: 'Zoeken',
         diagnostic_formulas_no_record_found: 'Geen Record Gevonden',
         diagnostic_formulas_table_row_per_page: 'Resultaten Per Pagina',
         diagnostic_formulas_bulk_no_record_is_selected_error_message:
           'Selecteer records voor groepsdeactivatie aub.',
         diagnostic_formulas_deactivated_message:
           'Diagnostiek is succesvol gedeactiveerd',
         diagnostic_formulas_activated_message:
           'Diagnostiek is succesvol geactiveerd',
         diagnostic_formulas_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Diagnostiek is succesvol gedeactiveerd',
         diagnostic_formulas_title: 'Diagnostische Formules',
         diagnostic_formulas_add_new: 'Voeg Nieuwe Toe',
         diagnostic_formulas_bread_crumb_main_title: 'Diagnostische Formules',
         add_diagnostic_formulas_bread_crumb_first_link:
           'Voeg Diagnostische Formules Toe',
         edit_diagnostic_formulas_bread_crumb_first_link:
           'Wijzig Diagnostische Formules',
         add_diagnostic_formulas_form_header: 'Voeg Diagnostische Formules Toe',
         edit_diagnostic_formulas_form_header: 'Wijzig Diagnostische Formules',
         diagnostic_formulas_form_diagnostic_formulas_identifier_field:
           'Identifier',
         diagnostic_formulas_identifier_required_form_error:
           'Identifier is verplicht',
         diagnostic_formulas_form_diagnostic_formulas_name_en_field:
           'Naam (EN)',
         diagnostic_formulas_form_diagnostic_formulas_name_nl_field:
           'Naam (NL)',
         diagnostic_formulas_name_en_required_form_error:
           'Naam (EN) is verplicht',
         diagnostic_formulas_name_nl_required_form_error:
           'Naam (NL) is verplicht',
         diagnostic_formulas_formula_required_form_error:
           'Formule is verplicht',
         diagnostic_formulas_form_description_en_field: 'Beschrijving (EN)',
         diagnostic_formulas_form_description_nl_field: 'Beschrijving (NL)',
         diagnostic_formulas_form_forumla_field: 'Formule',
         diagnostic_formulas_form_api_error: 'Interne Server Error',
         diagnostic_formulas_form_unqiue_diagnostic_formulas_name_error:
           'Identifer moet uniek zijn',
         diagnostic_formulas_form_api_forbidden:
           'Gebruiker heeft geen toestemming diagnostische formules toe te voegen',
         diagnostic_formulas_add_form_success:
           'Diagnostiek is succesvol aangemaakt',
         diagnostic_formulas_edit_form_success:
           'Diagnostiek is succesvol bijgewerkt',
         diagnostic_formulas_form_add_diagnostic_formulas_button:
           'Voeg Diagnostiek Toe',
         diagnostic_formulas_form_edit_diagnostic_formulas_button:
           'Wijzig Diagnostiek',
         diagnostic_formulas_form_cancel_button: 'Annuleer',
         sidebar_diagnostic_categories: 'Diagnostiek Categorien',
         diagnostic_categories_all: 'Allen',
         diagnostic_categories_active: 'Actief',
         diagnostic_categories_inactive: 'InActief',
         diagnostic_categories_filter_delete_button: 'Verwijder',
         diagnostic_categories_table_identifier: 'Identifier',
         diagnostic_categories_table_name_en: 'Naam (EN)',
         diagnostic_categories_table_name_nl: 'Naam (NL)',
         diagnostic_categories_table_description_en: 'Beschrijving (EN)',
         diagnostic_categories_table_description_nl: 'Beschrijving (NL)',
         diagnostic_categories_table_status: 'Status',
         diagnostic_categories_table_updated_at: 'Bijgewerkt op',
         diagnostic_categories_filter_search: 'Zoeken',
         diagnostic_categories_no_record_found: 'Geen Record Gevonden',
         diagnostic_categories_table_row_per_page: 'Resultaten Per Pagina',
         diagnostic_categories_bulk_no_record_is_selected_error_message:
           'Selecteer records voor groepsdeactivatie aub.',
         diagnostic_categories_deactivated_message:
           'Categorie is succesvol gedeactiveerd',
         diagnostic_categories_activated_message:
           'Categorie is succesvol geactiveerd',
         diagnostic_categories_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Categorien zijn succesvol gedeactiveerd',
         diagnostic_categories_title: 'Diagnostische Categorien',
         diagnostic_categories_add_new: 'Voeg Nieuwe Toe',
         diagnostic_categories_bread_crumb_main_title:
           'Diagnostische Categorien',
         add_diagnostic_categories_bread_crumb_first_link:
           'Voeg Diagnostische Categorien Toe',
         edit_diagnostic_categories_bread_crumb_first_link:
           'Wijzig Diagnostische Categorien',
         add_diagnostic_categories_form_header:
           'Voeg Diagnostische Categorien Toe',
         edit_diagnostic_categories_form_header:
           'Wijzig Diagnostische Categorien',
         diagnostic_categories_form_diagnostic_categories_identifier_field:
           'Identifier',
         diagnostic_categories_identifier_required_form_error:
           'Identifier is verplicht',
         diagnostic_categories_form_diagnostic_categories_name_en_field:
           'Naam (EN)',
         diagnostic_categories_form_diagnostic_categories_name_nl_field:
           'Naam (NL)',
         diagnostic_categories_name_en_required_form_error:
           'Naam (EN) is verplicht',
         diagnostic_categories_name_nl_required_form_error:
           'Naam (NL) is verplicht',
         diagnostic_categories_form_description_en_field: 'Beschrijving (EN)',
         diagnostic_categories_form_description_nl_field: 'Beschrijving (NL)',
         diagnostic_categories_form_api_error: 'Interne Server Error',
         diagnostic_categories_form_unqiue_diagnostic_categories_name_error:
           'Identifer moet uniek zijn',
         diagnostic_categories_form_api_forbidden:
           'Gebruiker heeft geen rechten om diagnotische categorie aan te maken',
         diagnostic_categories_add_form_success:
           'Categorie is succesvol aangemaakt',
         diagnostic_categories_edit_form_success:
           'Categorie is succesvol bijgewerkt',
         diagnostic_categories_form_add_diagnostic_categories_button:
           'Voeg Categorie Toe',
         diagnostic_categories_form_edit_diagnostic_categories_button:
           'Wijzig Categorie',
         diagnostic_categories_form_cancel_button: 'Annuleer',
         sidebar_diagnostics_overview: 'Diagnostiek',
         sidebar_firmware_menu: 'Firmware',
         firmwares_all: 'Allen',
         firmwares_active: 'Actief',
         firmwares_inactive: 'InActief',
         firmwares_table_identifier: 'Identifier',
         firmwares_table_name_en: 'Naam (EN)',
         firmwares_table_name_nl: 'Naam (NL)',
         firmwares_table_firmware: 'Firmware',
         firmwares_table_status: 'Status',
         firmwares_table_updated_at: 'Bijgewerkt Op',
         firmwares_filter_search: 'Zoeken',
         firmwares_no_record_found: 'Geen Record Gevonden',
         firmwares_table_row_per_page: 'Resultaten Per Pagina',
         firmwares_bulk_no_record_is_selected_error_message:
           'Selecteer records voor groepsdeactivatie aub..',
         firmwares_deactivated_message: 'Firmware is succesvol gedeactiveerd',
         firmwares_activated_message: 'Firmware is succesvol geactiveerd',
         firmwares_title: 'Firmware',
         firmwares_add_new: 'Voeg Nieuwe Toe',
         firmwares_bread_crumb_main_title: 'Firmware',
         add_firmwares_bread_crumb_first_link: 'Voeg firmware Toe',
         edit_firmwares_bread_crumb_first_link: 'Wijzig firmware',
         add_firmwares_form_header: 'Voeg firmware Toe',
         edit_firmwares_form_header: 'Wijzig firmware',
         firmwares_form_firmware_identifier_field: 'Identifier',
         firmwares_identifier_required_form_error: 'Identifier is verplicht',
         firmwares_form_firmware_name_en_field: 'Naam (EN)',
         firmwares_form_firmware_name_nl_field: 'Naam (NL)',
         firmwares_form_firmware_firmware_field: 'Firmware',
         firmwares_name_en_required_form_error: 'Naam (EN) is verplicht',
         firmwares_name_nl_required_form_error: 'Naam (NL) is verplicht',
         firmwares_form_description_en_field: 'Beschrijving (EN)',
         firmwares_form_description_nl_field: 'Beschrijving (NL)',
         firmwares_form_api_error: 'Interne Server Error',
         firmwares_form_unqiue_firmware_name_error: 'Identifer moet uniek zijn',
         firmwares_form_api_forbidden:
           'Gebruiker heeft geen toestemming om firmware aan te maken',
         firmwares_add_form_success: 'Firmware is succesvol aangemaakt',
         firmwares_edit_form_success: 'Firmware is updated succesvol',
         firmwares_form_edit_firmware_button: 'Wijzig firmware',
         firmwares_form_cancel_button: 'Annuleer',
         diagnostic_flows_all: 'Alle',
         diagnostic_flows_active: 'Active',
         diagnostic_flows_inactive: 'InActive',
         diagnostic_flows_filter_delete_button: 'Verwijder',
         diagnostic_flows_table_identifier: 'Identifier',
         diagnostic_flows_table_category: 'Category',
         diagnostic_flows_table_name_en: 'Naam (EN)',
         diagnostic_flows_table_name_nl: 'Naam (NL)',
         diagnostic_flows_table_description_en: 'Beschrijving (EN)',
         diagnostic_flows_table_description_nl: 'Beschrijving (NL)',
         diagnostic_flows_table_status: 'Status',
         diagnostic_flows_table_updated_at: 'Bijgewerkt Op',
         diagnostic_flows_filter_search: 'Zoeken',
         diagnostic_flows_no_record_found: 'Geen Record Gevonden',
         diagnostic_flows_table_row_per_page: 'Resultaten Per Pagina',
         diagnostic_flows_bulk_no_record_is_selected_error_message:
           'Selecter records voor groepsdeactivatie aub.',
         diagnostic_flows_deactivated_message:
           'Flow is succesvol gedeactiveerd',
         diagnostic_flows_activated_message: 'Flow is succesvol geactiveerd',
         diagnostic_flows_bulk_deactivated_message:
           '##DIAGNOSTICS_COUNT## Flows zijn succesvol gedeactiveerd',
         diagnostic_flows_title: 'Diagnostische Flows',
         diagnostic_flows_add_new: 'Voeg Nieuwe Toe',
         diagnostic_flows_bread_crumb_main_title: 'Diagnostische Flows',
         add_diagnostic_flows_bread_crumb_first_link:
           'Voeg Diagnostische Flow Toe',
         edit_diagnostic_flows_bread_crumb_first_link:
           'Wijzig Diagnostische Flow',
         add_diagnostic_flows_form_header: 'Voeg Diagnostische Flow Toe',
         edit_diagnostic_flows_form_header: 'Wijzig Diagnostische Flow',
         diagnostic_flows_form_diagnostic_flows_identifier_field: 'Identifier',
         diagnostic_flows_identifier_required_form_error:
           'Identifier is verplicht',
         diagnostic_flows_form_diagnostic_flows_name_en_field: 'Naam (EN)',
         diagnostic_flows_form_diagnostic_flows_name_nl_field: 'Naam (NL)',
         diagnostic_flows_name_en_required_form_error: 'Naam (EN) is verplicht',
         diagnostic_flows_name_nl_required_form_error: 'Naam (NL) is verplicht',
         diagnostic_flows_category_required_form_error:
           'Categorie is verplicht',
         diagnostic_flows_form_description_en_field: 'Beschrijving (EN)',
         diagnostic_flows_form_description_nl_field: 'Beschrijving (NL)',
         diagnostic_flows_form_flow_condition_error_field:
           'Conditie moet true en false regels hebben',
         diagnostic_flows_form_flow_modal_title_field: 'Weet je dit zeker?',
         diagnostic_flows_form_flow_modal_subtitle_field:
           'Wil je de aanpassingen aan de flow opslaan in de browser?',
         diagnostic_flows_form_flow_modal_cancel_button_field: 'Annuleer',
         diagnostic_flows_form_flow_modal_save_button_field:
           'Sla In Browser Op',
         diagnostic_flows_form_flow_modal_save_success_message:
           'Flow is succesvol opgeslagen in de browser',
         diagnostic_flows_form_featured_image_field: 'Uitgelichte Afbeelding',
         diagnostic_flows_form_upload_featured_image_label:
           'Upload Uitgelichte Afbeelding',
         diagnostic_flows_form_thumbnail_field: 'Miniatuur',
         diagnostic_flows_form_upload_thumbnail_image_label:
           'Upload Miniatuur Afbeelding',
         diagnostic_flows_form_api_error: 'Interne Server Error',
         diagnostic_flows_form_unqiue_diagnostic_flows_name_error:
           'Identifer moet uniek zijn',
         diagnostic_flows_form_api_forbidden:
           'Gebruiker heeft geen rechten om diagnostische flow aan te maken',
         diagnostic_flows_add_form_success:
           'Diagnostisch Flow is succesvol aangemaakt',
         diagnostic_flows_edit_form_success:
           'Diagnostisch Flow is updated succesvol',
         diagnostic_flows_form_add_diagnostic_flows_button: 'Voeg Flow Toe',
         diagnostic_flows_form_edit_diagnostic_flows_button: 'Wijzig Flow',
         diagnostic_flows_form_cancel_button: 'Annuleer',
         audits_select_event_type_error_option: 'Storing',
         diagnostic_flows_form_flow_field: 'Flow',
         diagnostic_flows_form_flow_condition_button: 'Conditie',
         diagnostic_flows_form_flow_timer_button: 'Timer',
         diagnostic_flows_form_flow_normal_node_button: 'Node',
         diagnostic_flows_form_flow_download_image_button:
           'Download Afbeelding',
         diagnostic_flows_form_flow_start_button: 'Start',
         diagnostic_flows_form_flow_end_button: 'Einde',
         devices_bulk_export_mbus_historic_data_button: 'Download Meterdata',
         devices_bulk_export_mbus_historic_data_file_name:
           'Historische Meterdata',
         devices_bulk_mbus_download_title: 'Download Historische Meterdata',
         devices_bulk_bulk_mbus_download_form_date_range: 'Datumbereik:',
         devices_bulk_bulk_mbus_download_form_submit_button:
           'Download Meterdata',
         devices_bulk_bulk_mbus_download_form_cancel_button: 'Annuleer',
         devices_bulk_mbus_download_form_success:
           'Historische Meterdata is succesvol gemaild naar ##EMAIL##!',
         devices_bulk_mbus_download_form_api_error: 'Interne Server Error',
         devices_bulk_mbus_download_no_devices_error: '',
         devices_bulk_mbus_download_form_no_devices_error:
           'Selecteer de devices om door te gaan.',
         devices_bulk_bulk_mbus_download_modal_title: 'Weet je het zeker?',
         devices_bulk_mbus_download_modal_subtitle:
           'Wil je een groepsdownload uitvoeren van Historische Meterdata?',
         devices_bulk_mbus_download_modal_cancel_button: 'Annuleer',
         devices_bulk_mbus_download_modal_submit_button: 'Bevestig',
         projects_bulk_export_mbus_historic_data_button: 'Download Meterdata',
         projects_bulk_export_mbus_historic_data_file_name:
           'Historische Meterdata',
         projects_bulk_mbus_download_title: 'Download Historische Meterdata',
         projects_bulk_bulk_mbus_download_form_date_range: 'Datumbereik:',
         projects_bulk_bulk_mbus_download_form_data_export_type:
           'Data Export Type',
         projects_bulk_bulk_mbus_download_form_data_export_type_combined:
           'Gecombineerd',
         projects_bulk_bulk_mbus_download_form_data_export_type_daily:
           'Dagelijks',
         projects_bulk_bulk_mbus_download_form_data_export_type_normal:
           'Normaal',
         projects_bulk_bulk_mbus_download_form_submit_button:
           'Download Meterdata',
         projects_bulk_bulk_mbus_download_form_cancel_button: 'Annuleer',
         projects_bulk_mbus_download_form_success:
           'Historische Meterdata is succesvol gemaild naar ##EMAIL##!',
         projects_bulk_mbus_download_form_api_error: 'Interne Server Error',
         projects_bulk_mbus_download_no_projects_error: '',
         projects_bulk_mbus_download_form_no_projects_error:
           'Selecteer projecten om door te gaan aub.',
         projects_bulk_bulk_mbus_download_modal_title: 'Weet je het zeker?',
         projects_bulk_mbus_download_modal_subtitle:
           'Wil je een groepsdownload uitvoeren van Historische Meterdata?',
         projects_bulk_mbus_download_modal_cancel_button: 'Annuleer',
         projects_bulk_mbus_download_modal_submit_button: 'Bevestig',
         projects_bulk_mbus_selected_projects: 'Geselecteerde Projecten',
         sidebar_diagnostic_flows: 'Diagnostische Flows',
         diagnostic_flows_form_diagnostic_flows_category_field:
           'Diagnostische Flow Categorie',
         diagnostics_send_message_modal_registers_label: 'Registers',
         diagnostics_send_message_modal_operator_label: 'Operator',
         diagnostics_send_message_modal_value_label: 'Waarde',
         diagnostics_send_message_modal_registers_label_default_option:
           'Selecteer Register',
         diagnostics_send_message_modal_save_button: 'Opslaan',
         diagnostics_send_message_modal_cancel_button: 'Annuleer',
         diagnostics_condition_modal_sensor_type_label: 'Sensor Type',
         diagnostics_condition_modal_modbus_label: 'Modbus Sensor',
         diagnostics_condition_modal_mbus_label: 'Mbus Sensor',
         diagnostics_condition_modal_formula_output_label: 'Formule Output',
         diagnostics_condition_modal_meter_type_label: 'Meter Type',
         diagnostics_condition_modal_meter_type_label_default_option:
           'Selecteer Meter Type',
         diagnostics_condition_modal_operator_label: 'Operator',
         diagnostics_condition_modal_operator_option_1: 'Minder',
         diagnostics_condition_modal_operator_option_2:
           'Minder dan of gelijk aan',
         diagnostics_condition_modal_operator_option_3: 'Gelijk aan',
         diagnostics_condition_modal_operator_option_4: 'Meer',
         diagnostics_condition_modal_operator_option_5:
           'Meer dan of gelijk aan',
         diagnostics_condition_modal_operator_option_6: 'Niet Gelijk aan',
         diagnostics_condition_modal_register_label: 'Register',
         diagnostics_condition_modal_value_label: 'Waarde',
         diagnostics_condition_modal_timer_label: 'Timer',
         diagnostics_condition_modal_retries_label: 'Pogingen',
         diagnostics_condition_modal_delay_label: 'Vertraging',
         diagnostics_condition_modal_times_label: 'times',
         diagnostics_condition_modal_second_label: 'sec',
         diagnostics_condition_modal_save_button: 'Opslaan',
         diagnostics_condition_modal_cancel_button: 'Annuleer',
         extra_white_space_form_error: 'Extra witte ruimte is niet toegestaan',
         diagnostic_flows_form_incomplete_flow_error:
           'Check randen en nodes met zwarte kleur en rode animatie',
         diagnostic_flows_menu_information: 'Informatie',
         diagnostic_flows_menu_modbus: 'Modbus',
         diagnostic_flows_menu_message: 'Bericht',
         diagnostic_flows_menu_condition: 'Conditie',
         diagnostic_flows_menu_user_interaction: 'Gebruikersinteractie',
         diagnostic_flows_menu_steps: 'Pagina',
         diagnostic_flows_menu_timer: 'Timer',
         diagnostic_flows_menu_formula: 'Formule',
         diagnostic_flows_form_user_interaction_operation_type: 'Operatie Type',
         diagnostic_flows_form_user_interaction_operation_type_default_option:
           'Selecteer Operatie Type',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_mbus_meter:
           'Kies Meter',
         diagnostic_flows_form_user_interaction_operation_type_option_choose_faucet:
           'Kies Kraan Register',
         diagnostic_flows_form_user_interaction_field_type_option_select_field:
           'Selecteer Field Type',
         diagnostic_flows_form_user_interaction_field_type: 'Field Type',
         diagnostic_flows_form_user_interaction_field_type_default_option:
           'Selecteer Field Type',
         diagnostic_flows_form_user_interaction_field_type_option_checkbox:
           'Checkbox',
         diagnostic_flows_form_user_interaction_field_type_option_radio_button:
           'Radio Knop',
         diagnostic_flows_form_user_interaction_field_type_option_text_field:
           'Textveld',
         diagnostic_flows_form_user_interaction_description_en:
           'Beschrijving (EN)',
         diagnostic_flows_form_user_interaction_description_nl:
           'Beschrijving (NL)',
         diagnostic_flows_form_steps_label_en: 'Beschrijving (EN)',
         diagnostic_flows_form_steps_label_nl: 'Beschrijving (NL)',
         diagnostic_formulas_form_diagnostic_formulas_retries_field: 'Pogingen',
         diagnostic_formulas_form_diagnostic_formulas_delay_field: 'Vertraging',
         diagnostic_formulas_form_diagnostic_formulas_unit_field:
           'Formule Unit',
         diagnostic_formulas_form_forumla_field_placeholder:
           'Kies @ om Modbus of Mbus Registers te selecteren',
         device_single_diagnostic_flow_missing_pages_error:
           '##SELECTED_FLOW## heeft geen paginas. Voeg paginas in de flow toe om door te gaan.',
         device_single_stepper_choose_flow_title: 'Kies de flow',
         device_single_stepper_choose_explanation_of_flow_wizard_title:
           'Uitleg van de wizard',
         device_single_stepper_result_title: 'Resultaat',
         diagnostic_flows_form_delete_node_modal_title: 'Weet je het zeker?',
         diagnostic_flows_form_delete_node_modal_subtitle:
           'Wil je de node ##NODE_LABEL## verwijderen?',
         diagnostic_flows_form_delete_node_modal_cancel_button: 'Annuleer',
         diagnostic_flows_form_delete_node_modal_delete_button: 'Verwijder',
         diagnostic_flows_form_loading_text: 'Laden ...',
         diagnostic_flows_form_processing_text: 'Verwerken',
         diagnostic_flows_form_main_error_text:
           'Flow is gestopt door een storing',
         diagnostic_flows_form_main_success_text: 'Flow is succesvol afgerond',
         devices_bulk_download_form_data_type: 'Data Type',
         devices_bulk_download_form_export_type: 'Export Type',
         devices_bulk_download_form_data_type_daily: 'Dagelijks',
         devices_bulk_download_form_data_type_hourly: 'Uurlijks',
         devices_bulk_download_form_export_type_combined: 'Gecombineerd',
         devices_bulk_download_form_export_type_separated: 'Gescheiden',
         diagnostic_flows_form_main_stopped_text:
           'Flow is gestopt door de gebruiker',
         diagnostic_execution_title: 'Diagnostisch Uitvoeringen',
         diagnostic_execution_table_created_at: 'Aangemaakt Op',
         diagnostic_execution_table_device: 'Device',
         diagnostic_execution_table_user: 'Gebruiker',
         diagnostic_execution_table_flow: 'Flow',
         diagnostic_execution_table_status: 'Status',
         diagnostic_execution_table_filter_search: 'Zoeken',
         diagnostic_executions_tab_all: 'Alle',
         diagnostic_executions_tab_completed: 'Voltooid',
         diagnostic_executions_tab_in_progress: 'In Uivoering',
         diagnostic_executions_tab_stopped: 'Gestopt',
         diagnostic_executions_tab_error: 'Storing',
         diagnostic_executions_table_no_record_found: 'Geen Records Gevonden',
         diagnostic_executions_table_row_per_page: 'Resultaten Per Pagina',
         diagnostic_flows_menu_result: 'Resultaat',
         diagnostic_flows_menu_result_form_description_en: 'Beschrijving (EN)',
         diagnostic_flows_menu_result_form_description_nl: 'Beschrijving (NL)',
         diagnostic_flows_menu_result_form_cancel_button: 'Annuleer',
         diagnostic_flows_menu_result_form_save_button: 'Opslaan',
         diagnostic_flows_menu_page_form_cancel_button: 'Annuleer',
         diagnostic_flows_menu_page_form_save_button: 'Opslaan',
         diagnostic_flows_menu_information_form_description_en:
           'Beschrijving (EN)',
         diagnostic_flows_menu_information_form_description_nl:
           'Beschrijving (NL)',
         diagnostic_flows_menu_information_form_cancel_button: 'Annuleer',
         diagnostic_flows_menu_information_form_save_button: 'Opslaan',
         sidebar_diagnostic_execution_title: 'Diagnostsche Uitvoeringen',
         diagnostic_flow_execution_single_first_bread_crumb:
           'Diagnostische Uitvoeringen',
         diagnostic_flow_execution_single_second_bread_crumb:
           'Bekijk Diagnostische Execution',
         diagnostic_flow_execution_single_output_tab: 'Output',
         diagnostic_flow_execution_single_device_name: 'Device',
         diagnostic_flow_execution_single_flow: 'Flow',
         diagnostic_flow_execution_single_user: 'Gebruiker',
         diagnostic_flow_execution_single_status: 'Status',
         diagnostic_flow_execution_single_created_at: 'Aangemaakt Op',
         diagnostic_flow_execution_single_bulk_export_file_name:
           'Diagnostische Uitvoeringen in Groep',
         diagnostic_flow_execution_single_bulk_export_date: 'Datum',
         diagnostic_flow_execution_single_bulk_export_time: 'Tijd',
         diagnostic_flow_execution_single_bulk_export_device_name:
           'Device Naam',
         diagnostic_flow_execution_single_bulk_export_device_serial_number_mercurius:
           'Serienummer Mercurius',
         diagnostic_flow_execution_single_bulk_export_device_user_full_name:
           'Gebruiker',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_en:
           'Flow Naam (EN)',
         diagnostic_flow_execution_single_bulk_export_device_flow_name_nl:
           'Flow Naam (NL)',
         diagnostic_flow_execution_single_bulk_export_device_status: 'Status',
         diagnostic_flows_form_main_flow_already_running_error_text:
           'Een flow is al bezig op dit Device. Meerdere flow uitvoeringen zijn niet toegestaan',
         diagnostic_flows_form_open_faucet_on_option: 'Aan',
         diagnostic_flows_form_open_faucet_off_option:
           'Uit (Flow gaat in storingsmodus)',
         diagnostic_flows_form_mbus_meters_error:
           'Device heeft geen vereiste Meters voor de flow',
         diagnostic_flows_result_title: 'Resultaat',
         duplicate_diagnostic_flows_form_header: 'Dupliceer Diagnostische Flow',
         duplicate_diagnostic_flows_bread_crumb_first_link:
           'Dupliceer Diagnostische Flow',
         diagnostic_flows_form_duplicate_diagnostic_flows_button: 'Dupliceer',
         diagnostic_flows_duplicate_form_success:
           'Diagnostische Flow is succesvol gedupliceerd ',
         diagnostic_flows_filter_duplicate_button: 'Dupliceer Flow',
         diagnostic_flows_menu_result_form_id: 'Id',
         audits_street_number_filter_label: 'Straat',
         audits_house_number_filter_label: 'Huisnummer',
         diagnostic_execution_counter_title: 'Diagnostisch Uitvoering Tellers',
         diagnostic_execution_counter_table_id: 'Id',
         diagnostic_execution_counter_table_counter: 'Tellers',
         diagnostic_execution_counter_table_flow: 'Flow',
         diagnostic_execution_counter_table_result: 'Resultaat',
         diagnostic_execution_counter_table_filter_search: 'Zoeken',
         diagnostic_execution_counter_table_no_record_found:
           'Geen Records Gevonden',
         diagnostic_execution_counter_table_row_per_page:
           'Resultaten Per Pagina',
         sidebar_diagnostic_flow_execution_counter: 'Diagnostisch Flow Tellers',
         device_single_firmware_hiu_label: 'Firmware afleverset',
         device_single_firmware_mercurius_label: 'Firmware Mercurius',
         custom_popover_105_long_description:
           'Storing Register Lange Beschrijving',
         settings_menu_title: 'Instellingen',
         settings_menu_clients_title: 'Klanten',
         settings_menu_admins_title: 'Admins',
         settings_menu_kong_admins_title: 'Kong admins',
         settings_menu_kong_clients_title: 'Kong klanten',
         settings_menu_diagnostics_title: 'Diagnostiek',
         settings_menu_formulas_title: 'Formules',
         settings_menu_flows_title: 'Flows',
         settings_menu_categories_title: 'Categorien',
         settings_menu_firmwares_title: 'Firmware',
         settings_menu_appliance_types_title: 'Toesteltypen',
         settings_menu_notifications_title: 'Berichten',
         settings_menu_roles_title: 'Rollen',
         settings_menu_modules_title: 'Modules',
         settings_menu_permissions_title: 'Rechten',
         settings_menu_go_back_button: 'Terug',
         audits_device_name_filter_label: 'Device naam',
         device_single_documentation_parts_button: 'Onderdelen',
         device_single_documentation_lab_vision_button: 'Labvision',
         device_single_documentation_manuals_button: 'Handleiding',
         device_single_documentation_incident_button: 'Storingsleutel',
         navbar_avg_proof_switch: 'Privacyschakelaar',
         clients_filter_bulk_delete_button: 'Verwijder',
         clients_bulk_delete_no_clients_with_zero_devices_is_selected_error_message:
           'Please select at least one record with 0 devices and 0 users',

         clients_bulk_delete_clients_with_devices_count_is_selected_error_message:
           'Please select only those records which have 0 devices and 0 users',
         projects_filter_bulk_delete_button: 'Verwijder',
         projects_bulk_delete_no_projects_with_zero_devices_is_selected_error_message:
           'Selecteer ten minste een record met 0 devices',
         projects_bulk_delete_projects_with_devices_count_is_selected_error_message:
           'Selecteer enkel die records die 0 devices hebben',
         projects_bulk_deleted_message:
           '{{ PROJECTS_COUNT }} Projecten zijn succesvol verwijderd',
         projects_delete_modal_title: 'Weet je het zeker?',
         projects_delete_modal_subtitle: 'Wil je de Records verwijderen?',
         projects_delete_modal_cancel_button: 'Annuleer',
         projects_delete_modal_delete_button: 'Verwijder',
         users_delete_modal_title: 'Weet je het zeker?',
         users_delete_modal_subtitle: 'Wil je de Records verwijderen?',
         users_delete_modal_cancel_button: 'Annuleer',
         users_delete_modal_delete_button: 'Verwijder',
         users_bulk_delete_no_user_is_selected_error_message:
           'Selecteer te verwijderen records',
         users_bulk_deleted_message:
           '{{ USERS_COUNT }} Gebruikers zijn succesvol verwijderd',
         service_client_single_filter_bulk_delete_button: 'Verwijder',
         service_client_single_no_user_selected_for_deleted_message:
           'Selecteer te verwijderen records',
         admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Admins zijn succesvol verwijderd',
         admins_no_user_selected_for_deleted_message:
           'Selecteer te verwijderen records',
         admins_filter_bulk_delete_button: 'Verwijder',
         kong_admins_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Admins zijn succesvol verwijderd',
         audits_message_type_label: 'Bericht Type',
         audit_bulk_export_file_name: 'Audits Bestand',
         registers_reporting_details_all_tab: 'Alle',
         registers_reporting_details_pending_tab: 'Bezig',
         registers_reporting_details_success_tab: 'Succesvol',
         registers_reporting_details_failure_tab: 'Mislukt',
         devices_form_is_service_device_field: 'Service Device',
         service_portal_login_in_correct_qr_code:
           'Device serienummer is incorrect',
         service_portal_login_in_correct_credentials:
           'Device gegevens zijn incorrect. Neem contact op met Fortes Administrator.',
         service_portal_login_not_a_registered_service_device:
           'Device met serienummer {{ SERIAL_NUMBER }} is niet geregistreerd.',
         devices_unprovisioned: 'Ongeregistreerd',
         sidebar_unprovisioned_devices: 'Devices - Ongeregistreerd',
         dashboard_unprovisioned: 'ONGEREGISTREERD',
         device_single_documentation_warmwater_button: 'Storing Warm Water',
         device_single_documentation_verwarming_button: 'Storing Verwarming',
         service_portal_login_in_serial_number_scan_button: 'Scan serienummer',
         service_portal_login_in_heat_interface_unit_scan_button:
           'Scan afleverset',
         service_portal_login_in_serial_number_scanned_message:
           'Serienummer is gescand',
         service_portal_login_in_heat_interface_unit_scanned_message:
           'Afleverset is gescand',
         swapping_device_missing_new_device_error:
           'Nieuw Device is niet geimporteerd in de Mercurius database',
         device_single_dashboard_mbus_title: 'MBus',
         device_single_dashboard_tab: 'Dashboard',
         device_single_offline_detailed_message: 'Device is "Offline"',
         device_single_online_detailed_message:
           'Device is "Online", alles werkt prima',
         device_single_error_detailed_message: 'Device is in "Storing" mode',
         device_single_status_documents_link: 'Device Documenten',
         email_device_delete_subscription_title:
           'Fortes Data Beheer - Verwijder Abonnement',
         email_device_delete_subscription_api_status_title:
           'Maxitel API Response:',
         email_device_delete_subscription_type_swapped_device_message:
           'Device abonnement is verwijderd in Device Uitwisseling module',
         email_device_delete_subscription_type_clear_device_message:
           'Device abonnement is verwijderd in Device Wissen module',
         devices_form_subscription_id_field: 'Abonnement Id',
         device_single_rss_sim_status: 'SIM Status',
         device_monitoring_error_list_table_title: 'Storingsgeschiedenis',
         device_monitoring_error_list_table_device: 'Device',
         device_monitoring_error_list_table_alarm_code: 'Storingscode',
         device_monitoring_error_list_table_start_date: 'Startdatum',
         device_monitoring_error_list_table_end_date: 'Einddatum',
         device_monitoring_data_consumed_list_table_title: 'Data Verbruikt',
         device_monitoring_data_consumed_list_table_device: 'Device',
         device_monitoring_data_consumed_list_table_data_usage: 'Dataverbruik',
         device_monitoring_data_consumed_list_table_date: 'Datum',
         device_monitoring_ota_history_list_table_title: 'OTA Geschiedenis',
         device_monitoring_ota_history_list_table_device: 'Device',
         device_monitoring_ota_history_list_table_status: 'Status',
         device_monitoring_ota_history_list_table_date: 'Datum',
         device_monitoring_device_status_history_title:
           'Device Status Geschiedenis',
         device_monitoring_device_status_history_hr: 'Uur',
         device_monitoring_device_status_history_no_graph_data_error:
           'De grafiek is niet beschikbaar',
         device_monitoring_device_status_history_graph_loading_data:
           'Laden grafiek',
         device_monitoring_firmware_history_title: 'Firmware Geschiedenis',
         device_monitoring_device_firmware_history_graph_loading_data:
           'Laden staafdiagram',
         device_monitoring_device_firmware_history_no_graph_data_error:
           'De staafdiagram is niet beschikbaar',
         sidebar_devices_monitoring: 'Devices Monitoring',
         device_monitoring_projects_counter_title: 'Projecten Teller',
         device_monitoring_device_projects_counter_graph_loading_data:
           'Laden staafdiagram',
         device_monitoring_device_projects_counter_no_graph_data_error:
           'De staafdiagram is niet beschikbaar',
         device_monitoring_users_counter_title: 'Gebruikers Teller',
         device_monitoring_device_users_counter_graph_loading_data:
           'Laden staafdiagram',
         device_monitoring_device_users_counter_no_graph_data_error:
           'De staafdiagram is niet beschikbaar',
         device_monitoring_sim_counter_title: 'SIM Data Teller',
         device_monitoring_sim_counter_exceeded_data_title: 'Overschreden',
         device_monitoring_sim_counter_in_package_data_title:
           'In Pakket Limiet',
         device_monitoring_device_sim_counter_graph_loading_data:
           'Laden staafdiagram',
         device_monitoring_device_sim_counter_no_graph_data_error:
           'De staafdiagram is niet beschikbaar',
         service_portal_login_in_dont_have_hiu_qr_code_checkbox_field:
           'Geen afleverset QR Code',
         service_portal_login_hiu_autocomplete: 'Afleverset',
         device_monitoring_device_error_counters_title:
           'Storingsteller geschiedenis',
         device_monitoring_device_error_counters_error: 'Geen data gevonden',
         device_monitoring_device_error_counters_no_graph_data_error:
           'Het cirkeldiagram is niet beschikbaar',
         device_monitoring_date_range_field: 'Datumbereik',
         reporting_ota_details_retries_tab: 'Pogingen',
         device_monitoring_single_page_title: 'Device Monitoring',
         device_monitoring_ota_history_list_table_fail_counter: 'Pogingen',
         device_monitoring_ota_history_list_table_user: 'Gebruiker',
         device_monitoring_ota_history_list_table_message: 'Bericht',
         device_monitoring_ota_history_list_table_old_firmware_version:
           'Oude firmware versie',
         device_monitoring_project_list_table_title: 'Projecten',
         device_monitoring_firmware_list_table_title: 'Firmware',
         device_monitoring_firmware_list_table_firmware_version: 'Firmware',
         device_monitoring_firmware_list_table_device: 'Device',
         device_monitoring_firmware_list_table_project: 'Project',
         device_monitoring_firmware_list_table_saved_at: 'Datum',
         monitoring_users_list_table_title: 'Gebruikers',
         monitoring_kong_users_list_table_title: 'Kong Gebruikers',
         monitoring_kong_users_filter_kong_admin: 'Kong Admin',
         monitoring_kong_users_filter_kong_client: 'Kong klant',
         client_single_users_table_role: 'Rol',
         device_monitoring_device_status_list_table_title: 'Device Status',
         navbar_languages_english: 'English',
         navbar_languages_dutch: 'Nederlands',
         navbar_languages_german: 'Deutsch',
         device_single_device_settings_tab: 'Instellingen v2',
         device_single_device_settings_title: 'Device v2 Instellingen',
         device_single_device_settings_secondary_device_type_field:
           'Secundaire Device Type',
         device_single_device_settings_base_topic_field: 'Base Topic',
         device_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         device_single_device_settings_select_baud_rate_uart_field:
           'Selecteer Baud Rate UART',
         device_single_device_settings_modbus_error_register_address_field:
           'Modbus storingsregister adres',
         device_single_device_settings_modbus_error_register_value_field:
           'Modbus verwachte storingsregister waarde',
         device_single_device_settings_reboot_device_v2: 'Herstarten',
         device_single_device_settings_send_button_v2: 'Versturen',
         device_single_device_settings_secondary_device_type_message_forwarded:
           'Device Secundaire Device Type bericht is verstuurd naar Device',
         device_single_device_settings_reboot_message_forwarded:
           'Device Reboot bericht is verstuurd naar Device',
         device_single_device_settings_base_topic_message_forwarded:
           'Device Base Topic bericht is verstuurd naar Device',
         device_single_device_settings_baud_rate_uart_message_forwarded:
           'Device Baud Rate UART bericht is verstuurd naar Device',
         device_single_device_settings_modbus_error_register_address_message_forwarded:
           'Device Modbus storingsregister adres bericht is verstuurd naar Device',
         device_single_device_settings_modbus_expected_error_register_value_message_forwarded:
           'Device Modbus verwachte storingsregister waarde bericht is verstuurd naar Device',
         device_single_device_settings_secondary_device_type_error:
           'Secundaire Device Type moet liggen tussen 1 en 254',
         device_single_device_settings_base_topic_error:
           'Base Topic lengte moet liggen tussen 5 en 50',
         device_single_device_settings_baud_rate_uart_error:
           'Selecteer een optie voor Baud Rate UART',
         device_single_device_settings_modbus_error_register_address_error:
           'Modbus storingsregister adres moet liggen tussen 0 en 65535',
         device_single_device_settings_modbus_error_register_value_error:
           'Modbus verwacht storingsregister waarde moet liggen tussen 0 en 65535',
         device_monitoring_device_error_counters_loading_data:
           'Laden cirkeldiagram',
         diagnostic_formulas_form_diagnostic_formulas_name_de_field:
           'Naam (DE)',
         diagnostic_formulas_name_de_required_form_error:
           'Naam (DE) is verplicht',
         diagnostic_formulas_form_description_de_field: 'Beschrijving (DE)',
         diagnostic_flows_form_diagnostic_flows_name_de_field: 'Naam (DE)',
         diagnostic_flows_name_de_required_form_error: 'Naam (DE) is verplicht',
         diagnostic_flows_form_description_de_field: 'Beschrijving (DE)',
         diagnostic_categories_form_diagnostic_categories_name_de_field:
           'Naam (DE)',
         diagnostic_categories_name_de_required_form_error:
           'Naam (DE) is verplicht',
         diagnostic_categories_form_description_de_field: 'Beschrijving (DE)',
         diagnostic_categories_table_name_de: 'Naam (DE)',
         diagnostic_flows_table_name_de: 'Naam (DE)',
         diagnostic_formulas_table_name_de: 'Naam (DE)',
         modules_form_module_name_de_field: 'Naam (DE)',
         modules_name_de_required_form_error: 'Naam (DE) is verplicht',
         modules_form_description_de_field: 'Beschrijving (DE)',
         modules_table_name_de: 'Naam (DE)',
         modules_table_description_de: 'Beschrijving (DE)',
         roles_form_role_name_de_field: 'Naam (DE)',
         roles_name_de_required_form_error: 'Naam (DE) is verplicht',
         roles_form_description_de_field: 'Beschrijving (DE)',
         roles_table_name_de: 'Naam (DE)',
         roles_table_description_de: 'Beschrijving (DE)',
         permissions_form_permission_name_de_field: 'Naam (DE)',
         permissions_form_description_de_field: 'Beschrijving (DE)',
         permissions_table_name_de: 'Naam (DE)',
         permissions_table_description_de: 'Beschrijving (DE)',
         notifications_form_title_de_field: 'Titel (DE)',
         notifications_form_description_de_field: 'Beschrijving (DE)',
         firmwares_name_de_required_form_error: 'Naam (DE)',
         firmwares_form_firmware_name_de_field: 'Naam (DE) is verplicht',
         navbar_languages_danish: 'Deens',
         firmwares_name_dk_required_form_error: 'Naam (DK)',
         firmwares_form_firmware_name_dk_field: 'Naam (DK) is verplicht',
         diagnostic_formulas_form_diagnostic_formulas_name_dk_field:
           'Naam (DK)',
         diagnostic_formulas_name_dk_required_form_error:
           'Naam (DK) is verplicht',
         diagnostic_formulas_form_description_dk_field: 'Beschrijving (DK)',
         diagnostic_flows_form_diagnostic_flows_name_dk_field: 'Naam (DK)',
         diagnostic_flows_name_dk_required_form_error: 'Naam (DK) is verplicht',
         diagnostic_flows_form_description_dk_field: 'Beschrijving (DK)',
         diagnostic_categories_form_diagnostic_categories_name_dk_field:
           'Naam (DK)',
         diagnostic_categories_name_dk_required_form_error:
           'Naam (DK) is verplicht',
         diagnostic_categories_form_description_dk_field: 'Beschrijving (DK)',
         diagnostic_categories_table_name_dk: 'Naam (DK)',
         diagnostic_flows_table_name_dk: 'Naam (DK)',
         diagnostic_formulas_table_name_dk: 'Naam (DK)',
         modules_form_module_name_dk_field: 'Naam (DK)',
         modules_name_dk_required_form_error: 'Naam (DK) is verplicht',
         modules_form_description_dk_field: 'Beschrijving (DK)',
         modules_table_name_dk: 'Naam (DK)',
         modules_table_description_dk: 'Beschrijving (DK)',
         roles_form_role_name_dk_field: 'Naam (DK)',
         roles_name_dk_required_form_error: 'Naam (DK) is verplicht',
         roles_form_description_dk_field: 'Beschrijving (DK)',
         roles_table_name_dk: 'Naam (DK)',
         roles_table_description_dk: 'Beschrijving (DK)',
         permissions_form_permission_name_dk_field: 'Naam (DK)',
         permissions_form_description_dk_field: 'Beschrijving (DK)',
         permissions_table_name_dk: 'Naam (DK)',
         permissions_table_description_dk: 'Beschrijving (DK)',
         notifications_form_title_dk_field: 'Titel (DK)',
         notifications_form_description_dk_field: 'Beschrijving (DK)',
         device_monitoring_data_consumed_list_table_project: 'Project',
         project_single_device_list_search_mbus_registers_by_project:
           'Zoeken Mbus Registers',
         project_single_fetch_mbus_registers_by_project_success_message:
           'Bericht is succesvol verstuurd naar Project ##PROJECT_NAME## Devices',
         project_single_fetch_mbus_registers_by_project_error_message:
           'Interval Server Storing',
         devices_list_diagnostic_filters_title: 'Registers Filter',
         devices_list_diagnostics_condition_modal_sensor_type_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_modbus_label: 'Modbus Sensor',
         devices_list_diagnostics_condition_modal_mbus_label: 'Mbus Sensor',
         devices_list_diagnostics_condition_modal_formula_output_label:
           'Formule Output',
         devices_list_diagnostics_condition_modal_meter_type_label:
           'Meter Type',
         devices_list_diagnostics_condition_modal_meter_type_label_default_option:
           'Selecteer Meter Type',
         devices_list_diagnostics_condition_modal_operator_label: 'Operator',
         devices_list_diagnostics_condition_modal_operator_option_1: 'Minder',
         devices_list_diagnostics_condition_modal_operator_option_2:
           'Minder dan of gelijk aan',
         devices_list_diagnostics_condition_modal_operator_option_3:
           'Gelijk aan',
         devices_list_diagnostics_condition_modal_operator_option_4: 'Meer',
         devices_list_diagnostics_condition_modal_operator_option_5:
           'Meer dan of gelijk aan',
         devices_list_diagnostics_condition_modal_operator_option_6:
           'Niet Gelijk aan',
         devices_list_diagnostics_condition_modal_register_label: 'Register',
         devices_list_diagnostics_condition_modal_register_required_error:
           'Register is verplicht',
         devices_list_diagnostics_send_message_modal_registers_label_default_option:
           'Selecteer Register',
         devices_list_diagnostics_condition_modal_value_label: 'Waarde',
         devices_list_diagnostics_condition_modal_value_is_required_error:
           'Waarde is verplicht',
         devices_list_diagnostics_condition_modal_operator_is_required_error:
           'Operator is verplicht',
         devices_list_diagnostics_condition_modal_meter_is_required_error:
           'Meter is verplicht',
         devices_list_diagnostics_condition_modal_value_invalid_error:
           'Ongeldige Waarde, controleer aub',
         devices_list_diagnostics_condition_modal_filter_button: 'Filter',
         devices_list_diagnostics_condition_modal_close_button: 'Sluiten',
         devices_list_diagnostics_condition_modal_add_button:
           'Voeg meer filters toe',
         error_check_table_title: 'Device Storing Checks',
         error_check_table_filter_search: 'Zoeken',
         error_check_table_no_record_found: 'Geen Records Gevonden',
         error_check_table_row_per_page: 'Resultaten Per Pagina',
         error_check_table_created_at: 'Aangemaakt Op',
         error_check_table_total_devices: 'Totale Devices',
         error_check_details_table_title: 'Device Storing Check Details',
         error_check_details_table_filter_search: 'Zoeken',
         error_check_details_table_no_record_found: 'Geen Records Gevonden',
         error_check_details_table_row_per_page: 'Resultaten Per Pagina',
         error_check_details_table_created_at: 'Aangemaakt Op',
         error_check_details_table_device: 'Device',
         error_check_details_table_old_error: 'Oude Storing',
         error_check_details_table_new_error: 'Nieuwe Storing',
         error_check_details_table_status: 'Status',
         error_check_details_table_status_success: 'Succes',
         error_check_details_table_status_failed: 'Failure',
         error_check_details_table_all_tab: 'Alle',
         error_check_details_table_success_tab: 'Succes',
         error_check_details_table_failure_tab: 'Fout',
         error_check_details_table_device_name: 'Device Naam',
         error_check_details_table_device_serial_number: 'Serienummer',
         sidebar_devices_error_check: 'Storing Devices',
         error_check_details_table_bulk_export_file_name:
           'Overzicht Storing Devices Details',
         error_check_table_bulk_export_file_name: 'Overzicht Storing Devices',
         device_single_registers_table_min_error:
           'Waarde moet groter zijn dan of gelijk aan minimale waarde',
         device_single_registers_table_invalid_value_error:
           'Voer een geldig nummer in',
         project_single_project_setting_tab: 'Project Instellingen',
         project_single_project_setting_mbus_registers_title: 'MBus Registers',
         project_single_project_setting_mbus_register_accumulated_heating_energy_title:
           'Eenheid cumulatieve verwarmingsenergie',
         project_single_project_setting_mbus_register_accumulated_heating_energy_success_message:
           'Eenheid cumulatieve verwarmingsenergie is succesvol geupdatet',
         project_single_project_setting_mbus_register_accumulated_heating_energy_error_message:
           'Update Eenheid cumulatieve verwarmingsenergie niet geslaagd',
         project_single_project_setting_select_mbus_register_accumulated_heating_energy_title:
           'Selecteer Cumulatieve verwarmingsenergie',
         project_single_project_setting_select_mbus_register_update_button:
           'Update',
         custom_popover_100_short_description: 'Verwarming status',
         custom_popover_101_short_description: 'Tapwater status',
         custom_popover_102_short_description: 'Warmhoud status',
         custom_popover_103_short_description: 'Anti Legionella status',
         custom_popover_104_short_description: 'Koelen status',
         custom_popover_1802_short_description: 'Elektrisch element',
         custom_popover_105_short_description: 'Storing',
         custom_popover_106_short_description: 'Software versie',
         custom_popover_107: 'Tapwater regelafsluiter (M1)',
         custom_popover_108: 'Verwarmen/koelen regelafsluiter (M2)',
         custom_popover_109_short_description: 'Circulatie pomp',
         custom_popover_110_short_description: '6-weg kogelafsluiter',
         custom_popover_113_short_description: 'Ruimte thermostaat',
         custom_popover_114_short_description: 'OpenTherm Indicatie',
         custom_popover_200_short_description: 'Volumestroom tapwater',
         custom_popover_201_short_description: 'T-Tapwater',
         custom_popover_202_short_description: 'T-Primaire aanvoer',
         custom_popover_203_short_description:
           'T-Primaire retour (T-Booster voor TE-Booster toestellen)',
         custom_popover_205_short_description: 'T-Secundaire aanvoer',
         custom_popover_206_short_description: 'T-Secundaire retour',
         custom_popover_204_short_description:
           'Berekende aanvoertemperatuur (setpoint)',
         custom_popover_207_short_description: 'Ruimte temperatuur(OpenTherm)',
         custom_popover_208_short_description: 'Ruimte setpoint (OpenTherm)',
         custom_popover_210_short_description:
           'Waterdruk in de binnenhuisinstallatie',
         custom_popover_800_short_description: 'Totale bedrijfstijd afleverset',
         custom_popover_801_short_description:
           'Totale bedrijfstijd warmte-vraag',
         custom_popover_802_short_description:
           'Totale bedrijfstijd koude-vraag',
         custom_popover_803_short_description:
           'Totale bedrijfstijd tapwater-vraag',
         custom_popover_804_short_description: 'Aantal tappingen',
         custom_popover_805_short_description:
           'Totale volume tapwater (let op! dit is een indicatie)',
         custom_popover_806_short_description: 'Stroomonderbrekingen',
         create_role_stepper_information_title: 'Informatie',
         create_role_stepper_client_title: 'Klant',
         create_role_stepper_service_client_title: 'Service klant',
         create_role_stepper_project_title: 'Project',
         create_role_stepper_device_management_title: 'Device Beheer',
         create_role_stepper_commissioning_title: 'Inbedrijfstelling',
         create_role_stepper_reporting_title: 'Rapport',
         create_role_stepper_general_title: 'Algemeen',
         roles_form_role_name_field: 'Naam',
         roles_name_required_form_error: 'Naam is verplicht',
         roles_form_description_field: 'Omschrijving',
         create_role_stepper_back_button: 'Terug',
         create_role_stepper_next_button: 'Volgende',
         create_role_stepper_finish_button: 'Voltooien',
         create_role_stepper_yes_label: 'Ja',
         create_role_stepper_no_label: 'Nee',
         create_role_stepper_step_2_client_view_all_users:
           'Bekijk alle gebruikers?',
         create_role_stepper_step_2_client_create_new_users:
           'Maak nieuwe gebruikers aan?',
         create_role_stepper_step_2_client_edit_new_users:
           'Wijzig bestaande gebruikers zoals de rol?',
         create_role_stepper_step_3_service_client_create_new:
           "Maak een nieuwe 'service klant' aan?",
         create_role_stepper_step_3_service_client_view_users:
           "Bekijk bestaande 'service klant' gebruikers?",
         create_role_stepper_step_3_service_client_create_users:
           "Maak nieuwe 'service klant' gebruiker aan?",
         create_role_stepper_step_3_service_client_modify_users:
           "Wijzig 'service klant' gebruikers zoals de rol?",
         create_role_stepper_step_4_project_view: 'Bekijk projecten?',
         create_role_stepper_step_4_project_create_new:
           'Maak nieuw project aan?',
         create_role_stepper_step_4_project_export_mbus_data:
           'Exporteer energiemeterdata van projecten?',
         create_role_stepper_step_5_device_view_single_page: 'Open een Device?',
         create_role_stepper_step_5_device_view_single_page_setting_registers:
           'Bekijk instelligen?',
         create_role_stepper_step_5_device_edit_single_page_setting_registers:
           'Wijzig instelligen?',
         create_role_stepper_step_5_device_edit_single_page_manual_control:
           'Gebruik handbediening?',
         create_role_stepper_step_5_device_single_page_view_history:
           'Bekijk geschiedenis?',
         create_role_stepper_step_5_device_single_page_view_meter_data:
           'Bekijk meterdata?',
         create_role_stepper_step_5_device_single_page_use_diagnostics_module:
           'Gebruik de diagnostische module?',
         create_role_stepper_step_5_device_single_page_information_and_delivery_set_data:
           'Bekijk informatie zoals Device info, adres details, en afleverset data?',
         create_role_stepper_step_6_commissioning_module_put_devices_into_operation:
           'Inbedrijfstelling module om devices in bedrijf te stellen?',
         create_role_stepper_step_6_commissioning_module_swapping:
           'Devices uitwisselen (verplaats data van oude Device naar nieuwe Device)?',
         create_role_stepper_step_7_reporting_audit:
           'Het logboek dat alle berichten, storingen, en acties bevat op devices?',
         create_role_stepper_step_7_reporting_swapped_devices:
           'Logboek van uitgewisselde devices?',
         create_role_stepper_step_7_reporting_error_devices:
           'Logboek van devices with faults?',
         create_role_stepper_step_7_reporting_bulk_registers_update:
           'Resultaten van groepsaanpassingen?',
         create_role_stepper_step_8_view_dashboard:
           'Dashboard volledige toegang en sidebar Device tellers',
         create_role_stepper_step_8_general_create_role: 'Rollen aanmaken?',
         create_role_stepper_question_required_error:
           'Een optie is verplicht om door te gaan',
         roles_form_role_name_en_field: 'Naam (EN)',
         roles_form_role_name_nl_field: 'Naam (NL)',
         roles_name_en_required_form_error: 'Naam (EN) is verplicht',
         roles_name_nl_required_form_error: 'Naam (NL) is verplicht',
         roles_form_description_en_field: 'Omschrijving (EN)',
         roles_form_description_nl_field: 'Omschrijving (NL)',
         project_single_project_setting_device_v2_settings_title:
           'Device V2 Instellingen',
         project_single_device_settings_secondary_device_type_field:
           'Secundaire Device Type',
         project_single_project_setting_base_topic_field: 'Base Topic',
         project_single_device_settings_baud_rate_uart_field: 'Baud Rate UART',
         project_single_device_settings_select_baud_rate_uart_field:
           'Selecteer Baud Rate UART',
         project_single_device_settings_modbus_error_register_address_field:
           'Modbus storingsregister adres',
         project_single_device_settings_modbus_error_register_value_field:
           'Modbus verwachte storingsregister waarde',
         project_single_project_setting_device_v2_send_button: 'Versturen',
         project_single_project_setting_base_topic_success_message:
           'Base Topic is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         project_single_project_setting_secondary_device_type_success_message:
           'Secundaire Device Type is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         project_single_project_setting_reboot_message:
           'Device Reboot Bericht is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         project_single_project_setting_baut_rate_uart_success_message:
           'Device Baut Rate UART Bericht is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         project_single_project_setting_modbus_expected_error_register_value_success_message:
           'Device Modbus Expected Storing Register Waarde Bericht is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         project_single_project_setting_modbus_error_register_address_success_message:
           'Device Reboot Bericht is succesvol verstuurd naar ##SENT_MESSAGE_TO_DEVICES_COUNTER## devices van Project',
         docs_third_tab_video_instruction: 'Video Instructie',
         docs_third_tab_video_instruction_title: 'Video Instructie',
         custom_popover_106_long_description: 'Software versie',
         EXPORT_MBUS_METER_SERIAL_NUMBER: 'Serienummer meter',
         navbar_languages_french: 'Frans',
         diagnostic_formulas_form_diagnostic_formulas_name_fr_field:
           'Naam (FR)',
         diagnostic_formulas_name_fr_required_form_error:
           'Naam (FR) is verplicht',
         diagnostic_formulas_form_description_fr_field: 'Beschrijving (FR)',
         diagnostic_flows_form_diagnostic_flows_name_fr_field: 'Naam (FR)',
         diagnostic_flows_name_fr_required_form_error: 'Naam (FR) is verplicht',
         diagnostic_flows_form_description_fr_field: 'Beschrijving (FR)',
         diagnostic_categories_form_diagnostic_categories_name_fr_field:
           'Naam (FR)',
         diagnostic_categories_name_fr_required_form_error:
           'Naam (FR) is verplicht',
         diagnostic_categories_form_description_fr_field: 'Beschrijving (FR)',
         modules_form_module_name_fr_field: 'Naam (FR)',
         modules_name_fr_required_form_error: 'Naam (FR) is verplicht',
         modules_form_description_fr_field: 'Beschrijving (FR)',
         roles_form_role_name_fr_field: 'Naam (FR)',
         roles_name_fr_required_form_error: 'Naam (FR) is verplicht',
         roles_form_description_fr_field: 'Beschrijving (FR)',
         permissions_form_permission_name_fr_field: 'Naam (FR)',
         permissions_form_description_fr_field: 'Beschrijving (FR)',
         firmwares_form_firmware_name_fr_field: 'Naam (FR)',
         firmwares_name_fr_required_form_error: 'Naam (FR) is verplicht',
         notifications_form_title_fr_field: 'Naam (FR)',
         notifications_form_description_fr_field: 'Beschrijving (FR)',
         notifications_title_dk_required_form_error: 'Naam (DK) is verplicht',
         notifications_title_fr_required_form_error: 'Naam (FR) is verplicht',
         notifications_title_de_required_form_error: 'Naam (DE) is verplicht',
         notifications_description_dk_required_form_error:
           'Beschrijving (DK) is verplicht',
         notifications_description_de_required_form_error:
           'Beschrijving (DE) is verplicht',
         notifications_description_fr_required_form_error:
           'Beschrijving (FR) is verplicht',
         client_single_error_devices_bread_crumb: 'Devices in storing',
         service_client_single_error_devices_bread_crumb: 'Devices in storing',
         devices_list_diagnostics_condition_modal_fetch_and_filter_button:
           'Ophalen & Filteren',
         diagnostic_register_drawer_selected_devices_title:
           'Geselecteerde Devices',
         diagnostic_register_drawer_fetch_and_filter_message_1:
           'Ophalen devices data',
         diagnostic_register_drawer_fetch_and_filter_message_2:
           'Verversen Database',
         diagnostic_register_drawer_fetch_and_filter_message_3:
           'Filteren devices',
         devices_bulk_selected_devices_title: 'Geselecteerde Devices',
         custom_popover_100_long_description: 'Verwarming status',
         custom_popover_101_long_description: 'Tapwater status',
         custom_popover_102_long_description: 'Warmhoud status',
         custom_popover_103_long_description: 'Anti Legionella status',
         custom_popover_104_long_description: 'Koelen status',
         custom_popover_1802_long_description: 'Elektrisch element',
         custom_popover_109_long_description: 'Circulatie pomp',
         custom_popover_110_long_description: '6-weg kogelafsluiter',
         custom_popover_113_long_description: 'Ruimte thermostaat',
         custom_popover_114_long_description: 'OpenTherm Indicatie',
         custom_popover_200_long_description: 'Volumestroom tapwater',
         custom_popover_201_long_description: 'T-Tapwater',
         custom_popover_202_long_description: 'T-Primaire aanvoer',
         custom_popover_203_long_description:
           'T-Primaire retour (T-Booster voor TE-Booster toestellen)',
         custom_popover_205_long_description: 'T-Secundaire aanvoer',
         custom_popover_206_long_description: 'T-Secundaire retour',
         custom_popover_204_long_description:
           'Berekende aanvoertemperatuur (setpoint)',
         custom_popover_207_long_description: 'Ruimte temperatuur(OpenTherm)',
         custom_popover_208_long_description: 'Ruimte setpoint (OpenTherm)',
         custom_popover_210_long_description:
           'Waterdruk in de binnenhuisinstallatie',
         custom_popover_800_long_description: 'Totale bedrijfstijd afleverset',
         custom_popover_801_long_description:
           'Totale bedrijfstijd warmte-vraag',
         custom_popover_802_long_description: 'Totale bedrijfstijd koude-vraag',
         custom_popover_803_long_description:
           'Totale bedrijfstijd tapwater-vraag',
         custom_popover_804_long_description: 'Aantal tappingen',
         custom_popover_805_long_description:
           'Totale volume tapwater (let op! dit is een indicatie)',
         custom_popover_806_long_description: 'Stroomonderbrekingen',
         project_single_project_setting_mbus_hourly_logs_title:
           'Uurlijkse Meterlogs',
         project_single_project_setting_mbus_hourly_logs_field:
           'Uurlijks ophalen Meterwaarden',
         project_single_project_setting_mbus_hourly_logs_update_button:
           'Update',
         project_single_project_setting_mbus_hourly_logs_success_set_message:
           'Uurlijkse Meterlogs zijn succesvol ingesteld voor het project',
         project_single_project_setting_mbus_hourly_logs_error_message:
           'Update Uurlijkse Meterlogs voor het project mislukt',
         sidebar_mbus_reporting: 'Meter Rapport',
         mbus_reporting_table_device: 'Device',
         mbus_reporting_table_project: 'Project',
         mbus_reporting_table_created_at: 'Aangemaakt Op',
         mbus_reporting_table_viewed_by: 'Bekeken door',
         mbus_reporting_table_viewed_at: 'Bekeken op',
         mbus_reporting_table_firmware: 'Firmware',
         mbus_reporting_table_no_record_found: 'Geen Records Gevonden',
         mbus_reporting_table_all_filter: 'Alle',
         mbus_reporting_table_read_filter: 'Gelezen',
         mbus_reporting_table_unread_filter: 'Ongelezen',
         mbus_reporting_table_row_per_page: 'Resultaten Per Pagina',
         mbus_reporting_table_title: 'Meter Rapport',
         mbus_reporting_anomaly_table_title: 'Meter Afwijkingen',
         mbus_reporting_anomaly_table_difference: 'Verschil',
         mbus_reporting_anomaly_table_detection: 'Detectie',
         mbus_reporting_anomaly_table_mbus_meter_type: 'Meter',
         mbus_reporting_anomaly_table_mbus_serial_number: 'Meter serienummer',
         mbus_reporting_anomaly_table_mbus_old_value: 'Oude Waarde',
         mbus_reporting_anomaly_table_mbus_register: 'Register',
         mbus_reporting_anomaly_table_mbus_reason: 'Reden',
         mbus_reporting_anomaly_table_mbus_fail_reason: 'Meer dan',
         mbus_reporting_anomaly_table_mbus_suspicious_reason: 'Ligt tussen',
         mbus_reporting_anomaly_table_fail: 'Mislukt',
         mbus_reporting_anomaly_table_suspicious: 'Verdacht',
         mbus_reporting_table_bulk_view_reports_success_message:
           'Meter Rapport Berichten zijn succesvol gelezen',
         mbus_reporting_table_bulk_view_reports_error_message:
           'Selecteer Meter Rapport records om door te gaan',
         mbus_reporting_table_bulk_view_button: 'Bulk Bekijk',
         mbus_reporting_table_view_button: 'Bekijk',
         mbus_reporting_table_filters_project_field: 'Project',
         mbus_reporting_table_filters_device_name_field: 'Device',
         mbus_reporting_table_filters_start_date: 'Start Datum',
         mbus_reporting_table_filters_end_date: 'Eind Datum',
         mbus_reporting_table_filters_firmware: 'Firmware',
         mbus_reporting_table_filters_mbus_serial_number: 'Meter serienummer',
         mbus_reporting_table_filters_viewed_by: 'Gezien door',
         business_situation_measured_values_TR03_209: 'Buiten Temperatuur',
         custom_popover_209_short_description: 'Buiten Temperatuur',
         custom_popover_209_long_description: 'Buiten Temperatuur',
         appliance_types_set_registers_table_dashboard: 'Dashboard',
         appliance_types_set_registers_table_dashboard_error_message:
           'Device dashboard registers moeten of 0 of precies 8 zijn.',
         sidebar_missing_hourly_reporting: 'Missende Meterdata Rapport',
         missing_hourly_reporting_table_title:
           'Uurlijkse Missende Meterdata Rapport',
         mbus_hourly_missing_reporting_table_filters_project_field: 'Project',
         mbus_hourly_missing_reporting_table_filters_device_name_field:
           'Device',
         mbus_hourly_missing_reporting_table_filters_firmware_field: 'Firmware',
         mbus_hourly_missing_reporting_table_last_seen: 'Meter Bericht Op',
         mbus_hourly_missing_reporting_table_created_at: 'Aangemaakt Op',
         mbus_hourly_missing_reporting_table_device: 'Device',
         mbus_hourly_missing_reporting_table_project: 'Project',
         mbus_hourly_missing_reporting_table_firmware: 'Firmware',
         mbus_hourly_missing_reporting_table_no_record_found:
           'Geen Records Gevonden',
         mbus_hourly_missing_reporting_table_row_per_page:
           'Resultaten Per Pagina',
         device_monitoring_device_frequency_history_counters_title:
           'Frequentie Device Afwijkingen',
         device_monitoring_device_frequency_history_counters_error:
           'Geen data gevonden',
         device_monitoring_device_frequency_history_counters_no_graph_data_error:
           'Het cirkeldiagram is niet beschikbaar',
         device_monitoring_device_frequency_history_counters_loading_data:
           'Laden ...',
         device_monitoring_project_frequency_history_counters_title:
           'Frequentie Project Afwijkingen',
         device_monitoring_project_frequency_history_counters_error:
           'Geen data gevonden',
         device_monitoring_project_frequency_history_counters_no_graph_data_error:
           'Het cirkeldiagram is niet beschikbaar',
         device_monitoring_project_frequency_history_counters_loading_data:
           'Laden ...',
         device_monitoring_firmware_anomalies_history_title:
           'Frequentie firmware afwijkingen',
         device_monitoring_device_firmware_anomalies_history_graph_loading_data:
           'Het staafdiagram is niet beschikbaar',
         device_monitoring_device_firmware_anomalies_history_no_graph_data_error:
           'Laden ...',
         devices_device_id: 'Device Id',
         device_monitoring_device_frequency_details_table_title:
           'Frequentie Device Afwijkingen',
         device_monitoring_device_frequency_details_table_firmware: 'Firmware',
         device_monitoring_device_frequency_details_table_device: 'Device',
         device_monitoring_device_frequency_details_table_project: 'Project',
         device_monitoring_device_frequency_details_table_saved_at: 'Datum',
         device_monitoring_device_frequency_details_table_startup_messages_count:
           'Telling opstartberichten',
         device_monitoring_project_frequency_details_table_title:
           'Frequentie Project Afwijkingen',
         device_monitoring_project_frequency_details_table_project: 'Project',
         device_monitoring_project_frequency_details_table_devices_count:
           'Telling Devices',
         device_monitoring_project_frequency_details_table_startup_messages_count:
           'Telling opstartberichten',
         device_monitoring_firmware_frequency_details_table_title:
           'Frequentie firmware afwijkingen',
         device_monitoring_firmware_frequency_details_table_firmware:
           'Firmware',
         device_monitoring_firmware_frequency_details_table_startup_messages_count:
           'Telling opstartberichten',
         client_single_users_list_reset_and_send_email_button:
           'Herstel Wachtwoord',
         user_reset_password_form_success:
           'Wachtwoord gebruiker is succesvol geupdatet',
         users_reset_password_modal_title: 'Herstel Wachtwoord',
         users_reset_password_modal_subtitle:
           'Wil je het wachtwoord herstellen voor deze gebruiker en een email versturen?',
         users_reset_password_modal_cancel_button: 'Sluiten',
         users_reset_password_modal_reset_password_button:
           'Herstel en Versturen Email',
         reset_password_subject: 'Fortes Data Beheer - Herstel Wachtwoord',
         clients_form_is_2fa_enabled_field:
           'Schakel tweefactorauthenticatie in (2FA)',
         service_clients_form_is_2fa_enabled_field:
           'Schakel tweefactorauthenticatie in (2FA)',
         two_factor_authentication_qr_verified_title:
           'Tweefactorauthenticatie (2FA)',
         two_factor_authentication_qr_unverified_title:
           'Stel tweefactorauthenticatie in (2FA)',
         two_factor_authentication_permission_error: '',
         two_factor_authentication_description_step_1:
           'Installeer een van de volgende applicaties op jouw mobiele apparaat:',
         two_factor_authentication_description_step_2:
           'Open de applicatie en scan de QR Code:',
         two_factor_authentication_description_step_2_rescan:
           'Genereer QR Code opnieuw',
         two_factor_authentication_description_step_3:
           'Vul de eenmalige code in die door de applicatie aangeboden is en klik Indienen om de setup af te ronden.',
         two_factor_authentication_form_otp_field: 'OTP Code',
         two_factor_authentication_form_otp_characters_limit_error:
           'OTP moet 6 karakters zijn',
         two_factor_authentication_form_otp_required_error: 'OTP is verplicht',
         two_factor_authentication_form_incorrect_otp_error:
           'Ongeldige OTP, probeer opnieuw met nieuwe OTP',
         two_factor_authentication_form_success:
           'OTP is succesvol geauthenticeerd',
         two_factor_authentication_submit_button: 'Indienen',
         client_single_users_list_enable_2fa_qr_code_button:
           'Schakel QR-code voor tweefactorauthenticatie (2FA) in',
         service_client_single_users_list_enable_2fa_qr_code_button:
           'Schakel QR-code voor tweefactorauthenticatie (2FA) in',
         users_enable_2fa_qr_code_modal_title:
           'Schakel QR-code voor tweefactorauthenticatie (2FA) in',
         users_enable_2fa_qr_code_modal_subtitle:
           'Weet je het zeker dat je de QR-code voor tweefactorauthenticatie (2FA) in wilt schakelen voor deze gebruiker?',
         users_enable_2fa_qr_code_modal_cancel_button: 'Annuleer',
         users_enable_2fa_qr_code_modal_enable_2fa_qr_code_button:
           'Schakel QR-code voor tweefactorauthenticatie (2FA) in',
         client_single_users_list_enable_2fa_qr_code_success_message:
           'QR-code voor tweefactorauthenticatie (2FA) is succesvol ingeschakeld',
         client_single_2fa_label: 'Tweefactorauthenticatie (2FA)',
         enabled_2fa_label: 'Inschakelen',
         disabled_2fa_label: 'Uitschakelen',
         service_client_single_2fa_label: 'Tweefactorauthenticatie (2FA)',
         client_single_users_table_last_access: 'Laatst gezien',
         service_client_single_users_table_last_access: 'Laatst gezien',
         projects_form_header: 'Project Informatie',
         projects_commissioning_form_header: 'Project Inbedrijfstelling',
         projects_commissioning_form_export_button: 'Exporteer Devices',
         projects_commissioning_form_export_file_name:
           'Project Inbedrijfstelling Export',
         projects_commissioning_form_import_button: 'Importeer Devices',
         projects_commissioning_form_import_message:
           '<strong>Stappen om Devices te importeren</strong> <ol> <li>Download de Project Inbedrijfstelling Bestand Voorbeeld via de groene Exporteer Devices Knop.</li> <li>Update het bestand zonder de namen van de kolommen aan te passen. in het geval dat ze aangepast zijn, zal de import mislukken.</li> <li>Import het bestand en de aanpassingen zullen geupdatet worden.</li> </ol>',
         projects_commissioning_form_import_success_message:
           'Devices data is succesvol geimporteerd',
         commissioning_device_stepper_step_1_scan_qr_serial_number_title:
           'Scan QR code Mercurius',
         commissioning_device_stepper_step_3_validate_project_setting_title:
           'Valideer verbinding',
         commissioning_device_stepper_step_4_update_address_information_title:
           'Update adres',
         commissioning_device_stepper_step_2_hiu_commissioning_title:
           'Scan QR code afleverset',
         commissioning_device_stepper_step_5_preview_and_submit_title:
           'Bekijken en verzenden',
         commissioning_device_stepper_step_mbus_labels_title:
           'Mbus Meterlabels',
         commissioning_mbus_labels_required_error:
           'Selecteer een label voor alle Mbus-meters voordat u verdergaat.',
         commissioning_form_dont_have_serial_number_checkbox:
           'Geen QR Code serienummer?',
         commissioning_form_back_button: 'Vorige',
         commissioning_form_next_button: 'Volgende',
         commissioning_form_finish_button: 'Afronden',
         commissioning_form_device_serial_is_missing_error:
           'Serienummer is verplicht',
         commissioning_form_device_offboarding_error:
           'This device is currently being offboarded and cannot be commissioned.',
         clear_device_offboarding_error:
           'This device is currently being offboarded and cannot be cleared.',
         swapping_old_device_offboarding_error:
           'This old device is currently being offboarded and cannot be swapped.',
         swapping_new_device_offboarding_error:
           'This new device is currently being offboarded and cannot be swapped.',
         commissioning_form_modbus_mbus_validation_error:
           'Validatie mislukt, wil je toch doorgaan?',
         commissioning_form_stepper_validation_project_setting_title:
           'Project Instellingen',
         commissioning_form_stepper_validation_current_setting_title:
           'Device Instellingen',
         commissioning_form_stepper_validation_validate_to_view:
           'Valideer om details te bekijken',
         commissioning_form_stepper_validation_modbus_title: 'Afleverset',
         commissioning_form_stepper_validation_mbus_title: 'Meter(s)',
         commissioning_form_stepper_validation_modbus_connected_title:
           'Verbonden',
         commissioning_form_stepper_validation_modbus_not_connected_title:
           'Niet Verbonden',
         commissioning_form_stepper_validation_mbus_meters_title: 'Meter(s)',
         project_single_project_setting_modbus_and_mbus_validation_form_title:
           'Modbus en M-Bus Instelling',
         commissioning_form_stepper_validation_is_modbus_connected:
           'Is Afleverset Verbonden',
         commissioning_form_stepper_validation_mbus_meters_select_field:
           'Meters',
         commissioning_form_stepper_validation_mbus_meters_select_option_field:
           'Selecteer Meters',
         commissioning_form_stepper_validation_mbus_meters_validate_button:
           'Valideer',
         commissioning_form_upload_file_type_error:
           'Enkel XLSX bestanden zijn toegestaan.',
         commissioning_form_upload_file_invalid_column_names_error:
           'Ongeldige kolom ##COLUMNS##, kolom namen niet veranderen aub',
         commissioning_form_upload_file_size_error:
           'Bestandsgrootte mag niet groter dan 5 MB zijn.',
         commissioning_form_uploading_text: 'Uploaden...',
         project_single_project_setting_mbus_reporting_form_title:
           'Meter Rapport Instelling',
         project_single_project_setting_mbus_hourly_missing_data_reporting_value_field:
           'Meter Uurlijks Missende Data Rapport',
         project_single_project_setting_mbus_anomaly_reporting_value_field:
           'Meter Afwijking Rapport',
         project_single_project_setting_mbus_reporting_form_button: 'Update',
         project_single_project_setting_mbus_reporting_success_message:
           'Meter Rapport data is succesvol ingesteld voor het project',
         project_single_project_setting_mbus_reporting_error_message:
           'Updaten van Meter Rapport data voor het project mislukt',
         commissioning_form_upload_file_incorrect_serial_number_error:
           'Incorrecte serienummer(s) gevonden voor de inbedrijfstelling van het project',
         commissioning_form_upload_file_incorrect_devices_data_error:
           'Incorrecte Device(s) data gevonden voor de inbedrijfstelling van het project',
         commissioning_form_upload_file_empty_sheet_error:
           'Project Inbedrijfstelling bestand is leeg',
         commissioning_form_upload_success_message:
           'Project Inbedrijfstelling is succesvol afgerond',
         commissioning_validation_failed_subject:
           'Mercurius Inbedrijfstelling Rapport',
         commissioning_form_stepper_validation_mbus_meters_loading_title:
           'Meter validatie duurt tot 30 - 60 seconden',
         commissioning_form_stepper_validation_mbus_meters_retries_label:
           'Meter Zoekpogingen',
         commissioning_form_stepper_validation_mbus_meters_retries_button:
           'Opnieuw proberen',
         mbus_reporting_table_bulk_snooze_button: 'Groeps Snooze',
         mbus_reporting_table_bulk_snooze_devices_success_message:
           'Meter Rapport Devices zijn succesvol gesnoozed',
         mbus_reporting_table_bulk_snooze_modal_title: 'Weet je het zeker?',
         mbus_reporting_table_bulk_snooze_modal_sub_title:
           'Wil je Meter Rapport snoozen voor de geselecteerde devices?',
         mbus_reporting_table_bulk_snooze_modal_cancel_button: 'Annuleer',
         mbus_reporting_table_bulk_snooze_modal_snooze_button: 'Snooze',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration: 'Snooze Duur',
         mbus_reporting_table_bulk_snooze_modal_select_snooze_duration:
           'Selecteer Snooze Duur',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_day: 'Day',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_week: 'Weken',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_month:
           'Maanden',
         mbus_reporting_table_bulk_snooze_modal_snooze_duration_year: 'Jaren',
         sidebar_mbus_reporting_snoozed_devices:
           'Meter Rapport - Snoozed Devices',
         mbus_reporting_snoozed_devices_table_title: 'Snoozed Devices',
         mbus_reporting_table_bulk_un_snooze_devices_success_message:
           'Meter Rapport Devices zijn succesvol UnSnoozed',
         mbus_reporting_table_bulk_un_snooze_modal_title: 'Weet je het zeker?',
         mbus_reporting_table_bulk_un_snooze_modal_sub_title:
           'Wil je Meter Rapport unsnoozen voor de geselecteerde devices?',
         mbus_reporting_table_bulk_un_snooze_modal_cancel_button: 'Annuleer',
         mbus_reporting_table_bulk_un_snooze_modal_snooze_button: 'UnSnooze',
         mbus_reporting_table_bulk_un_snooze_button: 'Groeps UnSnooze',
         mbus_reporting_table_snooze_request_at: 'Aangevaagd op',
         mbus_reporting_table_snooze_end_at: 'Eind op',
         mbus_reporting_snoozed_devices_table_all_filter: 'Alle',
         mbus_reporting_snoozed_devices_table_snoozed_filter: 'Snoozed',
         mbus_reporting_snoozed_devices_table_unsnoozed_filter: 'UnSnoozed',
         devices_list_diagnostics_condition_modal_single_meter_label: 'Meter',
         devices_list_diagnostics_condition_modal_multiple_meters_label:
           'Meters',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_label:
           'Verbonden Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_connected_label:
           'Verbonden',
         devices_list_diagnostics_condition_modal_are_mbus_connected_value_not_connected_label:
           'Niet Verbonden',
         devices_list_diagnostics_condition_modal_mbus_meters_dropdown_select_record_label:
           'Selecteer Verbonden Meters',
         devices_list_diagnostics_condition_modal_are_mbus_connected_dropdown_label:
           'Meters Verbinding',
         devices_list_diagnostics_condition_modal_are_mbus_connected_select_field_label:
           'Selecteer verbindingsstatus',
         devices_search_mbus_registers_multiple_devices_success:
           'Het bericht is succesvol verzonden naar de geselecteerde Device(s).',
         devices_testing_button: 'Device Testen',
         devices_testing_form_header: 'Device Test',
         devices_testing_device_serial_field: 'Device serienummer',
         devices_testing_modbus_registers_field: 'Modbus Registers',
         devices_testing_modbus_registers_button_field:
           'Versturen Modbus Bericht',
         devices_testing_single_mbus_register_field: 'Enkel MBus Register',
         devices_testing_single_mbus_register_button_field: 'Versturen Bericht',
         devices_testing_send_fetch_mbus_message:
           'Versturen Ophalen MBus Bericht',
         devices_testing_send_scan_mbus_message:
           'Versturen Scannen MBus Bericht',
         project_single_project_setting_mbus_hourly_logs_success_unset_message:
           'Meter Uurlijkse logs zijn succesvol uitgezet voor het project',
         mbus_reporting_table_export_button: 'Exporteer',
         mbus_reporting_table_export_file: 'Meter Rapport',
         mbus_hourly_missing_reporting_export_button: 'Exporteer',
         mbus_hourly_missing_reporting_export_file:
           'Meter Uurlijks Missende Data Rapportage',
         snoozed_devices_export_button: 'Exporteer',
         snoozed_devices_export_file: 'Snoozed Devices',
         device_single_documentation_instructie_pomp_button: 'Instructie Pomp',
         sidebar_inconsistent_mbus_devices_reporting: 'Inconsistente Meters',
         inconsistent_mbus_devices_reporting_table_header:
           'Inconsistente Meters',
         inconsistent_mbus_devices_reporting_bulk_export_button: 'Exporteer',
         inconsistent_mbus_devices_reporting_filter_reset_button: 'Herstel',
         inconsistent_mbus_devices_reporting_table_filter_search: 'Zoeken',
         inconsistent_mbus_devices_reporting_table_created_at: 'Aangemaakt Op',
         inconsistent_mbus_devices_reporting_table_total_devices:
           'Totale Devices',
         inconsistent_mbus_devices_reporting_table_total_projects:
           'Totale Projecten',
         inconsistent_mbus_devices_reporting_table_no_record_found:
           'Geen Record Gevonden',
         inconsistent_mbus_devices_reporting_table_row_per_page:
           'Resultaten Per Pagina',
         devices_mbus_meter_count: 'Meters',
         devices_mbus_labels: 'Mbus Meter Purpose Labels',
         devices_bulk_modbus_download_form_data_type: 'Data Type',
         devices_bulk_modbus_download_form_export_type: 'Export Type',
         devices_bulk_modbus_download_form_data_type_daily: 'Dagelijks',
         devices_bulk_modbus_download_form_data_type_hourly: 'Uurlijks',
         devices_bulk_modbus_download_form_export_type_combined: 'Gecombineerd',
         devices_bulk_modbus_download_form_export_type_separated: 'Gescheiden',
         devices_bulk_export_modbus_historic_data_button:
           'Download Afleversetdata',
         devices_bulk_export_modbus_historic_data_file_name:
           'Historische Afleversetdata',
         devices_bulk_modbus_download_title:
           'Download Historische Afleversetdata',
         devices_bulk_modbus_download_form_date_range: 'Datumbereik:',
         devices_bulk_modbus_download_form_submit_button:
           'Download Afleversetdata',
         devices_bulk_modbus_download_form_cancel_button: 'Annuleer',
         devices_bulk_modbus_download_form_success:
           'Historische Afleversetdata is succesvol gemaild naar ##EMAIL##!',
         devices_bulk_modbus_download_form_api_error: 'Interne Server Error',
         devices_bulk_modbus_download_no_devices_error:
           'Selecteer tenminste 1 devic met correct TR Type (TR03/TR04)',
         devices_bulk_modbus_download_form_no_devices_error:
           'Selecteer devices om door te gaan.',
         devices_bulk_modbus_download_modal_title: 'Weet je het zeker?',
         devices_bulk_modbus_download_modal_subtitle:
           'Wil je een groepsdownload uitvoeren voor Historische Afleversetdata?',
         devices_bulk_modbus_download_modal_cancel_button: 'Annuleer',
         devices_bulk_modbus_download_modal_submit_button: 'Bevestig',
         projects_bulk_export_modbus_historic_data_file_name:
           'Historische Afleversetdata',
         projects_bulk_modbus_download_title:
           'Download Historische Afleversetdata',
         projects_bulk_bulk_modbus_download_form_date_range: 'Datumbereik:',
         projects_bulk_bulk_modbus_download_form_data_export_type:
           'Datum Export Type',
         projects_bulk_bulk_modbus_download_form_data_export_type_combined:
           'Gecombineerd',
         projects_bulk_bulk_modbus_download_form_data_export_type_daily:
           'Dagelijks',
         projects_bulk_bulk_modbus_download_form_data_export_type_normal:
           'Normaal',
         projects_bulk_bulk_modbus_download_form_submit_button:
           'Download Afleversetdata',
         projects_bulk_bulk_modbus_download_form_cancel_button: 'Annuleer',
         projects_bulk_modbus_download_form_success:
           'Historische Afleversetdata is succesvol gemaild naar ##EMAIL##!',
         projects_bulk_modbus_download_form_api_error: 'Interne Server Error',
         projects_bulk_modbus_download_no_projects_error: '',
         projects_bulk_modbus_download_form_no_projects_error:
           'Selecteer projecten om door te gaan.',
         projects_bulk_bulk_modbus_download_modal_title: 'Weet je het zeker?',
         projects_bulk_modbus_download_modal_subtitle:
           'Wil je een groepsdownload uitvoeren voor Historische Afleversetdata?',
         projects_bulk_modbus_download_modal_cancel_button: 'Annuleer',
         projects_bulk_modbus_download_modal_submit_button: 'Bevestig',
         projects_bulk_modbus_selected_projects: '`Geselecteerde Projecten',
         device_single_status_modbus_date_export_label: 'Datum',
         device_single_download_modbus_data: 'Export Afleversetdata',
         device_monitoring_maxitel_status_heading: 'Network Status',
         device_monitoring_maxitel_status_online: 'Online',
         device_monitoring_maxitel_status_offline: 'Offline',
         device_monitoring_maxitel_operational_status: 'Operationeel',
         device_monitoring_maxitel_non_operational_status: 'Niet Operationeel',
         device_monitoring_maxitel_mobile_on_cloud_network_green:
           'MaxiTEL MobileOnCloud - Netwerk Paars',
         device_monitoring_maxitel_mobile_on_cloud_network_purple:
           'MaxiTEL MobileOnCloud - Netwerk Groen',
         device_monitoring_maxitel_mobile_data_network_purple:
           'Mobiele data - Network Paars',
         device_monitoring_maxitel_mobile_m2m_blend: 'M2M Blend',
         device_monitoring_maxitel_other_api: 'API',
         device_monitoring_maxitel_other_portal: 'Portaal',
         device_monitoring_maxitel_updated_at: 'Geupdatet',
         admins_last_seen: 'Laatst gezien',
         device_monitoring_send_grid_email_reached: 'Email Limiet Bereikt',
         sidebar_email_reporting: 'Email Rapport',
         email_reporting_title: 'Email Rapport',
         email_reporting_tab_all: 'Alle',
         email_reporting_tab_passed: 'Geslaagd',
         email_reporting_tab_failed: 'Mislukt',
         email_reporting_table_email_forwarded_at: 'Verzenddatum',
         email_reporting_table_to: 'Naar',
         email_reporting_table_recipient_name: 'Naam Ontvanger',
         email_reporting_table_subject: 'Onderwerp',
         email_reporting_table_status: 'Status',
         email_reporting_table_no_record_found: 'Geen Records Gevonden',
         email_reporting_single_output_tab: 'Email Inhoud',
         email_reporting_single_second_bread_crumb: 'Email Detail',
         email_reporting_single_email_logs_title: 'Email Logs',
         email_reporting_table_resend_failed_email_success_message:
           'Emails zijn opnieuw verstuurd.',
         email_reporting_table_resend_failed_email_error_message:
           'Selecteer tenminste een record om de email opnieuw te versturen.',
         email_reporting_table_resend_failed_email_button:
           'Verstuur Email Opnieuw',
         email_reporting_table_filter_search: 'Zoeken',
         email_reporting_table_row_per_page: 'Resultaten Per Pagina',
         settings_menu_modbus_global_configuration_title:
           'Modbus Algemene Configuratie',
         settings_menu_modbus_global_configuration_title_form_header:
           'Modbus Algemene Configuratie',
         settings_menu_modbus_global_configuration_TR03_tab:
           'TR03 Instellingen',
         settings_menu_modbus_global_configuration_TR04_tab:
           'TR04 Instellingen',
         settings_menu_modbus_global_configuration_form_success:
           'Modbus Algemene Configuraties zijn succesvol opgeslagen',
         settings_menu_modbus_global_configuration_form_error:
           'Opslaan van Modbus Algemene Configuratie mislukt',
         settings_menu_modbus_global_configuration_form_save_button:
           'Opslaan Modbus Instellingen',
         device_single_unprovisioned_detailed_message:
           'Device is in "Ongeregistreerd" modus',
         commissioning_form_stepper_validation_modbus_loading_title:
           'Validatie afleversetverbinding duurt tot 1 - 3 minuten',
         settings_menu_modbus_global_configuration_title_form_header_add_new:
           'Voeg Nieuwe Toe',
         settings_menu_modbus_global_configuration_title_add_form_header:
           'Voeg Artikelnummer toe',
         settings_menu_modbus_global_configuration_article_number_field:
           'Artikelnummer',
         settings_menu_modbus_global_configuration_article_number_required_form_error:
           'Artikelnummer is verplicht',
         settings_menu_modbus_global_configuration_article_number_unique_form_error:
           'Artikelnummer bestaat al. Vul een uniek Artikelnummer in',
         settings_menu_modbus_global_configuration_type_field: 'Type',
         settings_menu_modbus_global_configuration_type_required_form_error:
           'Type is verplicht',
         settings_menu_modbus_global_configuration_type_default_option:
           'Selecteer een Type',
         settings_menu_modbus_global_configuration_add_success_message:
           'Artikelnummer is succesvol toegevoegd',
         settings_menu_modbus_global_configuration_cancel_button: 'Annuleer',
         settings_menu_modbus_global_configuration_save_button: 'Opslaan',
         missing_article_number_message:
           'Het Artikelnummer veld is leeg of niet geregistreerd in de Modbus Algemene Configuraties. Stel het Device in bedrijf. Als het probleem blijft aanhouden, neem contact op met de administrator.',
         // General Modbus Control / Status registers(90-99) - TR04
         general_modbus_control_TR04_80: 'Firmware Image status',
         general_modbus_control_TR04_81: 'Firmware Image ID',
         general_modbus_control_TR04_82: 'Defaults Image status',
         general_modbus_control_TR04_83: 'Defaults Image Checksum',
         general_modbus_control_TR04_96: 'Modbus Versie',
         general_modbus_control_TR04_97: 'Modbus Device type / tabel',
         general_modbus_control_TR04_98: 'Unit selectie ',
         general_modbus_control_TR04_99: 'Control register ',

         // Operating Status - TR04
         business_situation_operating_status_TR04_title:
           'Bedrijfsstatus afleverset',
         business_situation_operating_status_TR04_100: 'Verwarmingsstatus',
         business_situation_operating_status_TR04_100_list: JSON.stringify({
           list: {
             0: 'Standby',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na Circulatie',
             4: 'Uit',
             5: 'Voor Circulatie',
             6: 'Geblokkeerd',
           },
         }),
         business_situation_operating_status_TR04_101: 'Tapwater status',
         business_situation_operating_status_TR04_101_list: JSON.stringify({
           list: {
             0: 'Standby',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na Circulatie',
             4: 'Uit',
             5: 'Voor Circulatie',
             6: 'Geblokkeerd',
           },
         }),
         business_situation_operating_status_TR04_102: 'Warmhoud status',
         business_situation_operating_status_TR04_102_list: JSON.stringify({
           list: {
             0: 'Standby',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na Circulatie',
             4: 'Uit',
             5: 'Voor Circulatie',
             6: 'Geblokkeerd',
           },
         }),
         business_situation_operating_status_TR04_103: 'Anti Legionella status',
         business_situation_operating_status_TR04_103_list: JSON.stringify({
           list: {
             0: 'Standby',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na Circulatie',
             4: 'Uit',
             5: 'Voor Circulatie',
             6: 'Geblokkeerd',
           },
         }),
         business_situation_operating_status_TR04_104: 'Koelingsstatus',
         business_situation_operating_status_TR04_104_list: JSON.stringify({
           list: {
             0: 'Standby',
             1: 'Verzoek',
             2: 'Vraag',
             3: 'Na Circulatie',
             4: 'Uit',
             5: 'Voor Circulatie',
             6: 'Geblokkeerd',
           },
         }),

         business_situation_operating_status_TR04_105: 'Storingscode',
         business_situation_operating_status_TR04_106: 'Software versie',
         business_situation_operating_status_TR04_107:
           'StepperMotor1 Huidige Positie',
         business_situation_operating_status_TR04_108:
           'StepperMotor2 Huidige Positie',
         business_situation_operating_status_TR04_109: 'Pomp',
         business_situation_operating_status_TR04_109_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         business_situation_operating_status_TR04_110: 'Klep1',
         business_situation_operating_status_TR04_110_list: JSON.stringify({
           list: {
             0: 'Positie: Verwarming',
             1: 'Positie: Koeling',
           },
         }),
         business_situation_operating_status_TR04_112_list: JSON.stringify({
           list: {
             0: 'Verwarming of vraag',
             1: 'Koeling',
           },
         }),
         business_situation_operating_status_TR04_113: 'Kamerthermostaat input',
         business_situation_operating_status_TR04_113_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Gesloten',
           },
         }),
         business_situation_operating_status_TR04_114: 'OpenTherm Indicator',
         business_situation_operating_status_TR04_114_list: JSON.stringify({
           list: {
             0: 'Inactief',
             1: 'Actief',
           },
         }),
         business_situation_operating_status_TR04_115: 'Toesteltype',
         business_situation_operating_status_TR03_130: 'Blokkeringsstatus',
         business_situation_operating_status_TR03_130_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'DHW (+Preheat)',
             2: 'CH (+FDP)',
             3: 'DHW (+Preheat) & CH (+FDP)',
             4: 'Cooling',
             5: 'DHW (+Preheat) & Cooling',
             6: 'CH (+FDP) & Cooling',
             7: 'DHW (+Preheat) & CH (+FDP) & Cooling',
           },
         }),
         business_situation_operating_status_TR04_130: 'Blokkeringsstatus',
         business_situation_operating_status_TR04_130_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'DHW (+Preheat)',
             2: 'CH (+FDP)',
             3: 'DHW (+Preheat) & CH (+FDP)',
             4: 'Cooling',
             5: 'DHW (+Preheat) & Cooling',
             6: 'CH (+FDP) & Cooling',
             7: 'DHW (+Preheat) & CH (+FDP) & Cooling',
           },
         }),

         // Business situation - TR04
         business_situation_measured_values_TR04_title: 'Meetwaarden',
         business_situation_measured_values_TR04_200: 'Debiet',
         business_situation_measured_values_TR04_201:
           'Tapwater Uit temperatuur',
         business_situation_measured_values_TR04_202: 'Primaire aanvoer',
         business_situation_measured_values_TR04_203: 'Primaire retour',
         business_situation_measured_values_TR04_205: 'Secundaire CV Aanvoer',
         business_situation_measured_values_TR04_206: 'Secundaire CV Retour',
         business_situation_measured_values_TR04_204: 'CV berekende setpoint',
         business_situation_measured_values_TR04_207: 'OT Kamertemperatuur',
         business_situation_measured_values_TR04_208: 'OT CV Setpoint',
         business_situation_measured_values_TR04_209: 'Buiten Temperatuur',
         business_situation_measured_values_TR04_210: 'Waterdruk',
         business_situation_measured_values_TR04_263: '% pomp vermogen',
         business_situation_measured_values_TR04_213:
           'Primaire Tapwater Retour',
         business_situation_measured_values_TR04_214: 'Primaire CV Retour',

         // Operating time - TR04
         business_situation_operating_time_TR04_title: 'Bedrijfstijden',
         business_situation_operating_time_TR04_800:
           'Totale bedrijfstijd afleverset',
         business_situation_operating_time_TR04_801:
           'Totale bedrijfstijd verwarming',
         business_situation_operating_time_TR04_802:
           'Totale bedrijfstijd koeling',
         business_situation_operating_time_TR04_803:
           'Totale bedrijfstijd tapwatervraag',
         business_situation_operating_time_TR04_804: 'Aantal tappingen',

         // Lockout Geschiedenis-TR04
         lockout_time_TR04_title: 'Lockout Geschiedenis',
         lockout_time_TR04_820: 'Lock-out 1',
         lockout_time_TR04_821: 'Lock-out 2',
         lockout_time_TR04_822: 'Lock-out 3',
         lockout_time_TR04_823: 'Lock-out 4',
         lockout_time_TR04_824: 'Lock-out 5',
         lockout_time_TR04_825: 'Lock-out 6',
         lockout_time_TR04_826: 'Lock-out 7',
         lockout_time_TR04_827: 'Lock-out 8',
         lockout_time_TR04_828: 'Lock-out 9',
         lockout_time_TR04_829: 'Lock-out 10',
         lockout_time_TR04_830: 'Lock-out 11',
         lockout_time_TR04_831: 'Lock-out 12',
         lockout_time_TR04_832: 'Lock-out 13',
         lockout_time_TR04_833: 'Lock-out 14',
         lockout_time_TR04_834: 'Lock-out 15',
         lockout_time_TR04_835: 'Lock-out 16',
         lockout_time_TR04_836: 'Lock-out history time 1',
         lockout_time_TR04_837: 'Lock-out history time 2',
         lockout_time_TR04_838: 'Lock-out history time 3',
         lockout_time_TR04_839: 'Lock-out history time 4 ',
         lockout_time_TR04_840: 'Lock-out history time 5 ',
         lockout_time_TR04_841: 'Lock-out history time 6 ',
         lockout_time_TR04_842: 'Lock-out history time 7',
         lockout_time_TR04_843: 'Lock-out history time 8',
         lockout_time_TR04_844: 'Lock-out history time 9',
         lockout_time_TR04_845: 'Lock-out history time 10',
         lockout_time_TR04_846: 'Lock-out history time 11',
         lockout_time_TR04_847: 'Lock-out history time 12',
         lockout_time_TR04_848: 'Lock-out history time 13',
         lockout_time_TR04_849: 'Lock-out history time 14',
         lockout_time_TR04_850: 'Lock-out history time 15',
         lockout_time_TR04_851: 'Lock-out history time 16',
         // Blocking Geschiedenis-TR04
         blocking_history_TR04_860: 'Blocking 1',
         blocking_history_TR04_861: 'Blocking 2',
         blocking_history_TR04_862: 'Blocking 3',
         blocking_history_TR04_863: 'Blocking 4',
         blocking_history_TR04_864: 'Blocking 5',
         blocking_history_TR04_865: 'Blocking 6',
         blocking_history_TR04_866: 'Blocking 7',
         blocking_history_TR04_867: 'Blocking 8',
         blocking_history_TR04_868: 'Blocking 9',
         blocking_history_TR04_869: 'Blocking 10',
         blocking_history_TR04_870: 'Blocking 11',
         blocking_history_TR04_871: 'Blocking 12',
         blocking_history_TR04_872: 'Blocking 13',
         blocking_history_TR04_873: 'Blocking 14',
         blocking_history_TR04_874: 'Blocking 15',
         blocking_history_TR04_875: 'Blocking 16',
         blocking_history_TR04_876: 'Blocking history time 1',
         blocking_history_TR04_877: 'Blocking history time 2',
         blocking_history_TR04_878: 'Blocking history time 3',
         blocking_history_TR04_879: 'Blocking history time 4',
         blocking_history_TR04_880: 'Blocking history time 5',
         blocking_history_TR04_881: 'Blocking history time 6',
         blocking_history_TR04_882: 'Blocking history time 7',
         blocking_history_TR04_883: 'Blocking history time 8',
         blocking_history_TR04_884: 'Blocking history time 9',
         blocking_history_TR04_885: 'Blocking history time 10',
         blocking_history_TR04_886: 'Blocking history time 11',
         blocking_history_TR04_887: 'Blocking history time 12',
         blocking_history_TR04_888: 'Blocking history time 13',
         blocking_history_TR04_889: 'Blocking history time 14',
         blocking_history_TR04_890: 'Blocking history time 15',
         blocking_history_TR04_891: 'Blocking history time 16',
         // Warmtapwater - TR04
         settings_dhw_warm_tap_water_TR04_title: 'Instellingen tapwater',
         settings_dhw_warm_tap_water_TR04_300: 'Tapwater setpoint',
         settings_dhw_warm_tap_water_TR04_301: 'Warmhoudmodus',
         settings_dhw_warm_tap_water_TR04_301_list: JSON.stringify({
           list: { 0: 'Eco', 1: 'Antievries', 2: 'Comfort', 3: 'Dynamisch' },
         }),
         settings_dhw_warm_tap_water_TR04_302:
           'Warmhoudsetpoint (comfort stand)',
         settings_dhw_warm_tap_water_TR04_303: 'Tapdrempel',
         settings_dhw_warm_tap_water_TR04_304: 'Tapwatermodus',
         settings_dhw_warm_tap_water_TR04_304_list: JSON.stringify({
           list: {
             0: 'Uit',
             8: 'PID Gecontroleerd',
           },
         }),
         settings_dhw_warm_tap_water_TR04_305:
           'Tapwater Primaire Boost Exit Tijd',
         settings_dhw_warm_tap_water_TR04_306:
           'Tapwater Mode8 Dynamisch Setpoint Actief',
         settings_dhw_warm_tap_water_TR04_306_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_dhw_warm_tap_water_TR04_307: 'Tapwater Huidige Setpoint',

         // Thermal disinfection - TR04
         settings_thermal_disinfection_TR04_title:
           'Instellingen Thermische disinfectie',
         settings_thermal_disinfection_TR04_400: 'Aleg ingeschakeld',
         settings_thermal_disinfection_TR04_400_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_thermal_disinfection_TR04_401: 'Aleg setpoint',
         settings_thermal_disinfection_TR04_402: 'Aleg bedrijfstijd',
         settings_thermal_disinfection_TR04_403: 'Aleg wachttijd',

         // Heating - TR04
         heating_and_cooling_settings_heating_TR04_title:
           'Instellingen verwarming',
         heating_and_cooling_settings_heating_TR04_500:
           'Maximale setpoint verwarming',
         heating_and_cooling_settings_heating_TR04_501:
           'Minimale setpoint verwarming',
         heating_and_cooling_settings_heating_TR04_502: 'OutdoorResetMin',
         heating_and_cooling_settings_heating_TR04_503: 'OutdoorResetMax',
         heating_and_cooling_settings_heating_TR04_504: 'WarmWeatherShut',
         heating_and_cooling_settings_heating_TR04_506:
           'Maximum primaire retour',
         heating_and_cooling_settings_heating_TR04_507:
           'Compensatiefactor van de primaire retour',
         heating_and_cooling_settings_heating_TR04_508:
           'Delta primaire-secundaire setpoint',
         heating_and_cooling_settings_heating_TR04_509:
           'Minimum primaire-secundaire delta',
         heating_and_cooling_settings_heating_TR04_510:
           'Maximaal beveiliging verwarmen',
         heating_and_cooling_settings_heating_TR04_514: 'Setpoint verwarming',
         heating_and_cooling_settings_heating_TR04_515:
           'Verwarming inschakelen',
         heating_and_cooling_settings_heating_TR04_515_list: JSON.stringify({
           list: {
             0: 'PID',
             8: 'Open/Gesloten',
             9: 'Primaire Delta-T',
             10: 'Secundaire Delta-T',
           },
         }),

         // Cooling - TR04
         heating_and_cooling_settings_cooling_TR04_title:
           'Instellingen koeling',
         heating_and_cooling_settings_cooling_TR04_600: 'Setpoint koeling',
         heating_and_cooling_settings_cooling_TR04_601:
           'Maximale primaire retour',
         heating_and_cooling_settings_cooling_TR04_602:
           'Compensatiefactor van de primaire retour',
         heating_and_cooling_settings_cooling_TR04_605:
           'Maximaalbeveiliging koeling',
         heating_and_cooling_settings_cooling_TR04_606:
           'Minimale setpoint koeling',
         heating_and_cooling_settings_cooling_TR04_607:
           'Maximale setpoint koeling',
         heating_and_cooling_settings_cooling_TR04_608:
           'Condensatie bescherming',
         heating_and_cooling_settings_cooling_TR04_608_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         heating_and_cooling_settings_cooling_TR04_609: 'Condensatie timer',
         heating_and_cooling_settings_cooling_TR04_610:
           'Condensatie verhoogd setpoint',
         heating_and_cooling_settings_cooling_TR04_611: 'Koeling inschakelen',
         heating_and_cooling_settings_cooling_TR04_611_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         // Secundaire General - TR04
         heating_and_cooling_settings_secondary_general_TR04_title:
           'Algemene Instellingen',
         heating_and_cooling_settings_secondary_general_TR04_512:
           'Minimale druk CV',
         heating_and_cooling_settings_secondary_general_TR04_513:
           'Maximale druk CV',
         heating_and_cooling_settings_secondary_general_TR04_603:
           'Wachttijd omschakelen verwarmen-koelen',
         heating_and_cooling_settings_secondary_general_TR04_604:
           '6-weg kogelkraan wachttijd',

         // Manual Operation - TR04
         settings_manual_operation_TR04_title: 'Handbediening',
         settings_manual_operation_TR04_700: 'Handbediening inschakelen',
         settings_manual_operation_TR04_700_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_manual_operation_TR04_701:
           'Handbediening tapwater regelafsluiter (M1)',
         settings_manual_operation_TR04_702:
           'Handbediening verwarming/koeling regelafsluiter (M2)',
         settings_manual_operation_TR04_703: 'Handbediening pomp (CV)',
         settings_manual_operation_TR04_703_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         settings_manual_operation_TR04_704:
           'Handbediening positie 6-weg kogelafsluiter',
         settings_manual_operation_TR04_704_list: JSON.stringify({
           list: {
             0: 'Verwarming',
             1: 'Koeling',
           },
         }),
         settings_manual_operation_TR04_707:
           'Handbediening tapwater regelafsluiter (M1)[%]',
         settings_manual_operation_TR04_708:
           'Handbediening verwarming/koeling regelafsluiter (M2)[%]',
         settings_manual_operation_TR04_709: 'Handbediening uitstellen',
         // DeltaP Parameters(LIN-PUMP)
         deltap_parameters_TR04_1870_1871: 'Klant installatie druk',
         deltap_parameters_TR04_1872_1873: 'DeltaP KV-Waarde',
         deltap_parameters_TR04_1874_1875: 'DeltaP Max Druk',
         device_status_name_TR03: 'Naam (TR03)',
         device_status_name_TR04: 'Naam (TR04)',
         device_single_set_register_device_tr_type_unavailable:
           'Device type is niet beschikbaar voor het gehele project',
         sidebar_terms_and_conditions_title: 'Voorwaarden',
         sidebar_support_text: 'Vragen of opmerkingen? Email',
         sidebar_support_text_copied: 'Email gekopieerd!',
         settings_menu_legal_document_title: 'Juridische documenten',
         legal_documents_name_en_required_form_error:
           'Document Naam (EN) is verplicht',
         legal_documents_name_nl_required_form_error:
           'Document Naam (NL) is verplicht',
         legal_documents_name_fr_required_form_error:
           'Document Naam (FR) is verplicht',
         legal_documents_name_de_required_form_error:
           'Document Naam (DE) is verplicht',
         legal_documents_name_dk_required_form_error:
           'Document Naam (DK) is verplicht',
         legal_documents_title_en_required_form_error:
           'Document Titel (EN) is verplicht',
         legal_documents_title_nl_required_form_error:
           'Document Titel (NL) is verplicht',
         legal_documents_title_fr_required_form_error:
           'Document Titel (FR) is verplicht',
         legal_documents_title_de_required_form_error:
           'Document Titel (DE) is verplicht',
         legal_documents_title_dk_required_form_error:
           'Document Titel (DK) is verplicht',
         legal_documents_checkbox_label_en_required_form_error:
           'Document Checkbox Label (EN) is verplicht',
         legal_documents_checkbox_label_nl_required_form_error:
           'Document Checkbox Label (NL) is verplicht',
         legal_documents_checkbox_label_fr_required_form_error:
           'Document Checkbox Label (FR) is verplicht',
         legal_documents_checkbox_label_de_required_form_error:
           'Document Checkbox Label (DE) is verplicht',
         legal_documents_checkbox_label_dk_required_form_error:
           'Document Checkbox Label (DK) is verplicht',
         legal_documents_document_url_required_form_error:
           'Juridisch Document (EN) is verplicht',
         legal_documents_version_required_form_error: 'Versie is verplicht',
         legal_documents_type_required_form_error: 'Document Type is verplicht',
         legal_documents_add_form_success:
           'Juridisch Document is succesvol aangemaakt',
         legal_document_modal_download_button: 'Download',
         legal_document_modal_download_error:
           'Failed to download the document',
         legal_documents_form_api_error:
           'Aanmaken juridisch document mislukt door een Interne Server Error',
         legal_documents_form_legal_document_name_en_field:
           'Document Naam (EN)',
         legal_documents_form_legal_document_name_nl_field:
           'Document Naam (NL)',
         legal_documents_form_legal_document_name_fr_field:
           'Document Naam (FR)',
         legal_documents_form_legal_document_name_de_field:
           'Document Naam (DE)',
         legal_documents_form_legal_document_name_dk_field:
           'Document Naam (DK)',
         legal_documents_form_legal_document_title_en_field:
           'Document Titel (EN)',
         legal_documents_form_legal_document_title_nl_field:
           'Document Titel (NL)',
         legal_documents_form_legal_document_title_fr_field:
           'Document Titel (FR)',
         legal_documents_form_legal_document_title_de_field:
           'Document Titel (DE)',
         legal_documents_form_legal_document_title_dk_field:
           'Document Titel (DK)',
         legal_documents_form_legal_document_checkbox_label_en_field:
           'Document Checkbox Label (EN)',
         legal_documents_form_legal_document_checkbox_label_nl_field:
           'Document Checkbox Label (NL)',
         legal_documents_form_legal_document_checkbox_label_fr_field:
           'Document Checkbox Label (FR)',
         legal_documents_form_legal_document_checkbox_label_de_field:
           'Document Checkbox Label (DE)',
         legal_documents_form_legal_document_checkbox_label_dk_field:
           'Document Checkbox Label (DK)',
         legal_documents_form_legal_document_document_url_field:
           'Upload Juridisch Document (EN) (PDF)',
         legal_documents_form_legal_document_document_url_nl_field:
           'Upload Legal Document (NL) (PDF)',
         legal_documents_form_legal_document_document_url_de_field:
           'Upload Legal Document (DE) (PDF)',
         legal_documents_form_legal_document_document_url_dk_field:
           'Upload Legal Document (DK) (PDF)',
         legal_documents_form_legal_document_document_url_fr_field:
           'Upload Legal Document (FR) (PDF)',
         legal_documents_form_legal_document_version_field: 'Versie',
         legal_documents_form_legal_document_type_field: 'Document Type',
         legal_documents_form_legal_is_mandatory_field: 'Is Document Verplicht',
         legal_documents_form_add_legal_document_button: 'Voeg Document Toe',
         legal_documents_form_cancel_button: 'Annuleer',
         add_legal_documents_form_header: 'Voeg Juridisch Document Toe',
         add_legal_documents_bread_crumb_first_link:
           'Voeg Juridisch Document Toe',
         legal_documents_bread_crumb_main_title: 'Juridische Documenten',
         legal_documents_edit_form_success:
           'Juridisch Document is succesvol geupdatet',
         legal_documents_form_edit_legal_document_button: 'Wijzig Document',
         edit_legal_documents_form_header: 'Wijzig Juridisch Document',
         edit_legal_documents_bread_crumb_first_link:
           'Wijzig Juridisch Document',
         loginTermsOfUseInfo:
           'Accepteer de Gebruikersvoorwaarden om door te gaan',
         legal_documents_table_document_name_en: 'Document Naam (EN)',
         legal_documents_table_document_title_en: 'Document Titel (EN)',
         legal_documents_table_document_checkbox_label_en:
           'Document Checkbox Label (EN)',
         legal_documents_table_document_document_url: 'Juridisch Document',
         legal_documents_table_document_type: 'Document Type',
         legal_documents_table_version: 'Versie',
         legal_documents_table_updated_at: 'Bijgewerkt Op',
         legal_documents_table_is_default: 'Status',
         legal_documents: 'Juridisch Documenten',
         legal_documents_add_new: 'Voeg Juridisch Document Toe',
         legal_documents_table_row_per_page: 'Resultaten Per Pagina',
         legal_documents_no_record_found: 'Geen records Gevonden',
         legal_documents_filter_delete_button: 'Verwijder',
         legal_documents_status_default: 'Standaard',
         legal_documents_status_archived: 'Gearchiveerd',
         legal_documents_all: 'Alle',
         legal_documents_filter_search: 'Zoeken',
         legal_documents_default_document_success_message:
           '"LEGAL_DOC_TYPE" standaard Juridisch Document is succesvol geupdatet.',
         legal_documents_bulk_delete_button: 'Verwijder',
         legal_documents_bulk_delete_success_message:
           'Juridisch Document(s) zijn succesvol verwijderd',
         legal_documents_bulk_delete_error_message:
           'Selecteer meerdere records om te verwijderen',
         legal_documents_bulk_delete_title: 'Weet je het zeker?',
         legal_documents_bulk_delete_subtitle: 'Wil je records verwijderen?',
         legal_documents_upload_success:
           'Document is succesvol geüpload, bevestig de aanpassingen.',
         legal_documents_upload_file_type_error:
           'Alleen PDF bestanden zijn toegestaan.',
         legal_documents_upload_file_size_error:
           'Bestand moet kleiner zijn dan 20 MB.',
         legal_documents_uploading_text: 'Uploaden...',
         legal_documents_reset_legal_documents_status_modal_title:
           'Weet je het zeker?',
         legal_documents_reset_legal_documents_status_modal_subtitle:
           'Gebruikers moeten het document nogmaals accepteren. Weet je zeker dat je wilt doorgaan?',
         legal_documents_reset_legal_documents_status_cancel_button: 'Annuleer',
         legal_documents_reset_legal_documents_status_update_without_acceptance_request_button:
           'Update zonder acceptatieverzoek',
         legal_documents_reset_legal_documents_status_update_with_acceptance_request_button:
           'Update met acceptatieverzoek',
         legal_documents_table_already_default_document_message:
           'Dit document is al ingesteld als een standaard "LEGAL_DOC_TYPE" document',
         cookie_banner_main_title: 'Toestemming beheren',
         cookie_banner_main_subtitle:
           'Deze website maakt gebruik van cookies om je gebruikerservaring te verbeteren. Door onze website te gebruiken, stem je in met alle cookies in overeenstemming met ons cookiebeleid.',
         cookie_banner_essential_cookie_title: 'Essentiële Cookies',
         cookie_banner_essential_cookie_status_title: 'Altijd Actief',
         cookie_banner_essential_cookie_subtitle:
           'Essentiële cookies zijn cruciaal voor de basisfuncties van een website, zoals ingelogd blijven, het onthouden van instellingen, en het waarborgen van de beveiliging. Ze zijn noodzakelijk om de site goed te laten functioneren en kunnen niet worden uitgeschakeld.',
         cookie_banner_tracking_cookie_title: 'Tracking Cookies',
         cookie_banner_tracking_cookie_subtitle:
           'Tracking cookies die door Google Analytics worden gebruikt, verzamelen gegevens over je interactie met de website, zoals bezochte paginas en bestede tijd. Dit helpt ons het gebruikersgedrag te begrijpen en de prestaties van de website te verbeteren. Deze cookies zijn optioneel en kunnen worden uitgeschakeld.',
         cookie_banner_accept_button_title: 'Accepteren',
         cookie_banner_decline_button_title: 'Afwijzen',
         cookie_banner_preferences_button_title: 'Voorkeuren',
         cookie_banner_save_preferences_button_title: 'Opslaan',
         settings_cookie_consent_title: 'Toestemming voor cookies beheren',
         settings_cookie_tracking_cookies_title: 'Tracking Cookies',
         settings_cookie_tracking_cookies_success_message:
           'Tracking Cookies Status is succesvol bijgewerkt',
         settings_menu_partner_setting_title: 'Portaal Instellingen',
         partner_settings_form_header: 'Portaal Instellingen',
         partner_settings_form_logo_title: 'Logo',
         partner_settings_form_primary_color_title: 'Primaire Kleur',
         partner_settings_form_secondary_color_title: 'Secundaire Kleur',
         partner_settings_form_submit_button: 'Wijzigingen opslaan',
         partner_settings_form_white_label_success_message:
           'White-label is succesvol bijgewerkt.',
         devices_bulk_edit_registers_tr_device_type_unavailable:
           'Selected devices don\'t have a valid controller type. Please perform commissioning to proceed.',
         commissioning_form_stepper_validation_sim_connectivity_title:
           'Verbinding',
         commissioning_form_stepper_validation_sim_connectivity_default_setting:
           'Actief',
         commissioning_form_stepper_validation_sim_connectivity_success:
           'Verbinding actief',
         commissioning_form_stepper_validation_sim_connectivity_error:
           'Verbindingsprobleem',
         commissioning_form_stepper_validation_sim_connectivity_loading_title:
           'Verbindingscontrole duurt ongeveer 1 minuut',
         device_single_device_settings_fetch_latest_settings_button_v2:
           'Vernieuw Data',
         kong_account_created_subject:
           'Fortes Data Management - Nieuwe API Gateway Account Aangemaakt',
         kong_admin_user_form_create_success_message:
           'Kong Admin User succesvol aangemaakt!',
         kong_client_user_form_create_success_message:
           'Kong Client User succesvol aangemaakt!',
         kong_admin_user_form_update_success_message:
           'Kong Admin User succesvol vernieuwd!',
         kong_client_user_form_update_success_message:
           'Kong Client User succesvol vernieuwd!',
         kong_admin_user_form_error_message: 'Interne Serverfout',
         kong_client_user_form_error_message: 'Interne Serverfout',
         kong_admin_user_form_unique_error_message:
           'E-mail moet uniek zijn in Kong',
         kong_client_user_form_unique_error_message:
           'E-mail moet uniek zijn in Kong',
         kong_user_admin_single_api_documentation_link_label:
           'OpenAPI Specificatie',
         kong_client_bulk_deleted_message:
           '{{ USERS_COUNT }} Kong Klanten zijn succesvol verwijderd',
         devices_form_project_disabled_field:
           'Project kan niet ingevuld worden, omdat dit Device een service Device is',
         partner_settings_white_label: 'White label',
         partner_settings_general_settings: 'Algemene instelling',
         partner_settings_general_settings_partner_locales: 'Beschikbare talen',
         partner_settings_form_general_settings_success_message:
           'Algemene instellingen zijn succesvol bijgewerkt.',
         commissioning_form_article_number_is_missing_error:
           'Artikelnummer ontbreekt',
         commissioning_form_stepper_validation_sim_connectivity_check_started_title:
           'Verificatie Verbinding gestart',
         commissioning_form_stepper_validation_sim_connectivity_check_success_title:
           'Verbinding Succesvol',
         commissioning_form_stepper_validation_project_modbus_settings_check_started_title:
           'Verificatie Project Instelling Afleverset gestart',
         commissioning_form_stepper_validation_project_modbus_settings_success_title:
           'Project Instelling Afleverset is ingeschakeld',
         commissioning_form_stepper_validation_project_modbus_settings_disabled_title:
           'Geen Afleverset toegewezen in Project',
         commissioning_form_stepper_validation_sim_connectivity_missing_sim_number_error_event:
           'Verbindingsprobleem - SIM Nummer ontbreekt in de database',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_error_event:
           'Verbindingsprobleem - Network Provider API reageert niet',
         commissioning_form_stepper_validation_firmware_is_less_then_2_title:
           'Device firmware versie, d.w.z. ###DEVICE_FIRMWARE_VERSIE###, moet 2.x.x zijn. Update de firmware naar de laatste versie',
         commissioning_form_stepper_validation_firmware_is_missing_title:
           'Device firmware versie ontbreekt',
         commissioning_form_stepper_validation_baud_rate_fetch_failed_error_event:
           'Afleverset - Kan Baud Rate niet ophalen. Verwachte Baud Rate was ###BAUD_RATE###',
         commissioning_form_stepper_validation_baud_rate_set_failed_error_event:
           'Afleverset - Kan Baud Rate niet instellen ###BAUD_RATE###',
         commissioning_form_stepper_validation_modbus_connection_error_event:
           'Afleverset - Niet Verbonden',
         commissioning_form_stepper_validation_modbus_connection_success_event:
           'Afleverset - Verbonden',
         commissioning_form_stepper_validation_mbus_meters_check_success_event:
           'Mbus - Aantal aangesloten meters ###DEVICE_MBUS_METERS_COUNT### komt overeen met aantal ingestelde meters bij Project Instellingen ###PROJECT_SETTINGS_MBUS_METERS_COUNT###',
         commissioning_form_stepper_validation_mbus_meters_check_error_event:
           'Mbus - Aantal aangesloten meters ###DEVICE_MBUS_METERS_COUNT### komt niet overeen met aantal ingestelde meters bij Project Instellingen ###PROJECT_SETTINGS_MBUS_METERS_COUNT###',
         commissioning_form_stepper_validation_complete_success_event:
           'Validatieproces succesvol afgerond',
         device_bulk_insert_form_header: 'Device Toegevoegd',
         devices_form_order_type_field: 'Order Type',
         partner_settings_general_settings_distributor_article_number_label:
           'Afleverset Instellingen',
         partner_settings_general_settings_distributor_article_number_enable_settings_label:
           'Artikel- en serienummer van distributeur inschakelen',
         partner_settings_general_settings_distributor_article_number_disable_settings_label:
           'Afleverset Instellingen van distributeur uitschakelen',
         devices_partner_serial_number:
           'Afleverset serienummer van distributeur',
         devices_partner_article_number_field:
           'Afleverset artikelnummer van distributeur',
         commissioning_form_stepper_validation_baud_rate_retries_label:
           'Baud Rate Pogingen',
         commissioning_form_stepper_validation_modbus_retries_label:
           'Afleverset Verbindingspogingen',
         commissioning_form_header_updated_information_title:
           'Bijgewerkte Informatie',
         commissioning_form_header_report_title: 'Verslag',
         commissioning_form_header_report_connectivity:
           'Verbinding Step Status: ',
         commissioning_form_header_report_modbus_validation_title:
           'Afleverset Validatie: ',
         commissioning_form_header_report_mbus_validation_title:
           'Meter Validatie: ',
         commissioning_form_header_report_failed_status_title: 'Mislukt',
         commissioning_form_header_report_passed_status_title: 'Geslaagd',
         commissioning_form_header_report_not_status_title: 'Niet beschikbaar',
         commissioning_form_stepper_validation_sim_connectivity_maxitel_success_event:
           'Network Provider API werkt prima',
         project_single_project_error_devices_tab:
           'Geschiedenis Project-Storingen',
         device_monitoring_project_active_device_errors_counters_title:
           'Aantal devices met actieve storingen',
         device_monitoring_project_active_device_errors_list_title:
           'Aantal devices met actieve storingen',
         device_v2_settings_tab_general: 'Algemeen',
         device_v2_settings_tab_modbus: 'Modbus',
         device_v2_settings_tab_mbus: 'Mbus',
         device_single_device_settings_hiu_reboot_device: 'Afleverset Herstel',
         device_single_device_settings_hiu_reboot_message_forwarded:
           'Afleverset Reboot-verzoek is verstuurd naar Device',
         device_single_device_settings_interval_field: 'Interval',
         device_single_device_settings_interval_in_seconds_field:
           'Interval (Minuten)',
         device_single_device_settings_mbus_interval_message_forwarded:
           'Set Mbus Interval bericht is verstuurd naar Device',
         device_single_device_settings_mbus_interval_error_message_forwarded:
           'Mbus Interval moet 0 of hoger zijn',
         device_single_device_settings_mbus_interval: 'Mbus Interval',
         email_device_swapping_title:
           'Fortes Data Management - Device Uitwisseling',
         email_device_swapping_subject: 'Device swapping',
         email_device_swapping_recipient_name: 'Fortes Data Management',
         mbus_export_is_validated_field: 'Is Gevalideerd',
         device_single_device_settings_fqdn_field: 'Device FQDN',
         device_single_device_settings_fqdn_field_default_option:
           'Selecteer FQDN',
         device_single_device_settings_fqdn_error:
           'Selecteer een FQDN om verder te gaan',
         device_single_device_settings_fqdn_message_forwarded:
           'FQDN bericht is verstuurd naar het Device',
         projects_table_online_devices: 'Online Devices',
         add_subscriptions_form_header: 'Verleng Abonnement',
         subscriptions_bread_crumb_main_title: 'Abonnementen',
         add_subscriptions_bread_crumb_first_link: 'Verlenging Abonnement',
         subscriptionOrderNumber_required_form_error:
           'Abonnement ordernummer is verplicht',
         subscriptionPeriod_required_form_error:
           'Abonnementsperiode is verplicht',
         projectId_required_form_error: 'Project is verplicht',
         clientId_required_form_error: 'Klant is verplicht',
         subscriptionType_required_form_error: 'Abonnementstype is verplicht',
         subscription_form_subscriptionOrderNumber_field:
           'Ordernummer abonnement ',
         subscription_form_subscriptionPeriod_field:
           'Periode Abonnement (Maanden)',
         subscription_form_projectId_field: 'Project',
         subscription_form_clientId_field: 'Klant',
         subscription_form_subscriptionType_field: 'Type Abonnement',
         subscription_form_subscriptionStartDate_field: 'Startdatum Abonnement',
         subscription_form_subscriptionEndDate_field:
           'Verwachte Einddatum Abonnement',
         subscription_form_description_field: 'Beschrijving',
         subscription_form_notes_field: 'Notities',
         subscription_form_add_subscription_button: 'Wijzigingen Opslaan',
         subscription_form_cancel_button: 'Annuleer',
         subscription_form_project_offboarding_error: 'The selected project is currently being offboarded:',
         subscription_form_project_offboarding_cancel_hint: 'If you want to create a subscription extension, please first cancel the offboarding of the project.',
         subscription_add_form_success: 'Abonnement is succesvol aangemaakt',
         subscription_form_api_error:
           'Poging om Abonnement aan te maken niet gelukt vanwege een Interne Server Storing',
         subscriptions_form_header: 'Abonnementen',
         subscriptions_add_new: 'Maak Verlenging Abonnement aan',
         subscriptions_table_project: 'Project',
         subscriptions_table_client: 'Klant',
         subscriptions_table_start_date: 'Startdatum',
         subscriptions_table_end_date: 'Einddatum',
         subscriptions_table_subscriptionPeriod: 'Duur',
         offboarding_no_client_title: 'Project Has No Client Assigned',
         offboarding_no_client_line1:
           'One or more selected projects do not have a client assigned.',
         offboarding_no_client_line2:
           'Please deselect the project and continue, or assign a client to the project and refresh this page.',
         offboarding_no_client_line3:
           'To make selection easier, use the client filter to view projects from a single client only.',
         offboarding_cannot_combine_title: 'Projects Cannot Be Combined',
         offboarding_cannot_combine_line1:
           'You can only select projects that belong to the same client.',
         offboarding_cannot_combine_line2:
           'Please deselect projects from other clients to continue.',
         offboarding_cannot_combine_line3:
           'To make selection easier, use the client filter to view projects from a single client only.',
         subscriptions_table_total_device: 'Totale Aantal Devices',
         subscriptions_table_total_credit: 'Totaal Credits',
         subscriptions_table_credit_used: 'Gebruikte Credits',
         subscriptions_table_credit_left: 'Resterende Credits',
         subscriptions_table_month_to_zero_credit: 'Maanden tot Nul Credit',
         subscriptions_table_status: 'Status',
         subscriptions_table_loading: 'Laden...',
         subscriptions_no_record_found: 'Geen Records Gevonden',
         subscriptions_all: 'Alle',
         subscriptions_active: 'Actief',
         subscriptions_inactive: 'Inactief',
         subscriptions_expired: 'Verlopen',
         subscriptions_expiring_soon: 'Verloopt Binnenkort',
         subscriptions_table_row_per_page: 'Resultaten Per Pagina',
         subscriptions_filter_search: 'Zoeken',
         subscriptions_filters: 'Filters',
         sidebar_subscriptions_overview: 'Overzicht Abonnementen',
         sidebar_subscriptions: 'Abonnementen',
         project_single_project_subscription_devices_tab: 'Device Abonnementen',
         project_single_project_subscription_overview_tab:
           'Verlenging Abonnementen',
         sidebar_subscriptions_analytics: 'Analyse Abonnementen',
         subscriptions_analytics_form_header: 'Analyse Abonnement',
         devices_form_order_type_order_with_hiu: 'Order met afleverset',
         devices_form_order_type_order_without_hiu: 'Order zonder afleverset',
         subscription_status_overview_title: 'Abonnement Status Overzicht',
         subscription_analytics_data_missing_message:
           'Data is niet beschikbaar',
         subscription_analytics_data_loading_message:
           'Data wordt opgehaald ...',
         subscription_status_overview_subscriptions: 'Abonnementen',
         subscription_status_overview_expiring_soon: 'Verloopt binnenkort',
         subscription_status_overview_not_expiring_in_3_months:
           'Verloopt niet over 3 maanden',
         subscription_status_overview_expired: 'Verlopen',
         subscription_analytics_subscriptions_expiring_soon_title:
           'Abonnementen Verlopen Binnenkort',
         subscription_analytics_subscriptions_expiring_soon_2_weeks: '2 Weken',
         subscription_analytics_subscriptions_expiring_soon_1_month: '1 maand',
         subscription_analytics_subscriptions_expiring_soon_2_months:
           '2 maanden',
         subscription_analytics_subscriptions_expiring_soon_3_months:
           '3 maanden',
         subscription_analytics_subscriptions_expiring_soon_6_months:
           '6 maanden',
         subscription_analytics_subscriptions_expiring_soon_12_months:
           '12 maanden',
         subscription_analytics_subscriptions_expiring_soon_no_of_subscriptions:
           'Aantal Abonnementen',
         subscription_analytics_projects_credits_timeline_title:
           'Projecten Credits Tijdslijn',
         subscription_analytics_projects_credits_timeline_no_of_credits:
           'Aantal Credits',
         subscription_analytics_projects_credits_timeline_months: 'Maanden',
         subscription_analytics_projects_credits_timeline_jan: 'Jan',
         subscription_analytics_projects_credits_timeline_feb: 'Feb',
         subscription_analytics_projects_credits_timeline_mar: 'Mar',
         subscription_analytics_projects_credits_timeline_apr: 'Apr',
         subscription_analytics_projects_credits_timeline_may: 'Mei',
         subscription_analytics_projects_credits_timeline_jun: 'Jun',
         subscription_analytics_projects_credits_timeline_jul: 'Jul',
         subscription_analytics_projects_credits_timeline_aug: 'Aug',
         subscription_analytics_projects_credits_timeline_sep: 'Sep',
         subscription_analytics_projects_credits_timeline_oct: 'Okt',
         subscription_analytics_projects_credits_timeline_nov: 'Nov',
         subscription_analytics_projects_credits_timeline_dec: 'Dec',
         subscription_analytics_projects_credits_consumed: 'Verbruikte Credits',
         subscription_analytics_projects_credits_details_active_subscriptions:
           'Actieve Abonnementen',
         subscription_analytics_projects_credits_details_expiring_soon:
           'Verloopt binnenkort',
         subscription_analytics_projects_credits_details_expired_subscriptions:
           'Verlopen Abonnementen',
         subscription_analytics_projects_credits_details_expiring_in_3_months:
           'Verloopt over 3 maanden',
         subscription_analytics_projects_credits_details_expiring_in_6_months:
           'Verloopt over 6 maanden',
         partner_settings_general_settings_partner_timezone:
           'Standaard Tijdzone',
         distributor_timezone_modal_update_distributor_and_external_api_timezone_only:
           'Alleen distributeur en externe API tijdzone bijwerken',
         distributor_timezone_modal_update_distributor_and_all_users_timezone:
           'Update Distributeur en timezone van alle gebruikers',
         distributor_timezone_modal_cancel: 'Annuleer',
         distributor_timezone_modal_title: 'Weet je het zeker?',
         distributor_timezone_modal_subtitle:
           'Wil je de tijdzone voor de distributeurmodule bijwerken?',
         distributor_timezone_modal_success_message:
           'Tijdzone is succesvol bijgewerkt',
         distributor_timezone_modal_error_message: 'Update tijdzone mislukt',
         commissioning_email_commissioned_at_field: 'In bedrijf gesteld op',
         commissioning_email_commissioned_by_field: 'In bedrijf gesteld door',
         commissioning_email_commissioned_status_field:
           'Inbedrijfstelling status',
         commissioning_email_commissioned_completed_hiu_details_field:
           'Voltooide afleverset details',
         commissioning_email_mobile_connectivity_validation_field:
           'Validatie mobiele verbinding',
         commissioning_email_modbus_connectivity_validation_field:
           'Validatie Afleversetverbinding',
         commissioning_email_mbus_connectivity_validation_field:
           'Validatie Meterverbinding',
         commissioning_email_updated_address_details_field:
           'Bijgewerkte adresdetails',
         commissioning_email_title: 'Inbedrijfstellingsrapport Mercurius',
         commissioning_email_commissioned_by_message:
           'heeft het inbedrijfstellingsproces afgerond.',
         commissioning_email_subtitle:
           'Hieronder vind je het inbedrijfstellingrapport van de onlangs in bedrijf gestelde Mercurius in je project.',
         commissioning_email_information:
           'genereert dit rapport nadat het inbedrijfstellingsproces van de Mercurius is voltooid. Hierdoor kan jij of je organisatie tijdig actie ondernemen om eventuele problemen met de aansluiting van de afleversets op te lossen en een correcte inbedrijfstelling te garanderen.',
         commissioning_email_questions:
           'Vragen? Neem contact op met <a href="mailto:support@fortesdata.com"><span style="color: {{ primaryColor }};">support@fortesdata.com</span></a> voor verdere ondersteuning.',
         commissioning_none_added_status: 'Niets toegevoegd',
         commissioning_partially_updated_status: 'Deels bijgewerkt',
         commissioning_completed_status: 'Voltooid',
         commissioning_hiu_failed: 'Mislukt',
         commissioning_hiu_passed: 'Gelukt',
         subscription_credits_overview_title: 'Overzicht Credits',
         subscription_credits_positive_credits: 'Positief',
         subscription_credits_negative_credits: 'Negatief',
         partner_settings_general_settings_partner_locale: 'Standaardtaal',
         distributor_locale_modal_update_distributor_locale_only:
           'Vernieuw alleen de standaardtaal',
         distributor_locale_modal_update_distributor_and_all_users_locale:
           'Vernieuw Distributeur en talen van alle gebruikers',
         distributor_locale_modal_cancel: 'Annuleer',
         distributor_locale_modal_title: 'Weet je het zeker?',
         distributor_locale_modal_subtitle:
           'Wil je de taal voor de distributeurmodule bijwerken?',
         distributor_locale_modal_success_message:
           'Taal is succesvol bijgewerkt',
         distributor_locale_modal_error_message: 'Taalupdate mislukt',
         users_form_timezone_field: 'Tijdzone',
         users_form_locale_field: 'Taal',
         error_check_details_table_new_tab: 'Nieuwe',
         error_check_details_table_resolved_tab: 'Opgelost',
         error_check_details_table_active_tab: 'Actief',
         error_check_details_table_error_status: 'Status Storing',
         error_check_details_table_error: 'Storing Code',
         error_check_details_table_error_at: 'Storing bij',
         partner_settings_general_settings_distributor_serial_number_and_article_number_settings_label:
           'Distributeur Serie-, Artikel- en Ordernummer',
         kong_user_admin_single_client_label: 'Klant',
         commissioning_updated_information_title: 'Bijgewerkte Informatie',
         subscription_form_customerReference_field: 'Referentie klant',
         subscriptionCustomerReference_required_form_error:
           'Referentie klant is verplicht',
         subscription_previous_credits_left: 'Resterende Credits ',
         subscription_new_credits_added: 'Nieuwe Credits Toegevoegd',
         subscription_actual_credits_available: 'Beschikbare Credits',
         subscription_start_date: 'Startdatum',
         subscription_expected_expiry_date: 'Verwachte Vervaldatum',
         subscription_created_at: 'Aangemaakt Op',
         subscription_created_by: 'Gemaakt Door',
         subscription_notes_detail_for_users:
           '(Alleen voor Fortes Intern gebruik): opmerkingen m.b.t. sales, follow-ups en andere relevante informatie kunnen hier worden gedocumenteerd.',
         subscription_extension_overview: 'Overzicht Abonnementsverlenging',
         view_subscriptions_form_header: 'Bekijk Abonnement',
         current_subscription_state: 'Huidige abonnementsstatus',
         subscription_analytics_projects_credits_details_expiring_in_1_month:
           'Verloopt over 1 maand',
         business_situation_measured_values_TR04_211:
           'Gefilterde Buitentemperatuur',
         business_situation_measured_values_TR04_212:
           'Secundair Binnenkomend Koud Water',
         business_situation_measured_values_TR04_215:
           'T-Primaire Aanvoer Tapwater',
         business_situation_measured_values_TR04_216: 'Primaire CV Aanvoer',
         appliance_types_applicable: 'Van toepassing',
         appliance_types_device_dashboard: 'Dashboard Device',
         appliance_types_register_name: 'Registreer Naam',
         firmware_registers_TR04_80: 'Firmware Image status',
         firmware_registers_TR04_80_list: JSON.stringify({
           list: {
             0: 'Gedeeltelijke Afbeelding (Inkomende Afbeelding)',
             1: 'Geldige Afbeelding (Klaar voor programmeren)',
             2: 'Corrupte Afbeelding',
             3: 'Afbeelding Onbekend',
             4: 'Afbeelding Onbekend',
             5: 'Afbeelding Onbekend',
             6: 'Afbeelding Onbekend',
             7: 'Afbeelding Onbekend',
             8: 'Afbeelding Onbekend',
             9: 'Afbeelding Onbekend',
             10: 'Afbeelding Onbekend',
           },
         }),
         firmware_registers_TR04_81_list: JSON.stringify({
           list: {
             0: 'Firmware/applicatie afbeelding',
             1: 'Defaults Afbeelding',
             2: 'Afbeelding Onbekend',
             3: 'Afbeelding Onbekend',
             4: 'Afbeelding Onbekend',
             5: 'Afbeelding Onbekend',
             6: 'Afbeelding Onbekend',
             7: 'Afbeelding Onbekend',
             8: 'Afbeelding Onbekend',
             9: 'Afbeelding Onbekend',
             10: 'Afbeelding Onbekend',
           },
         }),
         firmware_registers_TR04_82_list: JSON.stringify({
           list: {
             0: 'Gedeeltelijke Afbeelding (Inkomende Afbeelding)',
             1: 'Geldige Afbeelding (Klaar voor programmeren)',
             2: 'Corrupte Afbeelding',
             3: 'Afbeelding Onbekend',
             4: 'Afbeelding Onbekend',
             5: 'Afbeelding Onbekend',
             6: 'Afbeelding Onbekend',
             7: 'Afbeelding Onbekend',
             8: 'Afbeelding Onbekend',
             9: 'Afbeelding Onbekend',
             10: 'Afbeelding Onbekend',
           },
         }),
         firmware_registers_TR04_98_list: JSON.stringify({
           list: {
             0: '°C bar',
             1: '°F bar',
             2: '°C psi',
             3: '°F psi',
           },
         }),
         firmware_registers_TR04_81: 'Firmware Image ID',
         firmware_registers_TR04_82: 'Default Image status',
         firmware_registers_TR04_98: 'Selectie eenheid (C/F)',
         firmware_registers_TR04_title: 'Firmware Registers',
         lin_pump_delta_parameters_TR04_title: 'LIN-Pomp DeltaP Parameters',
         lin_pump_delta_parameters_TR04_1870: 'DeltaP Customer Installation',
         lin_pump_delta_parameters_TR04_1871:
           'DeltaP Customer Installation (1)',
         lin_pump_delta_parameters_TR04_1872: 'DeltaP Kv Waarde',
         lin_pump_delta_parameters_TR04_1873: 'DeltaP Kv Waarde (1)',
         lin_pump_delta_parameters_TR04_1874: 'NV DeltaP Max',
         lin_pump_delta_parameters_TR04_1875: 'NV DeltaP Max (1)',
         appliance_types_form_cancel_button: 'Annuleer',
         appliance_types_form_submit_button: 'Wijzigingen opslaan',
         custom_popover_211_short_description: 'Gefilterde Buitentemperatuur',
         custom_popover_212_short_description: 'T-secundair Aanvoer Tapwater',
         custom_popover_215_short_description: 'T-Primaire Aanvoer Tapwater',
         custom_popover_216_short_description: 'Primaire CV Aanvoer',
         custom_popover_80_short_description: 'Firmware Image status',
         custom_popover_81_short_description: 'Firmware Image ID',
         custom_popover_82_short_description: 'Defaults Image status',
         custom_popover_98_short_description: 'Selectie eenheid (C/F)',
         custom_popover_1871_short_description: 'DeltaP Klantinstallatie',
         custom_popover_1873_short_description: 'DeltaP Kv Waarde',
         custom_popover_1875_short_description: 'NV DeltaP Max',
         edit_devices_device_name_unique_error: 'Naam Device moet uniek zijn',
         edit_devices_serial_number_unique_error:
           'Serienummer Mercurius moet uniek zijn',
         edit_devices_description_error: 'Type afleverset is verplicht',
         edit_devices_box_serial_number_unique_error:
           'Serienummer afleverset moet uniek zijn',
         edit_devices_article_number_error: 'Artikelnummer is verplicht',
         edit_devices_distributor_article_number_error:
           'Artikelnummer Distributeur is verplicht',
         edit_devices_distributor_serial_number_unique_error:
           'Distributeur serienummer van afleverset moet uniek zijn',
         edit_devices_prod_order_nr_week_error:
           'Productie ordernummer is verplicht',
         edit_devices_sim_card_number_error: 'Simkaartnummer verplicht',
         edit_devices_production_date_error: 'Productiedatum verplicht',
         custom_popover_211_long_description: 'Gefilterde Buitentemperatuur',
         custom_popover_212_long_description: 'T-secundair Aanvoer Tapwater',
         custom_popover_215_long_description: 'T-Primaire Aanvoer Tapwater',
         custom_popover_216_long_description: 'Primaire CV Aanvoer',
         custom_popover_80_long_description: 'Firmware Image status',
         custom_popover_81_long_description: 'Firmware Image ID',
         custom_popover_82_long_description: 'Defaults Image status',
         custom_popover_98_long_description: 'Selectie eenheid (C/F)',
         custom_popover_1871_long_description: 'DeltaP Klantinstallatie',
         custom_popover_1873_long_description: 'DeltaP Kv Waarde',
         custom_popover_1875_long_description: 'NV DeltaP Max',
         devices_form_backend_error_message:
           'Er zijn enkele problemen met de invulvelden. Herzie het formulier en corrigeer om verder te gaan.',
         devices_sim_card_number_length_and_type_form_error:
           'Het Simkaartnummer moet numeriek zijn en exact 19 cijfers bevatten',
         devices_sim_card_number_required_form_error:
           'Simkaartnummer is verplicht',
         devices_name_type_form_error:
           'Naam van Device mag alleen hoofdletters en cijfers bevatten.',
         devices_name_min_length_form_error:
           'De naam van het Device moet mimimaal 5 tekens bevatten.',
         devices_name_max_length_form_error:
           'De naam van het Device mag maximaal 6 tekens bevatten.',
         devices_serial_number_type_form_error:
           'Het Mercurius serienummer mag alleen letters en cijfers bevatten.',
         devices_serial_number_min_length_form_error:
           'Het Mercurius serienummer moet exact 24 tekens lang zijn.',
         devices_serial_number_max_length_form_error:
           'Het Mercurius serienummer moet exact 24 tekens lang zijn.',
         devices_article_number_min_length_form_error:
           'Artikelnummer moet tussen de 10 en 13 tekens bevatten.',
         devices_article_number_max_length_form_error:
           'Artikelnummer moet tussen de 10 en 13 tekens bevatten.',
         device_single_device_error_reporting_tab: 'Storingsrapportage',
         error_reporting_alarm_type_field: 'Type Storing',
         error_reporting_description_field: 'Beschrijving',
         error_reporting_resolution_field: 'Oplossing',
         error_reporting_error_start_date_field: 'Startdatum',
         error_reporting_error_end_date_field: 'Einddatum',
         error_reporting_error_counters_title: 'Storingen tot nu toe',
         error_reporting_error_counters_error: 'Geen data gevonden',
         error_reporting_error_counters_no_graph_data_error:
           'De cirkeldiagram is niet beschikbaar',
         error_reporting_error_counters_loading_data: 'Laden ...',
         errorReporting_TR04_255_errorName: 'GEEN_STORING',
         errorReporting_TR04_255_errorDescription: 'Geen storing',
         errorReporting_TR04_255_errorResolution: 'Geen',

         errorReporting_TR04_0_errorName: 'E2PROM_LEES_STORING',
         errorReporting_TR04_0_errorDescription: 'Interne software storing',
         errorReporting_TR04_0_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_8_errorName: 'RAM_STORING',
         errorReporting_TR04_8_errorDescription: 'Interne software storing',
         errorReporting_TR04_8_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_10_errorName: 'E2PROM_STORING',
         errorReporting_TR04_10_errorDescription:
           'Verkeerde veiligheidsparameters in E2prom',
         errorReporting_TR04_10_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_11_errorName: 'STATUS_STORING',
         errorReporting_TR04_11_errorDescription: 'Interne software storing',
         errorReporting_TR04_11_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_12_errorName: 'ROM_STORING',
         errorReporting_TR04_12_errorDescription: 'Interne software storing',
         errorReporting_TR04_12_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_15_errorName: 'MAX_TEMP_STORING',
         errorReporting_TR04_15_errorDescription:
           'De externe oververhittingsbeveiliging is ingeschakeld of de Secundaire CV Aanvoer sensor (TT-4) meet een temp hoger dan Maximaal beveiliging verwarmen',
         errorReporting_TR04_15_errorResolution:
           'Los de storing op en druk op de resetknop',

         errorReporting_TR04_17_errorName: 'STACK_STORING',
         errorReporting_TR04_17_errorDescription: 'Interne software storing',
         errorReporting_TR04_17_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_18_errorName: 'INSTRUCTIE_STORING',
         errorReporting_TR04_18_errorDescription: 'Interne software storing',
         errorReporting_TR04_18_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_23_errorName: 'BESCHADIGING_STORING_NR',
         errorReporting_TR04_23_errorDescription:
           'Storingscode RAM byte beschadigd door onbekende storingscode',
         errorReporting_TR04_23_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_29_errorName: 'PSM_STORING',
         errorReporting_TR04_29_errorDescription: 'Interne software storing',
         errorReporting_TR04_29_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_30_errorName: 'REGISTER_STORING',
         errorReporting_TR04_30_errorDescription: 'Interne software storing',
         errorReporting_TR04_30_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_37_errorName: 'ADC_STORING',
         errorReporting_TR04_37_errorDescription: 'Interne hardware storing',
         errorReporting_TR04_37_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_39_errorName: 'E2PROM_VERSIE_CHECK_STORING',
         errorReporting_TR04_39_errorDescription: 'Interne software storing',
         errorReporting_TR04_39_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_106_errorName: 'REFHI_TE_HOOG',
         errorReporting_TR04_106_errorDescription: 'Interne hardware storing',
         errorReporting_TR04_106_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_107_errorName: 'REFHI_TE_LAAG',
         errorReporting_TR04_107_errorDescription: 'Interne hardware storing',
         errorReporting_TR04_107_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_108_errorName: 'REFLO_TE_HOOG',
         errorReporting_TR04_108_errorDescription: 'Interne hardware storing',
         errorReporting_TR04_108_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_109_errorName: 'REFLO_TE_LAAG',
         errorReporting_TR04_109_errorDescription: 'Interne hardware storing',
         errorReporting_TR04_109_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_114_errorName: 'E2PROM_VERSIE_STORING',
         errorReporting_TR04_114_errorDescription: 'Interne software storing',
         errorReporting_TR04_114_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_116_errorName: 'LAGE_WATER_DRUK_STORING',
         errorReporting_TR04_116_errorDescription:
           'Lage waterdruk in het CV systeem',
         errorReporting_TR04_116_errorResolution:
           'Vul water aan tot juiste druk in CV systeem',

         errorReporting_TR04_119_errorName: 'TEMP_PRIMAIR_RETOUR_CV_OPEN',
         errorReporting_TR04_119_errorDescription:
           'Temperatuursensor primaire retour verwarming open',
         errorReporting_TR04_119_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR04_120_errorName: 'T_PRIMAIR_AANVOER_OPEN',
         errorReporting_TR04_120_errorDescription:
           'Temperatuursensor primaire aanvoer open',
         errorReporting_TR04_120_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR04_122_errorName: 'T_SWW_UIT_OPEN',
         errorReporting_TR04_122_errorDescription:
           'Temperatuursensor tapwater uitvoer open',
         errorReporting_TR04_122_errorResolution:
           'Controleer en/of vervang sensor tapwater en/of kabel',

         errorReporting_TR04_126_errorName: 'T_PRIMAIR_RETOUR_CV_KORTSL',
         errorReporting_TR04_126_errorDescription:
           'Kortsluiting in temperatuursensor primaire CV retour',
         errorReporting_TR04_126_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR04_127_errorName: 'T_PRIMAIR_AANVOER_KORTSL',
         errorReporting_TR04_127_errorDescription:
           'Kortsluiting in temperatuursensor primaire aanvoer',
         errorReporting_TR04_127_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR04_129_errorName: 'T_SWW_UIT_KORTSL',
         errorReporting_TR04_129_errorDescription:
           'Kortsluiting in temperatuursensor tapwater uitvoer',
         errorReporting_TR04_129_errorResolution:
           'Controleer en/of vervang sensor tapwater en/of kabel',

         errorReporting_TR04_134_errorName: 'RESET_KNOP_STORING',
         errorReporting_TR04_134_errorDescription:
           'Te veel resets vlak achter elkaar',
         errorReporting_TR04_134_errorResolution:
           'Onderbreek de stroomtoevoer van de afleverset voor ongeveer 10 seconden',

         errorReporting_TR04_158_errorName: 'T_SECONDAIR_AANV_CV_OPEN',
         errorReporting_TR04_158_errorDescription:
           'Temperatuursensor secundaire aanvoer CV open',
         errorReporting_TR04_158_errorResolution:
           'Controleer en/of vervang sensor aanvoer en/of kabel',

         errorReporting_TR04_159_errorName: 'SEC_RETOUR_CV_TEMP_OPEN',
         errorReporting_TR04_159_errorDescription:
           'Sensor secundaire retour CV open',
         errorReporting_TR04_159_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR04_160_errorName: 'SECONDAIRE_AANV_CV_TEMP_KORTSL',
         errorReporting_TR04_160_errorDescription:
           'Kortsluiting in secundaire aanvoer CV sensor',
         errorReporting_TR04_160_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR04_161_errorName: 'SEC_RETOUR_CV_TEMP_KORTSL',
         errorReporting_TR04_161_errorDescription:
           'Kortsluiting in secundaire retour CV sensor',
         errorReporting_TR04_161_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR04_171_errorName: 'ADC_ONSTABIEL',
         errorReporting_TR04_171_errorDescription:
           'ADC meting detecteert te veel onstabiele metingen',
         errorReporting_TR04_171_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_174_errorName: 'PRIMAIRE_RETOUR_SWW_TEMP_OPEN',
         errorReporting_TR04_174_errorDescription:
           'Primaire Tapwater retour sensor open',
         errorReporting_TR04_174_errorResolution:
           'Controleer en/of vervang sensor tapwater en/of kabel',

         errorReporting_TR04_175_errorName: 'PRIMAIRE_RETOUR_SWW_TEMP_KORTSL',
         errorReporting_TR04_175_errorDescription:
           'Kortsluiting in primaire Tapwater retour sensor',
         errorReporting_TR04_175_errorResolution:
           'Controleer en/of vervang sensor tapwater en/of kabel',

         errorReporting_TR04_203_errorName: 'HOGE_DRUK',
         errorReporting_TR04_203_errorDescription:
           'Hoge waterdruk in CV systeem gedetecteerd',
         errorReporting_TR04_203_errorResolution:
           'Verlaag de waterdruk in het CV systeem tot onder de 3 bar',

         errorReporting_TR04_206_errorName: 'TE_BOOSTER_WAARSCHUWING',
         errorReporting_TR04_206_errorDescription:
           'Water in TE Booster gedurende 24u niet op 75C gekomen of thermische beveiliging geactiveerd',
         errorReporting_TR04_206_errorResolution:
           'Power Cycle TE Booster, druk op resetknop regelaar, power cycle TE booster. Check rode knop aan onderkant TE booster. Druk knop in indien deze uitsteekt',

         errorReporting_TR04_207_errorName: 'POWERPACK_DEFECT_WAARSCHUWING',
         errorReporting_TR04_207_errorDescription: 'PowerPack is defect',
         errorReporting_TR04_207_errorResolution: 'Vervang regelaar',

         errorReporting_TR04_208_errorName: 'STORINGSLOG_OPSLAG_FOUT',
         errorReporting_TR04_208_errorDescription:
           'Interne software waarschuwing',
         errorReporting_TR04_208_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_209_errorName: 'DATALOG_OPSLAG_FOUT',
         errorReporting_TR04_209_errorDescription:
           'Interne software waarschuwing',
         errorReporting_TR04_209_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_210_errorName: 'FIRMWARE_OPSLAG_FOUT',
         errorReporting_TR04_210_errorDescription:
           'Interne software waarschuwing',
         errorReporting_TR04_210_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_211_errorName: 'STANDAARDINSTELLINGEN_OPSLAG_FOUT',
         errorReporting_TR04_211_errorDescription:
           'Interne software waarschuwing',
         errorReporting_TR04_211_errorResolution:
           'Druk op de resetknop. Als storing aanhoudt, vervang dan de regelaar',

         errorReporting_TR04_212_errorName: 'GEEN_PRIMAIR_DEBIET',
         errorReporting_TR04_212_errorDescription:
           'Geen primair debiet beschikbaar MCV-1',
         errorReporting_TR04_212_errorResolution:
           'Check en/of vervang primaire leiding, kogelkranen en/of MCV-1',

         errorReporting_TR04_213_errorName: 'LAGE_PRIMAIR_DEBIET',
         errorReporting_TR04_213_errorDescription:
           'Geringe primair debiet beschikbaar MCV-1',
         errorReporting_TR04_213_errorResolution:
           'Check en/of vervang primaire leiding, filter en/of MVC-1',

         errorReporting_TR04_214_errorName: 'ONTERECHTE_PRIMAIRE_DEBIET_MCV1',
         errorReporting_TR04_214_errorDescription:
           'Onterechte primair debiet waarschuwing MCV-1',
         errorReporting_TR04_214_errorResolution:
           'Check sluiting MCV-1, vervuiling en/pf te hoge Delta-P',

         errorReporting_TR04_215_errorName: 'ONTERECHTE_PRIMAIR_DEBIET_MCV1_2',
         errorReporting_TR04_215_errorDescription:
           'Onterechte primair debiet waarschuwing MCV1 en MCV2',
         errorReporting_TR04_215_errorResolution:
           'Check sluiting MCV-1 en MCV22, vervuiling en/of te hoge Delta-P',

         errorReporting_TR04_216_errorName: 'TEMP_ALEG_TE_LAAG',
         errorReporting_TR04_216_errorDescription:
           'Retour temperatuur te laag tijdens thermische desinfectie',
         errorReporting_TR04_216_errorResolution:
           'Check primaire retourtemperatuur',

         errorReporting_TR04_217_errorName: 'TEMP_TAPW_TE_HOOG',
         errorReporting_TR04_217_errorDescription:
           'Tapwater temp is te hoog ( > 70ºC voor > 5 s.)',
         errorReporting_TR04_217_errorResolution:
           'Check primaire aanvoertemperatuur tapwater',

         errorReporting_TR04_218_errorName: 'EVALUATION_TIMER_EXPIRED',
         errorReporting_TR04_218_errorDescription:
           'Evaluation Timer has expired',
         errorReporting_TR04_218_errorResolution: 'N.v.t.',

         errorReporting_TR04_219_errorName: 'WATER_LEKKAGE',
         errorReporting_TR04_219_errorDescription: 'Waterlekkage gedetecteerd',
         errorReporting_TR04_219_errorResolution: 'Los waterlekkage op',

         errorReporting_TR03_255_errorName: 'GEEN_STORING',
         errorReporting_TR03_255_errorDescription: 'Geen storing',
         errorReporting_TR03_255_errorResolution: 'None',

         errorReporting_TR03_0_errorName: 'E2PROM_LEES_STORING',
         errorReporting_TR03_0_errorDescription: 'Interne software storing',
         errorReporting_TR03_0_errorResolution:
           'Druk op de resetknop. Vervang regelaar als het probleem aanhoudt',

         errorReporting_TR03_4_errorName: 'STORING_TE_LANG',
         errorReporting_TR03_4_errorDescription:
           'Regelaar staat langer dan 20 uur in een blokkerende storing',
         errorReporting_TR03_4_errorResolution:
           'Los onderliggende storing op en druk op resetknop',

         errorReporting_TR03_8_errorName: 'RAM_STORING',
         errorReporting_TR03_8_errorDescription: 'Interne software storing',
         errorReporting_TR03_8_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_9_errorName: 'VERKEERDE_EEPROM_SLEUTEL',
         errorReporting_TR03_9_errorDescription:
           'Inhoud van E2prom is niet up to date',
         errorReporting_TR03_9_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_10_errorName: 'E2PROM_STORING',
         errorReporting_TR03_10_errorDescription:
           'Verkeerde veiligheidsparameters in E2prom',
         errorReporting_TR03_10_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_11_errorName: 'STATUS_STORING',
         errorReporting_TR03_11_errorDescription: 'Interne software storing',
         errorReporting_TR03_11_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_12_errorName: 'ROM_STORING',
         errorReporting_TR03_12_errorDescription: 'Interne software storing',
         errorReporting_TR03_12_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_15_errorName: 'MAX_TEMP_STORING',
         errorReporting_TR03_15_errorDescription:
           'De externe oververhittingsbeveiliging is ingeschakeld of de Secundaire Aanvoer sensor (TT-1) meet een temp hoger dan Maximaal beveiliging verwarmen',
         errorReporting_TR03_15_errorResolution:
           'Los de storing op en druk op de reset knop',

         errorReporting_TR03_17_errorName: 'STACK_STORING',
         errorReporting_TR03_17_errorDescription: 'Interne software storing',
         errorReporting_TR03_17_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_18_errorName: 'INSTRUCTIE_STORING',
         errorReporting_TR03_18_errorDescription: 'Interne software storing',
         errorReporting_TR03_18_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_23_errorName: 'BESCHADIGING_STORING_NR',
         errorReporting_TR03_23_errorDescription:
           'Foutmelding RAM byte is beschadigd door een onbekende foutmelding',
         errorReporting_TR03_23_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_29_errorName: 'PSM_STORING',
         errorReporting_TR03_29_errorDescription: 'Interne software storing',
         errorReporting_TR03_29_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_30_errorName: 'REGISTER_STORING',
         errorReporting_TR03_30_errorDescription: 'Interne software storing',
         errorReporting_TR03_30_errorResolution:
           'Druk op reset knop. Vervang de regelaar als de storing aanhoudt',

         errorReporting_TR03_36_errorName: 'KOELING_TE_HOOG',
         errorReporting_TR03_36_errorDescription:
           'Koeltemperatuur op de secundaire aanvoer te hoog. Koeltemperatuur >3 minuten boven de Maximaalbeveiliging koeling.',
         errorReporting_TR03_36_errorResolution:
           'Verlaag koeltemperatuur. Druk op reset knop. Als storing aanhoudt of terugkomt, verhoog Maximaalbeveiliging koeling naar 54C. Vervang regelaar als storing blijft.',

         errorReporting_TR03_106_errorName: 'REFHI_TE_HOOG',
         errorReporting_TR03_106_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_106_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_107_errorName: 'REFHI_TE_LAAG',
         errorReporting_TR03_107_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_107_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_108_errorName: 'REFLO_TE_HOOG',
         errorReporting_TR03_108_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_108_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_109_errorName: 'REFLO_TE_LAAG',
         errorReporting_TR03_109_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_109_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_110_errorName: 'REFHI2_TE_HOOG',
         errorReporting_TR03_110_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_110_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_111_errorName: 'REFHI2_TE_LAAG',
         errorReporting_TR03_111_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_111_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_112_errorName: 'REFLO2_TE_HOOG',
         errorReporting_TR03_112_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_112_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_113_errorName: 'REFLO2_TE_LAAG',
         errorReporting_TR03_113_errorDescription: 'Interne hardware storing',
         errorReporting_TR03_113_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_115_errorName: 'LAGE_WATERDRUK_STORING',
         errorReporting_TR03_115_errorDescription: 'Lage waterdruk storing',
         errorReporting_TR03_115_errorResolution:
           'Vul CV circuit bij met water tot gewenste druk',

         errorReporting_TR03_116_errorName: 'LAGE_WATERDRUK_SENSOR',
         errorReporting_TR03_116_errorDescription: 'Lage waterdruk',
         errorReporting_TR03_116_errorResolution:
           'Vul CV circuit bij met water tot gewenste druk',

         errorReporting_TR03_119_errorName: 'T_RETOUR_OPEN',
         errorReporting_TR03_119_errorDescription:
           'Temperatuursensor primaire retour open',
         errorReporting_TR03_119_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR03_120_errorName: 'T_AANVOER_OPEN',
         errorReporting_TR03_120_errorDescription:
           'Temperatuursensor primaire aanvoer open',
         errorReporting_TR03_120_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR03_121_errorName: 'T_SEC_AANVOER_OPEN',
         errorReporting_TR03_121_errorDescription:
           'Temperatuursensor secundaire aanvoer open',
         errorReporting_TR03_121_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR03_122_errorName: 'T_TAPWATER_OPEN',
         errorReporting_TR03_122_errorDescription:
           'Temperatuursensor tapwater open',
         errorReporting_TR03_122_errorResolution:
           'Controleer en/of vervang Tapwater sensor en/of kabel',

         errorReporting_TR03_126_errorName: 'T_RETOUR_KORTSL',
         errorReporting_TR03_126_errorDescription:
           'Kortsluiting in temperatuursensor primaire retour',
         errorReporting_TR03_126_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR03_127_errorName: 'T_AANVOER_KORTSL',
         errorReporting_TR03_127_errorDescription:
           'Kortsluiting in temperatuursensor primaire aanvoer',
         errorReporting_TR03_127_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR03_128_errorName: 'T_SEC_AANVOER_KORTSL',
         errorReporting_TR03_128_errorDescription:
           'Kortsluiting in temperatuursensor secundaire aanvoer',
         errorReporting_TR03_128_errorResolution:
           'Controleer en/of vervang aanvoer sensor en/of kabel',

         errorReporting_TR03_129_errorName: 'T_TAPWATER_KORTSL',
         errorReporting_TR03_129_errorDescription:
           'Kortsluiting in temperatuursensor tapwater',
         errorReporting_TR03_129_errorResolution:
           'Controleer en/of vervang tapwater sensor en/of kabel',

         errorReporting_TR03_134_errorName: 'RESETKNOP_STORING',
         errorReporting_TR03_134_errorDescription:
           'Te veel resets achter elkaar',
         errorReporting_TR03_134_errorResolution:
           'Onderbreek de stroomtoevoer van de afleverset gedurende 10 seconden',

         errorReporting_TR03_167_errorName: 'T_SEC_RETOUR_KORTSL',
         errorReporting_TR03_167_errorDescription:
           'Kortsluiting in temperatuursensor secundaire retour',
         errorReporting_TR03_167_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR03_168_errorName: 'T_SEC_RETOUR_OPEN',
         errorReporting_TR03_168_errorDescription:
           'Temperatuursensor in secundaire retour open',
         errorReporting_TR03_168_errorResolution:
           'Controleer en/of vervang retour sensor en/of kabel',

         errorReporting_TR03_169_errorName: 'WARMTE_KOELING_ACTIEF',
         errorReporting_TR03_169_errorDescription:
           'Gelijktijdige vraag naar koeling en verwarming',
         errorReporting_TR03_169_errorResolution:
           'Controleer thermostaat/regelaar en/of kabels om gelijktijdige vraag naar koeling en verwarming te voorkomen',

         errorReporting_TR03_170_errorName: 'HW_IDENTIFICATIE_STORING ',
         errorReporting_TR03_170_errorDescription:
           'Niet-overeenkomende hardware ID detectie',
         errorReporting_TR03_170_errorResolution: 'Vervang regelaar',

         errorReporting_TR03_203_errorName: 'HOGE_DRUK',
         errorReporting_TR03_203_errorDescription:
           'Hoge waterdruk in CV systeem gedetecteerd',
         errorReporting_TR03_203_errorResolution:
           'Verlaag de waterdruk in het CV systeem tot onder de 3 bar',

         errorReporting_TR03_204_errorName: 'KORTSL_BUITENTEMP_SENSOR',
         errorReporting_TR03_204_errorDescription:
           'Kortsluiting in buitentemperatuur sensor',
         errorReporting_TR03_204_errorResolution:
           'Controleer en/of vervang sensor en/of kabel',

         errorReporting_TR03_206_errorName: 'TE_BOOSTER_WAARSCHUWING',
         errorReporting_TR03_206_errorDescription:
           'TE booster setpoint niet binnen de gestelde timer behaald',
         errorReporting_TR03_206_errorResolution:
           'Controleer e/o vervang TE booster (onderdelen)',
         errorReporting_errorType_lockout: 'Vergrendeling',
         errorReporting_errorType_blocking: 'Blokkering',
         errorReporting_errorType_warning: 'Waarschuwing',
         device_single_dashboard_active_error_title: 'Actieve Storing',
         devices_box_serial_number_start_with_F_error:
           'Serienummer afleverset moet beginnen met een F',
         devices_form_default_controller_type_field: 'Standaard Regelaar Type',
         devices_form_default_soft_version_field: 'Standaard Software Versie',
         devices_form_old_software_version_field: 'Oude Software Versie',
         devices_form_default_appliance_type_field: 'Standaard Toestel Type',
         devices_form_default_client_name_field: 'Standaard Klant Naam',
         projects_form_total_amount_order_field:
           'Aantal afleversets op de Productie Bestelling',
         error_check_details_table_device_status_field: 'Device Status',
         error_check_details_table_export_generated_at_field: 'Opgemaakt op',
         error_check_details_table_export_generated_for_field: 'Opgemaakt voor',
         error_check_details_table_export_generated_by_user_field:
           'Opgemaakt door',
         error_check_details_table_export_report_name_field: 'Naam',
         error_check_details_table_export_active_alarms_report_field:
           'Actieve Storingen',
         error_check_details_table_export_active_new_alarms_report_field:
           'Nieuwe Actieve Storingen',
         error_check_details_table_export_resolved_alarms_report_field:
           'Opgeloste Storingen',
         error_check_details_table_export_active_alarms_sheet_report_field:
           'Actieve Storingen',
         error_check_details_table_export_active_new_alarms_sheet_report_field:
           'Nieuwe Actieve Storingen',
         error_check_details_table_export_resolved_alarms_sheet_report_field:
           'Opgeloste Storingen',
         projects_form_main_client_contact_field: 'Contactpersoon Klant',
         projects_form_main_service_client_contact_field:
           'Contactpersoon Service klant',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Storing',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Storingsmodus',
         errorReporting_TR03_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Neem contact op met de Support Afdeling',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorName:
           'Storing',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorDescription:
           'Device is in Storingsmodus',
         errorReporting_TR04_IN_ERROR_MODE_BUT_SHOULD_NOT_BE_VISIBLE_TO_USER_errorResolution:
           'Neem contact op met de Support Afdeling',
         error_check_details_table_error_name: 'Naam storing',
         devices_sim_card_number_form_unique_error:
           'Simkaartnummer moet uniek zijn',
         roles_overview_bread_crumb_first_link:
           'Overzicht Rollen en Rechten (Actieve Rollen)',
         roles_overview_form_header:
           'Overzicht Rollen en Rechten (Actieve Rollen)',
         roles_overview_fortes_roles_tab: 'Fortes rollen',
         roles_overview_client_roles_tab: 'Klant rollen',
         roles_overview_service_client_roles_tab: 'Service klant rollen',
         roles_overview_filter_roles_button: 'Filter Rollen',
         roles_form_permissions_loading:
           'Aan het laden... Dit kan 10 to 20 seconden duren. Even geduld a.u.b..',
         roles_overview_success_message:
           'Rechten voor actieve rollen zijn succesvol geupdatet.',
         roles_overview_error_message:
           'Updaten van rechtern voor actieve rollen mislukt. Neem contact op met de beheerder.',
         roles_overview_success_no_permission_change_message:
           'Geen veranderingen in de rechten gedetecteerd. Terug navigeren naar de rollenoverzichtpagina.',
         roles_overview_export_button: 'Export',
         roles_overview_export_file_name: 'Rollen Overzicht',
         roles_list_table_roles_overview_button: 'Rollen Overzicht',
         roles_overview_update_button: 'Update Rollen',
         devices_form_first_event_timestamp_field: 'Datum Eerste Event',
         devices_list_diagnostics_condition_modal_sensor_type_field_label:
           'Sensor Type',
         devices_list_diagnostics_condition_modal_controller_type_field_label:
           'Regelaar Type',
         subscription_form_unique_error_message:
           'Ordernummer abonnement bestaat al',
         email_common_questions: `Vragen? Neem contact op met <a style="color: ${primaryColor};" href="mailto:${process.env.REACT_APP_SUPPORT_EMAIL}"><span>${process.env.REACT_APP_SUPPORT_EMAIL}</span></a> voor verdere ondersteuning.`,
         email_common_footer_receiving:
           'Je ontvangt deze email omdat je een actief account hebt op het ##distributorName## portaal en hebt aangegeven email meldingen te ontvangen.',
         email_common_footer_unsubscribe: `Geen email meer ontvangen? Zet email meldingen uit <a style="color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}/admin/setting">here</a>.`,

         email_template_new_account_created_title: 'Nieuw Account Aangemaakt',
         email_template_new_account_created_main_content:
           'Dank voor het registreren bij ##distributorName##, het platform om op afstand je Fortes afleversets en gekoppelde energiemeters te monitoren en beheren.',
         email_template_new_account_created_password_intro:
           'Om je op weg te helpen, hebben we een account voor je aangemaakt op het ##distributorName## portaal. Hieronder vind je jouw tijdelijke wachtwoord.',
         email_template_new_account_created_temp_password:
           'Tijdelijke Wachtwoord:',
         email_template_new_account_created_login_instruction: `Volg deze <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> link</a>, to <a style="font-weight: 600;color: ${primaryColor};" href="${process.env.REACT_APP_BASE_URL}"> login</a> and change your password.`,
         email_template_new_account_created_button: 'INLOGGEN',
         email_template_modbus_data_title: 'Afleversetdata',
         email_template_modbus_data_content:
           'Je hebt een export aangevraagd van de beschikbare data van de Fortes afleversets. Het exportbestand is beveiligd met een wachtwoord om jouw gegevens te beschermen.<br />Klik op deze link om het zipbestand te downloaden. Voer het wachtwoord in bij het openen van het zipbestand.',
         email_template_modbus_data_password: 'Wachtwoord:',
         email_template_modbus_data_expiry_note:
           'Opmerking: De bovenstaande link vervalt na 12 uur.',
         email_template_modbus_data_button: 'DOWNLOAD ZIP BESTAND',
         email_template_mbus_data_title: 'Meterdata',
         email_template_mbus_data_content:
           'Je hebt een export aangevraagd van de beschikbare data van de energiemeter(s).',
         email_template_mbus_data_content_1:
           'Het exportbestand is beveiligd met een wachtwoord om jouw gegevens te beschermen.',
         email_template_mbus_data_content_2:
           'Klik op deze link om het zipbestand te downloaden. Voer het wachtwoord in bij het openen van het zipbestand.',
         email_template_mbus_data_password: 'Wachtwoord:',
         email_template_mbus_data_expiry:
           'Opmerking: De bovenstaande link vervalt na 12 uur.',
         email_template_mbus_data_button: 'DOWNLOAD ZIP BESTAND',

         email_template_device_swapping_title: 'Device Uitwisselen',
         email_template_device_swapping_content:
           'Je hebt onlags een Mercurius Communicatie Module uitgewisseld voor een nieuw examplaar.',
         email_template_device_swapping_content_1:
           'Hieronder vind je een samenvatting van de uitwisseling in jouw project.',
         email_template_device_swapping_old_device_section: 'Oud Device',
         email_template_device_swapping_old_project: 'Project',
         email_template_device_swapping_old_client: 'Klant',
         email_template_device_swapping_old_device_name: 'Device naam',
         email_template_device_swapping_old_swapped_at: 'Uitgewisseld op',
         email_template_device_swapping_old_swapped_by: 'Uitgewisseld door',
         email_template_device_swapping_old_serial_number_mercurius:
           'Serienummer Mercurius',
         email_template_device_swapping_old_type_heat_interface_unit:
           'Type Afleverset',
         email_template_device_swapping_old_distributor_serial_number:
           'Distributeur Serie # afleverset',
         email_template_device_swapping_old_distributor_article_number:
           'Distributeur Artikel # afleverset',
         email_template_device_swapping_old_serial_number:
           'Serienummer Afleverset',
         email_template_device_swapping_old_production_date: 'Productie datum',
         email_template_device_swapping_old_customer_reference:
           'Klant referentie',
         email_template_device_swapping_old_article_number_heat_interface_unit:
           'Artikelnummer afleverset',
         email_template_device_swapping_old_production_order_number:
           'Productie ordernummer',
         email_template_device_swapping_old_order_number: 'Ordernummer',
         email_template_device_swapping_new_device_section: 'Nieuw Device',

         email_template_device_swapping_new_device_name: 'Naam',
         email_template_device_swapping_new_serial_number:
           'Serienummer Mercurius',
         email_template_device_swapping_new_sim_card: 'Simkaartnummer',
         email_template_device_swapping_new_firmware: 'Firmware versie',
         email_template_device_swapping_new_device_type: 'Device type',

         email_template_device_swapping_completion:
           'heeft het uitwisselingsproces afgerond.',
         email_template_device_swapping_completion_info:
           '##distributorName## genereert dit rapport na afronding van het uitwisselingsproces. Dit stelt jou of jouw organisatie in staat tijdig actie te ondernemen om eventuele problemen op te lossen.',

         email_template_active_alarms_title: 'Actieve Storingen Report',
         email_template_active_alarms_intro:
           'Hieronder vind je een overzicht van de actieve storingen <sup>2</sup> voor de aangesloten Fortes afleversets in jouw project(en).',
         email_template_active_alarms_new_active_alarms:
           'Nieuwe Actieve Storingen<sup>2</sup>',
         email_template_active_alarms_existing_active_alarms:
           'Bestaande Actieve Storingen',
         email_template_active_alarms_resolved_alarms:
           'Opgeloste Storingen<sup>3</sup>',
         email_template_active_alarms_download_report:
           'Om het volledige Excel-rapport te downloaden, klik je op deze link.',
         email_template_active_alarms_download_report_button:
           'DOWNLOAD VOLLEDIG EXCEL RAPPORT',
         email_template_active_alarms_report_info:
           '##distributorName## genereert dit rapport elke 6 uur. Dit stelt jou of jouw organisatie in staat om tijdig actie te ondernemen om de storingen in de afleversets op te lossen en een correcte werking te garanderen.',
         email_template_active_alarms_report_info_1:
           '1. Een Actieve Storing is een storing die is opgetreden en nog niet is opgelost.',
         email_template_active_alarms_report_info_2:
           '2. Een Nieuwe Actieve Storing is een storing die is opgetreden sinds het laatste rapport.',
         email_template_active_alarms_report_info_3:
           '3. Een Opgeloste Storing is een storing die is opgelost sinds het laatste rapport.',

         email_template_api_gateway_title:
           'Nieuwe API Gateway Account Aangemaakt',
         email_template_api_gateway_main_content:
           'Dank voor het registreren bij ##distributorName##, het platform om op afstand je Fortes afleversets en gekoppelde energiemeters te monitoren en beheren.',
         email_template_api_gateway_info:
           'Om je op weg te helpen, hebben we een account voor je aangemaakt op het ##distributorName## Platform. Hieronder vind je jouw API Key.',
         email_template_api_gateway_api_key: 'API Key:',
         email_template_api_gateway_spec_link: `Klik op deze <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, om de OpenAPI Specificatie te bekijken.`,
         email_template_api_gateway_button: 'OpenAPI Specificatie',

         email_template_forgot_password_title: 'Wachtwoord Vergeten',
         email_template_forgot_password_content:
           'We hebben een verzoek ontvangen om het wachtwoord voor jouw account opnieuw in te stellen.',
         email_template_forgot_password_content_1: `Klik op deze <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>, om jouw wachtwoord opnieuw in te stellen.`,
         email_template_forgot_password_reset_password_button:
           'RESET WACHTWOORD',

         email_template_mbus_hourly_logs_missing_title:
           'Ontbrekende Meterlog Rapport',
         email_template_mbus_hourly_logs_missing_content:
           'We hebben vastgesteld dat bepaalde energiemeters geen mbus-uurdata verzenden.',
         email_template_mbus_hourly_logs_view_report_button: 'BEKIJK RAPPORT',

         email_template_anomaly_digest_title: 'Device herstart overzicht',
         email_template_anomaly_digest_content:
           'Hier zijn de details van het device restart overzicht',
         email_template_anomaly_digest_duration:
           'Duur: <b>{{ anomalyDuration }}</b>',
         email_template_anomaly_digest_project_name:
           'Projectnaam: {{projectName}}',
         email_template_anomaly_digest_device_serial: 'Device serienummer',
         email_template_anomaly_digest_anomaly_count: 'Herstart teller',
         email_template_anomaly_digest_button: 'BEKIJK HERSTART RAPPORT',

         email_template_maxitel_m2m_blend_and_api_status_title:
           'Maxitel M2M Blend En API Status',
         email_template_maxitel_m2m_blend_and_api_status_intro:
           'Hier zijn de details van de Maxitel M2M Blend En API Status.',
         email_template_maxitel_m2m_blend_and_api_status_service_header:
           'Maxitel Service',
         email_template_maxitel_m2m_blend_and_api_status_status_header:
           'Status',
         email_template_maxitel_m2m_blend_and_api_status_api_status:
           'Niet-operationeel',
         email_template_maxitel_m2m_blend_and_api_status_operational:
           'Operationeel',

         email_template_device_commissioning_report_title:
           'Mercurius Inbedrijfstellingsrapport',
         email_template_device_commissioning_report_intro:
           'Hieronder vind je het inbedrijfstellingrapport van het onlangs in bedrijf gestelde Mercurius in jouw project.',
         email_template_device_commissioning_report_project: 'Project',
         email_template_device_commissioning_report_client: 'Klant',
         email_template_device_commissioning_report_device_name: 'Device naam',
         email_template_device_commissioning_report_commissioned_at:
           'In bedrijf gesteld op',
         email_template_device_commissioning_report_commissioned_by:
           'In bedrijf gesteld door',
         email_template_device_commissioning_report_commissioning_status:
           'Inbedrijfstelling status',
         email_template_device_commissioning_report_completed_hiu_details:
           '-Voltooide afleverset details',
         email_template_device_commissioning_report_mobile_connectivity_validation:
           '-Validatie mobiele verbinding',
         email_template_device_commissioning_report_modbus_connectivity_validation:
           '-Validatie afleversetverbinding',
         email_template_device_commissioning_report_mbus_connectivity_validation:
           '-Validatie meterverbinding',
         email_template_device_commissioning_report_updated_address_details:
           '-Bijgewerkte adresgegevens',
         email_template_device_commissioning_report_completion:
           'Gebruiker heeft het inbedrijfstellingsproces afgerond.',
         email_template_device_commissioning_report_footer:
           'genereert dit rapport nadat het inbedrijfstellingsproces van Mercurius is voltooid. Hierdoor kan jij of jouw organisatie tijdig actie ondernemen om eventuele problemen met de aansluiting van de afleversets op te lossen en een correcte inbedrijfstelling te garanderen.',

         email_template_subscriptions_expiring_title:
           'Binnenkort verlopen projectabonnementen',
         email_template_subscriptions_expiring_content:
           'Wij informeren je dat {{ numberOfProjects }} projecten binnenkort verlopen.',
         email_template_subscriptions_expiring_content_1: `Klik op deze <a style="font-weight: 600; color: ${primaryColor};" href={{ subscriptionsExpiringUrl }}>link</a> om de details te bekijken.`,
         email_template_subscriptions_expiring_soon_notification:
           'Binnenkort verlopen projectabonnementen melding',
         email_template_subscriptions_expiring_months: 'maanden',
         email_template_subscriptions_expiring_button:
           'BEKIJK BINNENKORT VERLOPEN ABONNEMENTEN',

         email_template_delete_device_sim_subscription_title:
           'Deactiveer Maxitel sim-abonnement',
         email_template_delete_device_sim_subscription_content:
           'Hieronder vind je de informatie die nodig is om het SIM-abonnement handmatig te verwijderen, omdat de Maxitel Delete Subscription API momenteel niet functioneert.',

         email_template_delete_device_sim_subscription_project: 'Project',
         email_template_delete_device_sim_subscription_client: 'Klant',
         email_template_delete_device_sim_subscription_device_name:
           'Device naam',
         email_template_delete_device_sim_subscription_device_edited_by:
           'Device gewijzigd door',
         email_template_delete_device_sim_subscription_device_edited_at:
           'Device gewijzigd op',
         email_template_delete_device_sim_subscription_old_sim_number:
           'Oud SIM nummer',
         email_template_greeting: 'Beste',
         swapping_email_swapped_at_field: 'Uitgewisseld op',
         swapping_email_swapped_by_field: 'Uitgewisseld door',
         projects_form_created_at_field: 'Aanmaakdatum',
         add_subscription_order_number_duplicate_error:
           'Ordernummer abonnement moet uniek zijn.',
         add_subscription_project_not_found_error:
           'Het opgegeven project bestaat niet.',
         add_subscription_subscription_project_credits_missing_error:
           'Geen devices gevonden voor het geselecteerde project.',
         add_subscription_subscription_creation_failed_error:
           'Kan abonnement niet aanmaken door een interne systeem fout.',
         add_subscription_invalid_or_null_payload_error:
           'De opgegeven payload is nul of ongeldig.',
         devices_bulk_delete_button: 'Verwijder Devices',
         devices_bulk_delete_modal_title: 'Weet je het zeker?',
         devices_bulk_delete_modal_subtitle: `<strong>De volgende data zal verwijderd worden:</strong>
          <ul>
            <li><i>Device informatie</i></li>
            <li><i>Events</i></li>
            <li><i>Afleversetdata</i></li>
            <li><i>Meterdata</i></li>
            <li><i>Grafiek Data</i></li>
            <li><i>Device Register</i></li>
            <li><i>Storingsdata</i></li>
            <li><i>Andere gerelateerde tabellen</i></li>
          </ul>`,
         devices_bulk_delete_modal_note:
           '<strong>Note:</strong> <br/> Zodra je de verwijdering hebt uitgevoerd, kan dit niet meer ongedaan worden gemaakt, tenzij het IT-team de gegevens handmatig herstelt vanuit oude back-ups. Het herstellen van events en andere gerelateerde informatie kost veel tijd. Het verwijderen van devices duurt even vanwege de bovengenoemde gegevens. Wees geduldig en annuleer of vernieuw de pagina niet.',
         devices_bulk_delete_modal_cancel_button: 'Annuleren',
         devices_bulk_delete_modal_delete_button: 'Verwijderen',
         devices_bulk_deleted_message:
           '{{ DEVICES_COUNT }} Devices zijn succesvol verwijderd',
         email_template_device_deletion_title: 'Verwijderde Devices Rapport',
         email_template_device_deletion_content:
           'Hieronder vind je een overzicht van de devices die van het ##distributorName##-platform zijn verwijderd:',
         email_template_device_deletion_content_1: `Om het volledige Excel-rapport te downloaden, klik je op deze <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a>.`,
         email_template_device_deletion_download_button:
           'Download Volledig Excel Rapport',
         email_template_device_deletion_note:
           '##distributorName## genereert dit rapport om het verwijderen van devices bij te houden voor controledoeleinden en om gegevens te bewaren in het geval van onbedoelde verwijderingen.',
         email_template_device_deletion_deleted_devices_count_field:
           'Aantal Verwijderde Devices ',
         email_template_device_deletion_deleted_at_field: 'Verwijderd Op',
         email_template_device_deletion_deleted_at_by: 'Verwijderd Door',
         inconsistent_mbus_devices_reporting_details_table_header:
           'Inconsistente Meters',
         inconsistent_mbus_devices_reporting_details_bulk_export_button:
           'Export',
         inconsistent_mbus_devices_reporting_details_filter_reset_button:
           'Reset',
         inconsistent_mbus_devices_reporting_details_table_filter_search:
           'Zoeken',
         inconsistent_mbus_devices_reporting_details_table_created_at:
           'Aangemaakt op',
         inconsistent_mbus_devices_reporting_details_table_device: 'Device',
         inconsistent_mbus_devices_reporting_details_table_project: 'Project',
         inconsistent_mbus_devices_reporting_details_table_client: 'Klant',
         inconsistent_mbus_devices_reporting_details_table_firmware: 'Firmware',
         inconsistent_mbus_devices_reporting_details_table_actual_rmeters_count:
           'Aantal Werkelijke Meters',
         inconsistent_mbus_devices_reporting_details_table_shown_meters_count:
           'Aantal Getoonde Meters',
         inconsistent_mbus_devices_reporting_details_table_no_record_found:
           'Geen Record Gevonden',
         inconsistent_mbus_devices_reporting_details_table_row_per_page:
           'Resultaten per pagina',
         error_check_details_table_export_success_message:
           'Er is een storingsmmail naar jouw inbox verzonden.',
         error_check_details_table_export_error_message:
           'Doorsturen van de storingsemail mislukt. Neem contact op met support voor ondersteuning',
         errorReporting_TR03_256_errorName: 'MODBUS_WAARSCH_BERICHT',
         errorReporting_TR03_256_errorDescription:
           'Geen Modbus communicatie mogelijk met de regelaar van de afleverset',
         errorReporting_TR03_256_errorResolution:
           'Check e/o vervang Modbus kabel e/o aansluitingen. Als het probleem aanblijft, vervang regelaar',
         errorReporting_TR04_256_errorName: 'MODBUS_WAARSCH_BERICHT',
         errorReporting_TR04_256_errorDescription:
           'Geen Modbus communicatie mogelijk met de regelaar van de afleverset',
         errorReporting_TR04_256_errorResolution:
           'Check e/o vervang Modbus kabel e/o aansluitingen. Als het probleem aanblijft, vervang regelaar',
         error_check_details_table_export_start_time_field: 'Starttijd',
         error_check_details_table_export_end_time_field: 'Eindtijd',
         error_check_details_table_export_resolution_field: 'Oplossing',
         error_check_details_table_export_alarm_code_field: 'Storingscode',
         error_check_details_table_export_alarm_name_field: 'Naam Storing',
         error_check_details_table_export_alarm_resolutions_field:
           'Oplossingen Storingen',
         error_check_details_table_export_alarm_description_field:
           'Beschrijving',
         subscription_form_subscriptionPeriod_years_field:
           'Abonnementsperiode (jaren)',
         subscription_form_project_devices_missing_error:
           'Er zijn geen devices gekoppeld aan het geselecteerde project. Voeg devices toe om door te gaan.',
         settings_notification_device_error_toast_message:
           '"Stuur een bericht wanneer een device een storing heeft" is succesvol bijgewerkt.',
         subscription_form_client_email_status_field: 'Klant Email Status',
         subscription_form_client_email_success_field:
           'De contactpersoon voor deze klant is ingesteld op de Wijzig Klant pagina en de e-mail is succesvol doorgestuurd voor de abonnementsverlenging.',
         subscription_form_client_email_error_field:
           'De contactpersoon voor deze klant is nog niet ingesteld op de Wijzig Klant pagina en de e-mail is niet doorgestuurd voor de abonnementsverlenging.',
         subscription_extension_client_email_status: 'Klant Email Status',
         subscription_form_keycloak_user_id_mismatch_issue_error:
           'Klant e-mail gebruikersaccount heeft een probleem. Neem contact op met de beheerder.',
         devices_partner_order_number_field: 'Ordernummer Distributeur',
         edit_devices_distributor_order_number_error:
           'Ordernummer Distributeur is vereist',
         legal_documents_checkbox_link_information_form_error:
           '<strong>Opmerking: </strong><i>In het veld voor het selectievakje-label van het document, gebruik [link] om de document-URL in te voegen; deze wordt automatisch vervangen door de daadwerkelijke link.</i>',
         devices_form_distinct_mercurius_type_field:
           'Onderscheidend Mercurius Type',
         device_label_table_label_field: 'Label',
         device_label_table_status_field: 'Status',
         device_label_table_last_modified_field: 'Laatst Gewijzigd',
         device_label_table_description_field: 'Beschrijving',
         sidebar_device_label_menu: 'Device Labels',
         device_labels_form_add_button: 'Voeg Device Label Toe',
         device_labels_form_edit_button: 'Wijzig Device Label',
         device_labels_form_cancel_button: 'Annuleer',
         device_labels_header: 'Device Labels',
         device_labels_table_no_record_found: 'Geen gegevens gevonden',
         device_labels_table_row_per_page: 'Rijen per pagina',
         add_device_label: 'Voeg Device Label Toe',
         add_device_labels_form_header: 'Voeg Device Label Toe',
         edit_device_labels_form_header: 'Wijzig Device Label',
         device_labels_add_new: 'Voeg nieuwe toe',
         device_label_form_label_field: 'Label',
         device_label_form_description_field: 'Beschrijving',
         device_label_form_color_field: 'Kleur',
         device_label_form_select_color_field: 'Selecteer Kleur',
         device_label_form_label_required_error: 'Device Label is vereist',
         device_label_form_description_required_error:
           'Beschrijving is vereist',
         device_label_form_label_unique_error: 'Device Label moet uniek zijn',
         device_label_form_color_required_error: 'Kleur is vereist',
         add_device_label_form_success: 'Device Label is succesvol aangemaakt.',
         add_device_label_form_api_error: 'Interne Server Alarm',
         device_label_activated_message: 'Device Label Succesvol Geactiveerd',
         device_label_deactivated_message: 'Device Label Succesvol Geactiveerd',
         edit_device_label_form_success:
           'Device Label is succesvol  bijgewerkt.',
         edit_device_label_form_api_error: 'Interne Server Alarm',
         device_label_table_filter_reset_button: 'Resetten',
         device_label_table_search: 'Zoeken',
         device_labels_green_color: 'Groen',
         device_labels_blue_color: 'Blauw',
         device_labels_red_color: 'Rood',
         device_labels_orange_color: 'Oranje',
         device_labels_grey_color: 'Grijs',
         devices_form_device_labels_field: 'Device Label(s)',
         devices_table_row_all_records_label: 'Allen',
         devices_show_all_devices_modal_title: 'Weet je het zeker?',
         devices_show_all_devices_modal_subtitle:
           'Door "Allen" in de keuzelijst te selecteren, vraag je om alle beschikbare gegevens te laden, d.w.z. ##TOTAL_DEVICES##.',
         devices_show_all_devices_modal_note:
           '<ul><li>Deze actie kan 30 seconden of langer duren en de pagina vertragen.</li><li>Het laden van alle records (meer dan 10 MB aan gegevens) kan prestatieproblemen veroorzaken, waaronder vertraging van de pagina door het grote aantal items dat wordt weergegeven.</li><li>Als je hiermee akkoord gaat, klik op<strong>"Toch doorgaan"</strong>.</li><li>Om te annuleren en terug te keren naar de standaard 25 rijen, klik op<strong>"Annuleren"</strong>.</li></ul>',
         devices_show_all_devices_modal_cancel_button: 'Annuleren',
         devices_show_all_devices_modal_proceed_anyway_button: 'Toch Doorgaan',
         device_labels_blue_category: '',
         device_labels_green_category: 'Opgelost',
         device_labels_grey_category: 'Installatie Type',
         device_labels_red_category: 'Probleem Type',
         device_labels_orange_category: 'Status Type',
         commissioning_form_stepper_validation_appliance_type_check_started_title:
           'Toesteltype Check Gestart',
         commissioning_form_stepper_validation_appliance_type_check_success_title:
           'Succes: Het device heeft het toesteltype verstuurd',
         commissioning_form_stepper_validation_appliance_type_check_warning_title:
           'Waarschuwing: Het device heeft het toesteltype niet verstuurd',
         device_table_dynamic_columns_modal_title: 'Dynamische Kolommen',
         device_table_dynamic_columns_modal_columns_info_message:
           'Je moet minimaal 14 kolommen kiezen, maar in totaal niet meer dan 20 kolommen.',
         device_table_dynamic_columns_modal_columns_freeze_message:
           'De kolom "Device naam" is standaard vastgezet in het overzicht en kan niet worden aangepast. Je kunt één extra kolom selecteren om vast te zetten, waarmee de standaardkolom "Serienummer Afleverset" wordt vervangen als je deze kiest. Vastgezette kolommen blijven altijd de eerste twee kolommen in de tabel. Er kunnen maximaal twee kolommen tegelijk worden vastgezet.',
         project_single_device_table_dynamic_columns_modal_columns_freeze_message:
           'De kolom "Serienummer Afleverset" is standaard vastgezet in het overzicht en kan niet worden aangepast. Je kunt één extra kolom selecteren om vast te zetten, waarmee de standaardkolom "Installatieadres" wordt vervangen als je deze kiest. Vastgezette kolommen blijven altijd de eerste twee kolommen in de tabel. Er kunnen maximaal twee kolommen tegelijk worden vastgezet.',
         device_table_dynamic_columns_modal_active_column_title:
           'Actieve Kolommen',
         device_table_dynamic_columns_modal_inactive_column_title:
           'Inactieve Kolommen',
         device_table_dynamic_columns_modal_cancel_button: 'Annuleren',
         device_table_dynamic_columns_modal_go_back_button: 'Terug',
         device_table_dynamic_columns_modal_next_button: 'Volgende',
         device_table_dynamic_columns_modal_save_button: 'Opslaan',
         device_table_dynamic_columns_modal_default_freeze_icon_title:
           'Deze kolom is standaard vastgezet en kan niet worden aangepast.',
         device_table_dynamic_columns_modal_freeze_icon_title:
           'Klik op het grijze vastzetpictogram om deze kolom vast te zetten. Zodra deze is vastgezet, wordt deze automatisch naar de tweede positie verplaatst en blijft daar staan totdat je ervoor kiest een andere kolom vast te zetten.',
         device_table_dynamic_columns_modal_stepper_step_1_button:
           'Selecteer kolommen',
         device_table_dynamic_columns_modal_stepper_step_2_button:
           'Selecteer kolom posities',
         device_table_dynamic_columns_modal_success_message:
           'Dynamische Kolommen zijn succesvol bijgewerkt.',
         device_table_dynamic_columns_modal_error_message:
           'Het bijwerken van Dynamische Kolommen is mislukt.',
         devices_export_download_form_success:
           'Devices Export Data is succesvol verstuurd naar ##EMAIL##!',
         devices_bulk_data_collect_button: 'VERNIEUW DATA',
         devices_bulk_data_collect_success_message:
           'Je bericht is doorgestuurd naar alle geselecteerde devices. Deze pagina wordt over 5 seconden automatisch vernieuwd.',
         device_list_filters_button_label_new: 'Nieuw',

         device_list_filters_button_label_export_devices: 'EXPORTEER DEVICES',

         device_list_filters_button_label_download_hiu_data:
           'DOWNLOAD AFLEVERSETDATA',

         device_list_filters_button_label_download_meter_data:
           'DOWNLOAD METERDATA',

         device_list_filters_button_label_change_settings:
           'INSTELLINGEN WIJZIGEN',
         device_list_filters_button_label_update_devices: 'DEVICE(S) BIJWERKEN',

         device_list_filters_button_label_delete_devices: 'VERWIJDER DEVICES',

         device_list_filters_button_label_data_collect: 'VERNIEUW DATA',
         device_table_dynamic_columns_modal_restore_default_button:
           'Herstel Naar Standaard',
         device_table_dynamic_columns_modal_columns_are_selected_label:
           '##NUMBER_OF_COLUMNS## kolommen zijn geselecteerd',
         device_table_dynamic_columns_modal_columns_restore_to_default_success:
           'Kolommen zijn succesvol hersteld naar de standaard instellingen',

         device_list_filters_button_label_export_devices_hover:
           'Exporteer device(s) data - exporteer afleverset info en data uit kolommen van geselecteerde devices',
         device_list_filters_button_label_download_hiu_data_hover:
           'Download Afleversetdata - download beschikbare meetdata van een geselecteerde periode',
         device_list_filters_button_label_download_meter_data_hover:
           'Download Meterdata - download beschikbare meterdata van een geselecteerde periode',
         device_list_filters_button_label_change_settings_hover:
           'Registers in bulk bijwerken - pas afleverset registers in bulk aan',
         device_list_filters_button_label_update_devices_hover:
           'Firmwareversie bijwerken - werk de firmware versie van de Mercurius bij',
         device_list_filters_button_label_delete_devices_hover:
           'Verwijder device(s) en hun data',
         device_list_filters_button_label_data_collect_hover:
           'Vernieuw data - haal de laatste afleversetdata op',
         device_list_filters_button_label_reset_advanced_filters:
           'Restet filters - reset alle toegepaste Geavanceerde of Register filters',
         device_list_filters_button_label_advanced_filters_description:
           'Geavanceerd filters - zoek in afzonderlijke kolommen zonder meetdata',
         device_list_filters_button_label_customize_device_list_table_columns:
           'Dynamische kolommen - pas de getoonde kolommen aan',
         device_list_filters_button_label_customize_project_device_list_columns:
           'Dynamische kolommen - pas de getoonde kolommen aan',
         device_list_filters_button_label_registers_filter:
           'Register filter - filter afleverset- of meterstatus of metingen op basis van voorwaarden',
         email_template_reset_password_main_content:
           'De beheerder van het ##distributorName## platform heeft je wachtwoord hersteld.',
         email_template_reset_password_info:
           'Hierbij je nieuwe wachtwoord. We raden je ten zeerste aan om dit wachtwoord daarna te wijzigen.',
         email_template_reset_password_login_link: `Klik op deze <a href="#" style="font-weight: 600; color: ${primaryColor};">link</a> om in te loggen met je nieuwe wachtwoord.`,
         email_template_reset_password_login_button: 'Inloggen',
         email_template_reset_password_new_password_label: 'Nieuw wachtwoord:',
         devices_form_set_logs_scope_field: 'Data Logs Scope',
         devices_form_set_logs_tooltip_field:
           'Specifies whether the device has "Project Data Log" or "Device Data Log"',
         devices_list_project_set_log_label: 'Project Data Log',
         devices_list_device_set_log_label: 'Device Data log',
         devices_single_set_logs_device_level_message:
           'De logs zijn ingesteld op device niveau door ##USER_NAME## op ##DATE##',
         devices_single_set_logs_project_level_message:
           'De logs zijn ingesteld op project niveau door ##USER_NAME## op ##DATE##',
         devices_single_set_logs_device_level_no_user_message:
           'De logs zijn ingesteld op device niveau op ##DATE##',
         devices_single_set_logs_project_level_no_user_message:
           'De logs zijn ingesteld op project niveau op ##DATE##',
         devices_single_set_logs_revert_to_project_set_log_button:
           'Reset naar Project Data Log',
         devices_single_set_logs_revert_success_message:
           'Device Data Logs zijn succesvol gereset naar Project Data Logs',
         project_single_set_logs_revert_success_message:
           'Device(s) Data Logs zijn succesvol gereset naar Project Data Logs',
         project_single_set_logs_revert_modal_title: 'Weet je het zeker?',
         project_single_set_logs_revert_modal_subtitle: `Bekijk de statistieken voor de huidige project devices:
          <ul>
            <li><strong>Totaal Devices:</strong> ##TOTAL_DEVICES##</li>
            <li><strong>Totaal Devices met Project Data Logs:</strong> ##TOTAL_PROJECT_SET_LOG_DEVICES##</li>
            <li><strong>Totaal Devices met Device Data Logs:</strong> ##TOTAL_DEVICE_SET_LOG_DEVICES##</li>
          </ul>`,

         project_single_set_logs_revert_modal_total_devices_with_device_set_logs_label:
           'Op dit moment zijn er geen devices met Device Data Logs',
         project_single_set_logs_revert_modal_note:
           '<strong>Note:</strong><br/> Zodra je de reset uitvoert, kan deze actie niet meer ongedaan worden gemaakt. De reset is van toepassing op alle devices waarop Device Data Logs door gebruikers zijn geconfigureerd.',

         project_single_set_logs_revert_modal_cancel_button: 'Annuleer',
         project_single_project_setting_modbus_and_mbus_setting_success_set_message:
           'Modbus and Mbus Settings are successfully updated.',
         project_single_project_setting_modbus_and_mbus_setting_error_message:
           'Failed to update Modbus and Mbus Settings. Please contact your adminstrator.',
         device_status_menu_list_operating_state: 'Bedrijfstatus',
         device_status_menu_list_settings_hot_water: 'Instellingen tapwater',
         device_status_menu_list_settings_heating_and_cooling:
           'Instellingen verwarmen en koelen',
         device_status_menu_list_manual_control: 'Handbediening',
         device_status_menu_list_firmware_registers: 'Firmware Registers',
         device_status_menu_list_lin_pump_deltap_parameters:
           'LIN-Pump DeltaP Parameters',
         device_status_menu_list_energy_meters_m_bus: 'Meters (M-Bus)',
         device_status_menu_list_livelog_hot_water: 'Livelog tapwater',
         device_status_menu_list_livelog_heating: 'Livelog verwarming',
         device_status_menu_list_livelog_cooling: 'Livelog koeling',
         devices_form_unit_id_field: 'Unit Id',
         sidebar_v3_settings_menu: 'Device v3 Settings',
         devices_form_v3_mbus_discovery_button: 'Mbus Discovery',
         devices_form_v3_fetch_device_information_button:
           'Fetch Device Information',
         substations_form_v3_fetch_device_information_button:
           'Fetch Substation Information',
         heat_pumps_form_v3_fetch_device_information_button:
           'Fetch Heat Pump Information',
         devices_form_v3_fetch_device_information_success_message:
           'Fetch Device Information message is forwarded to device',
         devices_form_v3_fota_file_path_field: 'FOTA File Path',
         devices_form_v3_fota_file_path_success_message:
           'FOTA File Path message is forwarded to device',
         devices_form_v3_ota_file_path_field: 'HIU Firmware',
         devices_form_v3_ota_file_path_success_message:
           'HIU Firmware message is forwarded to device',
         devices_form_v3_file_path_error_message:
           'Please enter a valid file URL or a valid file path.',
         set_registers_modbus_option: 'Modbus',
         set_registers_mbus_option: 'Mbus',
         set_registers_mbus_serial_number_title: 'Mbus Serial Numbers',
         set_registers_mbus_registers_not_found_run_mbus_discovery_error_message:
           'MBUS is not connected for this device. Please run Device Discovery from the Device Edit page.',
         device_v2_settings_tab_ftp_and_network_tab: 'FTP',
         device_v2_settings_tab_ftp_host_field: 'FOTA Server',
         device_v2_settings_tab_ftp_user_name_field: 'FTP User Name',
         device_v2_settings_tab_ftp_password_field: 'FTP Password',
         device_single_device_settings_ftp_message_forwarded:
           'FTP Credentials Message is successfully forwarded to the device.',
         device_single_device_settings_ftp_error:
           'FTP User Name and Password are required',
         devices_ota_select_same_serial_devices_to_proceed_error:
           'All selected devices must have serial numbers of the same length to proceed.',
         devices_ota_select_at_least_one_device_to_proceed_error:
           'You must select at least one device to proceed.',
         substations_ota_select_at_least_one_to_proceed_error:
           'U moet minimaal één substation selecteren om verder te gaan.',
         heat_pumps_ota_select_at_least_one_to_proceed_error:
           'U moet minimaal één warmtepomp selecteren om verder te gaan.',
         devices_ota_incompatible_firmware_selected_error:
           'The selected firmware version isn’t compatible with your device(s). Please choose a compatible version to continue.',
         devices_ota_go_back_to_devices_list_button: 'View All Devices',
         devices_bulk_edit_hiu_ota_mixed_device_type_error:
           'Your selection contains a mix of V2 and V3 devices. Please select either all V2 devices or all V3 devices to continue.',
         devices_bulk_edit_hiu_ota_all_tr03_error:
           'All selected devices are TR03 devices, which are not supported for this update. Please select TR04 devices to proceed.',
         devices_bulk_edit_hiu_ota_unknown_type_error:
           'The controller type for all selected devices is unknown. Please configure the devices properly before proceeding.',
         devices_bulk_edit_hiu_ota_update_selected_devices:
           'Devices Selected for Bulk HIU OTA Update',
         devices_bulk_edit_hiu_ota_valid_devices: 'valid',
         devices_bulk_edit_hiu_ota_partial_invalid_warning:
           'The devices highlighted in red are either TR03 devices or have an unknown controller type and will be excluded from the HIU OTA update. You can still proceed — only the valid TR04 devices will be updated.',
         sidebar_hiu_ota_reporting: 'HIU OTA Report',
         hiu_ota_reporting_filter_start_date: 'Start Date',
         hiu_ota_reporting_filter_end_date: 'End Date',
         hiu_ota_reporting_filter_apply_button: 'Apply',
         hiu_ota_reporting_filter_reset_button: 'Reset Filters',
         hiu_ota_reporting_col_created_at: 'Updated At',
         hiu_ota_reporting_col_firmware: 'HIU Firmware',
         hiu_ota_reporting_col_total_devices: 'Total Devices',
         hiu_ota_reporting_col_user: 'User',
         hiu_ota_reporting_col_message: 'Message',
         hiu_ota_reporting_no_records: 'No records found',
         hiu_ota_reporting_export_file_name: 'HIU OTA Reporting',
         hiu_ota_reporting_table_failed_message:
           'HIU Firmware is not updated to',
         hiu_ota_reporting_table_pending_message: 'HIU Firmware is updating to',
         hiu_ota_reporting_table_successful_message:
           'HIU Firmware is updated to',
         hiu_ota_reporting_details_page_title: 'HIU OTA Report Details',
         hiu_ota_reporting_details_tab_all: 'All',
         hiu_ota_reporting_details_tab_pending: 'Pending',
         hiu_ota_reporting_details_tab_successful: 'Success',
         hiu_ota_reporting_details_tab_failed: 'Failed',
         hiu_ota_reporting_details_col_updated_at: 'Updated At',
         hiu_ota_reporting_details_col_device: 'Device',
         hiu_ota_reporting_details_col_user: 'User',
         hiu_ota_reporting_details_col_old_firmware_version: 'Old Firmware',
         hiu_ota_reporting_details_col_old_firmware: 'HIU Firmware',
         hiu_ota_reporting_details_col_status: 'Status',
         hiu_ota_reporting_details_col_message: 'Message',
         hiu_ota_reporting_details_no_records: 'No records found',
         hiu_ota_reporting_details_export_file_name:
           'HIU OTA Reporting Details',
         hiu_ota_reporting_details_col_snapshot: 'Snapshot',
         hiu_ota_reporting_details_view_snapshot: 'View Snapshot',
         hiu_ota_snapshot_dialog_title: 'Device Snapshot',
         hiu_ota_snapshot_section_configuration: 'Configuration',
         hiu_ota_snapshot_section_registers: 'Device Registers',
         hiu_ota_snapshot_col_field: 'Field',
         hiu_ota_snapshot_col_nr: 'NR',
         hiu_ota_snapshot_col_register: 'Register',
         hiu_ota_snapshot_col_value: 'Value',
         hiu_ota_snapshot_no_registers: 'No register data available',
         device_single_device_settings_baud_rate_parity_field:
           'Baud Rate Parity',
         device_single_device_settings_select_baud_rate_parity_field:
           'Select Baud Rate Parity',
         device_single_device_settings_baud_rate_stop_bits_field:
           'Baud Rate Stop Bits',
         device_single_device_settings_select_baud_rate_stop_bits_field:
           'Select Baud Rate Stop Bits',
         device_single_device_settings_baud_rate_parity_none_option: 'None',
         device_single_device_settings_baud_rate_parity_odd_option: 'Odd',
         device_single_device_settings_baud_rate_parity_even_option: 'Even',
         device_single_device_settings_baud_rate_stop_bits_05_option:
           '0.5 Stop Bit',
         device_single_device_settings_baud_rate_stop_bits_1_option:
           '1 Stop Bit',
         device_single_device_settings_baud_rate_stop_bits_15_option:
           '1.5 Stop Bits',
         device_single_device_settings_baud_rate_stop_bits_2_option:
           '2 Stop Bits',
         device_single_device_settings_v3_baud_rate_required_validation_error:
           'Baud Rate is required.',
         device_single_device_settings_v3_baud_rate_uart_number_validation_error:
           'Baud Rate must be a valid number.',
         device_single_device_settings_v3_baud_rate_parity_required_validation_error:
           'Baud Rate Parity is required.',
         device_single_device_settings_v3_baud_rate_stop_bits_required_validation_error:
           'Baud Rate Stop Bits are required.',
         modbus_v3_heat_pump_title: 'Bedrijfsstatus',
         modbus_v3_heat_pump_reg_9163_label: 'Aanvoertemperatuur',

         modbus_v3_heat_pump_reg_9162_label: 'Retourtemperatuur',

         modbus_v3_heat_pump_reg_9085_label: 'Compressor 1 active',
         modbus_v3_heat_pump_reg_9085_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9086_label: 'Compressor 2 active',
         modbus_v3_heat_pump_reg_9086_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         modbus_v3_heat_pump_reg_10400_label: 'Buitentemperatuur',
         modbus_v3_heat_pump_reg_9165_label: 'Buitentemperatuur',
         modbus_v3_heat_pump_reg_9320_label:
           'Huidige setpoint watertemperatuur',
         modbus_v3_heat_pump_reg_9173_label: 'Aanzuigtemperatuur Circ1',
         modbus_v3_heat_pump_reg_9174_label: 'Aanzuigtemperatuur Circ2',
         modbus_v3_heat_pump_reg_9170_label: 'Zuigdruk Circ1',
         modbus_v3_heat_pump_reg_9180_label: 'Zuigdruk Circ2',
         modbus_v3_heat_pump_reg_9171_label: 'Ontlaadtemperatuur Circ1',
         modbus_v3_heat_pump_reg_9172_label: 'Ontlaadtemperatuur Circ2',
         modbus_v3_heat_pump_reg_9169_label: 'Persdruk Circ1',
         modbus_v3_heat_pump_reg_9179_label: 'Persdruk Circ2',
         modbus_v3_heat_pump_reg_9249_label: 'Ventilatiesnelheid Circ1',
         modbus_v3_heat_pump_reg_9253_label: 'Ventilatiesnelheid Circ2',
         modbus_v3_heat_pump_reg_9084_label: 'Status 4 weg klep Circ1',
         modbus_v3_heat_pump_reg_9084_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9095_label: 'Status 4 weg klep Circ2',
         modbus_v3_heat_pump_reg_9095_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9319_label: 'ODU mode',
         modbus_v3_heat_pump_reg_9319_label_list: JSON.stringify({
           list: {
             0: 'Koeling',
             1: 'Warmte',
             2: 'Tapwater',
           },
         }),

         modbus_v3_heat_pump_reg_9365_label: 'Vergrendeling actief',
         modbus_v3_heat_pump_reg_9365_label_list: JSON.stringify({
           list: {
             0: 'Nee',
             1: 'Ja',
           },
         }),

         modbus_v3_heat_pump_reg_10391_label: 'Foutcode',

         modbus_v3_heat_pump_reg_10395_label: 'Fout status',

         modbus_v3_heat_pump_reg_9005_label: 'Status Standby/Aan',
         modbus_v3_heat_pump_reg_9005_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9006_label: 'Status Warmte/Koeling',
         modbus_v3_heat_pump_reg_9006_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9079_label: 'Status Algemeen Alarm',
         modbus_v3_heat_pump_reg_9079_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9084_status_label: '4 weg klep status',
         modbus_v3_heat_pump_reg_9084_status_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),

         modbus_v3_heat_pump_reg_9090_label: 'Ontdooi status',
         modbus_v3_heat_pump_reg_9090_label_list: JSON.stringify({
           list: {
             0: 'Uit',
             1: 'Aan',
           },
         }),
         device_single_device_settings_modbus_write_register_address_field:
           'Modbus Write Register Address',
         device_single_device_settings_modbus_write_enabled_field:
           'Modbus Write Enabled',
         device_single_device_settings_v3_unit_id_required_validation_error:
           'Unit Id is required.',
         device_single_device_settings_v3_modbus_write_register_address_required_validation_error:
           'Modbus Write Register Address is required.',
         device_single_device_settings_v3_modbus_write_register_address_error:
           'The Modbus Write Register Address has not been saved. Please save it first before trying this function again.',
         device_single_device_settings_v3_unit_id_error:
           'The Unit ID has not been saved. Please save it first before trying this function again.',
         device_single_device_settings_v3_modbus_write_enable_success_message:
           'Modbus Write Enable Message is successfully forwarded.',
         sidebar_heat_pumps: 'Warmtepomp overzicht',
         heat_pumps_form_header: 'Warmtepompen',
         heat_pumps_bulk_edit_ota_title: 'Warmtepomp OTA bulk update',
         heat_pumps_bulk_hiu_ota_update_title: 'Warmtepomp bulk HIU OTA update',
         heat_pumps_filter_search: 'Search Warmtepomp',
         heat_pumps_no_record_found: 'No Warmtepompen found',
         device_single_modbus_write_enable_button:
           'Activeer Modbus Schrijf Modus',
         device_single_modbus_write_disabled_message:
           'Het schrijven van Modbus register is gedeactiveerd. Klik op de knop om de Modbus Schrijf Modus te activeren',
         device_list_modbus_write_enable_field: 'Modbus Schrijf Modus',
         devices_form_appliance_category_field: 'Appliance Category',
         devices_form_appliance_category_hiu_option_field:
           'Heat Interface Unit',
         devices_form_appliance_category_heat_pump_option_field: 'Warmtepomp',
         devices_form_appliance_category_substation_option_field: 'Substation',
         devices_form_appliance_category_boiler_option_field: 'Boiler',
         device_list_filters_button_label_modbus_write_hover:
           'Druk op de knop om ModBus schrijfmodus aan te zetten voor de geselecteerde devices',
         heat_pump_single_page_title: 'Warmtepomp details',
         heat_pumps_single_bread_crumb_main_title: 'Warmtepomp overzicht',
         heat_pumps_single_bread_crumb_first_link: 'Warmtepomp pagina',
         heat_pumps_single_edit_device_button: 'Edit Warmtepomp',
         edit_heat_pumps_bread_crumb_first_link: 'Edit Warmtepomp',
         edit_heat_pumps_form_header: 'Edit Warmtepomp',
         edit_substations_form_header: 'Edit Substation',
         substations_form_header: 'Substations',
         substations_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Substation Information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Substation Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         substations_bulk_delete_modal_note: `<strong>Note:</strong> <br /> Once you proceed with the deletion, it cannot be undone unless the IT team manually
          restores the data from old backups. Recovering events and other related information will be highly time-consuming.
          Substation deletion takes some time due to the data mentioned above. Please be patient and do not cancel or refresh the
          page.`,
         substations_bulk_edit_ota_title: 'Substation OTA bulk update',
         substations_bulk_hiu_ota_update_title: 'Substation bulk HIU OTA update',
         substations_bulk_modbus_download_title:
           'Download Substations Historical Data',
         substations_bulk_modbus_download_form_submit_button:
           'Download Substations data',
         substations_bulk_selected_devices_title: 'Substations Selected',
         substations_bulk_modbus_download_no_substations_error:
           'Please select atleast 1 Substation to proceed',
         heat_pumps_bulk_modbus_download_no_heat_pumps_error:
           'Please select atleast 1 Warmtepomp to proceed',
         modbus_v3_heat_pump_operating_state_title: 'Bedrijfsstatus warmtepomp',
         modbus_v3_heat_pump_measurements_title: 'Meetwaarden',
         heat_pump_single_temperature_title:
           'De historische data van de warmtepomp',
         heat_pump_single_offline_detailed_message: 'Warmtepomp is "Offline"',
         heat_pump_single_online_detailed_message:
           'Warmtepomp is "Online", alles werkt prima',
         heat_pump_single_error_detailed_message:
           'Warmtepomp is in "Storing" mode',
         heat_pump_single_unprovisioned_detailed_message:
           'Warmtepomp is in "Ongeregistreerd" modus',
         heat_pump_fetch_registers_success:
           'Het verzoek is succesvol verzonden naar het Warmtepomp.',
         heat_pumps_form_device_labels_field: 'Warmtepomp Label',
         heat_pumps_form_device_information_tab: 'Warmtepomp info',
         heat_pumps_form_name_field: 'Warmtepomp naam',
         heat_pumps_list_device_set_log_label: 'Warmtepomp Data log',
         heat_pumps_form_description_field: 'Warmtepomp type',
         heat_pumps_description: 'Warmtepomp type',
         heat_pump_single_firmware_hiu_label: 'Firmware warmtepomp',
         heat_pumps_form_box_serial_number_field: 'Serienummer warmtepomp',
         heat_pumps_form_article_number_field: 'Artikelnummer warmtepomp',
         heat_pumps_partner_serial_number:
           'Serienummer warmtepomp van distributeur',
         heat_pumps_partner_article_number_field:
           'Artikelnummer warmtepomp van distributeur',
         heat_pump_list_filters_button_label_registers_filter:
           'Register filter - filter warmtepomp- of meterstatus of metingen op basis van voorwaarden',
         heat_pump_list_filters_button_label_export_devices_hover:
           'Exporteer Warmtepompendata - exporteer warmtepomp info en data uit kolommen van geselecteerde Warmtepompen',
         heat_pump_list_filters_button_label_download_heat_pump_data_hover:
           'Download Warmtepompdata - download beschikbare meetdata van een geselecteerde periode',
         heat_pump_list_filters_button_label_download_meter_data_hover:
           'Download Meterdata - download beschikbare meterdata van een geselecteerde periode',
         heat_pump_list_filters_button_label_change_settings_hover:
           'Registers in bulk bijwerken - pas warmtepomp registers in bulk aan',
         heat_pump_list_filters_button_label_update_devices_hover:
           'Firmwareversie bijwerken - werk de firmware versie van de Mercurius bij',
         heat_pump_list_filters_button_label_delete_devices_hover:
           'Verwijder Warmtepompen en hun data',
         heat_pump_list_filters_button_label_data_collect_hover:
           'Vernieuw data - haal de laatste warmtepompdata op',
         heat_pump_list_filters_button_label_modbus_write_hover:
           'Druk op de knop om de Warmtepomp schrijfmodus aan te zetten voor de geselecteerde warmtepompen',
         heat_pump_single_download_modbus_data: 'Export warmtepomp data',
         project_single_heat_pumps_tab: 'Warmtepompen',
         heat_pumps_bulk_delete_modal_subtitle: `<strong>De volgende data zal verwijderd worden:</strong>
          <ul>
            <li><i>Warmtepomp informatie</i></li>
            <li><i>Events</i></li>
            <li><i>Warmtepompdata</i></li>
            <li><i>Meterdata</i></li>
            <li><i>Grafiek Data</i></li>
            <li><i>Warmtepomp Register</i></li>
            <li><i>Storingsdata</i></li>
            <li><i>Andere gerelateerde tabellen</i></li>
          </ul>`,
         heat_pumps_bulk_delete_modal_note:
           '<strong>Note:</strong> <br/> Zodra je de verwijdering hebt uitgevoerd, kan dit niet meer ongedaan worden gemaakt, tenzij het IT-team de gegevens handmatig herstelt vanuit oude back-ups. Het herstellen van events en andere gerelateerde informatie kost veel tijd. Het verwijderen van warmtepompen duurt even vanwege de bovengenoemde gegevens. Wees geduldig en annuleer of vernieuw de pagina niet.',
         heat_pumps_bulk_modbus_download_title:
           'Download Historische Warmtepompdata',
         heat_pumps_bulk_modbus_download_form_submit_button:
           'Download Warmtepompdata',
         heat_pumps_bulk_selected_devices_title: 'Geselecteerde Warmtepompen',
         device_single_temperature_hide_all_registers: 'Verberg alle registers',
         device_single_temperature_show_all_registers: 'Toon alle registers',
         heat_pumps_form_additional_information_tab: 'Warmtepomp Details',
         heat_pump_single_device_settings_title: 'Warmtepomp instellingen',
         heat_pump_filters_button_label_download_hiu_data_hover:
           'Download Warmtepompdata - download beschikbare meetdata van een geselecteerde periode',
         heat_pump_list_filters_button_label_download_hiu_data_hover:
           'Download heat pump data - download available measurement data for a selected period',
         heat_pump_single_rss_device_status: 'Warmtepomp status',
         heat_pumps_single_device_counters_title: 'Warmtepomp Tellers',
         mbus_set_registers_error_no_fields:
           'Please configure at least one MBus meter before proceeding with data logs.',
         mbus_set_registers_success:
           'Project MBus data logs have been updated successfully',
         devices_form_v3_reset_hiu_after_upload: 'Reset HIU After Upload',
         devices_form_v3_verify_checksum_timeout_seconds:
           'Checksum Verification Timeout (seconds)',
         heat_pump_E001_alarm_name: 'Flow switch',
         heat_pump_E002_alarm_name: 'Pump1',
         heat_pump_E003_alarm_name: 'Pump 2',
         heat_pump_E004_alarm_name: 'Alarm for phase/voltage control',
         heat_pump_E005_alarm_name: 'Alarm unit working-point out of envelope',
         heat_pump_E006_alarm_name: 'Alarm Leakage Detector Safety Chain',
         heat_pump_E020_alarm_name: 'Water inlet low temperature',
         heat_pump_E021_alarm_name: 'Water outlet low temperature',
         heat_pump_E022_alarm_name: 'Water inlet high temperature',
         heat_pump_E023_alarm_name: 'Water outlet high temperature',
         heat_pump_E040_alarm_name: 'Inlet water temperature',
         heat_pump_E041_alarm_name: 'Outlet water temperature',
         heat_pump_E044_alarm_name: 'Sanitary tank probe error',
         heat_pump_E045_alarm_name: 'Outdoor air temperature',
         heat_pump_E046_alarm_name: 'Alarm active setpoint sensor',
         heat_pump_E047_alarm_name: 'Alarm demand limit sensor',
         heat_pump_E101_alarm_name: 'High pressure switch circuit 1',
         heat_pump_E103_alarm_name: 'Fans circuit 1',
         heat_pump_E105_alarm_name:
           'Alarm compressor working-point out of envelope cir 1',
         heat_pump_E106_alarm_name: 'EEV driver circuit 1',
         heat_pump_E107_alarm_name: 'High pressure circuit 1',
         heat_pump_E108_alarm_name: 'Low pressure circuit 1',
         heat_pump_E109_alarm_name: 'Vacuum alarm cir1',
         heat_pump_E110_alarm_name: 'Low compression ratio alarm circuito 1',
         heat_pump_E111_alarm_name: 'High compression ratio alarm circuito 1',
         heat_pump_E114_alarm_name: 'Evaporator output temperature circuit 1',
         heat_pump_E115_alarm_name: 'High pressure sensor circuit 1',
         heat_pump_E117_alarm_name: 'Low pressure sensor circuit 1',
         heat_pump_E120_alarm_name: 'Motor compressor 1 circuit 1',
         heat_pump_E122_alarm_name:
           'Alarm High Discharge temperatur compr 1 cir1',
         heat_pump_E123_alarm_name:
           'Discharge temperature sensor comp. 1 circuit 1',
         heat_pump_E130_alarm_name: 'Motor compressor 2 circuit 1',
         heat_pump_E132_alarm_name:
           'Alarm High Discharge temperatur compr 2 cir1',
         heat_pump_E133_alarm_name:
           'Discharge temperature sensor comp. 2 circuit 1',
         heat_pump_E196_alarm_name: 'Compressors configuration circuit 1',
         heat_pump_E201_alarm_name: 'High pressure switch circuit 2',
         heat_pump_E203_alarm_name: 'Fans circuit 2',
         heat_pump_E205_alarm_name:
           'Alarm compressor working-point out of envelope cir 2',
         heat_pump_E206_alarm_name: 'EEV driver circuit 2',
         heat_pump_E207_alarm_name: 'High pressure circuit 2',
         heat_pump_E208_alarm_name: 'Low pressure circuit 2',
         heat_pump_E209_alarm_name: 'Vacuum alarm cir2',
         heat_pump_E210_alarm_name: 'Low compression ratio alarm circuito 2',
         heat_pump_E211_alarm_name: 'High compression ratio alarm circuito 2',
         heat_pump_E214_alarm_name: 'Evaporator output temperature circuit 2',
         heat_pump_E215_alarm_name: 'High pressure sensor circuit 2',
         heat_pump_E217_alarm_name: 'Low pressuresensor  circuit 2',
         heat_pump_E220_alarm_name: 'Motor compressor 1 circuit 2',
         heat_pump_E222_alarm_name:
           'Alarm High Discharge temperatur compr 1 cir2',
         heat_pump_E223_alarm_name:
           'Discharge temperature sensor comp. 1 circuit 2',
         heat_pump_E230_alarm_name: 'Motor compressor 2 circuit 2',
         heat_pump_E232_alarm_name:
           'Alarm High Discharge temperatur compr 2 cir2',
         heat_pump_E233_alarm_name:
           'Discharge temperature sensor comp. 2 circuit 2',
         heat_pump_E296_alarm_name: 'Compressors configuration circuit 2',
         heat_pump_E901_alarm_name: 'Hystorical alarm full',
         heat_pump_E902_alarm_name: 'Alarm that requires a PLC reboot',
         heat_pump_E903_alarm_name: 'Real Time Clock error',
         heat_pump_E904_alarm_name: 'Scheduler input variable out of range',
         heat_pump_E910_alarm_name: 'EEVD Communication',
         heat_pump_E920_alarm_name: 'EXP1 Communication',
         heat_pump_E921_alarm_name: 'EXP2 Communication',
         heat_pump_E930_alarm_name: 'RS485-1 Communication',
         heat_pump_E931_alarm_name: 'RS485-2 Communication',
         commissioning_form_step_0_status_led_check_stepper_title:
           'Status LED Check',
         commissioning_form_step_0_status_led_check_title:
           'Schakel uw device in',
         commissioning_form_step_0_status_led_check_subtitle:
           'Zet de Mercurius Communicatie Module aan. Deze zal automatisch beginnen met het zoeken naar het sterkste mobiele netwerk. Het kan tot 5 minuten duren voordat er verbinding wordt gemaakt met het platform, afhankelijk van een eerdere registratie en de dekking van het mobiele netwerk. Wanneer de Status-LED continu groen brandt, klikt u op Doorgaan om verder te gaan met het inbedrijfstellingsproces.',
         commissioning_form_step_0_status_led_check_note:
           'Brandt de Status-LED continu groen?',
         commissioning_form_step_0_status_led_check_continue_button: 'Doorgaan',
         commissioning_form_cancel_button: 'Cancel',
         events_set_log_is_missing:
           'Data Logs are missing on both device and project level',
         sidebar_knowledge_base: 'Knowledge Base',
         knowledge_base_title: 'Knowledge Base',
         knowledge_base_second_sidebar_subtitle: 'Knowledge Base',
         knowledge_base_search: 'Search',
         knowledge_base_page_contents: 'Page Contents',
         knowledge_base_root_folder: 'Root',
         knowledge_base_no_file_selected: 'NO FILE SELECTED',
         knowledge_base_select_file_hint: 'Please select a file to view',
         knowledge_base_no_results: 'No Records Found',
         knowledge_base_no_headings: 'No Headings Found',
         knowledge_base_share: 'Share',
         knowledge_base_print: 'Print',
         knowledge_base_url_copied: 'URL copied to clipboard!',
         knowledge_base_copy_failed: 'Failed to copy URL',
         notification_type_error: 'Error',
         notifications_form_display_in_top_navigation_field:
           'Display in top navigation',
         notifications_form_active_status_field: 'Active',
         notification_deactivated_message:
           'Notification is deactivated successfully!',
         notification_activated_message:
           'Notification is activated successfully!',
         notifications_edit_form_success:
           'Notification is updated successfully',
         notifications_add_new: 'Add New',
         sidebar_collapse: 'Collapse',
         sidebar_expand: 'Expand',
         sidebar_ask_a_question: 'Ask a Question',
         sidebar_support: 'Support',
         ask_question_title_label: 'Title',
         ask_question_description_label: 'Description',
         ask_question_attachments_label: 'Attachments',
         ask_question_upload_button: 'Upload',
         ask_question_drop_text: 'Or drag and drop your file in the box',
         ask_question_cancel_button: 'Cancel',
         ask_question_submit_button: 'Submit',
         ask_a_question_title: 'Ask a Question',
         attachment_file_type_error: 'Unsupported file type',
         attachment_file_size_error: `File size exceeds ##MAX_SIZE_MB## MB`,
         attachment_duplicate_error: 'File already added',
         ask_question_title_required_form_error: 'Title is required',
         ask_question_description_required_form_error:
           'Description is required',
         ask_question_api_error: 'Failed to submit question',
         ask_question_success: 'Question submitted successfully',
         devices_form_sim_status_field: 'Sim Status',
         devices_sim_status_update_success: 'SIM status updated',
         devices_sim_status_update_error: 'Failed to update SIM status',
         devices_form_sim_status_send_button: 'Send',
         devices_form_sim_status_tab: 'Sim Status',
         sidebar_knowledge_base_faq: 'FAQs',
         ask_a_question_request_type_group_operational: 'Operational',
         ask_a_question_request_type_group_informational: 'Informational',
         ask_a_question_request_type_group_commercial_admin:
           'Commercial / Admin',
         ask_a_question_request_type_group_improvement: 'Improvement',
         ask_a_question_request_type_group_other: 'Other',

         ask_a_question_request_type_operational_incident_something_is_not_working:
           'Incident / Something is not working',
         ask_a_question_request_type_operational_data_missing_incorrect:
           'Data missing / incorrect',
         ask_a_question_request_type_operational_connection_device_offline:
           'Connection / Device offline',
         ask_a_question_request_type_operational_access_or_login_problem:
           'Access or login problem',
         ask_a_question_request_type_operational_commissioning: 'Commissioning',
         ask_a_question_request_type_operational_settings_configuration:
           'Settings / Configuration',
         ask_a_question_request_type_operational_performance_issue:
           'Performance issue (slow / unstable)',
         ask_a_question_request_type_operational_hiu_or_meter_missing_in_portal:
           'HIU or meter missing in portal',
         ask_a_question_request_type_operational_hiu_or_meter_not_working:
           'HIU or meter not working',

         ask_a_question_request_type_informational_how_to_question:
           'How-to question',
         ask_a_question_request_type_informational_product_or_feature_information:
           'Product or feature information',
         ask_a_question_request_type_informational_integration_question:
           'Integration question (API / Modbus / M-Bus)',
         ask_a_question_request_type_informational_firmware_software_update:
           'Firmware / Software update',
         ask_a_question_request_type_informational_data_request: 'Data request',
         ask_a_question_request_type_informational_documentation_request:
           'Documentation request',

         ask_a_question_request_type_commercial_admin_account_management:
           'Account management',
         ask_a_question_request_type_commercial_admin_user_roles_permissions:
           'User roles & permissions',
         ask_a_question_request_type_commercial_admin_data_privacy:
           'Data privacy',

         ask_a_question_request_type_improvement_feature_request:
           'Feature request',
         ask_a_question_request_type_improvement_usability_feedback:
           'Usability feedback',
         ask_a_question_request_type_improvement_suggestion_for_improvement:
           'Suggestion for improvement',

         ask_a_question_request_type_other_general_enquiry: 'General enquiry',
         ask_a_question_request_type_other_complaint: 'Complaint',

         ask_question_request_type_required_form_error:
           'Request type is required',
         ask_question_request_type_placeholder:
           'What would you like help with?',
         ask_question_device_id_hint:
           'Are you contacting us about a specific device? If so, please include the Device ID (for example: 12345(6) or A12345).',
         ask_question_attachments_hint:
           'You may upload attachments to help us better understand your request. While attachments are not required, they are especially helpful if your question relates to a specific device, HIU, or technical issue.',
         devices_bulk_hiu_ota_update_title: 'Device bulk HIU OTA update',
         device_list_filters_button_label_update_hiu_hover:
           'Update device HIU OTA - Trigger an OTA update for the selected HIU device(s)',
         heat_pump_list_filters_button_label_update_hiu_hover:
           'Update Heat Pump HIU OTA - Trigger an OTA update for the selected HIU Heat Pump(s)',
         substation_list_filters_button_label_export_devices_hover:
           'Export substation(s) data - export substation and column data of selected substation',
         substation_list_filters_button_label_download_hiu_data_hover:
           'Download substation data - download available measurement data for a selected period',
         substation_list_filters_button_label_download_meter_data_hover:
           'Download Meter data - download available meter data for a selected period',
         substation_list_filters_button_label_change_settings_hover:
           'Bulk update substation registers - change substation settings in bulk',
         substation_list_filters_button_label_update_devices_hover:
           'Update substation firmware - update the Mercurius substation firmware',
         substation_list_filters_button_label_delete_devices_hover:
           'Delete substation(s) and their data',
         substation_list_filters_button_label_data_collect_hover:
           'Refresh data - fetch the latest substation data',
         substation_list_filters_button_label_modbus_write_hover:
           'Click the button to enable Substation Write Mode on the selected substations',
         substation_list_filters_button_label_update_hiu_hover:
           'Update Substation HIU OTA - Trigger an OTA update for the selected HIU Substation(s)',
         devices_bulk_edit_hiu_ota_modal_title:
           'Are you sure you want to run a bulk HIU OTA update?',
         devices_bulk_edit_hiu_ota_modal_subtitle:
           'You want to Bulk HIU OTA update ##firmware_value## for ##total_devices## devices?',
         devices_bulk_edit_hiu_ota_no_devices_error:
           'You must select at least one device to proceed.',
         devices_bulk_edit_hiu_ota_v2_devices_error:
           'V2 devices are not supported for HIU OTA updates and will be automatically removed from the request.',
         ask_question_device_label: 'Device Id / Device Name (Optional)',
         ask_a_question_please_see_our: 'Please see our',
         ask_a_question_faqs: 'FAQs',
         ask_a_question_and: 'and',
         ask_a_question_knowledge_base: 'Knowledge Base',
         hiu_ota_firmware_title: 'HIU Firmwares',
         settings_menu_hiu_ota_firmwares_title: 'HIU Firmwares',
         hiu_ota_table_filename: 'Filename',
         hiu_ota_table_size: 'Size',
         hiu_ota_table_ftp_path: 'FTP Path',
         hiu_ota_table_ftp_url: 'FTP URL',
         hiu_ota_table_created_by: 'Created By',
         hiu_ota_table_created_at: 'Created At',
         hiu_ota_no_record_found: 'No records found',
         hiu_ota_table_row_per_page: 'Rows per page',
         hiu_ota_internal_server_error: 'Internal server error',
         hiu_ota_filter_search: 'Search',
         hiu_ota_table_hiu_ota_firmwares_title: 'Upload HIU Firmware',
         hiu_ota_upload_modal_title: 'Upload HIU Firmware',
         hiu_ota_upload_drop_zone_text: 'Click or drag & drop a file here',
         hiu_ota_upload_drop_zone_sub_text: 'Only .bin files are supported',
         hiu_ota_upload_invalid_file_type: 'Only .bin files are allowed',
         hiu_ota_upload_filename_label: 'Filename',
         hiu_ota_upload_filename_placeholder: 'e.g. firmware_v1.0.bin',
         hiu_ota_upload_cancel: 'Cancel',
         hiu_ota_upload_submit: 'Upload',
         hiu_ota_upload_success: 'Firmware uploaded successfully',
         hiu_ota_upload_error: 'Failed to upload firmware',
         hiu_ota_upload_duplicate_file_error:
           'A file with this name already exists. Please rename the file and try again.',
         hiu_ota_upload_valid_file_error: 'Valid file size is required',
         modbus_v3_heat_pump_reg_8260_label: 'Cooling Temperature Setpoint',
         modbus_v3_heat_pump_reg_8263_label: 'Heating Temperature Setpoint',
         modbus_v3_heat_pump_reg_21761_label:
           'Inlet Water User Side Temperature',
         modbus_v3_heat_pump_reg_21762_label:
           'Outlet Water User Side Temperature 1',
         modbus_v3_heat_pump_reg_21765_label: 'Discharge Pressure Circuit 1',
         modbus_v3_heat_pump_reg_21767_label: 'Out Temperature',
         modbus_v3_heat_pump_reg_21768_label: 'Variable Setpoint',
         modbus_v3_heat_pump_reg_21781_label: 'Discharge Temperature Circuit 1',
         modbus_v3_heat_pump_reg_21253_label:
           'Protection Compressor 1 Circuit 1',
         modbus_v3_heat_pump_reg_21254_label:
           'Protection Compressor 2 Circuit 1',
         modbus_v3_heat_pump_reg_21280_label: 'Protection Heaters',
         modbus_v3_heat_pump_reg_21287_label: 'Protection Fans',
         modbus_v3_heat_pump_reg_21299_label: 'High Pressure Switch Circuit 1',
         modbus_v3_heat_pump_reg_21304_label: 'User Side Water Flow Status',
         modbus_v3_heat_pump_reg_21306_label: 'Protection User Side Pump 1',
         modbus_v3_heat_pump_reg_21309_label: 'Remote ON/OFF',
         modbus_v3_heat_pump_reg_21311_label: 'Phases/Voltage Status',
         modbus_v3_heat_pump_reg_21314_label: 'Remote Cooling/Heating',
         modbus_v3_heat_pump_reg_21319_label: 'Oil Level',
         modbus_v3_heat_pump_reg_21320_label: 'Compressor Inverter Alarm',
         modbus_v3_heat_pump_reg_21506_label: 'Compressor 1 Circuit 1',
         modbus_v3_heat_pump_reg_21507_label: 'Compressor 2 Circuit 1',
         modbus_v3_heat_pump_reg_21522_label: 'User Side Pump 1',
         modbus_v3_heat_pump_reg_21532_label: 'Sink/Source Side Reg. Enable 1',
         modbus_v3_heat_pump_reg_21534_label: 'General Alarm',
         modbus_v3_heat_pump_reg_21536_label: 'Four-Way Valve Circuit 1',
         modbus_v3_heat_pump_reg_21585_label: 'Heaters',
         modbus_v3_heat_pump_reg_22018_label: 'Sink/Source Side Reg. Value 1',
         modbus_v3_heat_pump_reg_21253_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21254_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21280_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21287_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21299_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21304_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21306_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21309_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21311_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21314_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21319_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21320_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Closed',
           },
         }),
         modbus_v3_heat_pump_reg_21506_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21507_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21522_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21532_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21534_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21536_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_reg_21585_label_list: JSON.stringify({
           list: {
             0: 'Open',
             1: 'Heater Off',
           },
         }),
         modbus_v3_heat_pump_danfoss_operating_state_title:
           'Operating State Heat Pump',
         modbus_heat_pump_clint_operating_state: 'Operating State (Clint)',
         modbus_heat_pump_danfoss_operating_state: 'Operating State (Danfoss)',
         modbus_heat_pump_clint_measurements: 'Measurements (Clint)',
         modbus_heat_pump_danfoss_measurements: 'Measurements (Danfoss)',
         // Heat Pump - Remeha Effenca MT
         modbus_v3_heat_pump_remeha_effenca_mt_operating_state_title: 'Operating State',
         modbus_v3_heat_pump_remeha_effenca_mt_measurements_title: 'Measurements',
         modbus_v3_heat_pump_remeha_effenca_mt_analog_readings_title: 'Pressure, Flow and Energy',
         modbus_v3_heat_pump_remeha_effenca_mt_writable_registers_title: 'Commands and Parameters',
         modbus_heat_pump_remeha_effenca_mt_operating_state: 'Operating State (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_measurements: 'Measurements (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_analog_readings: 'Pressure, Flow and Energy (Remeha Effenca MT)',
         modbus_heat_pump_remeha_effenca_mt_writable_registers: 'Commands and Parameters (Remeha Effenca MT)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_2_label: 'Alarm reset by modbus',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_6_label: 'Save date',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_13_label: 'Suction pressure C1 value',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_18_label: 'Plate exchanger electrical heater C1 status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_21_label: 'Crackcase heater C1 status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_23_label: 'Final unit setpoint',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_45_label: 'Superheating',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_50_label: 'Silent Mode Selector',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_50_label_list: JSON.stringify({
           list: {
             0: 'No Silent Mode',
             1: 'Low Noise 1',
             2: 'Low Noise 2',
             3: 'Low Noise 3',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_53_label: 'EEV position percentage',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_59_label: 'Instantaneous generated Power',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_65_label: 'Minimum Off time compressor',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_66_label: 'Minimum time between starts',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_67_label: 'Countdown Compressor Minimum OFF Time',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_68_label: 'Countdown Compressor Minimum On Time',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_70_label: 'Current day',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_75_label: 'Min Return Water Temp Compressor ON - Cooling mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_76_label: 'Return Water Temp allows Compressor Startup - Cooling Mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_100_label: 'Enable minimal outdoor temperature for defrost',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_102_label: 'Enable Pump shutdown when Compresor is OFF',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_110_label: 'Instantaneous absorbed Power',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_117_label: 'Pump speed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_120_label: 'C1 Fans analog output',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_185_label: 'Status of defrost C1',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_188_label: 'Software version (1.X.X version will be 1)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_189_label: 'Software version (X.6.X version will be 6)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_190_label: 'Software version (X.X.04 version will be 04)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_200_label: 'Setpoint from modbus',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_201_label: 'Request from modbus 0%=17% --> 100%-100%',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_204_label: 'Serial number (year)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_205_label: 'Serial number (month)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_206_label: 'Serial number (factory)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_207_label: 'Serial number (number)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_209_label: 'Working hours of compressor (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_211_label: 'Maximum speed fan in silent mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_217_label: 'Working hours of pump (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_218_label: 'Working hours of pump (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_225_label: 'Working hours of Plate exchanger heater (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_226_label: 'Working hours of Plate exchanger heater (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_229_label: 'Working hours of fan (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_231_label: 'Maximum limit of kW Dynamic (NOT AVALIABLE FUNCTION)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_251_label: 'Start-up number of compressor (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_252_label: 'Start-up number of compressor (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_259_label: 'Start-up number of pump (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_260_label: 'Start-up number of pump (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_267_label: 'Start-up number of Plate exchanger heater (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_268_label: 'Start-up number of Plate exchanger heater (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_271_label: 'Start-up number of fan (high part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_272_label: 'Start-up number of fan (low part)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_280_label: 'watts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_281_label: 'kilowatts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_282_label: 'Megawatts/h absorbed',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_283_label: 'watts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_284_label: 'kilowatts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_285_label: 'Megawatts/h generated',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_302_label: 'Feedback compressor in RPS',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_304_label: 'Feedback compressor in percentage',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_315_label: 'Compressor is in start-up mode',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_370_label: 'Maximum Heating Setpoint limit by Outdoor Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_371_label: 'Minimum Heating Setpoint Limit By Outdoot Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_372_label: 'Maximum Cooling Setpoint limit by Outdoor Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_373_label: 'Minimum Cooling Setpoint Limit By Outdoot Temp',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_485_label: 'Software version (1.6.04 version will be 1604)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_495_label: 'Request type',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_495_label_list: JSON.stringify({
           list: {
             0: 'PID',
             1: 'Setpoint 0-10V',
             2: 'SetPoint BMS',
             3: 'Request compressor 0-10V',
             4: 'Request compresor 0-100 BMS',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_600_label: 'Alarma and type alarm',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_610_label: 'Compressor is limited',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_611_label: 'Info Bms Need Rese tManual',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_651_label: 'It shows actual running unit status',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_651_label_list: JSON.stringify({
           list: {
             0: 'Unit ON',
             1: 'Unit ON (RESERVED)',
             2: 'Unit ON (RESERVED)',
             3: 'Unit OFF by Alarm',
             4: 'Unit OFF by Supervisor or BMS',
             5: 'Unit OFF by Time Band',
             6: 'Unit OFF by Digital Input',
             7: 'Unit OFF by PGD Keyboard',
             8: 'Unit OFF by Manufacturer',
             9: 'Unit OFF by ChangeOver (Heating <-> Cooling Modes)',
             10: 'Unit Running on Manual Mode',
             11: 'Unit OFF by Limit Ext. Temp',
             12: 'Unit OFF and CrankCase Heating ON',
             13: 'OFFx LIM.WATER T',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_652_label: 'Configured unit model',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_652_label_list: JSON.stringify({
           list: {
             41: 'PBM3-i 20 R32',
             42: 'PBM3-i 26 R32',
             43: 'PBM3-i 33 R32',
             44: 'PBM3-i 40 R32',
             46: 'MB4C 20 R290',
             47: 'MB4C 30 R290',
           },
         }),
         modbus_v3_heat_pump_remeha_effenca_mt_reg_653_label: 'CranKase heater time remain (Hour)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_654_label: 'CranKase heater time remain (Minute)',
         modbus_v3_heat_pump_remeha_effenca_mt_reg_655_label: 'CranKase heater time remain (Second)',
         custom_popover_remeha_effenca_mt_2_long_description: 'Alarm reset by modbus',
         custom_popover_remeha_effenca_mt_6_long_description: 'Save date',
         custom_popover_remeha_effenca_mt_13_long_description: 'Suction pressure C1 value',
         custom_popover_remeha_effenca_mt_18_long_description: 'Plate exchanger electrical heater C1 status',
         custom_popover_remeha_effenca_mt_21_long_description: 'Crackcase heater C1 status',
         custom_popover_remeha_effenca_mt_23_long_description: 'Final unit setpoint',
         custom_popover_remeha_effenca_mt_45_long_description: 'Superheating',
         custom_popover_remeha_effenca_mt_50_long_description: 'Silent Mode Selector (0= No Silent Mode, 1= Low Noise 1 , 2= Low Noise 2, 3= Low Noise 3)',
         custom_popover_remeha_effenca_mt_53_long_description: 'EEV position percentage',
         custom_popover_remeha_effenca_mt_59_long_description: 'Instantaneous generated Power',
         custom_popover_remeha_effenca_mt_65_long_description: 'Minimum Off time compressor',
         custom_popover_remeha_effenca_mt_66_long_description: 'Minimum time between starts',
         custom_popover_remeha_effenca_mt_67_long_description: 'Countdown Compressor Minimum OFF Time',
         custom_popover_remeha_effenca_mt_68_long_description: 'Countdown Compressor Minimum On Time',
         custom_popover_remeha_effenca_mt_70_long_description: 'Current day',
         custom_popover_remeha_effenca_mt_75_long_description: 'Min Return Water Temp Compressor ON - Cooling mode',
         custom_popover_remeha_effenca_mt_76_long_description: 'Return Water Temp allows Compressor Startup - Cooling Mode',
         custom_popover_remeha_effenca_mt_100_long_description: 'Enable minimal outdoor temperature for defrost',
         custom_popover_remeha_effenca_mt_102_long_description: 'Enable Pump shutdown when Compresor is OFF',
         custom_popover_remeha_effenca_mt_110_long_description: 'Instantaneous absorbed Power',
         custom_popover_remeha_effenca_mt_117_long_description: 'Pump speed',
         custom_popover_remeha_effenca_mt_120_long_description: 'C1 Fans analog output',
         custom_popover_remeha_effenca_mt_185_long_description: 'Status of defrost C1',
         custom_popover_remeha_effenca_mt_188_long_description: 'Software version (1.X.X version will be 1)',
         custom_popover_remeha_effenca_mt_189_long_description: 'Software version (X.6.X version will be 6)',
         custom_popover_remeha_effenca_mt_190_long_description: 'Software version (X.X.04 version will be 04)',
         custom_popover_remeha_effenca_mt_200_long_description: 'Setpoint from modbus',
         custom_popover_remeha_effenca_mt_201_long_description: 'Request from modbus 0%=17% --> 100%-100%',
         custom_popover_remeha_effenca_mt_204_long_description: 'Serial number (year)',
         custom_popover_remeha_effenca_mt_205_long_description: 'Serial number (month)',
         custom_popover_remeha_effenca_mt_206_long_description: 'Serial number (factory)',
         custom_popover_remeha_effenca_mt_207_long_description: 'Serial number (number)',
         custom_popover_remeha_effenca_mt_211_long_description: 'Maximum speed fan in silent mode',
         custom_popover_remeha_effenca_mt_217_long_description: 'Working hours of pump (high part)',
         custom_popover_remeha_effenca_mt_218_long_description: 'Working hours of pump (low part)',
         custom_popover_remeha_effenca_mt_225_long_description: 'Working hours of Plate exchanger heater (high part)',
         custom_popover_remeha_effenca_mt_226_long_description: 'Working hours of Plate exchanger heater (low part)',
         custom_popover_remeha_effenca_mt_229_long_description: 'Working hours of fan (high part)',
         custom_popover_remeha_effenca_mt_231_long_description: 'Maximum limit of kW Dynamic (NOT AVALIABLE FUNCTION)',
         custom_popover_remeha_effenca_mt_251_long_description: 'Start-up number of compressor (high part)',
         custom_popover_remeha_effenca_mt_252_long_description: 'Start-up number of compressor (low part)',
         custom_popover_remeha_effenca_mt_259_long_description: 'Start-up number of pump (high part)',
         custom_popover_remeha_effenca_mt_260_long_description: 'Start-up number of pump (low part)',
         custom_popover_remeha_effenca_mt_267_long_description: 'Start-up number of Plate exchanger heater (high part)',
         custom_popover_remeha_effenca_mt_268_long_description: 'Start-up number of Plate exchanger heater (low part)',
         custom_popover_remeha_effenca_mt_271_long_description: 'Start-up number of fan (high part)',
         custom_popover_remeha_effenca_mt_272_long_description: 'Start-up number of fan (low part)',
         custom_popover_remeha_effenca_mt_280_long_description: 'watts/h absorbed',
         custom_popover_remeha_effenca_mt_281_long_description: 'kilowatts/h absorbed',
         custom_popover_remeha_effenca_mt_282_long_description: 'Megawatts/h absorbed',
         custom_popover_remeha_effenca_mt_283_long_description: 'watts/h generated',
         custom_popover_remeha_effenca_mt_284_long_description: 'kilowatts/h generated',
         custom_popover_remeha_effenca_mt_285_long_description: 'Megawatts/h generated',
         custom_popover_remeha_effenca_mt_302_long_description: 'Feedback compressor in RPS',
         custom_popover_remeha_effenca_mt_304_long_description: 'Feedback compressor in percentage',
         custom_popover_remeha_effenca_mt_315_long_description: 'Compressor is in start-up mode',
         custom_popover_remeha_effenca_mt_370_long_description: 'Maximum Heating Setpoint limit by Outdoor Temp',
         custom_popover_remeha_effenca_mt_371_long_description: 'Minimum Heating Setpoint Limit By Outdoot Temp',
         custom_popover_remeha_effenca_mt_372_long_description: 'Maximum Cooling Setpoint limit by Outdoor Temp',
         custom_popover_remeha_effenca_mt_373_long_description: 'Minimum Cooling Setpoint Limit By Outdoot Temp',
         custom_popover_remeha_effenca_mt_485_long_description: 'Software version (1.6.04 version will be 1604)',
         custom_popover_remeha_effenca_mt_495_long_description: 'Request type (0 = PID, 1 = Setpoint 0-10V, 2 = SetPoint BMS, 3 = Request compressor 0-10V, 4 = Request compresor 0-100 BMS)',
         custom_popover_remeha_effenca_mt_600_long_description: 'Alarma and type alarm',
         custom_popover_remeha_effenca_mt_610_long_description: 'Compressor is limited',
         custom_popover_remeha_effenca_mt_611_long_description: 'Info Bms Need Rese tManual',
         custom_popover_remeha_effenca_mt_651_long_description: 'It shows actual running unit status: (0= Unit ON, 1 = Unit ON (RESERVED), 2= Unit ON (RESERVED), 3 = Unit OFF by Alarm, 4 = Unit OFF by Supervisor or BMS, 5 = Unit OFF by Time Band, 6 = Unit OFF by Digital Input, 7 = Unit OFF by PGD Keyboard, 8 = Unit OFF by Manufacturer, 9 = Unit OFF by ChangeOver (Heating <-> Cooling Modes), 10 = Unit Running on Manual Mode, 11 = Unit OFF by Limit Ext. Temp, 12 = Unit OFF and CrankCase Heating ON.), 13 = OFFx LIM.WATER T',
         custom_popover_remeha_effenca_mt_652_long_description: 'Configured unit model: (41 = PBM3-i 20 R32, 42 = PBM3-i 26 R32, 43 = PBM3-i 33 R32, 44 = PBM3-i 40 R32, 46 = MB4C 20 R290, 47 = MB4C 30 R290).',
         custom_popover_remeha_effenca_mt_653_long_description: 'CranKase heater time remain (Hour)',
         custom_popover_remeha_effenca_mt_654_long_description: 'CranKase heater time remain (Minute)',
         custom_popover_remeha_effenca_mt_655_long_description: 'CranKase heater time remain (Second)',
         manufacturer_controller_field: 'Manufacturer',
         manufacturer_variant_field: 'Product Variant / Model',
         devices_manufacturer_controller_required_form_error:
           'Manufacturer is required',
         devices_manufacturer_variant_required_form_error:
           'Product Variant / Model is required',
         partner_settings_general_settings_pre_payment_label:
           'Pre-payment Settings',
         partner_settings_general_settings_pre_payment_module_label:
           'Pre-payment Module',
         partner_settings_general_settings_pre_payment_module_description:
           'This setting will enable or disable the pre-payment functionality on the platform.',
         pre_payment_settings_title: 'Pre-payment Settings',
         pre_payment_enable_on_hiu: 'Enable Pre-Payment on HIU',
         pre_payment_enable_on_hiu_description:
           'Enabling this setting allows remote control of the HIU and activates API access. Once enabled, the settings below will become available.',
         pre_payment_override_on_hiu: 'Enable Pre-Payment Override on HIU',
         pre_payment_override_on_hiu_description:
           'Users without API access can perform this action directly from the portal. The manual override serves as a fallback in case the API is unavailable.',
         pre_payment_heating_settings: 'Heating Settings',
         pre_payment_heating_enable: 'Heating enable',
         pre_payment_hot_water_settings: 'Hot Water Settings',
         pre_payment_hot_water_enable: 'Hot water enable',
         pre_payment_cooling_settings: 'Cooling Settings',
         pre_payment_cooling_enable: 'Cooling enable',
         pre_payment_table_name: 'Name',
         pre_payment_table_value: 'Value',
         pre_payment_on: 'On',
         pre_payment_off: 'Off',
         pre_payment_description: 'Description: ',
         pre_payment_heating_settings_description:
           'Disables/enables the Central Heating functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_hot_water_settings_description:
           'Disables/enables the Domestic Hot Water functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_cooling_settings_description:
           'Disables/enables the Central Cooling functions of the HIU. Requires Pre-Payment Override on HIU to be enabled.',
         pre_payment_settings_update_success:
           'Pre-payment settings updated successfully.',
         pre_payment_reporting_title: 'Pre-Payment Reporting',
         pre_payment_reporting_tab_hiu_overview: 'HIUs Overview',
         pre_payment_reporting_tab_hiu_mismatches: 'HIU Mismatches',
         pre_payment_reporting_hiu_overview: 'HIUs Overview',
         pre_payment_reporting_hiu_mismatches: 'HIUs Mismatches',
         pre_payment_reporting_hiu_setting_mismatches:
           'HIUs With Setting Mismatches',
         pre_payment_enabled_on_hiu: 'Pre-Payment Enabled on HIU',
         pre_payment_disabled_on_hiu: 'Pre-Payment Disabled on HIU',
         pre_payment_hiu_with_issues: 'HIU with Issues',
         pre_payment_hiu_without_issues: 'HIU without Issues',
         pre_payment_heating_setting: 'Heating setting',
         pre_payment_hot_water_setting: 'Hot Water setting',
         pre_payment_cooling_setting: 'Cooling setting',
         pre_payment_select_setting_status: 'Select Setting Status',
         pre_payment_enabled: 'ENABLED',
         pre_payment_disabled: 'DISABLED',
         pre_payment_no_data: 'No data available',
         pre_payment_table_col_enable_pre_payment: 'Enable Pre-Payment on HIU',
         pre_payment_table_col_enable_override:
           'Enable Pre-Payment Override on HIU',
         pre_payment_table_col_water: 'Water',
         pre_payment_table_col_cooling: 'Cooling',
         pre_payment_table_col_heating: 'Heating',
         pre_payment_update_portal_message:
           'The latest Pre-payment configuration are set via "Portal" by ##USER_NAME## on ##DATE##',
         pre_payment_update_api_message:
           'The latest Pre-payment configuration are set via "API" by ##USER_NAME## on ##DATE##',
         sidebar_pre_payment_reporting: 'Pre-payment Reporting',
         pre_payment_expected_settings: 'Expected Settings',
         pre_payment_actual_settings: 'Actual Settings',
         pre_payment_match_status: 'Match Status',
         pre_payment_requested_from: 'Requested From',
         pre_payment_requested_by: 'Requested By',
         pre_payment_updated_at: 'Updated At',
         pre_payment_last_monitored: 'Last Monitored',
         prepayment_hot_water_enabled: 'Hot Water Enabled',
         prepayment_hot_water_disabled: 'Hot Water Disabled',
         prepayment_heating_enabled: 'Heating Enabled',
         prepayment_heating_disabled: 'Heating Disabled',
         prepayment_cooling_enabled: 'Cooling Enabled',
         prepayment_cooling_disabled: 'Cooling Disabled',
         pre_payment_matched: 'MATCHED',
         pre_payment_mismatched: 'MISMATCHED',
         device_single_prepayment_tab: 'Pre-payment',
         project_single_prepayment_tab: 'Pre-payment',
         pre_payment_reporting_tab_pre_payment_events: 'Pre-Payment Events',
         clients_form_prepayment_notification_email_field:
           'Prepayment Notification Email',
         device_single_mbus_graph_title: 'Mbus Historic Data',
         sidebar_api_overview: 'APIs',
         sidebar_api_device_import: 'Apparaat Import APIs',
         sidebar_api_external: 'Externe APIs',
         sidebar_api_prepayment: 'Prepayment APIs',
         sidebar_api_writer_v3: 'Writer v3',
         api_overview_no_apis_available:
           'Geen APIs beschikbaar voor deze omgeving',
         device_single_mbus_registers_tab: 'Mbus Registers',
         device_single_mbus_graph_tab: 'Mbus Graph',
         projects_form_send_subscription_expiring_notification_field:
           'Send Subscription Expiring Notification',
         projects_missing_contact_modal_title:
           'Action Required: Missing Client Contact',
         projects_missing_contact_modal_subtitle:
           'The following projects are missing a main client contact. Please assign a contact for each project before continuing.',
         projects_missing_contact_contact_required:
           'Client contact is required',
         projects_missing_contact_save_success:
           'Client contacts updated successfully',
         projects_missing_contact_save_error:
           'Failed to update client contacts. Please try again.',
         projects_missing_contact_remind_later_button: 'Remind Me Later',
         projects_missing_contact_save_button: 'Save',
         devices_form_autocomplete_device_name_or_serial_number_field:
           'Device naam of Serienummer Mercurius',
         swapping_same_device_error:
           'The selected devices cannot be the same. Please choose two different devices',
         clients_table_users: 'Users',
         service_clients_table_users: 'Users',
         clients_bulk_delete_success_message:
           'Clients with 0 devices and 0 users were successfully deleted.',
         clients_delete_modal_title:
           'Are you sure you want to delete the following client records?',
         service_clients_delete_modal_title:
           'Are you sure you want to delete the following service client records?',
         clients_bulk_delete_subtitle:
           'You want to delete client records with 0 devices and 0 users? \n Any selected clients with more than 0 devices or users will be ignored.',
         service_clients_bulk_delete_success_message:
           'Service Clients with 0 devices and 0 users were successfully deleted.',
         service_clients_bulk_delete_subtitle:
           'You want to delete service client records with 0 devices and 0 users? \n Any selected service clients with more than 0 devices or users will be ignored.',
         clients_bulk_deactivate_title: 'Are you sure?',
         clients_bulk_deactivate_subtitle:
           'You want to deactivate the selected clients?',
         service_clients_bulk_deactivate_title: 'Are you sure?',
         service_clients_bulk_deactivate_subtitle:
           'You want to deactivate the selected service clients?',
         sidebar_offboarding_overview: 'Offboarding Overview',
         offboarding_form_header: 'Offboarding Overview',
         offboarding_initiate_button: 'Initiate Offboarding',
         offboarding_initiate_page_title: 'Offboarding - Initiate',
         offboarding_scope_page_title: 'Offboarding - Scope',
         offboarding_review_page_title: 'Offboarding - Review',
         offboarding_confirm_page_title: 'Offboarding - Confirmation',
         offboarding_initiated_page_title: 'Offboarding - Initiated',
         offboarding_breadcrumb_subscription: 'Subscription',
         offboarding_breadcrumb_offboarding: 'Offboarding',
         offboarding_start_title: 'Initiate Offboarding',
         offboarding_start_about_to_begin:
           'You are about to begin the full offboarding process for',
         offboarding_start_includes:
           'This process includes a grace period, restricted access, and eventual data removal for the affected scope.',
         offboarding_partial_scope_about_to_begin:
           'You are about to begin the partial offboarding process for',
         offboarding_immediate_scope_about_to_begin:
           'You are about to initiate the immediate offboarding process for',
         offboarding_immediate_scope_includes:
           'Once the request is approved, all data within the affected scope will be permanently deleted immediately, with access restricted throughout the process.',
         offboarding_what_to_expect: 'What to Expect',
         offboarding_what_to_expect_1:
           'Review the full list of projects belonging to this client and confirm your selection',
         offboarding_what_to_expect_2:
           'Select the projects or account scope to offboard',
         offboarding_what_to_expect_3:
           'Review timelines, including grace period and data download window',
         offboarding_what_to_expect_4:
           'Confirm and initiate the offboarding process for the client',
         offboarding_note: 'Note',
         offboarding_note_text:
           'The client will retain limited access to view and export data before permanent deletion takes place.',
         offboarding_start_button: 'Start Offboarding',
         offboarding_scope_select_title: 'Select Offboarding Scope',
         offboarding_scope_choose_description:
           'Choose whether you want to offboard the client entirely or only selected projects.',
         offboarding_type_full: 'Full Offboarding',
         offboarding_type_full_description:
           'Offboard your entire account, including all projects and associated data.',
         offboarding_type_partial: 'Partial Offboarding',
         offboarding_type_partial_description:
           'Offboard selected projects while keeping the rest of your account active.',
         offboarding_type_immediate: 'Immediate Deletion',
         offboarding_type_immediate_description:
           'Immediately delete selected project data without a grace period.',
         offboarding_selected_projects: 'Selected project(s)',
         offboarding_add_projects: 'Add Projects',
         offboarding_please_select_projects:
           'Please select projects to proceed',
         offboarding_projects_selected_count: 'selected',
         offboarding_search_projects: 'Search projects...',
         offboarding_full_info_text:
           'All projects under this client will be offboarded. No project selection is required.',
         offboarding_partial_info_text:
           'Only the selected scope will be affected. All other projects will remain active and unchanged.',
         offboarding_immediate_info_text:
           'Selected projects will be immediately queued for deletion without a grace period.',
         offboarding_continue_button: 'Continue',
         offboarding_back_button: 'Back',
         offboarding_review_title: 'Review Timeline & Impact',
         offboarding_review_description:
           'Review what will happen after the offboarding process begins, including timelines, client access changes, and data handling for the affected projects.',
         offboarding_timeline: 'Timeline',
         offboarding_contract_termination_date: 'Contract Termination Date',
         offboarding_contract_termination_text:
           'The offboarding process for the selected projects will begin from this date.',
         offboarding_grace_period: 'Grace Period (1 Month)',
         offboarding_grace_period_1:
           'Client access will be limited to view and export only',
         offboarding_grace_period_2: 'No new data will be collected or logged',
         offboarding_grace_period_3:
           'The client may request renewal during this period',
         offboarding_data_download_window:
           'Data Download Window (Additional 1 Month)',
         offboarding_data_download_1:
           'The client can continue to access and export data',
         offboarding_data_download_2:
           'No changes or new activity will be allowed',
         offboarding_impact_summary: 'Impact Summary',
         offboarding_impact_1:
           'Write actions and configuration changes will be disabled',
         offboarding_impact_2: 'Device control and data collection will stop',
         offboarding_impact_3:
           'Data will be permanently removed after the download window',
         offboarding_review_note:
           'The client may request renewal during the grace period before final deletion.',
         offboarding_confirm_description:
           'Please review the selected projects and confirm to start the offboarding process for',
         offboarding_summary: 'Summary',
         offboarding_client_name: 'Client name',
         offboarding_scope_label: 'Scope',
         offboarding_projects_affected: 'Projects Affected',
         offboarding_data_download_deadline: 'Data Download Deadline',
         offboarding_set_upon_approval: 'Set upon approval',
         offboarding_important: 'Important',
         offboarding_important_1:
           'Client access to affected projects will be restricted to read and export only',
         offboarding_important_2:
           'Device activity and data collection for affected projects will stop',
         offboarding_important_3:
           'Data for affected projects will be permanently deleted after the download window',
         offboarding_important_4:
           'This action cannot be reversed once the process begins',
         offboarding_understand_checkbox:
           'I understand the consequences of offboarding and want to proceed with this request for',
         offboarding_understand_checkbox_prefix:
           'I understand the consequences of offboarding and want to proceed with this request for',
         offboarding_understand_checkbox_suffix: '.',
         offboarding_attachment_title: 'Mandatory Acknowledgement Attachment',
         offboarding_attachment_instruction:
           'Upload proof of customer acknowledgement to offboard the project(s). Drag & drop files here, or click to browse.',
         offboarding_attachment_subtext:
           'Accepted: images, PDFs, Word documents, or any file format. One or more files required.',
         offboarding_attachment_required_error:
           'Please upload at least one attachment confirming customer acknowledgement before proceeding.',
         offboarding_attachment_remove: 'Remove',
         offboarding_confirm_button: 'Confirm',
         offboarding_initiated_started: 'Offboarding Started',
         offboarding_initiated_success_prefix: 'The offboarding process for',
         offboarding_initiated_success_suffix:
           'has been successfully initiated.',
         offboarding_initiated_bold:
           'The selected projects are now in the offboarding process. Client access and project permissions have been updated based on the current stage.',
         offboarding_what_happens_next: 'What Happens Next',
         offboarding_next_1:
           'The grace period will begin from the contract termination date',
         offboarding_next_2:
           'Client access will be limited to view and export only',
         offboarding_next_3:
           'The client may request renewal during the grace period',
         offboarding_next_4:
           'After the deadline, affected project data will be permanently deleted',
         offboarding_go_to_dashboard: 'Go to Dashboard',
         offboarding_rejection_reason_hint:
           'A minimum of 30 characters is required for the rejection reason.',
         offboarding_toast_cancelled_success:
           'Offboarding cancelled successfully.',
         offboarding_toast_cancelled_failed:
           'Failed to cancel. Please try again.',
         offboarding_toast_create_success:
           'Offboarding request submitted successfully.',
         offboarding_toast_paused_success: 'Offboarding paused successfully.',
         offboarding_toast_resumed_success: 'Offboarding resumed successfully.',
         offboarding_toast_action_failed: 'Action failed. Please try again.',
         offboarding_toast_review_request_sent:
           'You have successfully requested offboarding review from your ##COLLEGUE_FULL_NAME##',
         offboarding_email_link_already_reviewed:
           'The selected project is already reviewed.',
         offboarding_email_link_status_not_initiated:
           'This project offboarding has already been reviewed.',
         offboarding_email_link_wrong_reviewer:
           '##REVIEWER_NAME## has already been requested to review this project.',
         offboarding_bulk_all_devices_offboarded_error: 'Please select devices which are not offboarded.',
         offboarding_toast_rejected_success:
           'Offboarding request rejected successfully.',
         offboarding_toast_rejected_failed:
           'Failed to reject. Please try again.',
         offboarding_toast_approved_success:
           'Offboarding request approved successfully.',
         offboarding_toast_approved_failed:
           'Failed to approve. Please try again.',
         offboarding_dialog_close: 'Close',
         offboarding_dialog_cancel: 'Cancel',
         offboarding_dialog_reject: 'Reject',
         offboarding_dialog_approve: 'Approve',
         offboarding_dialog_no_reason_provided: 'No reason provided.',
         offboarding_dialog_deletion_reason_title: 'Immediate Deletion Reason',
         offboarding_dialog_rejection_reason_title: 'Rejection Reason',
         offboarding_dialog_rejected_by: 'Rejected By',
         offboarding_action_review: 'Review',
         offboarding_action_pause: 'Pause',
         offboarding_action_resume: 'Resume',
         offboarding_action_cancel_offboarding: 'Cancel Offboarding',
         offboarding_action_download_attachment: 'Download Attachment',
         offboarding_toast_download_attachment_success:
           'Attachments downloaded successfully.',
         offboarding_action_review_deletion_reason:
           'Review Immediate Deletion Reason',
         offboarding_action_review_rejection_reason: 'Review Rejection Reason',
         offboarding_action_request_review_colleague:
           'Request Review From Colleague',
         offboarding_request_review_dialog_title:
           'Request Review From Colleague',
         offboarding_request_review_colleague_label:
           'Select a colleague to review this request',
         offboarding_request_review_colleague_placeholder:
           'Search by name or email...',
         offboarding_request_review_send_button: 'Send Request',
         offboarding_review_dialog_title: 'Review',
         offboarding_review_instructions:
           'and make your decision accordingly. Approve with caution, as the project will be moved to the grace period and an email will also be forwarded to the customer.',
         offboarding_review_what_will_happen: 'What Will Happen',
         offboarding_review_what_happens_next: 'What Happens Next',
         offboarding_review_partial_bullet_1:
           'Once approved, the grace period will begin immediately.',
         offboarding_review_partial_bullet_2:
           'Client access will be limited to view and export only.',
         offboarding_review_partial_bullet_3:
           'After the deadline, affected project data will be permanently deleted.',
         offboarding_review_full_bullet_1:
           'Once approved, the grace period will begin immediately.',
         offboarding_review_full_bullet_2:
           'Client access will be limited to view and export only.',
         offboarding_review_full_bullet_3:
           'Device activity and data collection for affected projects will stop.',
         offboarding_review_full_bullet_4:
           'After the deadline, affected data will be permanently deleted.',
         offboarding_review_immediate_bullet_1:
           'Once approved, deletion for the affected projects will begin immediately.',
         offboarding_review_immediate_bullet_2:
           'Client access will be revoked.',
         offboarding_review_immediate_bullet_3:
           'All project data will be permanently deleted.',
         offboarding_review_note_text:
           'The client may request renewal during the grace period. A Fortes Super Admin can pause or resume the offboarding process if the client has expressed interest to the Sales department in renewing their subscription.',
         offboarding_review_summary_title: 'Summary',
         offboarding_review_note_label: 'Note',
         offboarding_review_label_requested_by: 'Requested By',
         offboarding_review_label_client_name: 'Client Name',
         offboarding_review_label_status: 'Status',
         offboarding_review_label_status_value: 'INITIATED / UNDER REVIEW',
         offboarding_review_label_scope: 'Scope',
         offboarding_review_label_projects_affected: 'Projects Affected',
         offboarding_review_label_all_projects: 'All',
         offboarding_review_label_request_date: 'Request Date',
         offboarding_review_label_grace_period_expiry:
           'Expected Grace Period Expiry',
         offboarding_review_rejection_reason_field: 'Rejection Reason',
         offboarding_error_create:
           'Failed to initiate offboarding. Please try again.',
         offboarding_select_projects_title: 'Select Project(s)',
         offboarding_col_project_name: 'Project Name',
         offboarding_col_expiry_date: 'Expiry Date',
         offboarding_col_months_to_zero: 'Months to Zero',
         offboarding_col_devices: 'Devices',
         offboarding_no_projects_found: 'No projects found.',
         offboarding_done_button: 'Done',

         /* Full Offboarding flow */
         full_offboarding_page_title: 'Offboarding - Full',
         full_offboarding_scope_info:
           'All projects will be affected in the full offboarding process.',
         full_offboarding_confirm_title: 'Confirm Full Offboarding',
         full_offboarding_confirm_description:
           'Please review the selected scope and confirm to start the offboarding process for',
         full_offboarding_projects_all: 'All',
         full_offboarding_important_5:
           'This action cannot be reversed once the process begins',
         full_offboarding_understand_prefix:
           'I understand the consequences of full offboarding and want to proceed with this request for',
         full_offboarding_initiated_title: 'Full Offboarding Started',
         full_offboarding_initiated_success_prefix:
           'The offboarding process for',
         full_offboarding_initiated_success_suffix:
           'has been successfully initiated.',
         full_offboarding_initiated_body:
           'The selected scope is now in the offboarding process. Client access and project permissions have been updated based on the current stage.',
         full_offboarding_next_1:
           'The grace period will begin from the contract termination date',
         full_offboarding_next_2:
           'Client access will be limited to view and export only',
         full_offboarding_next_3:
           'The client may request renewal during the grace period',
         full_offboarding_next_4:
           'Device activity and data collection for affected projects will stop',
         full_offboarding_next_5:
           'After the deadline, affected data will be permanently deleted or anonymized',

         /* Immediate Deletion flow */
         immediate_offboarding_page_title: 'Offboarding - Immediate Deletion',
         immediate_offboarding_scope_warning:
           'Please note that this option will permanently delete all data associated with the selected projects. Use it with caution.',
         immediate_offboarding_review_title: 'Request Immediate Deletion',
         immediate_offboarding_review_description_prefix:
           'Select the projects belonging to',
         immediate_offboarding_review_description_suffix:
           'that should be deleted immediately.',
         immediate_offboarding_select_projects_label: 'Select Project(s)',
         immediate_offboarding_reason_label: 'Reason for Deletion',
         immediate_offboarding_reason_placeholder:
           'Provide a reason for this request',
         immediate_offboarding_review_important_1:
           'This request must be approved before deletion begins',
         immediate_offboarding_review_important_2:
           'Client access to affected projects may be restricted once approved',
         immediate_offboarding_review_important_3:
           'This process may bypass the grace period and data download window',
         immediate_offboarding_review_important_4:
           'Deletion is permanent and cannot be undone',
         immediate_offboarding_confirm_title: 'Request Immediate Deletion',
         immediate_offboarding_confirm_description_prefix:
           'You are requesting immediate deletion of the selected projects belonging to',
         immediate_offboarding_confirm_description_suffix:
           'This request will be reviewed before any action is taken.',
         immediate_offboarding_status: 'Status',
         immediate_offboarding_pending_approval: 'Pending approval',
         immediate_offboarding_scope_value: 'Request Immediate Deletion',
         immediate_offboarding_request_date: 'Request Date',
         immediate_offboarding_checkbox:
           'I understand that this action may result in permanent data loss for the affected projects.',
         immediate_offboarding_submit_button: 'Submit',
         immediate_offboarding_projects_required:
           'Please select at least one project.',
         immediate_offboarding_reason_required:
           'Please provide a reason for deletion.',
         immediate_offboarding_initiated_title: 'Deletion Request Submitted',
         immediate_offboarding_initiated_success_prefix:
           'The immediate deletion request for',
         immediate_offboarding_initiated_success_suffix:
           'has been successfully submitted and is pending review.',
         immediate_offboarding_next_1:
           'The request will be reviewed by the offboarding team',
         immediate_offboarding_next_2:
           'The client and internal stakeholders may be notified once a decision is made',
         immediate_offboarding_next_3:
           'If approved, deletion for the affected projects will begin immediately',
         immediate_offboarding_error_create:
           'Failed to submit the immediate deletion request.',
         device_single_device_settings_hiu_search_device: 'HIU Search',
         device_single_device_settings_hiu_search_message_forwarded:
           'Device HIU Modbus Search message is forwarded to device',
         device_single_device_settings_hiu_reboot_device_tooltip:
           'It reboots the modbus device',
         device_single_device_settings_hiu_search_device_tooltip:
           'The Mercurius resets the Modbus UART and Search for Modbus again.',
         sidebar_offboarding_reporting: 'Offboarding Reporting',
         offboarding_reporting_page_title: 'Offboarding Report',
         offboarding_reporting_breadcrumb: 'Offboarding Report',
         offboarding_reporting_client_filter: 'Client',
         offboarding_reporting_project_filter: 'Project',
         offboarding_reporting_status_filter: 'Status',
         offboarding_reporting_all_statuses: 'All Statuses',
         offboarding_reporting_reset_filters: 'Reset Filters',
         offboarding_reporting_tab_all: 'All',
         offboarding_reporting_tab_partial: 'Partial',
         offboarding_reporting_tab_full: 'Full',
         offboarding_reporting_tab_immediate: 'Immediate',
         offboarding_reporting_requests_title: 'Offboarding Requests',
         offboarding_reporting_trend_title: 'Offboarding Trend',
         offboarding_reporting_requests_label: 'REQUESTS',
         offboarding_reporting_legend_initiated: 'Initiated / Under Review',
         offboarding_reporting_legend_grace_period: 'Grace Period',
         offboarding_reporting_legend_rejected: 'Offboarding Rejected',
         offboarding_reporting_legend_offboarded: 'Offboarded',
         offboarding_reporting_status_initiated: 'Initiated',
         offboarding_reporting_status_grace_period: 'Grace Period',
         offboarding_reporting_status_grace_period_expired:
           'Grace Period Expired',
         offboarding_reporting_status_in_progress: 'Deletion In Progress',
         offboarding_reporting_status_completed: 'Offboarded',
         offboarding_reporting_status_approved: 'Approved',
         offboarding_reporting_status_rejected: 'Rejected',
         offboarding_reporting_status_cancelled: 'Cancelled',
         offboarding_reporting_col_request_id: 'Request ID',
         offboarding_reporting_col_client: 'Client',
         offboarding_reporting_col_project: 'Project',
         offboarding_reporting_col_scope: 'Scope',
         offboarding_reporting_col_status: 'Status',
         offboarding_reporting_col_initiator: 'Initiated by',
         offboarding_reporting_col_initiated_at: 'Initiated At',
         offboarding_reporting_col_manager: 'Offboarding Manager',
         offboarding_reporting_no_data: 'No offboarding records found',
         offboarding_reporting_col_actions: 'Actions',
         sidebar_substations: 'Substation Overview',
         sidebar_boilers: 'Boiler Overview',
         boilers_bulk_edit_ota_form_submit_button: 'Update boilers',
         boilers_ota_select_at_least_one_to_proceed_error: 'You must select at least one boiler to proceed.',
         boilers_bulk_edit_ota_title: 'Boiler OTA bulk update',
         boilers_bulk_edit_registers_title: 'Boiler registers bulk update',
         boilers_bulk_hiu_ota_update_title: 'Boiler bulk HIU OTA update',
         custom_popover_boiler_luna_mp_386_short_description: 'Heating outdoor temperature upper limit',
         custom_popover_boiler_luna_mp_387_short_description: 'Cooling neutral band',
         custom_popover_boiler_luna_mp_388_short_description: 'Antifreeze activation temperature',
         custom_popover_boiler_luna_mp_389_short_description: 'Force summer mode',
         custom_popover_boiler_luna_mp_405_short_description: 'Domestic hot water internal setpoint',
         custom_popover_boiler_luna_mp_406_short_description: 'Central heating setpoint',
         custom_popover_boiler_luna_mp_408_short_description: 'Domestic hot water flow temperature setpoint',
         custom_popover_boiler_luna_mp_409_short_description: 'Water pressure',
         custom_popover_boiler_luna_mp_410_short_description: 'Flow rate',
         custom_popover_boiler_luna_mp_413_short_description: 'Actual relative power',
         custom_popover_boiler_luna_mp_414_short_description: 'Power setpoint',
         custom_popover_boiler_luna_mp_415_short_description: 'Flame current',
         custom_popover_boiler_luna_mp_416_short_description: 'Internal heat demand power',
         custom_popover_boiler_luna_mp_417_short_description: 'Internal heat demand temperature setpoint',
         custom_popover_boiler_luna_mp_418_short_description: 'Internal heat demand type',
         custom_popover_boiler_luna_mp_419_short_description: 'Burner/compressor starts',
         custom_popover_boiler_luna_mp_421_short_description: 'Burner operating hours',
         custom_popover_boiler_luna_mp_423_short_description: 'Backup 1 starts',
         custom_popover_boiler_luna_mp_425_short_description: 'Backup 1 hours',
         custom_popover_boiler_luna_mp_427_short_description: 'Backup 2 starts',
         custom_popover_boiler_luna_mp_429_short_description: 'Backup 2 hours',
         custom_popover_boiler_luna_mp_431_short_description: 'Operating hours',
         custom_popover_boiler_luna_mp_433_short_description: 'Central heating energy consumed',
         custom_popover_boiler_luna_mp_435_short_description: 'DHW energy consumed',
         custom_popover_boiler_luna_mp_439_short_description: 'Total energy consumed',
         custom_popover_boiler_luna_mp_441_short_description: 'Backup energy consumed',
         custom_popover_boiler_luna_mp_443_short_description: 'Total energy delivered',
         custom_popover_boiler_luna_mp_445_short_description: 'Central heating energy delivered',
         custom_popover_boiler_luna_mp_447_short_description: 'DHW energy delivered',
         custom_popover_boiler_luna_mp_451_short_description: 'Backup energy delivered',
         custom_popover_boiler_luna_mp_458_short_description: 'System flow setpoint',
         custom_popover_boiler_luna_mp_459_short_description: 'Pump speed',
         custom_popover_boiler_luna_mp_477_short_description: 'Minimum heating time before DHW production',
         custom_popover_boiler_luna_mp_478_short_description: 'Maximum DHW production time',
         custom_popover_boiler_luna_mp_479_short_description: 'DHW ECO/COMFORT mode',
         custom_popover_boiler_luna_mp_516_short_description: 'Burner starts since service',
         boilers_form_is_service_device_field: 'Service Boiler',
         boiler_single_device_settings_secondary_device_type_field: 'Secondary Boiler Type',
         boiler_single_device_settings_fqdn_field: 'Boiler FQDN',
         boilers_form_project_disabled_field: 'The Project Field is disabled because this boiler is a service boiler',
         boilers_form_device_address_tab: 'Installation address',
         boilers_form_project_field: 'Project',
         boilers_form_firmware_field: 'Firmware version',
         boilers_form_serial_number_field: 'Serial number Mercurius',
         boilers_form_type_field: 'Boiler type',
         boilers_form_client_field: 'Client',
         boilers_form_sim_card_number_field: 'Sim card number',
         boilers_form_first_event_timestamp_field: 'First Incoming Event Date',
         boilers_mbus_meter_count: 'Mbus Meters',
         boilers_mbus_labels: 'Mbus Meter Purpose Labels',
         boilers_last_viewed: 'Last seen',
         boilers_form_service_client_field: 'Service client',
         boilers_form_set_logs_scope_field: 'Data Logs Scope',
         boiler_list_modbus_write_enable_field: 'Modbus Write Mode',
         boilers_form_order_type_field: 'Order Type',
         boilers_form_default_controller_type_field: 'Default Controller Type',
         boilers_form_prod_order_nr_week_field: 'Production order number',
         boilers_form_order_number_field: 'Order number',
         boilers_form_default_client_name_field: 'Default Client Name',
         boilers_form_customer_ref_field: 'Customer reference',
         boilers_form_default_appliance_type_field: 'Default Appliance Type',
         boilers_form_default_soft_version_field: 'Default Software Version',
         boiler_is_claimed_field: 'Is Claimed',
         boiler_claimed_by_field: 'Claimed By',
         boiler_is_stock_product_field: 'Is Stock Product',
         boiler_commissioned_by_field: 'Commissioned By',
         boiler_commissioned_at_field: 'Commissioned At',
         boilers_form_v3_fetch_device_information_button: 'Fetch Boiler Information',
         boilers_partner_order_number_field: 'Boiler Distributor Order Number',
         boiler_single_temperature_no_graph_data_error: 'No graph data available',
         edit_boilers_form_header: 'Edit Boiler',
         edit_boilers_bread_crumb_first_link: 'Edit Boiler',
         boiler_menu_overview: 'Overview',
         boiler_menu_heating: 'Heating',
         boiler_menu_domestic_hot_water: 'Domestic Hot Water',
         boiler_menu_performance: 'Performance',
         boiler_menu_energy: 'Energy',
         boiler_menu_maintenance: 'Maintenance',
         boiler_menu_configuration: 'Configuration',
         boiler_menu_overview_water_pressure: 'Water Pressure',
         boiler_menu_overview_flow_rate: 'Flow Rate',
         boiler_menu_overview_current_power: 'Current Power',
         boiler_menu_heating_heat_demand: 'Heat Demand',
         boiler_menu_heating_setpoint: 'Setpoint',
         boiler_menu_domestic_hot_water_setpoint: 'Setpoint',
         boiler_menu_performance_power: 'Power',
         boiler_menu_performance_burner: 'Burner',
         boiler_menu_performance_burner_starts: 'Burner Starts',
         boiler_menu_performance_burner_operating_hours: 'Burner Operating Hours',
         boiler_menu_performance_pump_speed: 'Pump Speed',
         boiler_menu_energy_consumed_total: 'Total Energy Consumed',
         boiler_menu_energy_consumed_central_heating: 'Central Heating Energy Consumed',
         boiler_menu_energy_consumed_dhw: 'DHW Energy Consumed',
         boiler_menu_energy_consumed_backup: 'Backup Energy Consumed',
         boiler_menu_energy_delivered_total: 'Total Energy Delivered',
         boiler_menu_energy_delivered_central_heating: 'Central Heating Energy Delivered',
         boiler_menu_energy_delivered_dhw: 'DHW Energy Delivered',
         boiler_menu_energy_delivered_backup: 'Backup Energy Delivered',
         boiler_menu_maintenance_burner_starts: 'Burner Starts Since Service',
         boiler_menu_configuration_heating: 'Heating',
         boiler_menu_configuration_domestic_hot_water: 'Domestic Hot Water',
         boilers_bulk_delete_modal_subtitle: `<strong>The following data will be deleted:</strong>
          <ul>
            <li><i>Boiler Information</i></li>
            <li><i>Events</i></li>
            <li><i>Modbus Data</i></li>
            <li><i>Mbus Data</i></li>
            <li><i>Graph Data</i></li>
            <li><i>Boiler Register</i></li>
            <li><i>Error Data</i></li>
            <li><i>Other related tables</i></li>
          </ul>`,
         boiler_fetch_registers_success: 'Het verzoek is succesvol verzonden naar het Boiler.',
         boiler_form_description_field: 'Description',
         boiler_list_filters_button_label_change_settings_hover: 'Bulk update boiler registers - change boiler settings in bulk',
         boiler_list_filters_button_label_data_collect_hover: 'Refresh data - fetch the latest boiler data',
         boiler_list_filters_button_label_delete_devices_hover: 'Delete boiler(s) and their data',
         boiler_list_filters_button_label_download_hiu_data_hover: 'Download boiler data - download available measurement data for a selected period',
         boiler_list_filters_button_label_download_meter_data_hover: 'Download Meter data - download available meter data for a selected period',
         boiler_list_filters_button_label_export_devices_hover: 'Export boiler(s) data - export boiler and column data of selected boiler',
         boiler_list_filters_button_label_modbus_write_hover: 'Click the button to enable Boiler Write Mode on the selected boilers',
         boiler_list_filters_button_label_update_devices_hover: 'Update boiler firmware - update the Mercurius boiler firmware',
         boiler_list_filters_button_label_update_hiu_hover: 'Update Boiler HIU OTA - Trigger an OTA update for the selected HIU Boiler(s)',
         boiler_single_device_settings_title: 'Boiler instellingen',
         boiler_single_download_modbus_data: 'Export boiler data',
         boiler_single_error_detailed_message: 'Boiler is in "Storing" mode',
         boiler_single_firmware_hiu_label: 'Firmware boiler',
         boiler_single_offline_detailed_message: 'Boiler is "Offline"',
         boiler_single_online_detailed_message: 'Boiler is "Online", alles werkt prima',
         boiler_single_page_title: 'Boiler details',
         boiler_single_rss_device_status: 'Boiler status',
         boiler_single_temperature_title: 'De historische data van de boiler',
         boilers_bulk_delete_modal_note: '<strong>Note:</strong> <br/> Zodra je de verwijdering hebt uitgevoerd, kan dit niet meer ongedaan worden gemaakt, tenzij het IT-team de gegevens handmatig herstelt vanuit oude back-ups. Het herstellen van events en andere gerelateerde informatie kost veel tijd. Het verwijderen van warmtepompen duurt even vanwege de bovengenoemde gegevens. Wees geduldig en annuleer of vernieuw de pagina niet.',
         boilers_bulk_modbus_download_form_submit_button: 'Download Boilers data',
         boilers_bulk_modbus_download_title: 'Download Boilers Historical Data',
         boilers_bulk_selected_devices_title: 'Boilers Selected',
         boilers_filter_search: 'Search Boiler',
         boilers_form_additional_information_tab: 'Boiler Details',
         boilers_form_article_number_field: 'Artikelnummer boiler',
         boilers_form_box_serial_number_field: 'Serienummer boiler',
         boilers_form_description_field: 'Boiler type',
         boilers_form_device_information_tab: 'Boiler info',
         boilers_form_device_labels_field: 'Boiler Label',
         boilers_form_header: 'Boilers',
         boilers_form_name_field: 'Boiler naam',
         boilers_list_device_set_log_label: 'Warmtepomp Data log',
         boilers_no_record_found: 'Geen boilers gevonden',
         boilers_partner_article_number_field: 'Artikelnummer boiler van distributeur',
         boilers_partner_serial_number: 'Serienummer boiler van distributeur',
         boilers_single_bread_crumb_first_link: 'Boiler pagina',
         boilers_single_bread_crumb_main_title: 'Boiler overzicht',
         boilers_single_device_counters_title: 'Boiler Tellers',
         boilers_single_edit_device_button: 'Edit Boiler',
         modbus_v3_boiler_luna_mp_reg_386_label: 'Heating outdoor temperature upper limit',
         custom_popover_boiler_luna_mp_386_long_description: 'Heating outdoor temperature upper limit',
         modbus_v3_boiler_luna_mp_reg_387_label: 'Cooling neutral band',
         custom_popover_boiler_luna_mp_387_long_description: 'Cooling neutral band',
         modbus_v3_boiler_luna_mp_reg_388_label: 'Antifreeze activation temperature',
         custom_popover_boiler_luna_mp_388_long_description: 'Antifreeze activation temperature',
         modbus_v3_boiler_luna_mp_reg_389_label: 'Force summer mode',
         modbus_v3_boiler_luna_mp_reg_389_label_list: '{"list":{"0":"Off","1":"On"}}',
         custom_popover_boiler_luna_mp_389_long_description: 'Force summer mode',
         modbus_v3_boiler_luna_mp_reg_405_label: 'Domestic hot water internal setpoint',
         custom_popover_boiler_luna_mp_405_long_description: 'Domestic hot water internal setpoint',
         modbus_v3_boiler_luna_mp_reg_406_label: 'Central heating setpoint',
         custom_popover_boiler_luna_mp_406_long_description: 'Central heating setpoint',
         modbus_v3_boiler_luna_mp_reg_408_label: 'Domestic hot water flow temperature setpoint',
         custom_popover_boiler_luna_mp_408_long_description: 'Domestic hot water flow temperature setpoint',
         modbus_v3_boiler_luna_mp_reg_409_label: 'Water pressure',
         custom_popover_boiler_luna_mp_409_long_description: 'Water pressure',
         modbus_v3_boiler_luna_mp_reg_410_label: 'Flow rate',
         custom_popover_boiler_luna_mp_410_long_description: 'Flow rate',
         modbus_v3_boiler_luna_mp_reg_413_label: 'Actual relative power',
         custom_popover_boiler_luna_mp_413_long_description: 'Actual relative power',
         modbus_v3_boiler_luna_mp_reg_414_label: 'Power setpoint',
         custom_popover_boiler_luna_mp_414_long_description: 'Power setpoint',
         modbus_v3_boiler_luna_mp_reg_415_label: 'Flame current',
         custom_popover_boiler_luna_mp_415_long_description: 'Flame current',
         modbus_v3_boiler_luna_mp_reg_416_label: 'Internal heat demand power',
         custom_popover_boiler_luna_mp_416_long_description: 'Internal heat demand power',
         modbus_v3_boiler_luna_mp_reg_417_label: 'Internal heat demand temperature setpoint',
         custom_popover_boiler_luna_mp_417_long_description: 'Internal heat demand temperature setpoint',
         modbus_v3_boiler_luna_mp_reg_418_label: 'Internal heat demand type',
         custom_popover_boiler_luna_mp_418_long_description: 'Internal heat demand type',
         modbus_v3_boiler_luna_mp_reg_419_label: 'Burner/compressor starts',
         custom_popover_boiler_luna_mp_419_long_description: 'Burner/compressor starts',
         modbus_v3_boiler_luna_mp_reg_421_label: 'Burner operating hours',
         custom_popover_boiler_luna_mp_421_long_description: 'Burner operating hours',
         modbus_v3_boiler_luna_mp_reg_423_label: 'Backup 1 starts',
         custom_popover_boiler_luna_mp_423_long_description: 'Backup 1 starts',
         modbus_v3_boiler_luna_mp_reg_425_label: 'Backup 1 hours',
         custom_popover_boiler_luna_mp_425_long_description: 'Backup 1 hours',
         modbus_v3_boiler_luna_mp_reg_427_label: 'Backup 2 starts',
         custom_popover_boiler_luna_mp_427_long_description: 'Backup 2 starts',
         modbus_v3_boiler_luna_mp_reg_429_label: 'Backup 2 hours',
         custom_popover_boiler_luna_mp_429_long_description: 'Backup 2 hours',
         modbus_v3_boiler_luna_mp_reg_431_label: 'Operating hours',
         custom_popover_boiler_luna_mp_431_long_description: 'Operating hours',
         modbus_v3_boiler_luna_mp_reg_433_label: 'Central heating energy consumed',
         custom_popover_boiler_luna_mp_433_long_description: 'Central heating energy consumed',
         modbus_v3_boiler_luna_mp_reg_435_label: 'DHW energy consumed',
         custom_popover_boiler_luna_mp_435_long_description: 'DHW energy consumed',
         modbus_v3_boiler_luna_mp_reg_439_label: 'Total energy consumed',
         custom_popover_boiler_luna_mp_439_long_description: 'Total energy consumed',
         modbus_v3_boiler_luna_mp_reg_441_label: 'Backup energy consumed',
         custom_popover_boiler_luna_mp_441_long_description: 'Backup energy consumed',
         modbus_v3_boiler_luna_mp_reg_443_label: 'Total energy delivered',
         custom_popover_boiler_luna_mp_443_long_description: 'Total energy delivered',
         modbus_v3_boiler_luna_mp_reg_445_label: 'Central heating energy delivered',
         custom_popover_boiler_luna_mp_445_long_description: 'Central heating energy delivered',
         modbus_v3_boiler_luna_mp_reg_447_label: 'DHW energy delivered',
         custom_popover_boiler_luna_mp_447_long_description: 'DHW energy delivered',
         modbus_v3_boiler_luna_mp_reg_451_label: 'Backup energy delivered',
         custom_popover_boiler_luna_mp_451_long_description: 'Backup energy delivered',
         modbus_v3_boiler_luna_mp_reg_458_label: 'System flow setpoint',
         custom_popover_boiler_luna_mp_458_long_description: 'System flow setpoint',
         modbus_v3_boiler_luna_mp_reg_459_label: 'Pump speed',
         custom_popover_boiler_luna_mp_459_long_description: 'Pump speed',
         modbus_v3_boiler_luna_mp_reg_477_label: 'Minimum heating time before DHW production',
         custom_popover_boiler_luna_mp_477_long_description: 'Minimum heating time before DHW production',
         modbus_v3_boiler_luna_mp_reg_478_label: 'Maximum DHW production time',
         custom_popover_boiler_luna_mp_478_long_description: 'Maximum DHW production time',
         modbus_v3_boiler_luna_mp_reg_479_label: 'DHW ECO/COMFORT mode',
         modbus_v3_boiler_luna_mp_reg_479_label_list: '{"list":{"0":"Eco only - heat pump","1":"Comfort - heat pump/boiler"}}',
         custom_popover_boiler_luna_mp_479_long_description: 'DHW ECO/COMFORT mode',
         modbus_v3_boiler_luna_mp_reg_516_label: 'Burner starts since service',
         custom_popover_boiler_luna_mp_516_long_description: 'Burner starts since service',
         boiler_form_header: 'Boilers',
         substation_form_header: 'Substations',
         substation_add_form_header: 'Add substation',
         substation_add_new_button: 'Add new',
         substation_add_form_success: 'Substation imported successfully',
         substation_form_order_type_field: 'Order type',
         substation_device_name_characters_error: 'Device name should contain only capital alphabets and numbers.',
         substation_device_name_length_range_error: 'Device name length should be between 3 and 24 characters long.',
         substation_serial_number_mercurius_v3_length_error: 'Serial number mercurius length should be between 3 and 23 characters. It should contain only alphabets and numbers.',
         substation_serial_number_mercurius_identical_error: 'For V3 devices, the Serial Number Mercurius and Device Name must be identical.',
         substation_sim_card_number_v3_length_error: 'Sim card number length should be exactly 19 or 20 characters.',
         substation_production_date_format_error: 'Production date must be in format MM/DD/YYYY HH:mm:ss (e.g., 04/16/2021 13:39:00)',
         substation_default_soft_version_hex_error: 'Factory Default Software Version should be in hexadecimal.',
         substation_order_type_required_error: 'Order type is missing.',
         substation_order_type_invalid_error: 'Order type should be 1 or 2.',
         substation_form_order_type_general_option: 'General order in combination with HIU',
         substation_form_order_type_without_hiu_option: 'Order without HIU',
         substation_form_serial_number_mercurius_field: 'Serial number mercurius',
         substation_form_distinct_mercurius_type_field: 'Distinct mercurius type',
         substation_form_serial_number_field: 'Serial number',
         substation_form_production_date_field: 'Production date',
         substation_form_article_number_field: 'Article number',
         substation_form_description_field: 'Description',
         substation_form_order_number_field: 'Order number',
         substation_form_customer_ref_field: 'Customer reference',
         substation_form_prod_order_nr_field: 'Production order number',
         substation_form_sim_card_number_field: 'Sim card number',
         substation_form_default_controller_type_field: 'Default controller type',
         substation_form_default_soft_version_field: 'Default software version',
         substation_form_default_appliance_type_field: 'Default appliance type',
         substation_form_total_amount_order_field: 'Total amount order',
         substation_form_default_client_name_field: 'Default client name',
         substation_form_distributor_order_number_field: 'Distributor order number',
         substation_form_distributor_serial_number_field: 'Distributor serial number',
         substation_form_distributor_article_number_field: 'Distributor article number',
         substation_form_batch_number_field: 'Batch number',
         substation_form_is_stock_product_field: 'Is stock product',
         substation_device_name_required_error: 'Device name is missing.',
         substation_device_name_digits_error: 'Device name should only contain digits.',
         substation_device_name_length_error: 'Device name length should be exactly 5 characters.',
         substation_serial_number_mercurius_required_error: 'Serial number mercurius is missing.',
         substation_serial_number_mercurius_format_error: 'Serial number mercurius length should be exactly 24 characters. It should contain only alphabets and numbers.',
         substation_serial_number_required_error: 'Serial number is missing.',
         substation_serial_number_prefix_error: "Serial number should start with 'F' Letter.",
         substation_serial_number_alphanumeric_error: 'Serial number should contain only alphabets and numbers.',
         substation_sim_card_number_required_error: 'Sim card number is missing.',
         substation_sim_card_number_digits_error: 'Sim card number should only contain digits.',
         substation_sim_card_number_length_error: 'Sim card number length should be exactly 19 characters.',
         substation_article_number_required_error: 'Article number is missing.',
         substation_article_number_length_error: 'Article number length should be between 11 and 13 characters.',
         substation_order_number_required_error: 'Order number is missing.',
         substation_prod_order_nr_required_error: 'Production order number is missing.',
         substation_prod_order_nr_prefix_error: "Production order number should start with 'PR' Letters.",
         substation_prod_order_nr_characters_error: 'Production order number should contain only letters, numbers, dots, and dashes.',
         substation_prod_order_nr_length_error: 'Production order number length should be between 12 and 16 characters.',
         substation_production_date_required_error: 'Production date is missing.',
         substation_production_date_invalid_error: 'Invalid production date format.',
         substation_production_date_future_error: 'Production date cannot be in the future.',
         substation_import_failed_error: 'The substation could not be imported. Please review the errors below.',
         project_single_substations_tab: 'Substations',
         project_single_boilers_tab: 'Boilers',
         modbus_v3_substation_title: 'Substation',
         substation_alarms_reg_11100_label: 'Buiten acc. T',
         substation_alarms_reg_11161_label: 'Dauw punt T',
         substation_alarms_reg_11180_label: 'Gew. T comfort',
         substation_alarms_reg_11181_label: 'Gew. T bewaren',
         substation_alarms_reg_11201_label: 'S1 sensor',
         substation_alarms_reg_11215_label: 'Humidity',
         substation_alarms_reg_11501_label: 'Reference place',
         substation_alarms_reg_12180_label: 'Gew. T comfort',
         substation_alarms_reg_12181_label: 'Gew. T bewaren',
         substation_alarms_reg_12501_label: 'Reference place',
         substation_application_1_reg_11010_label: 'ECA addr.',
         substation_application_1_reg_11017_label: 'Demand offset',
         substation_application_1_reg_11022_label: 'P exercise',
         substation_application_1_reg_11023_label: 'M exercise',
         substation_application_1_reg_11040_label: 'P post-run',
         substation_application_1_reg_11077_label: 'P frost T',
         substation_application_1_reg_11078_label: 'P heat T',
         substation_application_1_reg_11093_label: 'Frost pr. T',
         substation_application_1_reg_11141_label: 'Ext. input',
         substation_application_1_reg_11142_label: 'Ext. mode',
         substation_application_1_reg_11179_label: 'Cut-out',
         substation_application_1_reg_11498_label: 'T out depend.',
         substation_application_1_reg_11500_label: 'Send desired T',
         substation_application_2_reg_12092_label: 'Standby T',
         substation_application_2_reg_12141_label: 'Ext. input',
         substation_application_2_reg_12142_label: 'Ext. mode',
         substation_application_2_reg_12144_label: 'Activation, acc. T',
         substation_application_2_reg_12156_label: 'Act. acc kamer T',
         substation_application_2_reg_12500_label: 'Send desired T',
         substation_circuit_1_heat_reg_11010_label: 'ECA adres',
         substation_circuit_1_heat_reg_11022_label: 'P exercise',
         substation_circuit_1_heat_reg_11023_label: 'M exercise',
         substation_circuit_1_heat_reg_11040_label: 'P post-run',
         substation_circuit_1_heat_reg_11077_label: 'P vorst T',
         substation_circuit_1_heat_reg_11078_label: 'P verwarming T',
         substation_circuit_1_heat_reg_11093_label: 'Vorst pr. T',
         substation_circuit_1_return_reg_11210_label: 'S10 sensor',
         substation_circuit_1_return_reg_11260_label: 'S10 Sensor reference',
         substation_circuit_1_room_reg_11031_label: 'Hoog T uit X1',
         substation_circuit_1_room_reg_11032_label: 'Grens laag Y1',
         substation_circuit_1_room_reg_11033_label: 'Laag T uit X2',
         substation_circuit_1_room_reg_11034_label: 'Grens hoog Y2',
         substation_circuit_1_room_reg_11035_label: 'Infl. - max.',
         substation_circuit_1_room_reg_11036_label: 'Infl. - min.',
         substation_circuit_1_room_reg_11037_label: 'Adapt. tijd',
         substation_circuit_1_supply_reg_11154_label: 'Filt. Acc. buiten T',
         substation_circuit_1_supply_reg_11175_label: 'Stooklijn',
         substation_circuit_1_supply_reg_11177_label: 'Temp. min.',
         substation_circuit_1_supply_reg_11178_label: 'Temp. max.',
         substation_circuit_1_supply_reg_11253_label: 'Gewenste flow T',
         substation_circuit_1_supply_reg_11400_label: 'Y1',
         substation_circuit_1_supply_reg_11401_label: 'Y2',
         substation_circuit_1_supply_reg_11402_label: 'Y3',
         substation_circuit_1_supply_reg_11403_label: 'Y4',
         substation_circuit_1_supply_reg_11404_label: 'Y5',
         substation_circuit_1_supply_reg_11405_label: 'Y6',
         substation_circuit_2_heat_reg_11038_label: 'Stop bij T uit',
         substation_circuit_2_heat_reg_11083_label: 'Add. funktie',
         substation_circuit_2_heat_reg_11089_label: 'Acc. uitg. funktie',
         substation_circuit_2_supply_reg_11141_label: 'Ext. ingang',
         substation_circuit_2_supply_reg_11142_label: 'Ext. mode',
         substation_circuit_2_supply_reg_11179_label: 'Cut-out',
         substation_circuit_2_supply_reg_11498_label: 'T out depend.',
         substation_circuit_2_supply_reg_11500_label: 'Zenden gew. T',
         substation_compensating1_2_reg_12060_label: 'Limit',
         substation_compensating1_2_reg_12061_label: 'Adapt. time',
         substation_compensating1_2_reg_12063_label: 'Infl. - min.',
         substation_compensating1_2_reg_12256_label: 'S6 Sensor reference',
         substation_control_parameter_1_reg_11024_label: 'Actuator',
         substation_control_parameter_1_reg_11174_label: 'Motor pr.',
         substation_control_parameter_1_reg_11184_label: 'Xp',
         substation_control_parameter_1_reg_11185_label: 'Tn',
         substation_control_parameter_1_reg_11186_label: 'M run',
         substation_control_parameter_1_reg_11187_label: 'Nz',
         substation_control_parameter_1_reg_11189_label: 'Min. act. time',
         substation_cooling_reg_10500_label: 'Min Outdoor Temp',
         substation_cooling_reg_10501_label: 'Min Hour Time',
         substation_cooling_reg_10502_label: 'Min Minute Time',
         substation_cooling_reg_10503_label: 'Cooling Reg 10503',
         substation_cooling_reg_10504_label: 'Cooling Reg 10504',
         substation_cooling_reg_10505_label: 'Max Outdoor Temp',
         substation_cooling_reg_10506_label: 'Max Hou Time',
         substation_cooling_reg_10507_label: 'Max Minute Time',
         substation_cooling_reg_10508_label: 'Cooling Reg 10508',
         substation_cooling_reg_10509_label: 'Cooling Reg 10509',
         substation_cooling_reg_10510_label: 'Outdoor Trend',
         substation_cooling_reg_10603_label: 'Digitaal S7',
         substation_cooling_reg_10643_label: 'Digitaal S9',
         substation_data_log_reg_10198_label: 'Autom. daglicht',
         substation_data_log_reg_10398_label: 'Scada heatoffset/setpoint',
         substation_data_log_reg_10399_label: 'Scada Timeout',
         substation_data_log_reg_10400_label: 'Scada Outdoor temperature',
         substation_data_log_reg_10401_label: 'Scada heat offset 1',
         substation_data_log_reg_10402_label: 'Scada heat offset 2',
         substation_data_log_reg_10403_label: 'Scada heat offset 3',
         substation_data_log_reg_10404_label: 'Scada heat offset 4',
         substation_data_log_reg_10409_label: 'SCADA slave request',
         substation_data_log_reg_10410_label: 'SCADA resulting reference',
         substation_data_log_reg_10420_label: 'Scada Schedule timeout',
         substation_data_log_reg_2048_label: 'ECL 485 addr.',
         substation_data_log_reg_2049_label: 'Modbus bias',
         substation_data_log_reg_2050_label: 'Taal',
         substation_data_log_reg_2150_label: 'Service pin',
         substation_data_log_reg_2151_label: 'Ext. reset',
         substation_data_log_reg_2152_label: 'Inbound accept',
         substation_data_log_reg_2153_label: 'Portal encryption',
         substation_data_log_reg_2160_label: 'ECL Portal',
         substation_data_log_reg_2161_label: 'Connectie status',
         substation_data_log_reg_2162_label: 'Poort status',
         substation_data_log_reg_2240_label: 'DNS IP1 1',
         substation_data_log_reg_2244_label: 'DNS IP2 1',
         substation_data_log_reg_258_label: 'Adres type',
         substation_data_log_reg_278_label: 'IP 1',
         substation_data_log_reg_282_label: 'Poort IP 1',
         substation_data_log_reg_286_label: 'Net Mask 1',
         substation_data_log_reg_38_label: 'Modbus adres',
         substation_data_log_reg_39_label: 'Baud',
         substation_data_log_reg_4236_label: 'AccumulatedPulse 1',
         substation_data_log_reg_4238_label: 'AccumulatedPulse 2',
         substation_data_log_reg_4240_label: 'AccumulatedPulse 3',
         substation_data_log_reg_5994_label: 'GW Command request',
         substation_data_log_reg_5995_label: 'GW State',
         substation_data_log_reg_5996_label: 'GW Telegram size',
         substation_data_log_reg_5997_label: 'Baud',
         substation_data_log_reg_5998_label: 'Commando',
         substation_data_log_reg_5999_label: 'Status',
         substation_data_log_reg_60058_label: 'Achtergrond licht',
         substation_data_log_reg_60059_label: 'Contrast',
         substation_dhw_reg_11158_label: 'Stat. luchtv. Diff',
         substation_dhw_reg_11159_label: 'St. luchtv. post T',
         substation_dhw_reg_11160_label: 'Stat. luchtv. Setp.',
         substation_dhw_settings_reg_12164_label: 'Dauw p. T offset',
         substation_dhw_settings_reg_12172_label: 'Koellijn',
         substation_dhw_settings_reg_12177_label: 'Temp. min.',
         substation_dhw_settings_reg_12178_label: 'Temp. max.',
         substation_ecl_alarm_reg_1024_label: 'Alarm field 2',
         substation_ecl_alarm_reg_1025_label: 'Alarm field 1',
         substation_ecl_alarm_reg_1032_label: 'Alarm clear 2',
         substation_ecl_alarm_reg_1033_label: 'Alarm clear 1',
         substation_ecl_alarm_reg_2052_label: 'Sensor monitor valid mask1',
         substation_ecl_alarm_reg_2054_label: 'Sensor monitor error mask1',
         substation_ecl_extension_reg_2150_label: 'Service pin',
         substation_ecl_extension_reg_2151_label: 'Ext. reset',
         substation_ecl_system_ex_reg_4236_label: 'AccumulatedPulse 1',
         substation_ecl_system_ex_reg_4238_label: 'AccumulatedPulse 2',
         substation_ecl_system_ex_reg_4240_label: 'AccumulatedPulse 3',
         substation_ecl_system_reg_10198_label: 'Aut. daylight',
         substation_ecl_system_reg_19_label: 'Code no.',
         substation_ecl_system_reg_1_label: 'System Command',
         substation_ecl_system_reg_2048_label: 'ECL 485 addr.',
         substation_ecl_system_reg_2049_label: 'Modbus bias.',
         substation_ecl_system_reg_2050_label: 'Language',
         substation_ecl_system_reg_2097_label: 'Wink',
         substation_ecl_system_reg_2099_label: 'Production week',
         substation_ecl_system_reg_34_label: 'Hardware',
         substation_ecl_system_reg_35_label: 'Software',
         substation_ecl_system_reg_36_label: 'Serial no.',
         substation_ecl_system_reg_38_label: 'Modbus addr.',
         substation_ecl_system_reg_39_label: 'Baud',
         substation_ecl_system_reg_60058_label: 'Backlight',
         substation_ecl_system_reg_60059_label: 'Contrast',
         substation_ecl_system_reg_8_label: 'Build no.',
         substation_ethernet_reg_2152_label: 'Inbound accept',
         substation_ethernet_reg_2153_label: 'Portal encryption',
         substation_ethernet_reg_2160_label: 'ECL Portal',
         substation_ethernet_reg_2161_label: 'Connection status',
         substation_ethernet_reg_2162_label: 'Portal status',
         substation_ethernet_reg_2240_label: 'DNS IP1 1',
         substation_ethernet_reg_2244_label: 'DNS IP2 1',
         substation_ethernet_reg_258_label: 'Address type',
         substation_ethernet_reg_278_label: 'IP 1',
         substation_ethernet_reg_282_label: 'Gateway IP 1',
         substation_ethernet_reg_286_label: 'Net Mask 1',
         substation_flow_temperature_1_reg_11154_label: 'Filt. acc. outdoor T',
         substation_flow_temperature_1_reg_11175_label: 'Heat curve',
         substation_flow_temperature_1_reg_11177_label: 'Temp. min.',
         substation_flow_temperature_1_reg_11178_label: 'Temp. max.',
         substation_flow_temperature_1_reg_11253_label: 'Des. flow T',
         substation_flow_temperature_1_reg_11400_label: 'Y1',
         substation_flow_temperature_1_reg_11401_label: 'Y2',
         substation_flow_temperature_1_reg_11402_label: 'Y3',
         substation_flow_temperature_1_reg_11403_label: 'Y4',
         substation_flow_temperature_1_reg_11404_label: 'Y5',
         substation_flow_temperature_1_reg_11405_label: 'Y6',
         substation_flow_temperature_2_reg_12164_label: 'Dew point T offset',
         substation_flow_temperature_2_reg_12172_label: 'Cooling curve',
         substation_flow_temperature_2_reg_12177_label: 'Temp. min.',
         substation_flow_temperature_2_reg_12178_label: 'Temp. max.',
         substation_flow_temperature_2_reg_12253_label: 'Des. flow T',
         substation_flow_temperature_2_reg_12400_label: 'Y1',
         substation_flow_temperature_2_reg_12401_label: 'Y2',
         substation_flow_temperature_2_reg_12402_label: 'Y3',
         substation_flow_temperature_2_reg_12403_label: 'Y4',
         substation_flow_temperature_2_reg_12404_label: 'Y5',
         substation_flow_temperature_2_reg_12405_label: 'Y6',
         substation_general_1_reg_10500_label: 'Min Outdoor Temp',
         substation_general_1_reg_10501_label: 'Min Hour Time',
         substation_general_1_reg_10502_label: 'Min Minute Time',
         substation_general_1_reg_10505_label: 'Max Outdoor Temp',
         substation_general_1_reg_10506_label: 'Max Hou Time',
         substation_general_1_reg_10507_label: 'Max Minute Time',
         substation_general_1_reg_10510_label: 'Outdoor Trend',
         substation_general_1_reg_10603_label: 'Digital S7',
         substation_general_1_reg_10643_label: 'Digital S9',
         substation_general_1_reg_11100_label: 'Outdoor acc. T',
         substation_general_1_reg_11161_label: 'Dew point T',
         substation_general_1_reg_11180_label: 'Des. T comfort',
         substation_general_1_reg_11181_label: 'Des. T saving',
         substation_general_1_reg_11201_label: 'S1 sensor',
         substation_general_1_reg_11330_label: 'Wake up level',
         substation_general_1_reg_11215_label: 'Humidity',
         substation_general_1_reg_11501_label: 'Reference place',
         substation_general_1_reg_4201_label: 'Mode',
         substation_general_1_reg_4211_label: 'Circuit 1 status',
         substation_general_1_reg_4220_label: 'Circuit 1 limiter flags 1',
         substation_general_1_reg_4221_label: 'Circuit 1 limiter flags 2',
         substation_general_1_reg_4222_label: 'Circuit 1 limiter flags 3',
         substation_general_1_reg_4223_label: 'Circuit 1 limiter flags 4',
         substation_general_2_reg_12180_label: 'Des. T comfort',
         substation_general_2_reg_12181_label: 'Des. T saving',
         substation_general_2_reg_12501_label: 'Reference place',
         substation_general_2_reg_4202_label: 'Mode',
         substation_general_2_reg_4212_label: 'Circuit 2 status',
         substation_general_2_reg_4224_label: 'Circuit 2 limiter flags 1',
         substation_general_5_reg_4215_label: 'Circuit 5 status',
         substation_general_5_reg_4246_label: 'Circuit 5 limiter flags 1',
         substation_general_5_reg_4247_label: 'Circuit 5 limiter flags 2',
         substation_general_5_reg_4248_label: 'Circuit 5 limiter flags 3',
         substation_general_5_reg_4249_label: 'Circuit 5 limiter flags 4',
         substation_general_6_reg_4216_label: 'Circuit 6 status',
         substation_general_6_reg_4250_label: 'Circuit 6 limiter flags 1',
         substation_general_6_reg_4251_label: 'Circuit 6 limiter flags 2',
         substation_general_6_reg_4252_label: 'Circuit 6 limiter flags 3',
         substation_general_6_reg_4253_label: 'Circuit 6 limiter flags 4',
         substation_io_test_reg_10201_label: 'S1 sensor',
         substation_io_test_reg_10202_label: 'S2 sensor',
         substation_io_test_reg_10203_label: 'S3 sensor',
         substation_io_test_reg_10204_label: 'S4 sensor',
         substation_io_test_reg_10205_label: 'S5 sensor',
         substation_io_test_reg_10206_label: 'S6 sensor',
         substation_io_test_reg_10207_label: 'S7 sensor',
         substation_io_test_reg_10208_label: 'S8 sensor',
         substation_io_test_reg_10209_label: 'S9 sensor',
         substation_io_test_reg_10210_label: 'S10 sensor',
         substation_io_test_reg_10211_label: 'S11 sensor',
         substation_io_test_reg_10212_label: 'S12 sensor',
         substation_io_test_reg_10213_label: 'Room Unit A, Sensor 1',
         substation_io_test_reg_10216_label: 'Room Unit B, Sensor 1',
         substation_m_bus_config_reg_5994_label: 'GW Command request',
         substation_m_bus_config_reg_5995_label: 'GW State',
         substation_m_bus_config_reg_5996_label: 'GW Telegram size',
         substation_m_bus_config_reg_5997_label: 'Baud',
         substation_m_bus_config_reg_5998_label: 'Command',
         substation_m_bus_config_reg_5999_label: 'State',
         substation_network_reg_12060_label: 'Grens',
         substation_network_reg_12061_label: 'Adapt. tijd',
         substation_network_reg_12063_label: 'Infl. - min.',
         substation_network_reg_12256_label: 'S6 Sensor reference',
         substation_optimization_1_reg_11011_label: 'Auto saving',
         substation_optimization_1_reg_11012_label: 'Boost',
         substation_optimization_1_reg_11014_label: 'Optimizer',
         substation_optimization_1_reg_11020_label: 'Based on',
         substation_optimization_1_reg_11021_label: 'Total stop',
         substation_optimization_1_reg_11026_label: 'Pre-stop',
         substation_outdoor_reg_11011_label: 'Autom. opslaan',
         substation_outdoor_reg_11012_label: 'Boost',
         substation_outdoor_reg_11014_label: 'Optimalisatie',
         substation_outdoor_reg_11020_label: 'Gebaseerd op',
         substation_outdoor_reg_11021_label: 'Totale stop',
         substation_outdoor_reg_11026_label: 'Pre-stop',
         substation_output_control_1_reg_11038_label: 'Stop at T out',
         substation_output_control_1_reg_11083_label: 'Add. function',
         substation_output_control_1_reg_11089_label: 'Acc. output function',
         substation_output_control_1_reg_11158_label: 'Stat. ventilation diff.',
         substation_output_control_1_reg_11159_label: 'Stat. ventilation post-run',
         substation_output_control_1_reg_11160_label: 'Stat. ventilation setp.',
         substation_output_status_reg_3995_label: 'Estimated Motor Position 1',
         substation_output_status_reg_3996_label: 'Estimated Motor Position 2',
         substation_output_status_reg_3997_label: 'Estimated Motor Position 3',
         substation_output_status_reg_4000_label: 'Triac 1',
         substation_output_status_reg_4001_label: 'Triac 2',
         substation_output_status_reg_4002_label: 'Triac 3',
         substation_output_status_reg_4003_label: 'Triac 4',
         substation_output_status_reg_4004_label: 'Triac 5',
         substation_output_status_reg_4005_label: 'Triac 6',
         substation_output_status_reg_4006_label: 'Relay 1',
         substation_output_status_reg_4007_label: 'Relay 2',
         substation_output_status_reg_4008_label: 'Relay 3',
         substation_output_status_reg_4009_label: 'Relay 4',
         substation_output_status_reg_4010_label: 'Relay 5',
         substation_output_status_reg_4011_label: 'Relay 6',
         substation_output_status_reg_4019_label: 'ECA35 PWM4',
         substation_outputs_reg_4201_label: 'Mode',
         substation_outputs_reg_4202_label: 'Mode',
         substation_outputs_reg_4211_label: 'Circuit 1 status',
         substation_outputs_reg_4212_label: 'Circuit 2 status',
         substation_outputs_reg_4220_label: 'Circuit 1 limiter flags 1',
         substation_outputs_reg_4221_label: 'Circuit 1 limiter flags 2',
         substation_outputs_reg_4222_label: 'Circuit 1 limiter flags 3',
         substation_outputs_reg_4223_label: 'Circuit 1 limiter flags 4',
         substation_outputs_reg_4224_label: 'Circuit 2 limiter flags 1',
         substation_raw_sensor_reg_10201_label: 'S1 sensor',
         substation_raw_sensor_reg_10202_label: 'S2 sensor',
         substation_raw_sensor_reg_10203_label: 'S3 sensor',
         substation_raw_sensor_reg_10204_label: 'S4 sensor',
         substation_raw_sensor_reg_10205_label: 'S5 sensor',
         substation_raw_sensor_reg_10206_label: 'S6 sensor',
         substation_raw_sensor_reg_10207_label: 'S7 sensor',
         substation_raw_sensor_reg_10208_label: 'S8 sensor',
         substation_raw_sensor_reg_10209_label: 'S9 sensor',
         substation_raw_sensor_reg_10210_label: 'S10 sensor',
         substation_raw_sensor_reg_10211_label: 'S11 sensor',
         substation_raw_sensor_reg_10212_label: 'S12 sensor',
         substation_raw_sensor_reg_10213_label: 'Room Unit A, Sensor 1',
         substation_raw_sensor_reg_10216_label: 'Room Unit B, Sensor 1',
         substation_return_limit_1_reg_11031_label: 'High T out X1',
         substation_return_limit_1_reg_11032_label: 'Low limit Y1',
         substation_return_limit_1_reg_11033_label: 'Low T out X2',
         substation_return_limit_1_reg_11034_label: 'High limit Y2',
         substation_return_limit_1_reg_11035_label: 'Infl. - max.',
         substation_return_limit_1_reg_11036_label: 'Infl. - min.',
         substation_return_limit_1_reg_11037_label: 'Adapt. time',
         substation_return_limit_1_reg_11210_label: 'S10 sensor',
         substation_return_limit_1_reg_11260_label: 'S10 Sensor reference',
         substation_return_limit_2_reg_12030_label: 'Limit',
         substation_return_limit_2_reg_12035_label: 'Infl. - max.',
         substation_return_limit_2_reg_12036_label: 'Infl. - min.',
         substation_return_limit_2_reg_12037_label: 'Adapt. time',
         substation_return_limit_2_reg_12210_label: 'S10 sensor',
         substation_return_limit_2_reg_12260_label: 'S10 Sensor reference',
         substation_scada_override_reg_10398_label: 'Scada heatoffset/setpoint',
         substation_scada_override_reg_10399_label: 'Scada Timeout',
         substation_scada_override_reg_10400_label: 'Scada Outdoor temperature',
         substation_scada_override_reg_10401_label: 'Scada heat offset 1',
         substation_scada_override_reg_10402_label: 'Scada heat offset 2',
         substation_scada_override_reg_10403_label: 'Scada heat offset 3',
         substation_scada_override_reg_10404_label: 'Scada heat offset 4',
         substation_scada_override_reg_10405_label: 'Scada boiler ctrl 1',
         substation_scada_override_reg_10406_label: 'Scada boiler ctrl 2',
         substation_scada_override_reg_10407_label: 'Scada boiler ctrl 3',
         substation_scada_override_reg_10408_label: 'Scada boiler ctrl 4',
         substation_scada_override_reg_10409_label: 'SCADA slave request',
         substation_scada_override_reg_10410_label: 'SCADA resulting reference',
         substation_scada_override_reg_10420_label: 'Scada Schedule timeout',
         substation_scada_override_reg_10421_label: 'Scada Schedule 1',
         substation_scada_override_reg_10422_label: 'Scada Schedule 2',
         substation_scada_override_reg_10423_label: 'Scada Schedule 3',
         substation_scada_override_reg_10424_label: 'Scada Schedule 4',
         substation_scada_override_reg_10425_label: 'Scada Schedule 5',
         substation_scada_override_reg_10426_label: 'Scada Schedule 6',
         substation_scada_override_reg_10427_label: 'Scada Optim value 1',
         substation_scada_override_reg_10428_label: 'Scada Optim value 2',
         substation_scada_override_reg_10429_label: 'Scada Optim value 3',
         substation_scada_override_reg_10430_label: 'Scada Optim value 4',
         substation_scada_override_reg_10431_label: 'Scada Optim value 5',
         substation_scada_override_reg_10432_label: 'Scada Optim value 6',
         substation_sensors_reg_11024_label: 'Aandrijving',
         substation_sensors_reg_11174_label: 'Motor pr.',
         substation_sensors_reg_11184_label: 'Xp',
         substation_sensors_reg_11185_label: 'Tn',
         substation_sensors_reg_11186_label: 'M run',
         substation_sensors_reg_11187_label: 'Nz',
         substation_sensors_reg_11189_label: 'Min. act. tijd',
         substation_statistics_reg_4215_label: 'Circuit 5 status',
         substation_statistics_reg_4216_label: 'Circuit 6 status',
         substation_statistics_reg_4246_label: 'Circuit 5 limiter flags 1',
         substation_statistics_reg_4247_label: 'Circuit 5 limiter flags 2',
         substation_statistics_reg_4248_label: 'Circuit 5 limiter flags 3',
         substation_statistics_reg_4249_label: 'Circuit 5 limiter flags 4',
         substation_statistics_reg_4250_label: 'Circuit 6 limiter flags 1',
         substation_statistics_reg_4251_label: 'Circuit 6 limiter flags 2',
         substation_statistics_reg_4252_label: 'Circuit 6 limiter flags 3',
         substation_statistics_reg_4253_label: 'Circuit 6 limiter flags 4',
         substation_system_info_reg_1024_label: 'Alarm field 2',
         substation_system_info_reg_1025_label: 'Alarm field 1',
         substation_system_info_reg_1032_label: 'Alarm clear 2',
         substation_system_info_reg_1033_label: 'Alarm clear 1',
         substation_system_info_reg_2052_label: 'Sensor monitor valid mask1',
         substation_system_info_reg_2054_label: 'Sensor monitor error mask1',
         substation_system_reg_12253_label: 'Gewenste flow T',
         substation_system_reg_12400_label: 'Y1',
         substation_system_reg_12401_label: 'Y2',
         substation_system_reg_12402_label: 'Y3',
         substation_system_reg_12403_label: 'Y4',
         substation_system_reg_12404_label: 'Y5',
         substation_system_reg_12405_label: 'Y6',
         substation_temp_monitoring_1_reg_12092_label: 'Standby T',
         substation_temp_monitoring_1_reg_12141_label: 'Ext. ingang',
         substation_temp_monitoring_1_reg_12142_label: 'Ext. mode',
         substation_temp_monitoring_1_reg_12144_label: 'Activation, acc. T',
         substation_temp_monitoring_1_reg_12156_label: 'Act. acc kamer T',
         substation_temp_monitoring_1_reg_12500_label: 'Zenden gew. T',
         substation_temp_monitoring_2_reg_12147_label: 'Upper difference',
         substation_temp_monitoring_2_reg_12148_label: 'Lower difference',
         substation_temp_monitoring_2_reg_12149_label: 'Delay',
         substation_temp_monitoring_2_reg_12150_label: 'Lowest temp.',
         substation_time_program_reg_3995_label: 'Estimated Motor Position 1',
         substation_time_program_reg_3996_label: 'Estimated Motor Position 2',
         substation_time_program_reg_3997_label: 'Estimated Motor Position 3',
         substation_time_program_reg_4000_label: 'Triac 1',
         substation_time_program_reg_4001_label: 'Triac 2',
         substation_time_program_reg_4002_label: 'Triac 3',
         substation_time_program_reg_4003_label: 'Triac 4',
         substation_time_program_reg_4004_label: 'Triac 5',
         substation_time_program_reg_4005_label: 'Triac 6',
         substation_time_program_reg_4006_label: 'Relay 1',
         substation_time_program_reg_4007_label: 'Relay 2',
         substation_time_program_reg_4008_label: 'Relay 3',
         substation_time_program_reg_4009_label: 'Relay 4',
         substation_time_program_reg_4010_label: 'Relay 5',
         substation_time_program_reg_4011_label: 'Relay 6',
         substation_time_program_reg_4019_label: 'ECA35 PWM4',
         substation_user_params_reg_12030_label: 'Grens',
         substation_user_params_reg_12035_label: 'Infl. - max.',
         substation_user_params_reg_12036_label: 'Infl. - min.',
         substation_user_params_reg_12037_label: 'Adapt. tijd',
         substation_user_params_reg_12210_label: 'S10 sensor',
         substation_user_params_reg_12260_label: 'S10 Sensor reference',
         substation_user_params_reg_19_label: 'Code nr.',
         substation_user_params_reg_1_label: 'System Command',
         substation_user_params_reg_2099_label: 'Productie week',
         substation_user_params_reg_34_label: 'Hardware',
         substation_user_params_reg_35_label: 'Software',
         substation_user_params_reg_36_label: 'Serie nr.',
         substation_user_params_reg_8_label: 'Prod nr.',
         substation_general_1_reg_4201_label_list: JSON.stringify({
           list: {
             0: 'Manual',
             1: 'Schedule',
             2: 'Constant comfort',
             3: 'Constant setback',
             4: 'Frost protection',
           },
         }),
         substation_general_1_reg_4211_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_2_reg_4202_label_list: JSON.stringify({
           list: {
             0: 'Manual',
             1: 'Schedule',
             2: 'Constant comfort',
             3: 'Constant setback',
             4: 'Frost protection',
           },
         }),
         substation_general_2_reg_4212_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_5_reg_4215_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_6_reg_4216_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_input_config_reg_4100_label: 'Config type S7',
         substation_input_config_reg_4100_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4101_label: 'Config type S8',
         substation_input_config_reg_4101_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
             4: 'Flow switch',
           },
         }),
         substation_input_config_reg_4102_label: 'Config type S9',
         substation_input_config_reg_4102_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4103_label: 'Config type S10',
         substation_input_config_reg_4103_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4104_label: 'Config type S11',
         substation_input_config_reg_4104_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4105_label: 'Config type S12',
         substation_input_config_reg_4105_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4120_label: 'Config option S7',
         substation_input_config_reg_4120_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4121_label: 'Config option S8',
         substation_input_config_reg_4121_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4122_label: 'Config option S9',
         substation_input_config_reg_4122_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4123_label: 'Config option S10',
         substation_input_config_reg_4123_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4124_label: 'Config option S11',
         substation_input_config_reg_4124_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4125_label: 'Config option S12',
         substation_alarm1_1_reg_11614_label: 'Alarm high',
         substation_alarm1_1_reg_11615_label: 'Alarm low',
         substation_alarm1_1_reg_11617_label: 'Alarm time-out',
         substation_application_1_reg_11024_label: 'Actuator',
         substation_application_1_reg_11050_label: 'P demand',
         substation_application_1_reg_11052_label: 'DHW priority',
         substation_application_1_reg_11070_label: 'P cool T',
         substation_application_1_reg_11084_label: 'Ext. signal',
         substation_application_1_reg_11092_label: 'Standby T',
         substation_application_1_reg_11327_label: 'Input type',
         substation_compensating1_1_reg_11060_label: 'Limit',
         substation_compensating1_1_reg_11061_label: 'Adapt. time',
         substation_compensating1_1_reg_11062_label: 'Infl. - max.',
         substation_compensating1_1_reg_11063_label: 'Infl. - min.',
         substation_compensating2_1_reg_11064_label: 'Limit',
         substation_compensating2_1_reg_11065_label: 'Adapt. time',
         substation_compensating2_1_reg_11066_label: 'Infl. - max.',
         substation_compensating2_1_reg_11067_label: 'Infl. - min.',
         substation_control_parameter_1_reg_11017_label: 'Demand offset',
         substation_control_parameter_1_reg_11097_label: 'Supply T (idle)',
         substation_control_parameter_1_reg_11145_label: 'Mon. T select',
         substation_control_parameter_1_reg_11330_label: 'Wake up level',
         substation_control_parameter_1_reg_11364_label: 'Control, delay',
         substation_control_parameter_1_reg_11700_label: 'Await time',
         substation_control_parameter_2_reg_12165_label: 'V out max.',
         substation_control_parameter_2_reg_12167_label: 'V out min.',
         substation_control_parameter_2_reg_12184_label: 'Xp',
         substation_control_parameter_2_reg_12185_label: 'Tn',
         substation_control_parameter_2_reg_12187_label: 'Nz',
         substation_control_parameter_2_reg_12197_label: 'Td',
         substation_control_parameter_2_reg_12322_label: 'Pressure, diff.',
         substation_control_parameter_5_reg_15113_label: 'Filter constant',
         substation_control_parameter_5_reg_15352_label: 'Position',
         substation_control_parameter_5_reg_15607_label: 'Low X',
         substation_control_parameter_5_reg_15608_label: 'High X',
         substation_control_parameter_5_reg_15609_label: 'Low Y',
         substation_control_parameter_5_reg_15610_label: 'High Y',
         substation_energy_meter_1_reg_6000_label: 'M-bus address',
         substation_energy_meter_1_reg_6001_label: 'Type',
         substation_energy_meter_1_reg_6002_label: 'Scan time',
         substation_energy_meter_1_reg_6003_label: 'ID',
         substation_energy_meter_1_reg_6005_label: 'Meter Status',
         substation_energy_meter_1_reg_6006_label: 'Flow T',
         substation_energy_meter_1_reg_6007_label: 'Return T',
         substation_energy_meter_1_reg_6008_label: 'Flow',
         substation_energy_meter_1_reg_6010_label: 'Power',
         substation_energy_meter_1_reg_6012_label: 'Volume',
         substation_energy_meter_1_reg_6014_label: 'Energy',
         substation_energy_meter_1_reg_6016_label: 'Flow MAX',
         substation_energy_meter_1_reg_6018_label: 'Power MAX',
         substation_energy_meter_1_reg_6020_label: 'Flow T MAX',
         substation_energy_meter_1_reg_6021_label: 'Return T MAX',
         substation_energy_meter_1_reg_6022_label: 'Energy Storage',
         substation_ethernet_reg_2165_label: 'Server name, char 1',
         substation_ethernet_reg_2230_label: 'Password, char 1',
         substation_flow_power_limit_1_reg_11109_label: 'Input type',
         substation_flow_power_limit_1_reg_11110_label: 'Actual',
         substation_flow_power_limit_1_reg_11111_label: 'Limit',
         substation_flow_power_limit_1_reg_11112_label: 'Adapt. time',
         substation_flow_power_limit_1_reg_11113_label: 'Filter constant',
         substation_flow_power_limit_1_reg_11115_label: 'Units',
         substation_flow_power_limit_1_reg_11116_label: 'High limit Y2',
         substation_flow_power_limit_1_reg_11117_label: 'Low limit Y1',
         substation_flow_power_limit_1_reg_11118_label: 'Low T out X2',
         substation_flow_power_limit_1_reg_11119_label: 'High T out X1',
         substation_flow_temperature_1_reg_11004_label: 'Desired T',
         substation_flow_temperature_1_reg_11079_label: 'Max. flow T',
         substation_flow_temperature_1_reg_11080_label: 'Delay',
         substation_flow_temperature_1_reg_11101_label: 'Ext. desired T',
         substation_flow_temperature_1_reg_11297_label: 'Temperature reference',
         substation_flow_temperature_1_reg_11301_label: 'High T max Y2',
         substation_flow_temperature_1_reg_11303_label: 'Low T max Y1',
         substation_flow_temperature_1_reg_11609_label: 'Low Y',
         substation_flow_temperature_1_reg_11610_label: 'High Y',
         substation_general_1_reg_11018_label: 'Des. T comfort',
         substation_general_1_reg_11019_label: 'Des. T saving',
         substation_general_1_reg_11040_label: 'P post-run',
         substation_general_1_reg_11203_label: 'S3 Sensor',
         substation_general_1_reg_11204_label: 'S4 Sensor',
         substation_general_1_reg_11205_label: 'S5 Sensor',
         substation_general_1_reg_11247_label: 'Selected temperature',
         substation_general_1_reg_11331_label: 'Sleep level',
         substation_general_1_reg_11332_label: 'Sleep mode time',
         substation_general_1_reg_11333_label: 'Boost',
         substation_general_3_reg_4213_label: 'Circuit 3 status',
         substation_general_4_reg_4214_label: 'Circuit 4 status',
         substation_input_config_reg_4106_label: 'ECA 32 Config type S13',
         substation_input_config_reg_4107_label: 'ECA 32 Config type S14',
         substation_input_config_reg_4108_label: 'ECA 32 Config type S15',
         substation_input_config_reg_4109_label: 'ECA 32 Config type S16',
         substation_input_config_reg_4110_label: 'ECA 32 Config type S17',
         substation_input_config_reg_4111_label: 'ECA 32 Config type S18',
         substation_input_config_reg_4126_label: 'ECA 32 Config option S13',
         substation_input_config_reg_4127_label: 'ECA 32 Config option S14',
         substation_input_config_reg_4128_label: 'ECA 32 Config option S15',
         substation_input_config_reg_4129_label: 'ECA 32 Config option S16',
         substation_input_config_reg_4130_label: 'ECA 32 Config option S17',
         substation_input_config_reg_4131_label: 'ECA 32 Config option S18',
         substation_optimization_1_reg_11013_label: 'Ramp',
         substation_optimization_1_reg_11179_label: 'Summer, cut-out',
         substation_optimization_1_reg_11392_label: 'Sum. start, month',
         substation_optimization_1_reg_11393_label: 'Sum. start, day',
         substation_optimization_1_reg_11395_label: 'Summer, filter',
         substation_optimization_1_reg_11396_label: 'Win. start, month',
         substation_optimization_1_reg_11397_label: 'Winter start, day',
         substation_optimization_1_reg_11398_label: 'Winter, cut-out',
         substation_optimization_1_reg_11399_label: 'Winter, filter',
         substation_output_manual_status_reg_4056_label: 'ECA32 AO1 Value',
         substation_output_manual_status_reg_4057_label: 'ECA32 AO2 Value',
         substation_output_manual_status_reg_4058_label: 'ECA32 AO3 Value',
         substation_output_status_reg_4012_label: 'ECA32 Relay 1',
         substation_output_status_reg_4013_label: 'ECA32 Relay 2',
         substation_output_status_reg_4014_label: 'ECA32 Relay 3',
         substation_output_status_reg_4015_label: 'ECA32 Relay 4',
         substation_output_status_reg_4016_label: 'ECA32 AO1',
         substation_output_status_reg_4017_label: 'ECA32 AO2',
         substation_output_status_reg_4018_label: 'ECA32 AO3',
         substation_pressure1_reg_11600_label: 'Pressure',
         substation_pressure1_reg_11607_label: 'Low X',
         substation_pressure1_reg_11608_label: 'High X',
         substation_pressure1_reg_11609_label: 'Low Y',
         substation_pressure1_reg_11610_label: 'High Y',
         substation_pressure1_reg_11620_label: 'Pressure',
         substation_pressure1_reg_11629_label: 'Low Y',
         substation_pressure1_reg_11630_label: 'High Y',
         substation_pressure1_reg_17113_label: 'Filter constant',
         substation_pressure2_reg_14113_label: 'Filter constant',
         substation_pressure2_reg_14600_label: 'Pressure',
         substation_pressure2_reg_14607_label: 'Low X',
         substation_pressure2_reg_14608_label: 'High X',
         substation_pressure2_reg_14609_label: 'Low Y',
         substation_pressure2_reg_14610_label: 'High Y',
         substation_pressure3_reg_12113_label: 'Filter constant',
         substation_pressure3_reg_12600_label: 'Pressure',
         substation_pressure3_reg_12607_label: 'Low X',
         substation_pressure3_reg_12608_label: 'High X',
         substation_pressure3_reg_12609_label: 'Low Y',
         substation_pressure3_reg_12610_label: 'High Y',
         substation_pressure4_reg_13113_label: 'Filter constant',
         substation_pressure4_reg_13600_label: 'Pressure',
         substation_pressure4_reg_13607_label: 'Low X',
         substation_pressure4_reg_13608_label: 'High X',
         substation_pressure4_reg_13609_label: 'Low Y',
         substation_pressure4_reg_13610_label: 'High Y',
         substation_raw_sensor_reg_10219_label: 'ECA32 Sensor 13',
         substation_raw_sensor_reg_10220_label: 'ECA32 Sensor 14',
         substation_raw_sensor_reg_10221_label: 'ECA32 Sensor 15',
         substation_raw_sensor_reg_10222_label: 'ECA32 Sensor 16',
         substation_raw_sensor_reg_10223_label: 'ECA32 Sensor 17 PF',
         substation_raw_sensor_reg_10224_label: 'ECA32 Sensor 18 PF',
         substation_return_limit_1_reg_11028_label: 'Con. T, ret. T lim.',
         substation_return_limit_1_reg_11029_label: 'DHW, ret. T limit',
         substation_return_limit_1_reg_11030_label: 'Limit',
         substation_return_limit_1_reg_11085_label: 'Priority',
         substation_return_limit_1_reg_11255_label: 'S5 Sensor reference',
         substation_temp_monitoring_1_reg_11147_label: 'Upper difference',
         substation_temp_monitoring_1_reg_11148_label: 'Lower difference',
         substation_temp_monitoring_1_reg_11149_label: 'Delay',
         substation_temp_monitoring_1_reg_11150_label: 'Lowest temp.',
         substation_general_3_reg_4213_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_general_4_reg_4214_label_list: JSON.stringify({
           list: {
             0: 'Setback',
             1: 'Pre-comfort',
             2: 'Comfort',
             3: 'Pre-setback',
           },
         }),
         substation_input_config_reg_4106_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4107_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4108_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4109_label_list: JSON.stringify({
           list: {
             1: 'Pt1000',
             2: '0-10 volt',
             3: 'Digital',
           },
         }),
         substation_input_config_reg_4110_label_list: JSON.stringify({
           list: {
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4111_label_list: JSON.stringify({
           list: {
             5: 'Pulse',
             6: 'Frequency',
           },
         }),
         substation_input_config_reg_4126_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4127_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4128_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4129_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4130_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4131_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),
         substation_input_config_reg_4125_label_list: JSON.stringify({
           list: {
             0: 'None',
             1: 'Pull up',
             2: 'Cap load',
             3: 'Pull up and Cap load',
             255: 'Default',
           },
         }),

         // Substation single-page keys
         substations_filter_search: 'Search Substation',
         substation_single_page_title: 'Substation details',
         substations_single_bread_crumb_main_title: 'Substation overzicht',
         substations_single_bread_crumb_first_link: 'Substation pagina',
         substations_single_edit_device_button: 'Edit Substation',
         substation_single_temperature_title:
           'De historische data van de substation',
         substation_single_offline_detailed_message: 'Substation is "Offline"',
         substation_single_online_detailed_message:
           'Substation is "Online", alles werkt prima',
         substation_single_error_detailed_message:
           'Substation is in "Storing" mode',
         substation_single_unprovisioned_detailed_message:
           'Substation is in "Ongeregistreerd" modus',
         substation_fetch_registers_success:
           'Het verzoek is succesvol verzonden naar het Substation.',
         substation_single_firmware_hiu_label: 'Firmware substation',
         substation_single_download_modbus_data: 'Export substation data',
         substation_single_device_settings_title: 'Substation instellingen',
         substation_single_rss_device_status: 'Substation status',
         substations_single_device_counters_title: 'Substation Tellers',

         // Substation edit form keys
         substations_form_device_information_tab: 'Substation info',
         substations_form_name_field: 'Substation naam',
         substations_form_device_labels_field: 'Substation Label',
         substations_form_additional_information_tab: 'Substation Details',
         substations_form_description_field: 'Substation type',
         substations_form_article_number_field: 'Artikelnummer substation',
         substations_partner_article_number_field:
           'Artikelnummer substation van distributeur',
         substations_form_box_serial_number_field: 'Serienummer substation',
         substations_partner_serial_number:
           'Serienummer substation van distributeur',

         // Substation register category menu labels (grouped)
         substation_menu_general: 'General',
         substation_menu_application: 'Application',
         substation_menu_ecl: 'ECL',
         substation_menu_return_limit: 'Return Limit',
         substation_menu_output: 'Output',
         substation_menu_flow_temperature: 'Flow Temperature',
         // Individual table titles
         substation_menu_general_1: 'General 1',
         substation_menu_general_2: 'General 2',
         substation_menu_ecl_alarm: 'ECL Alarm',
         substation_menu_ecl_system: 'ECL System',
         substation_menu_raw_sensor: 'Raw Sensor',
         substation_menu_output_status: 'Output Status',
         substation_menu_input_config: 'Input Config',
         substation_menu_ecl_system_ex: 'ECL System Extended',
         substation_menu_general_5: 'General 5',
         substation_menu_general_6: 'General 6',
         substation_menu_flow_temperature_1: 'Flow Temperature 1',
         substation_menu_return_limit_1: 'Return Limit 1',
         substation_menu_optimization_1: 'Optimization 1',
         substation_menu_control_parameter_1: 'Control Parameter 1',
         substation_menu_application_1: 'Application 1',
         substation_menu_output_control_1: 'Output Control 1',
         substation_menu_flow_temperature_2: 'Flow Temperature 2',
         substation_menu_return_limit_2: 'Return Limit 2',
         substation_menu_application_2: 'Application 2',
         substation_menu_temp_monitoring_2: 'Temp Monitoring 2',
         substation_menu_compensating1_2: 'Compensating 1/2',
         substation_menu_flow_power_limit: 'Flow / Power Limit',
         substation_menu_pressure: 'Pressure',
         substation_menu_alarm1_1: 'Alarm 1',
         substation_menu_general_3: 'General 3',
         substation_menu_general_4: 'General 4',
         substation_menu_output_manual_status: 'Output Manual Status',
         substation_menu_pressure1: 'Pressure 1',
         substation_menu_pressure2: 'Pressure 2',
         substation_menu_pressure3: 'Pressure 3',
         substation_menu_pressure4: 'Pressure 4',
         substation_menu_energy_meter_1: 'Energy Meter 1',
         substation_menu_flow_power_limit_1: 'Flow / Power Limit 1',
         substation_menu_control_parameter_2: 'Control Parameter 2',
         substation_menu_control_parameter_5: 'Control Parameter 5',
         substation_menu_temp_monitoring_1: 'Temp Monitoring 1',
         substation_menu_compensating1_1: 'Compensating 1/1',
         substation_menu_compensating2_1: 'Compensating 2/1',
         substation_menu_energy_meter: 'Energy Meter',
         substation_menu_ecl_system_meas: 'ECL System (Config)',
         substation_menu_ecl_extension: 'ECL Extension',
         substation_menu_ethernet: 'Ethernet',
         substation_menu_scada_override: 'SCADA Override',
         substation_menu_m_bus_config: 'M-Bus Config',
         project_offboarding_alert_title: 'This project is currently being offboarded.',
         project_offboarding_grace_period_end: 'Grace period end date',
         project_offboarding_deletion_window_end: 'Deletion window end date',
         project_offboarding_days_left: 'days left',
         custom_popover_107_long_description: 'Hot water valve (M1)',
         custom_popover_107_short_description: 'Hot water valve (M1)',
         custom_popover_108_long_description: 'Heating/cooling valve (M2)',
         custom_popover_108_short_description: 'Heating/cooling valve (M2)',
         custom_popover_115_long_description: 'Appliance Type',
         custom_popover_115_short_description: 'Appliance Type',
         custom_popover_MBUS_METER_ELECTRICITY_ENERGY_short_description:
           'Accumulated Electricity',
         devices_testing: 'Device Testing',
         eerrorReporting_TR04_15_errorDescription:
           'The external overheat protection is enabled or the Secondary CH Supply sensor (TT-4) measures a temp higher than Maximum heating temp',
         email_device_swapping_new_device_title: 'New device',
         email_device_swapping_old_device_title: 'Old device',
         mbus_reporting_anomaly_table_mbus_new_value: 'New Value',
         mbus_reporting_anomaly_table_mbus_port: 'Port',
         projects: 'Projects',
         swapping_audit_message: 'Device is swapped',
         three_scale_temporary_password_subject:
           'Fortes Energy - kong Account Created',
         custom_popover_1_short_description: 'System Command',
         custom_popover_1_long_description: 'System Command',
         custom_popover_8_short_description: 'Build no.',
         custom_popover_8_long_description: 'Build no.',
         custom_popover_19_short_description: 'Code no.',
         custom_popover_19_long_description: 'Code no.',
         custom_popover_34_short_description: 'Hardware',
         custom_popover_34_long_description: 'Hardware',
         custom_popover_35_short_description: 'Software',
         custom_popover_35_long_description: 'Software',
         custom_popover_36_short_description: 'Serial no.',
         custom_popover_36_long_description: 'Serial no.',
         custom_popover_38_short_description: 'Modbus addr.',
         custom_popover_38_long_description: 'Modbus addr.',
         custom_popover_39_short_description: 'Baud',
         custom_popover_39_long_description: 'Baud',
         custom_popover_258_short_description: 'Address type',
         custom_popover_258_long_description: 'Address type',
         custom_popover_278_short_description: 'IP 1',
         custom_popover_278_long_description: 'IP 1',
         custom_popover_282_short_description: 'Gateway IP 1',
         custom_popover_282_long_description: 'Gateway IP 1',
         custom_popover_286_short_description: 'Net Mask 1',
         custom_popover_286_long_description: 'Net Mask 1',
         custom_popover_1024_short_description: 'Alarm field 2',
         custom_popover_1024_long_description: 'Alarm field 2',
         custom_popover_1025_short_description: 'Alarm field 1',
         custom_popover_1025_long_description: 'Alarm field 1',
         custom_popover_1032_short_description: 'Alarm clear 2',
         custom_popover_1032_long_description: 'Alarm clear 2',
         custom_popover_1033_short_description: 'Alarm clear 1',
         custom_popover_1033_long_description: 'Alarm clear 1',
         custom_popover_2048_short_description: 'ECL 485 addr.',
         custom_popover_2048_long_description: 'ECL 485 addr.',
         custom_popover_2049_short_description: 'Modbus bias.',
         custom_popover_2049_long_description: 'Modbus bias.',
         custom_popover_2050_short_description: 'Language',
         custom_popover_2050_long_description: 'Language',
         custom_popover_2052_short_description: 'Sensor monitor valid mask1',
         custom_popover_2052_long_description: 'Sensor monitor valid mask1',
         custom_popover_2054_short_description: 'Sensor monitor error mask1',
         custom_popover_2054_long_description: 'Sensor monitor error mask1',
         custom_popover_2097_short_description: 'Wink',
         custom_popover_2097_long_description: 'Wink',
         custom_popover_2099_short_description: 'Production week',
         custom_popover_2099_long_description: 'Production week',
         custom_popover_2150_short_description: 'Service pin',
         custom_popover_2150_long_description: 'Service pin',
         custom_popover_2151_short_description: 'Ext. reset',
         custom_popover_2151_long_description: 'Ext. reset',
         custom_popover_2152_short_description: 'Inbound accept',
         custom_popover_2152_long_description: 'Inbound accept',
         custom_popover_2153_short_description: 'Portal encryption',
         custom_popover_2153_long_description: 'Portal encryption',
         custom_popover_2160_short_description: 'ECL Portal',
         custom_popover_2160_long_description: 'ECL Portal',
         custom_popover_2161_short_description: 'Connection status',
         custom_popover_2161_long_description: 'Connection status',
         custom_popover_2162_short_description: 'Portal status',
         custom_popover_2162_long_description: 'Portal status',
         custom_popover_2240_short_description: 'DNS IP1 1',
         custom_popover_2240_long_description: 'DNS IP1 1',
         custom_popover_2244_short_description: 'DNS IP2 1',
         custom_popover_2244_long_description: 'DNS IP2 1',
         custom_popover_3995_short_description: 'Estimated Motor Position 1',
         custom_popover_3995_long_description: 'Estimated Motor Position 1',
         custom_popover_3996_short_description: 'Estimated Motor Position 2',
         custom_popover_3996_long_description: 'Estimated Motor Position 2',
         custom_popover_3997_short_description: 'Estimated Motor Position 3',
         custom_popover_3997_long_description: 'Estimated Motor Position 3',
         custom_popover_4000_short_description: 'Triac 1',
         custom_popover_4000_long_description: 'Triac 1',
         custom_popover_4001_short_description: 'Triac 2',
         custom_popover_4001_long_description: 'Triac 2',
         custom_popover_4002_short_description: 'Triac 3',
         custom_popover_4002_long_description: 'Triac 3',
         custom_popover_4003_short_description: 'Triac 4',
         custom_popover_4003_long_description: 'Triac 4',
         custom_popover_4004_short_description: 'Triac 5',
         custom_popover_4004_long_description: 'Triac 5',
         custom_popover_4005_short_description: 'Triac 6',
         custom_popover_4005_long_description: 'Triac 6',
         custom_popover_4006_short_description: 'Relay 1',
         custom_popover_4006_long_description: 'Relay 1',
         custom_popover_4007_short_description: 'Relay 2',
         custom_popover_4007_long_description: 'Relay 2',
         custom_popover_4008_short_description: 'Relay 3',
         custom_popover_4008_long_description: 'Relay 3',
         custom_popover_4009_short_description: 'Relay 4',
         custom_popover_4009_long_description: 'Relay 4',
         custom_popover_4010_short_description: 'Relay 5',
         custom_popover_4010_long_description: 'Relay 5',
         custom_popover_4011_short_description: 'Relay 6',
         custom_popover_4011_long_description: 'Relay 6',
         custom_popover_4019_short_description: 'ECA35 PWM4',
         custom_popover_4019_long_description: 'ECA35 PWM4',
         custom_popover_4100_short_description: 'Config type S7',
         custom_popover_4100_long_description: 'Config type S7',
         custom_popover_4101_short_description: 'Config type S8',
         custom_popover_4101_long_description: 'Config type S8',
         custom_popover_4102_short_description: 'Config type S9',
         custom_popover_4102_long_description: 'Config type S9',
         custom_popover_4103_short_description: 'Config type S10',
         custom_popover_4103_long_description: 'Config type S10',
         custom_popover_4104_short_description: 'Config type S11',
         custom_popover_4104_long_description: 'Config type S11',
         custom_popover_4105_short_description: 'Config type S12',
         custom_popover_4105_long_description: 'Config type S12',
         custom_popover_4120_short_description: 'Config option S7',
         custom_popover_4120_long_description: 'Config option S7',
         custom_popover_4121_short_description: 'Config option S8',
         custom_popover_4121_long_description: 'Config option S8',
         custom_popover_4122_short_description: 'Config option S9',
         custom_popover_4122_long_description: 'Config option S9',
         custom_popover_4123_short_description: 'Config option S10',
         custom_popover_4123_long_description: 'Config option S10',
         custom_popover_4124_short_description: 'Config option S11',
         custom_popover_4124_long_description: 'Config option S11',
         custom_popover_4125_short_description: 'Config option S12',
         custom_popover_4125_long_description: 'Config option S12',
         custom_popover_4201_short_description: 'Mode',
         custom_popover_4201_long_description: 'Mode',
         custom_popover_4202_short_description: 'Mode',
         custom_popover_4202_long_description: 'Mode',
         custom_popover_4211_short_description: 'Circuit 1 status',
         custom_popover_4211_long_description: 'Circuit 1 status',
         custom_popover_4212_short_description: 'Circuit 2 status',
         custom_popover_4212_long_description: 'Circuit 2 status',
         custom_popover_4215_short_description: 'Circuit 5 status',
         custom_popover_4215_long_description: 'Circuit 5 status',
         custom_popover_4216_short_description: 'Circuit 6 status',
         custom_popover_4216_long_description: 'Circuit 6 status',
         custom_popover_4220_short_description: 'Circuit 1 limiter flags 1',
         custom_popover_4220_long_description: 'Circuit 1 limiter flags 1',
         custom_popover_4221_short_description: 'Circuit 1 limiter flags 2',
         custom_popover_4221_long_description: 'Circuit 1 limiter flags 2',
         custom_popover_4222_short_description: 'Circuit 1 limiter flags 3',
         custom_popover_4222_long_description: 'Circuit 1 limiter flags 3',
         custom_popover_4223_short_description: 'Circuit 1 limiter flags 4',
         custom_popover_4223_long_description: 'Circuit 1 limiter flags 4',
         custom_popover_4224_short_description: 'Circuit 2 limiter flags 1',
         custom_popover_4224_long_description: 'Circuit 2 limiter flags 1',
         custom_popover_4236_short_description: 'AccumulatedPulse 1',
         custom_popover_4236_long_description: 'AccumulatedPulse 1',
         custom_popover_4238_short_description: 'AccumulatedPulse 2',
         custom_popover_4238_long_description: 'AccumulatedPulse 2',
         custom_popover_4240_short_description: 'AccumulatedPulse 3',
         custom_popover_4240_long_description: 'AccumulatedPulse 3',
         custom_popover_4246_short_description: 'Circuit 5 limiter flags 1',
         custom_popover_4246_long_description: 'Circuit 5 limiter flags 1',
         custom_popover_4247_short_description: 'Circuit 5 limiter flags 2',
         custom_popover_4247_long_description: 'Circuit 5 limiter flags 2',
         custom_popover_4248_short_description: 'Circuit 5 limiter flags 3',
         custom_popover_4248_long_description: 'Circuit 5 limiter flags 3',
         custom_popover_4249_short_description: 'Circuit 5 limiter flags 4',
         custom_popover_4249_long_description: 'Circuit 5 limiter flags 4',
         custom_popover_4250_short_description: 'Circuit 6 limiter flags 1',
         custom_popover_4250_long_description: 'Circuit 6 limiter flags 1',
         custom_popover_4251_short_description: 'Circuit 6 limiter flags 2',
         custom_popover_4251_long_description: 'Circuit 6 limiter flags 2',
         custom_popover_4252_short_description: 'Circuit 6 limiter flags 3',
         custom_popover_4252_long_description: 'Circuit 6 limiter flags 3',
         custom_popover_4253_short_description: 'Circuit 6 limiter flags 4',
         custom_popover_4253_long_description: 'Circuit 6 limiter flags 4',
         custom_popover_5994_short_description: 'GW Command request',
         custom_popover_5994_long_description: 'GW Command request',
         custom_popover_5995_short_description: 'GW State',
         custom_popover_5995_long_description: 'GW State',
         custom_popover_5996_short_description: 'GW Telegram size',
         custom_popover_5996_long_description: 'GW Telegram size',
         custom_popover_5997_short_description: 'Baud',
         custom_popover_5997_long_description: 'Baud',
         custom_popover_5998_short_description: 'Command',
         custom_popover_5998_long_description: 'Command',
         custom_popover_5999_short_description: 'State',
         custom_popover_5999_long_description: 'State',
         custom_popover_10198_short_description: 'Aut. daylight',
         custom_popover_10198_long_description: 'Aut. daylight',
         custom_popover_10201_short_description: 'S1 sensor',
         custom_popover_10201_long_description: 'S1 sensor',
         custom_popover_10202_short_description: 'S2 sensor',
         custom_popover_10202_long_description: 'S2 sensor',
         custom_popover_10203_short_description: 'S3 sensor',
         custom_popover_10203_long_description: 'S3 sensor',
         custom_popover_10204_short_description: 'S4 sensor',
         custom_popover_10204_long_description: 'S4 sensor',
         custom_popover_10205_short_description: 'S5 sensor',
         custom_popover_10205_long_description: 'S5 sensor',
         custom_popover_10206_short_description: 'S6 sensor',
         custom_popover_10206_long_description: 'S6 sensor',
         custom_popover_10207_short_description: 'S7 sensor',
         custom_popover_10207_long_description: 'S7 sensor',
         custom_popover_10208_short_description: 'S8 sensor',
         custom_popover_10208_long_description: 'S8 sensor',
         custom_popover_10209_short_description: 'S9 sensor',
         custom_popover_10209_long_description: 'S9 sensor',
         custom_popover_10210_short_description: 'S10 sensor',
         custom_popover_10210_long_description: 'S10 sensor',
         custom_popover_10211_short_description: 'S11 sensor',
         custom_popover_10211_long_description: 'S11 sensor',
         custom_popover_10212_short_description: 'S12 sensor',
         custom_popover_10212_long_description: 'S12 sensor',
         custom_popover_10213_short_description: 'Room Unit A, Sensor 1',
         custom_popover_10213_long_description: 'Room Unit A, Sensor 1',
         custom_popover_10216_short_description: 'Room Unit B, Sensor 1',
         custom_popover_10216_long_description: 'Room Unit B, Sensor 1',
         custom_popover_10398_short_description: 'Scada heatoffset/setpoint',
         custom_popover_10398_long_description: 'Scada heatoffset/setpoint',
         custom_popover_10399_short_description: 'Scada Timeout',
         custom_popover_10399_long_description: 'Scada Timeout',
         custom_popover_10400_short_description: 'Scada Outdoor temperature',
         custom_popover_10400_long_description: 'Scada Outdoor temperature',
         custom_popover_10401_short_description: 'Scada heat offset 1',
         custom_popover_10401_long_description: 'Scada heat offset 1',
         custom_popover_10402_short_description: 'Scada heat offset 2',
         custom_popover_10402_long_description: 'Scada heat offset 2',
         custom_popover_10403_short_description: 'Scada heat offset 3',
         custom_popover_10403_long_description: 'Scada heat offset 3',
         custom_popover_10404_short_description: 'Scada heat offset 4',
         custom_popover_10404_long_description: 'Scada heat offset 4',
         custom_popover_10405_short_description: 'Scada boiler ctrl 1',
         custom_popover_10405_long_description: 'Scada boiler ctrl 1',
         custom_popover_10406_short_description: 'Scada boiler ctrl 2',
         custom_popover_10406_long_description: 'Scada boiler ctrl 2',
         custom_popover_10407_short_description: 'Scada boiler ctrl 3',
         custom_popover_10407_long_description: 'Scada boiler ctrl 3',
         custom_popover_10408_short_description: 'Scada boiler ctrl 4',
         custom_popover_10408_long_description: 'Scada boiler ctrl 4',
         custom_popover_10409_short_description: 'SCADA slave request',
         custom_popover_10409_long_description: 'SCADA slave request',
         custom_popover_10410_short_description: 'SCADA resulting reference',
         custom_popover_10410_long_description: 'SCADA resulting reference',
         custom_popover_10420_short_description: 'Scada Schedule timeout',
         custom_popover_10420_long_description: 'Scada Schedule timeout',
         custom_popover_10421_short_description: 'Scada Schedule 1',
         custom_popover_10421_long_description: 'Scada Schedule 1',
         custom_popover_10422_short_description: 'Scada Schedule 2',
         custom_popover_10422_long_description: 'Scada Schedule 2',
         custom_popover_10423_short_description: 'Scada Schedule 3',
         custom_popover_10423_long_description: 'Scada Schedule 3',
         custom_popover_10424_short_description: 'Scada Schedule 4',
         custom_popover_10424_long_description: 'Scada Schedule 4',
         custom_popover_10425_short_description: 'Scada Schedule 5',
         custom_popover_10425_long_description: 'Scada Schedule 5',
         custom_popover_10426_short_description: 'Scada Schedule 6',
         custom_popover_10426_long_description: 'Scada Schedule 6',
         custom_popover_10427_short_description: 'Scada Optim value 1',
         custom_popover_10427_long_description: 'Scada Optim value 1',
         custom_popover_10428_short_description: 'Scada Optim value 2',
         custom_popover_10428_long_description: 'Scada Optim value 2',
         custom_popover_10429_short_description: 'Scada Optim value 3',
         custom_popover_10429_long_description: 'Scada Optim value 3',
         custom_popover_10430_short_description: 'Scada Optim value 4',
         custom_popover_10430_long_description: 'Scada Optim value 4',
         custom_popover_10431_short_description: 'Scada Optim value 5',
         custom_popover_10431_long_description: 'Scada Optim value 5',
         custom_popover_10432_short_description: 'Scada Optim value 6',
         custom_popover_10432_long_description: 'Scada Optim value 6',
         custom_popover_10500_short_description: 'Min Outdoor Temp',
         custom_popover_10500_long_description: 'Min Outdoor Temp',
         custom_popover_10501_short_description: 'Min Hour Time',
         custom_popover_10501_long_description: 'Min Hour Time',
         custom_popover_10502_short_description: 'Min Minute Time',
         custom_popover_10502_long_description: 'Min Minute Time',
         custom_popover_10503_short_description: 'Cooling Reg 10503',
         custom_popover_10503_long_description: 'Cooling Reg 10503',
         custom_popover_10504_short_description: 'Cooling Reg 10504',
         custom_popover_10504_long_description: 'Cooling Reg 10504',
         custom_popover_10505_short_description: 'Max Outdoor Temp',
         custom_popover_10505_long_description: 'Max Outdoor Temp',
         custom_popover_10506_short_description: 'Max Hou Time',
         custom_popover_10506_long_description: 'Max Hou Time',
         custom_popover_10507_short_description: 'Max Minute Time',
         custom_popover_10507_long_description: 'Max Minute Time',
         custom_popover_10508_short_description: 'Cooling Reg 10508',
         custom_popover_10508_long_description: 'Cooling Reg 10508',
         custom_popover_10509_short_description: 'Cooling Reg 10509',
         custom_popover_10509_long_description: 'Cooling Reg 10509',
         custom_popover_10510_short_description: 'Outdoor Trend',
         custom_popover_10510_long_description: 'Outdoor Trend',
         custom_popover_10603_short_description: 'Digital S7',
         custom_popover_10603_long_description: 'Digital S7',
         custom_popover_10643_short_description: 'Digital S9',
         custom_popover_10643_long_description: 'Digital S9',
         custom_popover_11010_short_description: 'ECA addr.',
         custom_popover_11010_long_description: 'ECA addr.',
         custom_popover_11011_short_description: 'Auto saving',
         custom_popover_11011_long_description: 'Auto saving',
         custom_popover_11012_short_description: 'Boost',
         custom_popover_11012_long_description: 'Boost',
         custom_popover_11018_short_description: 'Des. T comfort',
         custom_popover_11018_long_description: 'Des. T comfort',
         custom_popover_11019_short_description: 'Des. T saving',
         custom_popover_11019_long_description: 'Des. T saving',
         custom_popover_10219_short_description: 'ECA32 Sensor 13',
         custom_popover_10219_long_description: 'ECA32 Sensor 13',
         custom_popover_10220_short_description: 'ECA32 Sensor 14',
         custom_popover_10220_long_description: 'ECA32 Sensor 14',
         custom_popover_10221_short_description: 'ECA32 Sensor 15',
         custom_popover_10221_long_description: 'ECA32 Sensor 15',
         custom_popover_10222_short_description: 'ECA32 Sensor 16',
         custom_popover_10222_long_description: 'ECA32 Sensor 16',
         custom_popover_10223_short_description: 'ECA32 Sensor 17 PF',
         custom_popover_10223_long_description: 'ECA32 Sensor 17 PF',
         custom_popover_10224_short_description: 'ECA32 Sensor 18 PF',
         custom_popover_10224_long_description: 'ECA32 Sensor 18 PF',
         custom_popover_4012_short_description: 'ECA32 Relay 1',
         custom_popover_4012_long_description: 'ECA32 Relay 1',
         custom_popover_4013_short_description: 'ECA32 Relay 2',
         custom_popover_4013_long_description: 'ECA32 Relay 2',
         custom_popover_4014_short_description: 'ECA32 Relay 3',
         custom_popover_4014_long_description: 'ECA32 Relay 3',
         custom_popover_4015_short_description: 'ECA32 Relay 4',
         custom_popover_4015_long_description: 'ECA32 Relay 4',
         custom_popover_4016_short_description: 'ECA32 AO1',
         custom_popover_4016_long_description: 'ECA32 AO1',
         custom_popover_4017_short_description: 'ECA32 AO2',
         custom_popover_4017_long_description: 'ECA32 AO2',
         custom_popover_4018_short_description: 'ECA32 AO3',
         custom_popover_4018_long_description: 'ECA32 AO3',
         custom_popover_4056_short_description: 'ECA32 AO1 Value',
         custom_popover_4056_long_description: 'ECA32 AO1 Value',
         custom_popover_4106_short_description: 'ECA 32 Config type S13',
         custom_popover_4106_long_description: 'ECA 32 Config type S13',
         custom_popover_4107_short_description: 'ECA 32 Config type S14',
         custom_popover_4107_long_description: 'ECA 32 Config type S14',
         custom_popover_4108_short_description: 'ECA 32 Config type S15',
         custom_popover_4108_long_description: 'ECA 32 Config type S15',
         custom_popover_4109_short_description: 'ECA 32 Config type S16',
         custom_popover_4109_long_description: 'ECA 32 Config type S16',
         custom_popover_4110_short_description: 'ECA 32 Config type S17',
         custom_popover_4110_long_description: 'ECA 32 Config type S17',
         custom_popover_4111_short_description: 'ECA 32 Config type S18',
         custom_popover_4111_long_description: 'ECA 32 Config type S18',
         custom_popover_4126_short_description: 'ECA 32 Config option S13',
         custom_popover_4126_long_description: 'ECA 32 Config option S13',
         custom_popover_4127_short_description: 'ECA 32 Config option S14',
         custom_popover_4127_long_description: 'ECA 32 Config option S14',
         custom_popover_4128_short_description: 'ECA 32 Config option S15',
         custom_popover_4128_long_description: 'ECA 32 Config option S15',
         custom_popover_4129_short_description: 'ECA 32 Config option S16',
         custom_popover_4129_long_description: 'ECA 32 Config option S16',
         custom_popover_4130_short_description: 'ECA 32 Config option S17',
         custom_popover_4130_long_description: 'ECA 32 Config option S17',
         custom_popover_4131_short_description: 'ECA 32 Config option S18',
         custom_popover_4131_long_description: 'ECA 32 Config option S18',
         custom_popover_11101_short_description: 'Ext. desired T',
         custom_popover_11101_long_description: 'Ext. desired T',
         custom_popover_11301_short_description: 'High T max Y2',
         custom_popover_11301_long_description: 'High T max Y2',
         custom_popover_11303_short_description: 'Low T max Y1',
         custom_popover_11303_long_description: 'Low T max Y1',
         custom_popover_11030_short_description: 'Limit',
         custom_popover_11030_long_description: 'Limit',
         custom_popover_11255_short_description: 'S5 Sensor reference',
         custom_popover_11255_long_description: 'S5 Sensor reference',
         custom_popover_11017_short_description: 'Demand offset',
         custom_popover_11017_long_description: 'Demand offset',
         custom_popover_11050_short_description: 'P demand',
         custom_popover_11050_long_description: 'P demand',
         custom_popover_11070_short_description: 'P cool T',
         custom_popover_11070_long_description: 'P cool T',
         custom_popover_11084_short_description: 'Ext. signal',
         custom_popover_11084_long_description: 'Ext. signal',
         custom_popover_11092_short_description: 'Standby T',
         custom_popover_11092_long_description: 'Standby T',
         custom_popover_11060_short_description: 'Limit',
         custom_popover_11060_long_description: 'Limit',
         custom_popover_11061_short_description: 'Adapt. time',
         custom_popover_11061_long_description: 'Adapt. time',
         custom_popover_11062_short_description: 'Infl. - max.',
         custom_popover_11062_long_description: 'Infl. - max.',
         custom_popover_11063_short_description: 'Infl. - min.',
         custom_popover_11063_long_description: 'Infl. - min.',
         custom_popover_11064_short_description: 'Limit',
         custom_popover_11064_long_description: 'Limit',
         custom_popover_11065_short_description: 'Adapt. time',
         custom_popover_11065_long_description: 'Adapt. time',
         custom_popover_11066_short_description: 'Infl. - max.',
         custom_popover_11066_long_description: 'Infl. - max.',
         custom_popover_11067_short_description: 'Infl. - min.',
         custom_popover_11067_long_description: 'Infl. - min.',
         custom_popover_6000_short_description: 'M-bus address',
         custom_popover_6000_long_description: 'M-bus address',
         custom_popover_6001_short_description: 'Type',
         custom_popover_6001_long_description: 'Type',
         custom_popover_6002_short_description: 'Scan time',
         custom_popover_6002_long_description: 'Scan time',
         custom_popover_6003_short_description: 'ID',
         custom_popover_6003_long_description: 'ID',
         custom_popover_6005_short_description: 'Meter Status',
         custom_popover_6005_long_description: 'Meter Status',
         custom_popover_6006_short_description: 'Flow T',
         custom_popover_6006_long_description: 'Flow T',
         custom_popover_6007_short_description: 'Return T',
         custom_popover_6007_long_description: 'Return T',
         custom_popover_6008_short_description: 'Flow',
         custom_popover_6008_long_description: 'Flow',
         custom_popover_6010_short_description: 'Power',
         custom_popover_6010_long_description: 'Power',
         custom_popover_6012_short_description: 'Volume',
         custom_popover_6012_long_description: 'Volume',
         custom_popover_6014_short_description: 'Energy',
         custom_popover_6014_long_description: 'Energy',
         custom_popover_6016_short_description: 'Flow MAX',
         custom_popover_6016_long_description: 'Flow MAX',
         custom_popover_6018_short_description: 'Power MAX',
         custom_popover_6018_long_description: 'Power MAX',
         custom_popover_6020_short_description: 'Flow T MAX',
         custom_popover_6020_long_description: 'Flow T MAX',
         custom_popover_6021_short_description: 'Return T MAX',
         custom_popover_6021_long_description: 'Return T MAX',
         custom_popover_6022_short_description: 'Energy Storage',
         custom_popover_6022_long_description: 'Energy Storage',
         custom_popover_2165_short_description: 'Server name, char 1',
         custom_popover_2165_long_description: 'Server name, char 1',
         custom_popover_2230_short_description: 'Password, char 1',
         custom_popover_2230_long_description: 'Password, char 1',
         custom_popover_11203_short_description: 'S3 Sensor',
         custom_popover_11203_long_description: 'S3 Sensor',
         custom_popover_11204_short_description: 'S4 Sensor',
         custom_popover_11204_long_description: 'S4 Sensor',
         custom_popover_11205_short_description: 'S5 Sensor',
         custom_popover_11205_long_description: 'S5 Sensor',
         custom_popover_11247_short_description: 'Selected temperature',
         custom_popover_11247_long_description: 'Selected temperature',
         custom_popover_4213_short_description: 'Circuit 3 status',
         custom_popover_4213_long_description: 'Circuit 3 status',
         custom_popover_4214_short_description: 'Circuit 4 status',
         custom_popover_4214_long_description: 'Circuit 4 status',
         custom_popover_11004_short_description: 'Desired T',
         custom_popover_11004_long_description: 'Desired T',
         custom_popover_11079_short_description: 'Max. flow T',
         custom_popover_11079_long_description: 'Max. flow T',
         custom_popover_11080_short_description: 'Delay',
         custom_popover_11080_long_description: 'Delay',
         custom_popover_11297_short_description: 'Temperature reference',
         custom_popover_11297_long_description: 'Temperature reference',
         custom_popover_11609_short_description: 'Low Y',
         custom_popover_11609_long_description: 'Low Y',
         custom_popover_11610_short_description: 'High Y',
         custom_popover_11610_long_description: 'High Y',
         custom_popover_11028_short_description: 'Con. T, ret. T lim.',
         custom_popover_11028_long_description: 'Con. T, ret. T lim.',
         custom_popover_11029_short_description: 'DHW, ret. T limit',
         custom_popover_11029_long_description: 'DHW, ret. T limit',
         custom_popover_11085_short_description: 'Priority',
         custom_popover_11085_long_description: 'Priority',
         custom_popover_11013_short_description: 'Ramp',
         custom_popover_11013_long_description: 'Ramp',
         custom_popover_11392_short_description: 'Sum. start, month',
         custom_popover_11392_long_description: 'Sum. start, month',
         custom_popover_11393_short_description: 'Sum. start, day',
         custom_popover_11393_long_description: 'Sum. start, day',
         custom_popover_11395_short_description: 'Summer, filter',
         custom_popover_11395_long_description: 'Summer, filter',
         custom_popover_11396_short_description: 'Win. start, month',
         custom_popover_11396_long_description: 'Win. start, month',
         custom_popover_11397_short_description: 'Winter start, day',
         custom_popover_11397_long_description: 'Winter start, day',
         custom_popover_11398_short_description: 'Winter, cut-out',
         custom_popover_11398_long_description: 'Winter, cut-out',
         custom_popover_11399_short_description: 'Winter, filter',
         custom_popover_11399_long_description: 'Winter, filter',
         custom_popover_11097_short_description: 'Supply T (idle)',
         custom_popover_11097_long_description: 'Supply T (idle)',
         custom_popover_11145_short_description: 'Mon. T select',
         custom_popover_11145_long_description: 'Mon. T select',
         custom_popover_11330_short_description: 'Wake up level',
         custom_popover_11330_long_description: 'Wake up level',
         custom_popover_11364_short_description: 'Control, delay',
         custom_popover_11364_long_description: 'Control, delay',
         custom_popover_11700_short_description: 'Await time',
         custom_popover_11700_long_description: 'Await time',
         custom_popover_11052_short_description: 'DHW priority',
         custom_popover_11052_long_description: 'DHW priority',
         custom_popover_11327_short_description: 'Input type',
         custom_popover_11327_long_description: 'Input type',
         custom_popover_11620_short_description: 'Pressure',
         custom_popover_11620_long_description: 'Pressure',
         custom_popover_11629_short_description: 'Low Y',
         custom_popover_11629_long_description: 'Low Y',
         custom_popover_11630_short_description: 'High Y',
         custom_popover_11630_long_description: 'High Y',
         custom_popover_11331_short_description: 'Sleep level',
         custom_popover_11331_long_description: 'Sleep level',
         custom_popover_11332_short_description: 'Sleep mode time',
         custom_popover_11332_long_description: 'Sleep mode time',
         custom_popover_11333_short_description: 'Boost',
         custom_popover_11333_long_description: 'Boost',
         custom_popover_4057_short_description: 'ECA32 AO2 Value',
         custom_popover_4057_long_description: 'ECA32 AO2 Value',
         custom_popover_4058_short_description: 'ECA32 AO3 Value',
         custom_popover_4058_long_description: 'ECA32 AO3 Value',
         custom_popover_11109_short_description: 'Input type',
         custom_popover_11109_long_description: 'Input type',
         custom_popover_11110_short_description: 'Actual',
         custom_popover_11110_long_description: 'Actual',
         custom_popover_11111_short_description: 'Limit',
         custom_popover_11111_long_description: 'Limit',
         custom_popover_11112_short_description: 'Adapt. time',
         custom_popover_11112_long_description: 'Adapt. time',
         custom_popover_11113_short_description: 'Filter constant',
         custom_popover_11113_long_description: 'Filter constant',
         custom_popover_11115_short_description: 'Units',
         custom_popover_11115_long_description: 'Units',
         custom_popover_11116_short_description: 'High limit Y2',
         custom_popover_11116_long_description: 'High limit Y2',
         custom_popover_11117_short_description: 'Low limit Y1',
         custom_popover_11117_long_description: 'Low limit Y1',
         custom_popover_11118_short_description: 'Low T out X2',
         custom_popover_11118_long_description: 'Low T out X2',
         custom_popover_11119_short_description: 'High T out X1',
         custom_popover_11119_long_description: 'High T out X1',
         custom_popover_12165_short_description: 'V out max.',
         custom_popover_12165_long_description: 'V out max.',
         custom_popover_12167_short_description: 'V out min.',
         custom_popover_12167_long_description: 'V out min.',
         custom_popover_12184_short_description: 'Xp',
         custom_popover_12184_long_description: 'Xp',
         custom_popover_12185_short_description: 'Tn',
         custom_popover_12185_long_description: 'Tn',
         custom_popover_12187_short_description: 'Nz',
         custom_popover_12187_long_description: 'Nz',
         custom_popover_12197_short_description: 'Td',
         custom_popover_12197_long_description: 'Td',
         custom_popover_12322_short_description: 'Pressure, diff.',
         custom_popover_12322_long_description: 'Pressure, diff.',
         custom_popover_15113_short_description: 'Filter constant',
         custom_popover_15113_long_description: 'Filter constant',
         custom_popover_15352_short_description: 'Position',
         custom_popover_15352_long_description: 'Position',
         custom_popover_15607_short_description: 'Low X',
         custom_popover_15607_long_description: 'Low X',
         custom_popover_15608_short_description: 'High X',
         custom_popover_15608_long_description: 'High X',
         custom_popover_15609_short_description: 'Low Y',
         custom_popover_15609_long_description: 'Low Y',
         custom_popover_15610_short_description: 'High Y',
         custom_popover_15610_long_description: 'High Y',
         custom_popover_11147_short_description: 'Upper difference',
         custom_popover_11147_long_description: 'Upper difference',
         custom_popover_11148_short_description: 'Lower difference',
         custom_popover_11148_long_description: 'Lower difference',
         custom_popover_11149_short_description: 'Delay',
         custom_popover_11149_long_description: 'Delay',
         custom_popover_11150_short_description: 'Lowest temp.',
         custom_popover_11150_long_description: 'Lowest temp.',
         custom_popover_11614_short_description: 'Alarm high',
         custom_popover_11614_long_description: 'Alarm high',
         custom_popover_11615_short_description: 'Alarm low',
         custom_popover_11615_long_description: 'Alarm low',
         custom_popover_11617_short_description: 'Alarm time-out',
         custom_popover_11617_long_description: 'Alarm time-out',
         custom_popover_11600_short_description: 'Pressure',
         custom_popover_11600_long_description: 'Pressure',
         custom_popover_11607_short_description: 'Low X',
         custom_popover_11607_long_description: 'Low X',
         custom_popover_11608_short_description: 'High X',
         custom_popover_11608_long_description: 'High X',
         custom_popover_17113_short_description: 'Filter constant',
         custom_popover_17113_long_description: 'Filter constant',
         custom_popover_14113_short_description: 'Filter constant',
         custom_popover_14113_long_description: 'Filter constant',
         custom_popover_14600_short_description: 'Pressure',
         custom_popover_14600_long_description: 'Pressure',
         custom_popover_14607_short_description: 'Low X',
         custom_popover_14607_long_description: 'Low X',
         custom_popover_14608_short_description: 'High X',
         custom_popover_14608_long_description: 'High X',
         custom_popover_14609_short_description: 'Low Y',
         custom_popover_14609_long_description: 'Low Y',
         custom_popover_14610_short_description: 'High Y',
         custom_popover_14610_long_description: 'High Y',
         custom_popover_12113_short_description: 'Filter constant',
         custom_popover_12113_long_description: 'Filter constant',
         custom_popover_12600_short_description: 'Pressure',
         custom_popover_12600_long_description: 'Pressure',
         custom_popover_12607_short_description: 'Low X',
         custom_popover_12607_long_description: 'Low X',
         custom_popover_12608_short_description: 'High X',
         custom_popover_12608_long_description: 'High X',
         custom_popover_12609_short_description: 'Low Y',
         custom_popover_12609_long_description: 'Low Y',
         custom_popover_12610_short_description: 'High Y',
         custom_popover_12610_long_description: 'High Y',
         custom_popover_13113_short_description: 'Filter constant',
         custom_popover_13113_long_description: 'Filter constant',
         custom_popover_13600_short_description: 'Pressure',
         custom_popover_13600_long_description: 'Pressure',
         custom_popover_13607_short_description: 'Low X',
         custom_popover_13607_long_description: 'Low X',
         custom_popover_13608_short_description: 'High X',
         custom_popover_13608_long_description: 'High X',
         custom_popover_13609_short_description: 'Low Y',
         custom_popover_13609_long_description: 'Low Y',
         custom_popover_13610_short_description: 'High Y',
         custom_popover_13610_long_description: 'High Y',
         custom_popover_11014_short_description: 'Optimizer',
         custom_popover_11014_long_description: 'Optimizer',
         custom_popover_11020_short_description: 'Based on',
         custom_popover_11020_long_description: 'Based on',
         custom_popover_11021_short_description: 'Total stop',
         custom_popover_11021_long_description: 'Total stop',
         custom_popover_11022_short_description: 'P exercise',
         custom_popover_11022_long_description: 'P exercise',
         custom_popover_11023_short_description: 'M exercise',
         custom_popover_11023_long_description: 'M exercise',
         custom_popover_11024_short_description: 'Actuator',
         custom_popover_11024_long_description: 'Actuator',
         custom_popover_11026_short_description: 'Pre-stop',
         custom_popover_11026_long_description: 'Pre-stop',
         custom_popover_11031_short_description: 'High T out X1',
         custom_popover_11031_long_description: 'High T out X1',
         custom_popover_11032_short_description: 'Low limit Y1',
         custom_popover_11032_long_description: 'Low limit Y1',
         custom_popover_11033_short_description: 'Low T out X2',
         custom_popover_11033_long_description: 'Low T out X2',
         custom_popover_11034_short_description: 'High limit Y2',
         custom_popover_11034_long_description: 'High limit Y2',
         custom_popover_11035_short_description: 'Infl. - max.',
         custom_popover_11035_long_description: 'Infl. - max.',
         custom_popover_11036_short_description: 'Infl. - min.',
         custom_popover_11036_long_description: 'Infl. - min.',
         custom_popover_11037_short_description: 'Adapt. time',
         custom_popover_11037_long_description: 'Adapt. time',
         custom_popover_11038_short_description: 'Stop at T out',
         custom_popover_11038_long_description: 'Stop at T out',
         custom_popover_11040_short_description: 'P post-run',
         custom_popover_11040_long_description: 'P post-run',
         custom_popover_11077_short_description: 'P frost T',
         custom_popover_11077_long_description: 'P frost T',
         custom_popover_11078_short_description: 'P heat T',
         custom_popover_11078_long_description: 'P heat T',
         custom_popover_11083_short_description: 'Add. function',
         custom_popover_11083_long_description: 'Add. function',
         custom_popover_11089_short_description: 'Acc. output function',
         custom_popover_11089_long_description: 'Acc. output function',
         custom_popover_11093_short_description: 'Frost pr. T',
         custom_popover_11093_long_description: 'Frost pr. T',
         custom_popover_11100_short_description: 'Outdoor acc. T',
         custom_popover_11100_long_description: 'Outdoor acc. T',
         custom_popover_11141_short_description: 'Ext. input',
         custom_popover_11141_long_description: 'Ext. input',
         custom_popover_11142_short_description: 'Ext. mode',
         custom_popover_11142_long_description: 'Ext. mode',
         custom_popover_11154_short_description: 'Filt. acc. outdoor T',
         custom_popover_11154_long_description: 'Filt. acc. outdoor T',
         custom_popover_11158_short_description: 'Stat. ventilation diff.',
         custom_popover_11158_long_description: 'Stat. ventilation diff.',
         custom_popover_11159_short_description: 'Stat. ventilation post-run',
         custom_popover_11159_long_description: 'Stat. ventilation post-run',
         custom_popover_11160_short_description: 'Stat. ventilation setp.',
         custom_popover_11160_long_description: 'Stat. ventilation setp.',
         custom_popover_11161_short_description: 'Dew point T',
         custom_popover_11161_long_description: 'Dew point T',
         custom_popover_11174_short_description: 'Motor pr.',
         custom_popover_11174_long_description: 'Motor pr.',
         custom_popover_11175_short_description: 'Heat curve',
         custom_popover_11175_long_description: 'Heat curve',
         custom_popover_11177_short_description: 'Temp. min.',
         custom_popover_11177_long_description: 'Temp. min.',
         custom_popover_11178_short_description: 'Temp. max.',
         custom_popover_11178_long_description: 'Temp. max.',
         custom_popover_11179_short_description: 'Summer, cut-out',
         custom_popover_11179_long_description: 'Summer, cut-out',
         custom_popover_11180_short_description: 'Des. T comfort',
         custom_popover_11180_long_description: 'Des. T comfort',
         custom_popover_11181_short_description: 'Des. T saving',
         custom_popover_11181_long_description: 'Des. T saving',
         custom_popover_11184_short_description: 'Xp',
         custom_popover_11184_long_description: 'Xp',
         custom_popover_11185_short_description: 'Tn',
         custom_popover_11185_long_description: 'Tn',
         custom_popover_11186_short_description: 'M run',
         custom_popover_11186_long_description: 'M run',
         custom_popover_11187_short_description: 'Nz',
         custom_popover_11187_long_description: 'Nz',
         custom_popover_11189_short_description: 'Min. act. time',
         custom_popover_11189_long_description: 'Min. act. time',
         custom_popover_11201_short_description: 'S1 sensor',
         custom_popover_11201_long_description: 'S1 sensor',
         custom_popover_11210_short_description: 'S10 sensor',
         custom_popover_11210_long_description: 'S10 sensor',
         custom_popover_11215_short_description: 'Humidity',
         custom_popover_11215_long_description: 'Humidity',
         custom_popover_11253_short_description: 'Des. flow T',
         custom_popover_11253_long_description: 'Des. flow T',
         custom_popover_11260_short_description: 'S10 Sensor reference',
         custom_popover_11260_long_description: 'S10 Sensor reference',
         custom_popover_11400_short_description: 'Y1',
         custom_popover_11400_long_description: 'Y1',
         custom_popover_11401_short_description: 'Y2',
         custom_popover_11401_long_description: 'Y2',
         custom_popover_11402_short_description: 'Y3',
         custom_popover_11402_long_description: 'Y3',
         custom_popover_11403_short_description: 'Y4',
         custom_popover_11403_long_description: 'Y4',
         custom_popover_11404_short_description: 'Y5',
         custom_popover_11404_long_description: 'Y5',
         custom_popover_11405_short_description: 'Y6',
         custom_popover_11405_long_description: 'Y6',
         custom_popover_11498_short_description: 'T out depend.',
         custom_popover_11498_long_description: 'T out depend.',
         custom_popover_11500_short_description: 'Send desired T',
         custom_popover_11500_long_description: 'Send desired T',
         custom_popover_11501_short_description: 'Reference place',
         custom_popover_11501_long_description: 'Reference place',
         custom_popover_12030_short_description: 'Limit',
         custom_popover_12030_long_description: 'Limit',
         custom_popover_12035_short_description: 'Infl. - max.',
         custom_popover_12035_long_description: 'Infl. - max.',
         custom_popover_12036_short_description: 'Infl. - min.',
         custom_popover_12036_long_description: 'Infl. - min.',
         custom_popover_12037_short_description: 'Adapt. time',
         custom_popover_12037_long_description: 'Adapt. time',
         custom_popover_12060_short_description: 'Limit',
         custom_popover_12060_long_description: 'Limit',
         custom_popover_12061_short_description: 'Adapt. time',
         custom_popover_12061_long_description: 'Adapt. time',
         custom_popover_12063_short_description: 'Infl. - min.',
         custom_popover_12063_long_description: 'Infl. - min.',
         custom_popover_12092_short_description: 'Standby T',
         custom_popover_12092_long_description: 'Standby T',
         custom_popover_12141_short_description: 'Ext. input',
         custom_popover_12141_long_description: 'Ext. input',
         custom_popover_12142_short_description: 'Ext. mode',
         custom_popover_12142_long_description: 'Ext. mode',
         custom_popover_12144_short_description: 'Activation, acc. T',
         custom_popover_12144_long_description: 'Activation, acc. T',
         custom_popover_12147_short_description: 'Upper difference',
         custom_popover_12147_long_description: 'Upper difference',
         custom_popover_12148_short_description: 'Lower difference',
         custom_popover_12148_long_description: 'Lower difference',
         custom_popover_12149_short_description: 'Delay',
         custom_popover_12149_long_description: 'Delay',
         custom_popover_12150_short_description: 'Lowest temp.',
         custom_popover_12150_long_description: 'Lowest temp.',
         custom_popover_12156_short_description: 'Act. acc kamer T',
         custom_popover_12156_long_description: 'Act. acc kamer T',
         custom_popover_12164_short_description: 'Dew point T offset',
         custom_popover_12164_long_description: 'Dew point T offset',
         custom_popover_12172_short_description: 'Cooling curve',
         custom_popover_12172_long_description: 'Cooling curve',
         custom_popover_12177_short_description: 'Temp. min.',
         custom_popover_12177_long_description: 'Temp. min.',
         custom_popover_12178_short_description: 'Temp. max.',
         custom_popover_12178_long_description: 'Temp. max.',
         custom_popover_12180_short_description: 'Des. T comfort',
         custom_popover_12180_long_description: 'Des. T comfort',
         custom_popover_12181_short_description: 'Des. T saving',
         custom_popover_12181_long_description: 'Des. T saving',
         custom_popover_12210_short_description: 'S10 sensor',
         custom_popover_12210_long_description: 'S10 sensor',
         custom_popover_12253_short_description: 'Des. flow T',
         custom_popover_12253_long_description: 'Des. flow T',
         custom_popover_12256_short_description: 'S6 Sensor reference',
         custom_popover_12256_long_description: 'S6 Sensor reference',
         custom_popover_12260_short_description: 'S10 Sensor reference',
         custom_popover_12260_long_description: 'S10 Sensor reference',
         custom_popover_12400_short_description: 'Y1',
         custom_popover_12400_long_description: 'Y1',
         custom_popover_12401_short_description: 'Y2',
         custom_popover_12401_long_description: 'Y2',
         custom_popover_12402_short_description: 'Y3',
         custom_popover_12402_long_description: 'Y3',
         custom_popover_12403_short_description: 'Y4',
         custom_popover_12403_long_description: 'Y4',
         custom_popover_12404_short_description: 'Y5',
         custom_popover_12404_long_description: 'Y5',
         custom_popover_12405_short_description: 'Y6',
         custom_popover_12405_long_description: 'Y6',
         custom_popover_12500_short_description: 'Send desired T',
         custom_popover_12500_long_description: 'Send desired T',
         custom_popover_12501_short_description: 'Reference place',
         custom_popover_12501_long_description: 'Reference place',
         custom_popover_60058_short_description: 'Backlight',
         custom_popover_60058_long_description: 'Backlight',
         custom_popover_60059_short_description: 'Contrast',
         custom_popover_60059_long_description: 'Contrast',
         device_offboarding_write_disabled_error: 'Write operation is disabled for devices currently being offboarded.',
         bulk_all_devices_offboarded_error: 'All selected devices are offboarded. Please select other devices to proceed.',
         bulk_all_heat_pumps_offboarded_error: 'All selected heat pumps are offboarded. Please select other heat pumps to proceed.',
         bulk_all_substations_offboarded_error: 'All selected substations are offboarded. Please select other substations to proceed.',
         bulk_some_devices_offboarded_warning: 'Some selected devices are being offboarded and will be skipped in this operation.',
         partner_settings_general_settings_unclaimed_devices_label:
           'Unclaimed Devices Settings',
         partner_settings_general_settings_unclaimed_devices_module_label:
           'Unclaimed devices module',
         partner_settings_general_settings_unclaimed_devices_module_description:
           'This setting will enable or disable the unclaimed devices functionality on the platform.',
         commissioning_device_stepper_step_claim_device_title: 'Claim Device',
         commissioning_form_success_claimed: 'Device is updated and claimed successfully!',
         device_is_claimed_field: 'Is Claimed',
         device_claimed_by_field: 'Claimed By',
         device_is_stock_product_field: 'Is Stock Product',
         device_commissioned_by_field: 'Commissioned By',
         device_commissioned_at_field: 'Commissioned At',
         general_yes: 'Yes',
         general_no: 'No',
         commissioning_claim_project_hint: "Unable to find the project you'd like to move the device to? Please navigate to the <a href=\"/admin/project\" target=\"_blank\" rel=\"noopener noreferrer\">project list</a> and verify the project name. If the project doesn't exist yet, use the <a href=\"/admin/project/create\" target=\"_blank\" rel=\"noopener noreferrer\">Add New button</a> in the project list to create it, then try commissioning again.",
         commissioning_form_project_is_missing_error: 'Project is required',
         commissioning_form_serial_number_search_hint: "Can't scan the QR code? You can search for the device by typing its serial number, e.g. 001122366455667788991234 or A00001.",
         commissioning_form_serial_number_claiming_hint: 'When claiming a device, enter the full serial number exactly as it appears, e.g. 001122366455667788991234 or A00001.',
         sidebar_mbus_purpose_label_menu: 'Mbus Meter Purpose Labels',
         mbus_meter_labels_header: 'Mbus Meter Purpose Labels',
         add_mbus_meter_labels_form_header: 'Add Mbus Meter Purpose Label',
         edit_mbus_meter_labels_form_header: 'Edit Mbus Meter Purpose Label',
         mbus_meter_labels_form_add_button: 'Add Mbus Meter Purpose Label',
         mbus_meter_labels_form_edit_button: 'Edit Mbus Meter Purpose Label',
         mbus_meter_label_activated_message: 'Mbus Meter Purpose Label Successfully Activated',
         mbus_meter_label_deactivated_message: 'Mbus Meter Purpose Label Successfully Deactivated',
         mbus_meter_label_form_label_required_error: 'Mbus Meter Purpose Label is required',
         mbus_meter_label_form_label_unique_error: 'Mbus Meter Purpose Label must be unique',
         add_mbus_meter_label_form_success: 'Mbus Meter Purpose Label is successfully created.',
         edit_mbus_meter_label_form_success: 'Mbus Meter Purpose Label is successfully updated.',
         mbus_meter_label_form_select_label_field: 'Select Mbus Meter Purpose Label',
         mbus_meter_label_field: 'Mbus Meter Purpose Label',

         device_events_data_logs_unavailable: 'Zowel device specifieke Data Logs als die op projectniveau zijn niet beschikbaar, daarom zijn er geen Data Logs toegepast.',
         device_events_fetch_device_base_topic: 'Haal device base topic op',
         device_events_device_is_offline: 'Apparaat is offline',
         device_events_fetch_device_information: 'Haal device informatie op',
         device_events_device_shutdown_lwt: 'Device uitschakelen (LWT-bericht)',
         device_events_discovering_mbus_meter: 'MBus-meter op devices detecteren',
         device_events_device_mbus_discovery_no_meter: 'Device MBus-detectie [geen MBus-meter beschikbaar]',
         device_events_fetch_mbus_sample_configuration: 'Haal MBus-sampleconfiguratie op',
         device_events_fetch_modbus_baudrate_config: 'Haal Modbus-baudrateconfiguratie op',
         device_events_fetch_modbus_enable_configuration: 'Haal Modbus-activeringsconfiguratie op',
         device_events_fetch_modbus_error_configuration: 'Haal Modbus-foutconfiguratie op',
         device_events_fetch_modbus_write_enable_configuration: 'Haal Modbus-schrijfactiveringsconfiguratie op',
         device_events_fetch_remote_network_endpoint_config: 'Haal configuratie van remote network endpoint op',
         device_events_fetch_remote_ftp_credentials: 'Haal remote FTP-inloggegevens op',
         device_events_commissioning_connectivity_error_sim_missing: 'Inbedrijfstelling - connectiviteitsfout - SIM-nummer ontbreekt in de database',
         device_events_rebooting_device: 'Apparaat opnieuw opstarten',
         device_events_get_all_mbus_values: 'Haal alle Mbus-waarden op',
         device_events_request_base_topic_from_device: 'Vraag basistopic op van device',
         device_events_request_device_type_from_device: 'Vraag apparaattype op van device',
         device_events_get_modbus_baud_rate: 'Haal Modbus-baudrate op',
         device_events_get_modbus_error_register_address: 'Haal adres van Modbus-foutregister op',
         device_events_get_modbus_error_register_value: 'Haal waarde van Modbus-foutregister op',
         device_events_search_mbus_registers_on_device: 'Zoek Mbus-registers op device',
         device_events_search_mbus_registers_on_project_devices: 'Zoek Mbus-registers op project devices',
         device_events_rebooting_modbus_hiu_reset: 'Modbus / HIU reset uitvoeren',
         device_events_request_mbus_interval_from_device: 'Vraag Mbus-interval op van device',
         device_events_hiu_no_error: 'geen fout',
         device_events_base_topic_is: 'Base topic is {{value}}',
         device_events_baudrate_is: 'Baudrate is {{value}}',
         device_events_set_device_base_topic: 'Stel device base topic in op {{value}}',
         device_events_fqdn_is_set_to: 'FQDN is ingesteld op {{value}}',
         device_events_update_fota_gateway_on_device: 'Werk FOTA gateway op device bij met bestandspad={{value}}',
         device_events_ftp_credentials: 'FTP-inloggegevens: gebruikersnaam={{username}}, wachtwoord={{password}}',
         device_events_hiu_firmware_update: 'HIU-firmware-update: Fase - {{stage}}. Fout: {{error}}',
         device_events_update_hiu_ota: 'Werk HIU OTA bij op unitID={{unitId}}, bestandspad={{filePath}}, resetHiuAfterUpload={{resetHiu}}, verifyChecksumTimeoutSeconds={{timeout}}',
         device_events_reset_hiu_with_unit_id: 'Reset HIU met unitID={{value}}',
         device_events_fetching_mbus_data_records: 'MBus-datarecords ophalen voor MBUS_SERIAL_NUMBER={{serialNumber}} met data-adressen {{addresses}}',
         device_events_apply_mbus_data_logs_project_level: 'Pas MBUS data logs toe op projectniveau met configuratie {{config}}',
         device_events_set_mbus_sample_configuration: 'Stel MBus-sampleconfiguratie in met configuratie {{config}}',
         device_events_device_send_meter_new_readings: 'Device stuurt nieuwe meterstanden: {{readings}}',
         device_events_set_modbus_error_register: 'Stel Modbus-foutregister in op {{value}}',
         device_events_modbus_error_report: 'Modbus-foutrapport: NieuweWaarde={{newValue}}, VorigeWaarde={{previousValue}}',
         device_events_get_values_of: 'Haal waarden van reg_{{value}} op',
         device_events_get_value_of: 'Haal waarde van reg_{{value}} op',
         device_events_modbus_baudrate_config: 'Modbus-baudrateconfiguratie: baudrate={{baudrate}}, parity={{parity}}, stopbits={{stopbits}}',
         device_events_set_modbus_baudrate_config: 'Stel Modbus-baudrateconfiguratie in: [baudrate={{baudrate}}, parity={{parity}}, stopbits={{stopbits}}]',
         device_events_set_modbus_registers_interval: 'Stel interval voor Modbus-registers in op {{value}}',
         device_events_set_modbus_write_enable_configuration: 'Stel Modbus-schrijfactiveringsconfiguratie in voor register={{register}}, unitId={{unitId}}, enable={{enable}}, disable={{disable}}',
         device_events_set_modbus_register_values: 'Stel Modbus-registerwaarden in {{value}}',
         device_events_resending_ota_firmware: 'OTA-firmwareversie-update ({{version}}) voor de {{nth}} keer opnieuw verzenden',
         device_events_set_remote_ftp_credentials: 'Stel remote FTP in met inloggegevens: gebruikersnaam={{username}}, wachtwoord={{password}}',
         device_events_set_remote_network_endpoint_config: 'Stel configuratie van remote network endpoint in op fqdn={{value}}',
         device_events_reset_device_within_seconds: 'Reset apparaat binnen {{value}} seconden',
         device_events_fetch_reg_for_modbus_connection: 'Haal reg_{{value}} op voor Modbus-verbinding',
         device_events_set_base_topic_to: 'Stel basistopic in op {{value}}',
         device_events_set_fqdn_to: 'Stel FQDN in op {{value}}',
         device_events_set_modbus_baud_rate_to: 'Stel Modbus-baudrate in op {{value}}',
         device_events_set_modbus_error_register_value_to: 'stel waarde van Modbus-foutregister in op {{value}}',
         device_events_set_modbus_error_register_address_to: 'stel adres van Modbus-foutregister in op {{value}}',
         device_events_set_secondary_device_type_to: 'Stel secundair device type in op {{value}}',
       };